const hplcUVVisJcamp = `
##TITLE=multi_hplc.1_bagit
##JCAMP-DX=5.0
##DATA TYPE=LINK
##BLOCKS=1


$$ === CHEMSPECTRA SPECTRUM ORIG ===
##TITLE=multi_hplc.1_bagit
##JCAMP-DX=5.00
##DATA TYPE=HPLC UV/VIS SPECTRUM
##DATA CLASS=XYDATA
##$CSCATEGORY=SPECTRUM
##ORIGIN=
##OWNER=
##XUNITS=MINUTES
##YUNITS=TRANSMITTANCE
##XFACTOR=1.0
##YFACTOR=1.0
##FIRSTX=0.0
##LASTX=30.0
##MAXX=30.0
##MAXY=401.209891
##MINX=0.0
##MINY=-1.308446
##NPOINTS=9001
##XYDATA= (XY..XY)
0.0, 0.0
0.003333, -0.000135
0.006667, -0.001123
0.01, -0.004562
0.013333, -0.012176
0.016667, -0.02432
0.02, -0.039356
0.023333, -0.054564
0.026667, -0.067403
0.03, -0.076169
0.033333, -0.080257
0.036667, -0.080164
0.04, -0.077103
0.043333, -0.072508
0.046667, -0.067725
0.05, -0.063768
0.053333, -0.061113
0.056667, -0.059763
0.06, -0.059447
0.063333, -0.05968
0.066667, -0.059847
0.07, -0.059607
0.073333, -0.059283
0.076667, -0.05955
0.08, -0.060545
0.083333, -0.061603
0.086667, -0.06201
0.09, -0.061728
0.093333, -0.061346
0.096667, -0.061514
0.1, -0.062506
0.103333, -0.064246
0.106667, -0.066523
0.11, -0.06902
0.113333, -0.071342
0.116667, -0.073102
0.12, -0.074006
0.123333, -0.074157
0.126667, -0.074262
0.13, -0.075227
0.133333, -0.077428
0.136667, -0.080335
0.14, -0.082913
0.143333, -0.084436
0.146667, -0.084819
0.15, -0.084284
0.153333, -0.083188
0.156667, -0.082263
0.16, -0.082321
0.163333, -0.08356
0.166667, -0.085701
0.17, -0.088473
0.173333, -0.091557
0.176667, -0.094455
0.18, -0.09668
0.183333, -0.098107
0.186667, -0.099235
0.19, -0.100837
0.193333, -0.103238
0.196667, -0.106073
0.2, -0.108727
0.203333, -0.110903
0.206667, -0.112693
0.21, -0.114232
0.213333, -0.115497
0.216667, -0.116414
0.22, -0.117027
0.223333, -0.117639
0.226667, -0.11878
0.23, -0.120806
0.233333, -0.123545
0.236667, -0.126457
0.24, -0.129121
0.243333, -0.131495
0.246667, -0.13366
0.25, -0.135447
0.253333, -0.136525
0.256667, -0.136782
0.26, -0.136518
0.263333, -0.136319
0.266667, -0.136713
0.27, -0.137978
0.273333, -0.140029
0.276667, -0.14229
0.28, -0.143966
0.283333, -0.144636
0.286667, -0.144515
0.29, -0.144247
0.293333, -0.144334
0.296667, -0.144713
0.3, -0.145171
0.303333, -0.145908
0.306667, -0.147219
0.31, -0.149007
0.313333, -0.151019
0.316667, -0.15335
0.32, -0.156337
0.323333, -0.159797
0.326667, -0.162828
0.33, -0.164737
0.333333, -0.165643
0.336667, -0.166029
0.34, -0.166254
0.343333, -0.166406
0.346667, -0.166405
0.35, -0.166427
0.353333, -0.167044
0.356667, -0.168677
0.36, -0.171152
0.363333, -0.173822
0.366667, -0.17596
0.37, -0.177323
0.373333, -0.17841
0.376667, -0.179887
0.38, -0.181874
0.383333, -0.183911
0.386667, -0.18546
0.39, -0.186491
0.393333, -0.187532
0.396667, -0.189032
0.4, -0.190937
0.403333, -0.19291
0.406667, -0.194693
0.41, -0.196267
0.413333, -0.197751
0.416667, -0.199054
0.42, -0.199845
0.423333, -0.199968
0.426667, -0.199595
0.43, -0.199159
0.433333, -0.199281
0.436667, -0.200281
0.44, -0.201806
0.443333, -0.203305
0.446667, -0.204648
0.45, -0.206033
0.453333, -0.207595
0.456667, -0.209324
0.46, -0.211174
0.463333, -0.213157
0.466667, -0.215344
0.47, -0.21784
0.473333, -0.220493
0.476667, -0.222564
0.48, -0.223283
0.483333, -0.222726
0.486667, -0.221617
0.49, -0.220693
0.493333, -0.22044
0.496667, -0.220984
0.5, -0.222128
0.503333, -0.223486
0.506667, -0.224699
0.51, -0.22575
0.513333, -0.226934
0.516667, -0.228526
0.52, -0.230601
0.523333, -0.232915
0.526667, -0.234884
0.53, -0.235905
0.533333, -0.235813
0.536667, -0.234964
0.54, -0.233973
0.543333, -0.233515
0.546667, -0.234194
0.55, -0.236243
0.553333, -0.239332
0.556667, -0.242838
0.56, -0.246227
0.563333, -0.249046
0.566667, -0.250906
0.57, -0.25172
0.573333, -0.251775
0.576667, -0.251533
0.58, -0.25141
0.583333, -0.251593
0.586667, -0.251997
0.59, -0.252478
0.593333, -0.253108
0.596667, -0.254135
0.6, -0.255691
0.603333, -0.257671
0.606667, -0.259856
0.61, -0.262048
0.613333, -0.264215
0.616667, -0.266439
0.62, -0.268645
0.623333, -0.270644
0.626667, -0.272421
0.63, -0.273934
0.633333, -0.274963
0.636667, -0.275528
0.64, -0.275977
0.643333, -0.276479
0.646667, -0.276891
0.65, -0.27719
0.653333, -0.277773
0.656667, -0.279114
0.66, -0.281208
0.663333, -0.283563
0.666667, -0.285572
0.67, -0.286805
0.673333, -0.287231
0.676667, -0.287121
0.68, -0.286709
0.683333, -0.286221
0.686667, -0.286064
0.69, -0.286736
0.693333, -0.288398
0.696667, -0.290643
0.7, -0.292863
0.703333, -0.294607
0.706667, -0.295658
0.71, -0.296001
0.713333, -0.295728
0.716667, -0.295037
0.72, -0.294218
0.723333, -0.293523
0.726667, -0.293218
0.73, -0.293573
0.733333, -0.294679
0.736667, -0.296339
0.74, -0.298127
0.743333, -0.299683
0.746667, -0.300998
0.75, -0.302379
0.753333, -0.304063
0.756667, -0.305784
0.76, -0.306973
0.763333, -0.30747
0.766667, -0.307657
0.77, -0.307793
0.773333, -0.307783
0.776667, -0.307717
0.78, -0.308089
0.783333, -0.309232
0.786667, -0.310931
0.79, -0.312662
0.793333, -0.313871
0.796667, -0.314274
0.8, -0.31413
0.803333, -0.314056
0.806667, -0.314543
0.81, -0.315437
0.813333, -0.315944
0.816667, -0.315489
0.82, -0.314311
0.823333, -0.312942
0.826667, -0.311583
0.83, -0.310119
0.833333, -0.308373
0.836667, -0.306487
0.84, -0.305173
0.843333, -0.305298
0.846667, -0.307063
0.85, -0.309736
0.853333, -0.312322
0.856667, -0.314223
0.86, -0.315268
0.863333, -0.315598
0.866667, -0.315651
0.87, -0.315948
0.873333, -0.316691
0.876667, -0.317636
0.88, -0.318487
0.883333, -0.319327
0.886667, -0.320416
0.89, -0.321665
0.893333, -0.322721
0.896667, -0.323351
0.9, -0.32334
0.903333, -0.322458
0.906667, -0.320928
0.91, -0.319466
0.913333, -0.318755
0.916667, -0.319205
0.92, -0.320809
0.923333, -0.322835
0.926667, -0.324192
0.93, -0.324323
0.933333, -0.323442
0.936667, -0.322235
0.94, -0.321561
0.943333, -0.321888
0.946667, -0.322854
0.95, -0.323694
0.953333, -0.323895
0.956667, -0.323272
0.96, -0.321933
0.963333, -0.320441
0.966667, -0.319555
0.97, -0.319609
0.973333, -0.320294
0.976667, -0.321114
0.98, -0.321765
0.983333, -0.321942
0.986667, -0.321168
0.99, -0.319292
0.993333, -0.316959
0.996667, -0.315123
1.0, -0.314112
1.003333, -0.313522
1.006667, -0.312913
1.01, -0.312219
1.013333, -0.311625
1.016667, -0.311422
1.02, -0.311834
1.023333, -0.312725
1.026667, -0.313693
1.03, -0.314664
1.033333, -0.315901
1.036667, -0.317402
1.04, -0.318745
1.043333, -0.319401
1.046667, -0.319062
1.05, -0.317888
1.053333, -0.316351
1.056667, -0.314924
1.06, -0.313959
1.063333, -0.313567
1.066667, -0.313727
1.07, -0.314588
1.073333, -0.316208
1.076667, -0.318
1.08, -0.31902
1.083333, -0.318922
1.086667, -0.318314
1.09, -0.318032
1.093333, -0.318345
1.096667, -0.31902
1.1, -0.319816
1.103333, -0.32065
1.106667, -0.321421
1.11, -0.321979
1.113333, -0.32229
1.116667, -0.322471
1.12, -0.322519
1.123333, -0.32212
1.126667, -0.321052
1.13, -0.31971
1.133333, -0.318832
1.136667, -0.318777
1.14, -0.319343
1.143333, -0.320038
1.146667, -0.320384
1.15, -0.320206
1.153333, -0.319771
1.156667, -0.319599
1.16, -0.320061
1.163333, -0.321039
1.166667, -0.321916
1.17, -0.322269
1.173333, -0.322335
1.176667, -0.322404
1.18, -0.322444
1.183333, -0.322457
1.186667, -0.322495
1.19, -0.322567
1.193333, -0.322773
1.196667, -0.323214
1.2, -0.323668
1.203333, -0.323612
1.206667, -0.32272
1.21, -0.32119
1.213333, -0.319622
1.216667, -0.318814
1.22, -0.319412
1.223333, -0.321302
1.226667, -0.323539
1.23, -0.325043
1.233333, -0.325298
1.236667, -0.324458
1.24, -0.323029
1.243333, -0.321591
1.246667, -0.320748
1.25, -0.320893
1.253333, -0.321736
1.256667, -0.322499
1.26, -0.322761
1.263333, -0.322706
1.266667, -0.322702
1.27, -0.322956
1.273333, -0.323384
1.276667, -0.323747
1.28, -0.323821
1.283333, -0.323391
1.286667, -0.322511
1.29, -0.321651
1.293333, -0.321063
1.296667, -0.320309
1.3, -0.318737
1.303333, -0.316318
1.306667, -0.313892
1.31, -0.312231
1.313333, -0.311114
1.316667, -0.309751
1.32, -0.307693
1.323333, -0.305182
1.326667, -0.30288
1.33, -0.301203
1.333333, -0.300005
1.336667, -0.298886
1.34, -0.297558
1.343333, -0.29598
1.346667, -0.294215
1.35, -0.292076
1.353333, -0.289211
1.356667, -0.285759
1.36, -0.282404
1.363333, -0.279581
1.366667, -0.277203
1.37, -0.275083
1.373333, -0.273133
1.376667, -0.271158
1.38, -0.268775
1.383333, -0.265737
1.386667, -0.262168
1.39, -0.258401
1.393333, -0.254809
1.396667, -0.251677
1.4, -0.248977
1.403333, -0.24624
1.406667, -0.242886
1.41, -0.238791
1.413333, -0.234468
1.416667, -0.230595
1.42, -0.227363
1.423333, -0.224233
1.426667, -0.220485
1.43, -0.215992
1.433333, -0.211151
1.436667, -0.206233
1.44, -0.201292
1.443333, -0.196561
1.446667, -0.19247
1.45, -0.189126
1.453333, -0.186086
1.456667, -0.182815
1.46, -0.179182
1.463333, -0.175471
1.466667, -0.171859
1.47, -0.167914
1.473333, -0.162944
1.476667, -0.156678
1.48, -0.14943
1.483333, -0.141923
1.486667, -0.134898
1.49, -0.128642
1.493333, -0.123065
1.496667, -0.118079
1.5, -0.113578
1.503333, -0.109332
1.506667, -0.105077
1.51, -0.100636
1.513333, -0.096062
1.516667, -0.091624
1.52, -0.087379
1.523333, -0.082927
1.526667, -0.077924
1.53, -0.072703
1.533333, -0.068005
1.536667, -0.064069
1.54, -0.06025
1.543333, -0.055773
1.546667, -0.050587
1.55, -0.04513
1.553333, -0.039677
1.556667, -0.034332
1.56, -0.029267
1.563333, -0.024623
1.566667, -0.020448
1.57, -0.016761
1.573333, -0.013405
1.576667, -0.010002
1.58, -0.006356
1.583333, -0.002838
1.586667, -0.00018
1.59, 0.001318
1.593333, 0.002315
1.596667, 0.003901
1.6, 0.006592
1.603333, 0.009945
1.606667, 0.013167
1.61, 0.015872
1.613333, 0.018039
1.616667, 0.019632
1.62, 0.020552
1.623333, 0.02086
1.626667, 0.020928
1.63, 0.021215
1.633333, 0.021942
1.636667, 0.023069
1.64, 0.024397
1.643333, 0.025556
1.646667, 0.026138
1.65, 0.026055
1.653333, 0.025593
1.656667, 0.024978
1.66, 0.024179
1.663333, 0.023155
1.666667, 0.022011
1.67, 0.020917
1.673333, 0.019827
1.676667, 0.018473
1.68, 0.016915
1.683333, 0.015696
1.686667, 0.015002
1.69, 0.014258
1.693333, 0.012904
1.696667, 0.010993
1.7, 0.008883
1.703333, 0.006662
1.706667, 0.004003
1.71, 0.000697
1.713333, -0.002949
1.716667, -0.006381
1.72, -0.009184
1.723333, -0.01136
1.726667, -0.01339
1.73, -0.015758
1.733333, -0.018541
1.736667, -0.021633
1.74, -0.025027
1.743333, -0.028689
1.746667, -0.032469
1.75, -0.036239
1.753333, -0.039947
1.756667, -0.043449
1.76, -0.046495
1.763333, -0.048957
1.766667, -0.050779
1.77, -0.051842
1.773333, -0.052268
1.776667, -0.052694
1.78, -0.053904
1.783333, -0.056258
1.786667, -0.059662
1.79, -0.063979
1.793333, -0.069017
1.796667, -0.074162
1.8, -0.078544
1.803333, -0.08163
1.806667, -0.083473
1.81, -0.084471
1.813333, -0.085173
1.816667, -0.086225
1.82, -0.088204
1.823333, -0.091431
1.826667, -0.095723
1.83, -0.100353
1.833333, -0.104486
1.836667, -0.107571
1.84, -0.109534
1.843333, -0.110827
1.846667, -0.112026
1.85, -0.11329
1.853333, -0.114413
1.856667, -0.115374
1.86, -0.116577
1.863333, -0.118433
1.866667, -0.120805
1.87, -0.122957
1.873333, -0.124103
1.876667, -0.124001
1.88, -0.123122
1.883333, -0.122452
1.886667, -0.122981
1.89, -0.124934
1.893333, -0.127651
1.896667, -0.130472
1.9, -0.133323
1.903333, -0.13632
1.906667, -0.139327
1.91, -0.142101
1.913333, -0.144603
1.916667, -0.146953
1.92, -0.149069
1.923333, -0.150677
1.926667, -0.15188
1.93, -0.15317
1.933333, -0.154759
1.936667, -0.156423
1.94, -0.158009
1.943333, -0.159684
1.946667, -0.161598
1.95, -0.163583
1.953333, -0.165462
1.956667, -0.167364
1.96, -0.169396
1.963333, -0.171369
1.966667, -0.173168
1.97, -0.175065
1.973333, -0.177393
1.976667, -0.180205
1.98, -0.183348
1.983333, -0.186574
1.986667, -0.189581
1.99, -0.192123
1.993333, -0.194069
1.996667, -0.195323
2.0, -0.195968
2.003333, -0.196471
2.006667, -0.197331
2.01, -0.198612
2.013333, -0.200173
2.016667, -0.20196
2.02, -0.203813
2.023333, -0.205429
2.026667, -0.206587
2.03, -0.207262
2.033333, -0.207576
2.036667, -0.207732
2.04, -0.207958
2.043333, -0.208535
2.046667, -0.209835
2.05, -0.212059
2.053333, -0.214824
2.056667, -0.217456
2.06, -0.219637
2.063333, -0.221396
2.066667, -0.222614
2.07, -0.22301
2.073333, -0.222572
2.076667, -0.221581
2.08, -0.220355
2.083333, -0.219303
2.086667, -0.218851
2.09, -0.219026
2.093333, -0.219478
2.096667, -0.220054
2.1, -0.221156
2.103333, -0.223275
2.106667, -0.226136
2.11, -0.228724
2.113333, -0.230238
2.116667, -0.230645
2.12, -0.230445
2.123333, -0.23024
2.126667, -0.230461
2.13, -0.231248
2.133333, -0.232375
2.136667, -0.233314
2.14, -0.233539
2.143333, -0.232763
2.146667, -0.230945
2.15, -0.228345
2.153333, -0.225467
2.156667, -0.222713
2.16, -0.220321
2.163333, -0.218568
2.166667, -0.217622
2.17, -0.217332
2.173333, -0.217353
2.176667, -0.217296
2.18, -0.216822
2.183333, -0.215793
2.186667, -0.214282
2.19, -0.212466
2.193333, -0.210533
2.196667, -0.208613
2.2, -0.20686
2.203333, -0.205436
2.206667, -0.2043
2.21, -0.203307
2.213333, -0.202319
2.216667, -0.201137
2.22, -0.199756
2.223333, -0.198612
2.226667, -0.198172
2.23, -0.198368
2.233333, -0.198548
2.236667, -0.197972
2.24, -0.196329
2.243333, -0.19382
2.246667, -0.190955
2.25, -0.188335
2.253333, -0.186317
2.256667, -0.184886
2.26, -0.183912
2.263333, -0.183268
2.266667, -0.1828
2.27, -0.182482
2.273333, -0.182529
2.276667, -0.183197
2.28, -0.184327
2.283333, -0.185181
2.286667, -0.185014
2.29, -0.183737
2.293333, -0.181844
2.296667, -0.180035
2.3, -0.179029
2.303333, -0.179357
2.306667, -0.181044
2.31, -0.183492
2.313333, -0.185751
2.316667, -0.187044
2.32, -0.187181
2.323333, -0.186485
2.326667, -0.185449
2.33, -0.184538
2.333333, -0.184129
2.336667, -0.184322
2.34, -0.184789
2.343333, -0.185059
2.346667, -0.184956
2.35, -0.184675
2.353333, -0.184442
2.356667, -0.184199
2.36, -0.183857
2.363333, -0.18366
2.366667, -0.183957
2.37, -0.184771
2.373333, -0.185751
2.376667, -0.186498
2.38, -0.186945
2.383333, -0.187235
2.386667, -0.187208
2.39, -0.186492
2.393333, -0.18523
2.396667, -0.184111
2.4, -0.183561
2.403333, -0.183554
2.406667, -0.184008
2.41, -0.184889
2.413333, -0.186225
2.416667, -0.188068
2.42, -0.190209
2.423333, -0.192119
2.426667, -0.193372
2.43, -0.194021
2.433333, -0.194467
2.436667, -0.195058
2.44, -0.195906
2.443333, -0.196868
2.446667, -0.197595
2.45, -0.197756
2.453333, -0.197259
2.456667, -0.196381
2.46, -0.195663
2.463333, -0.195358
2.466667, -0.195242
2.47, -0.195139
2.473333, -0.195123
2.476667, -0.195169
2.48, -0.195146
2.483333, -0.19526
2.486667, -0.196043
2.49, -0.197726
2.493333, -0.199903
2.496667, -0.201906
2.5, -0.203349
2.503333, -0.20428
2.506667, -0.20492
2.51, -0.205312
2.513333, -0.205193
2.516667, -0.204313
2.52, -0.202888
2.523333, -0.201464
2.526667, -0.200368
2.53, -0.199538
2.533333, -0.198734
2.536667, -0.197885
2.54, -0.197197
2.543333, -0.196878
2.546667, -0.197049
2.55, -0.197799
2.553333, -0.198851
2.556667, -0.199549
2.56, -0.199367
2.563333, -0.198281
2.566667, -0.196903
2.57, -0.196232
2.573333, -0.196923
2.576667, -0.198824
2.58, -0.201216
2.583333, -0.203285
2.586667, -0.204415
2.59, -0.204354
2.593333, -0.203227
2.596667, -0.201488
2.6, -0.199913
2.603333, -0.199276
2.606667, -0.19962
2.61, -0.200208
2.613333, -0.200428
2.616667, -0.200367
2.62, -0.200562
2.623333, -0.201512
2.626667, -0.203332
2.63, -0.205706
2.633333, -0.207966
2.636667, -0.209366
2.64, -0.209636
2.643333, -0.209057
2.646667, -0.20813
2.65, -0.207526
2.653333, -0.207871
2.656667, -0.209171
2.66, -0.210824
2.663333, -0.212169
2.666667, -0.212875
2.67, -0.213128
2.673333, -0.213389
2.676667, -0.213798
2.68, -0.214211
2.683333, -0.214648
2.686667, -0.215191
2.69, -0.215806
2.693333, -0.216453
2.696667, -0.21698
2.7, -0.217148
2.703333, -0.216918
2.706667, -0.216535
2.71, -0.216342
2.713333, -0.216486
2.716667, -0.216862
2.72, -0.217425
2.723333, -0.218237
2.726667, -0.219092
2.73, -0.219485
2.733333, -0.219083
2.736667, -0.21805
2.74, -0.216985
2.743333, -0.216636
2.746667, -0.217417
2.75, -0.219048
2.753333, -0.220681
2.756667, -0.221522
2.76, -0.221446
2.763333, -0.221104
2.766667, -0.221409
2.77, -0.222786
2.773333, -0.224907
2.776667, -0.227057
2.78, -0.228635
2.783333, -0.229462
2.786667, -0.229681
2.79, -0.22942
2.793333, -0.228742
2.796667, -0.227702
2.8, -0.226283
2.803333, -0.224662
2.806667, -0.223499
2.81, -0.223542
2.813333, -0.225058
2.816667, -0.227779
2.82, -0.231007
2.823333, -0.233751
2.826667, -0.235278
2.83, -0.235722
2.833333, -0.235935
2.836667, -0.236734
2.84, -0.238273
2.843333, -0.240058
2.846667, -0.241441
2.85, -0.241955
2.853333, -0.24141
2.856667, -0.23996
2.86, -0.238025
2.863333, -0.236303
2.866667, -0.235613
2.87, -0.236241
2.873333, -0.237757
2.876667, -0.239667
2.88, -0.2418
2.883333, -0.244075
2.886667, -0.246346
2.89, -0.248437
2.893333, -0.250035
2.896667, -0.250713
2.9, -0.25041
2.903333, -0.249776
2.906667, -0.249736
2.91, -0.250695
2.913333, -0.252278
2.916667, -0.25383
2.92, -0.255071
2.923333, -0.255956
2.926667, -0.256278
2.93, -0.255971
2.933333, -0.255509
2.936667, -0.255557
2.94, -0.256339
2.943333, -0.257503
2.946667, -0.258629
2.95, -0.259763
2.953333, -0.261287
2.956667, -0.263291
2.96, -0.265285
2.963333, -0.266643
2.966667, -0.267096
2.97, -0.266642
2.973333, -0.265458
2.976667, -0.264005
2.98, -0.262831
2.983333, -0.262256
2.986667, -0.262236
2.99, -0.262369
2.993333, -0.262133
2.996667, -0.261348
3.0, -0.26031
3.003333, -0.259496
3.006667, -0.259384
3.01, -0.260256
3.013333, -0.261813
3.016667, -0.263469
3.02, -0.264967
3.023333, -0.266302
3.026667, -0.267541
3.03, -0.26884
3.033333, -0.270233
3.036667, -0.271468
3.04, -0.272196
3.043333, -0.27216
3.046667, -0.271287
3.05, -0.269819
3.053333, -0.268317
3.056667, -0.267501
3.06, -0.267846
3.063333, -0.269181
3.066667, -0.270909
3.07, -0.272517
3.073333, -0.273621
3.076667, -0.273969
3.08, -0.27375
3.083333, -0.2736
3.086667, -0.274033
3.09, -0.27501
3.093333, -0.276157
3.096667, -0.277196
3.1, -0.277924
3.103333, -0.278099
3.106667, -0.277643
3.11, -0.276827
3.113333, -0.276105
3.116667, -0.275862
3.12, -0.276316
3.123333, -0.277581
3.126667, -0.279662
3.13, -0.282266
3.133333, -0.284796
3.136667, -0.286518
3.14, -0.286825
3.143333, -0.285683
3.146667, -0.283736
3.15, -0.281742
3.153333, -0.280118
3.156667, -0.279104
3.16, -0.278977
3.163333, -0.27973
3.166667, -0.280788
3.17, -0.281434
3.173333, -0.28143
3.176667, -0.281018
3.18, -0.280463
3.183333, -0.279839
3.186667, -0.279213
3.19, -0.278844
3.193333, -0.27912
3.196667, -0.280231
3.2, -0.281813
3.203333, -0.283132
3.206667, -0.283681
3.21, -0.283416
3.213333, -0.282619
3.216667, -0.281631
3.22, -0.280613
3.223333, -0.27967
3.226667, -0.279083
3.23, -0.279173
3.233333, -0.279865
3.236667, -0.280729
3.24, -0.281543
3.243333, -0.282353
3.246667, -0.283195
3.25, -0.284128
3.253333, -0.285114
3.256667, -0.28583
3.26, -0.285927
3.263333, -0.285432
3.266667, -0.284896
3.27, -0.284993
3.273333, -0.285732
3.276667, -0.286323
3.28, -0.285997
3.283333, -0.284775
3.286667, -0.283288
3.29, -0.28206
3.293333, -0.281313
3.296667, -0.281128
3.3, -0.28131
3.303333, -0.281528
3.306667, -0.281764
3.31, -0.282233
3.313333, -0.282902
3.316667, -0.283433
3.32, -0.283455
3.323333, -0.282747
3.326667, -0.281516
3.33, -0.280516
3.333333, -0.280518
3.336667, -0.281744
3.34, -0.283844
3.343333, -0.286258
3.346667, -0.288627
3.35, -0.290883
3.353333, -0.293023
3.356667, -0.29498
3.36, -0.296591
3.363333, -0.297696
3.366667, -0.298292
3.37, -0.298428
3.373333, -0.298047
3.376667, -0.297257
3.38, -0.296567
3.383333, -0.296494
3.386667, -0.297148
3.39, -0.298447
3.393333, -0.30036
3.396667, -0.302784
3.4, -0.305433
3.403333, -0.307895
3.406667, -0.30983
3.41, -0.311252
3.413333, -0.312595
3.416667, -0.314293
3.42, -0.316108
3.423333, -0.317277
3.426667, -0.317512
3.43, -0.317279
3.433333, -0.317323
3.436667, -0.318315
3.44, -0.320483
3.443333, -0.323384
3.446667, -0.326218
3.45, -0.328319
3.453333, -0.329331
3.456667, -0.329284
3.46, -0.328744
3.463333, -0.32858
3.466667, -0.329365
3.47, -0.331072
3.473333, -0.333251
3.476667, -0.335316
3.48, -0.336901
3.483333, -0.338081
3.486667, -0.339144
3.49, -0.340267
3.493333, -0.341518
3.496667, -0.342932
3.5, -0.344547
3.503333, -0.34637
3.506667, -0.348237
3.51, -0.349923
3.513333, -0.351309
3.516667, -0.352206
3.52, -0.352291
3.523333, -0.351527
3.526667, -0.350488
3.53, -0.35002
3.533333, -0.350581
3.536667, -0.352101
3.54, -0.354273
3.543333, -0.3566
3.546667, -0.358431
3.55, -0.359441
3.553333, -0.359829
3.556667, -0.360019
3.56, -0.360402
3.563333, -0.361192
3.566667, -0.362321
3.57, -0.363495
3.573333, -0.364308
3.576667, -0.364425
3.58, -0.363785
3.583333, -0.36255
3.586667, -0.360939
3.59, -0.359251
3.593333, -0.357915
3.596667, -0.357338
3.6, -0.357692
3.603333, -0.358859
3.606667, -0.360459
3.61, -0.361996
3.613333, -0.363085
3.616667, -0.363486
3.62, -0.363076
3.623333, -0.361995
3.626667, -0.360752
3.63, -0.359978
3.633333, -0.35995
3.636667, -0.360461
3.64, -0.361003
3.643333, -0.361029
3.646667, -0.360268
3.65, -0.358784
3.653333, -0.356781
3.656667, -0.354577
3.66, -0.352612
3.663333, -0.351198
3.666667, -0.350379
3.67, -0.350142
3.673333, -0.350369
3.676667, -0.350615
3.68, -0.350408
3.683333, -0.349717
3.686667, -0.348772
3.69, -0.347633
3.693333, -0.346228
3.696667, -0.344705
3.7, -0.343421
3.703333, -0.342592
3.706667, -0.342093
3.71, -0.34153
3.713333, -0.340563
3.716667, -0.339426
3.72, -0.338881
3.723333, -0.339297
3.726667, -0.340197
3.73, -0.340862
3.733333, -0.340956
3.736667, -0.340682
3.74, -0.340584
3.743333, -0.341194
3.746667, -0.342828
3.75, -0.34532
3.753333, -0.347946
3.756667, -0.350066
3.76, -0.351865
3.763333, -0.354355
3.766667, -0.358837
3.77, -0.366267
3.773333, -0.376791
3.776667, -0.389789
3.78, -0.404367
3.783333, -0.419828
3.786667, -0.43573
3.79, -0.4516
3.793333, -0.466746
3.796667, -0.480343
3.8, -0.491539
3.803333, -0.499582
3.806667, -0.504031
3.81, -0.504817
3.813333, -0.502168
3.816667, -0.496491
3.82, -0.488378
3.823333, -0.478629
3.826667, -0.468053
3.83, -0.457261
3.833333, -0.446616
3.836667, -0.436247
3.84, -0.426162
3.843333, -0.41639
3.846667, -0.407091
3.85, -0.398511
3.853333, -0.390765
3.856667, -0.383863
3.86, -0.377864
3.863333, -0.372693
3.866667, -0.368004
3.87, -0.363396
3.873333, -0.358572
3.876667, -0.353234
3.88, -0.346975
3.883333, -0.339259
3.886667, -0.329446
3.89, -0.316995
3.893333, -0.30177
3.896667, -0.284102
3.9, -0.264465
3.903333, -0.243248
3.906667, -0.220839
3.91, -0.197652
3.913333, -0.174148
3.916667, -0.151138
3.92, -0.129939
3.923333, -0.11191
3.926667, -0.097683
3.93, -0.086646
3.933333, -0.076655
3.936667, -0.063944
3.94, -0.043406
3.943333, -0.008929
3.946667, 0.046448
3.95, 0.130063
3.953333, 0.248535
3.956667, 0.406523
3.96, 0.60579
3.963333, 0.844466
3.966667, 1.116658
3.97, 1.412622
3.973333, 1.719636
3.976667, 2.023305
3.98, 2.308692
3.983333, 2.561691
3.986667, 2.771028
3.99, 2.929771
3.993333, 3.035441
3.996667, 3.089165
4.0, 3.094671
4.003333, 3.057315
4.006667, 2.982984
4.01, 2.877036
4.013333, 2.743888
4.016667, 2.587428
4.02, 2.411487
4.023333, 2.219955
4.026667, 2.016882
4.03, 1.80661
4.033333, 1.593825
4.036667, 1.383781
4.04, 1.182739
4.043333, 0.99799
4.046667, 0.837036
4.05, 0.70652
4.053333, 0.611726
4.056667, 0.556386
4.06, 0.542383
4.063333, 0.56974
4.066667, 0.637126
4.07, 0.742231
4.073333, 0.881863
4.076667, 1.052392
4.08, 1.250452
4.083333, 1.473232
4.086667, 1.718742
4.09, 1.986367
4.093333, 2.276793
4.096667, 2.591079
4.1, 2.929911
4.103333, 3.293376
4.106667, 3.680895
4.11, 4.091215
4.113333, 4.522254
4.116667, 4.970797
4.12, 5.431958
4.123333, 5.898779
4.126667, 6.362553
4.13, 6.813593
4.133333, 7.241673
4.136667, 7.635958
4.14, 7.984899
4.143333, 8.276952
4.146667, 8.501882
4.15, 8.651394
4.153333, 8.718861
4.156667, 8.699355
4.16, 8.590693
4.163333, 8.394376
4.166667, 8.115296
4.17, 7.760674
4.173333, 7.339194
4.176667, 6.860732
4.18, 6.336556
4.183333, 5.779329
4.186667, 5.202258
4.19, 4.617824
4.193333, 4.037299
4.196667, 3.471068
4.2, 2.928469
4.203333, 2.41684
4.206667, 1.940941
4.21, 1.50357
4.213333, 1.106661
4.216667, 0.751496
4.22, 0.437905
4.223333, 0.163865
4.226667, -0.073708
4.23, -0.277902
4.233333, -0.451674
4.236667, -0.598249
4.24, -0.720962
4.243333, -0.822921
4.246667, -0.907144
4.25, -0.976533
4.253333, -1.033551
4.256667, -1.08012
4.26, -1.117738
4.263333, -1.147688
4.266667, -1.171178
4.27, -1.189145
4.273333, -1.202157
4.276667, -1.210721
4.28, -1.215367
4.283333, -1.216514
4.286667, -1.214483
4.29, -1.209458
4.293333, -1.201446
4.296667, -1.19047
4.3, -1.176656
4.303333, -1.160063
4.306667, -1.140777
4.31, -1.119079
4.313333, -1.095285
4.316667, -1.069545
4.32, -1.041889
4.323333, -1.012384
4.326667, -0.98116
4.33, -0.948249
4.333333, -0.913712
4.336667, -0.878161
4.34, -0.842834
4.343333, -0.808859
4.346667, -0.776602
4.35, -0.745834
4.353333, -0.716268
4.356667, -0.687783
4.36, -0.660432
4.363333, -0.634414
4.366667, -0.609886
4.37, -0.586816
4.373333, -0.56517
4.376667, -0.545134
4.38, -0.527111
4.383333, -0.51147
4.386667, -0.498252
4.39, -0.487198
4.393333, -0.478076
4.396667, -0.470613
4.4, -0.464298
4.403333, -0.458828
4.406667, -0.454556
4.41, -0.451971
4.413333, -0.450952
4.416667, -0.450921
4.42, -0.451377
4.423333, -0.451969
4.426667, -0.452425
4.43, -0.452659
4.433333, -0.452796
4.436667, -0.453017
4.44, -0.453433
4.443333, -0.45406
4.446667, -0.454682
4.45, -0.454927
4.453333, -0.454736
4.456667, -0.454548
4.46, -0.454909
4.463333, -0.456054
4.466667, -0.45782
4.47, -0.459802
4.473333, -0.461567
4.476667, -0.462829
4.48, -0.463575
4.483333, -0.464059
4.486667, -0.46456
4.49, -0.465128
4.493333, -0.465582
4.496667, -0.465742
4.5, -0.46579
4.503333, -0.466185
4.506667, -0.467014
4.51, -0.467811
4.513333, -0.468144
4.516667, -0.46795
4.52, -0.467287
4.523333, -0.466276
4.526667, -0.465299
4.53, -0.464821
4.533333, -0.464993
4.536667, -0.465667
4.54, -0.466617
4.543333, -0.467573
4.546667, -0.468335
4.55, -0.46901
4.553333, -0.469862
4.556667, -0.470928
4.56, -0.472066
4.563333, -0.473208
4.566667, -0.474284
4.57, -0.47516
4.573333, -0.475838
4.576667, -0.476455
4.58, -0.47711
4.583333, -0.477803
4.586667, -0.478489
4.59, -0.479131
4.593333, -0.479704
4.596667, -0.480242
4.6, -0.480937
4.603333, -0.481936
4.606667, -0.482977
4.61, -0.483588
4.613333, -0.48355
4.616667, -0.482855
4.62, -0.481566
4.623333, -0.479921
4.626667, -0.478441
4.63, -0.477765
4.633333, -0.47811
4.636667, -0.479153
4.64, -0.480758
4.643333, -0.483112
4.646667, -0.485967
4.65, -0.488466
4.653333, -0.489815
4.656667, -0.489887
4.66, -0.489325
4.663333, -0.489143
4.666667, -0.489942
4.67, -0.491557
4.673333, -0.493632
4.676667, -0.495975
4.68, -0.498244
4.683333, -0.500059
4.686667, -0.501445
4.69, -0.502535
4.693333, -0.502986
4.696667, -0.502297
4.7, -0.500689
4.703333, -0.499315
4.706667, -0.499328
4.71, -0.500863
4.713333, -0.503084
4.716667, -0.505074
4.72, -0.5065
4.723333, -0.507536
4.726667, -0.508518
4.73, -0.50974
4.733333, -0.511255
4.736667, -0.51284
4.74, -0.514131
4.743333, -0.514858
4.746667, -0.515147
4.75, -0.515643
4.753333, -0.517156
4.756667, -0.519921
4.76, -0.523368
4.763333, -0.526751
4.766667, -0.529549
4.77, -0.531329
4.773333, -0.53188
4.776667, -0.531573
4.78, -0.531251
4.783333, -0.531611
4.786667, -0.532832
4.79, -0.534665
4.793333, -0.536679
4.796667, -0.538537
4.8, -0.540281
4.803333, -0.542348
4.806667, -0.545266
4.81, -0.549156
4.813333, -0.553447
4.816667, -0.557324
4.82, -0.560449
4.823333, -0.56315
4.826667, -0.566106
4.83, -0.569821
4.833333, -0.574189
4.836667, -0.578635
4.84, -0.582685
4.843333, -0.586314
4.846667, -0.589875
4.85, -0.593716
4.853333, -0.59788
4.856667, -0.602166
4.86, -0.60637
4.863333, -0.610491
4.866667, -0.614772
4.87, -0.619399
4.873333, -0.624204
4.876667, -0.628816
4.88, -0.632863
4.883333, -0.636031
4.886667, -0.638241
4.89, -0.639644
4.893333, -0.640409
4.896667, -0.640741
4.9, -0.640758
4.903333, -0.640308
4.906667, -0.639284
4.91, -0.63795
4.913333, -0.636831
4.916667, -0.636382
4.92, -0.636703
4.923333, -0.63752
4.926667, -0.638289
4.93, -0.638391
4.933333, -0.637538
4.936667, -0.635983
4.94, -0.634338
4.943333, -0.6332
4.946667, -0.632899
4.95, -0.633449
4.953333, -0.634354
4.956667, -0.634704
4.96, -0.633999
4.963333, -0.632488
4.966667, -0.63051
4.97, -0.628204
4.973333, -0.625782
4.976667, -0.623596
4.98, -0.621904
4.983333, -0.620702
4.986667, -0.619921
4.99, -0.619748
4.993333, -0.620314
4.996667, -0.621171
5.0, -0.621519
5.003333, -0.62079
5.006667, -0.618967
5.01, -0.616636
5.013333, -0.614603
5.016667, -0.613212
5.02, -0.612224
5.023333, -0.611444
5.026667, -0.611105
5.03, -0.611507
5.033333, -0.612607
5.036667, -0.614001
5.04, -0.615148
5.043333, -0.615692
5.046667, -0.615555
5.05, -0.614735
5.053333, -0.613343
5.056667, -0.611874
5.06, -0.611044
5.063333, -0.61128
5.066667, -0.612522
5.07, -0.614425
5.073333, -0.616477
5.076667, -0.617985
5.08, -0.61833
5.083333, -0.61744
5.086667, -0.615902
5.09, -0.614442
5.093333, -0.613352
5.096667, -0.612606
5.1, -0.612124
5.103333, -0.611634
5.106667, -0.610698
5.11, -0.609174
5.113333, -0.607373
5.116667, -0.605724
5.12, -0.60442
5.123333, -0.603316
5.126667, -0.602189
5.13, -0.600949
5.133333, -0.599497
5.136667, -0.597785
5.14, -0.595984
5.143333, -0.594297
5.146667, -0.592839
5.15, -0.591828
5.153333, -0.591543
5.156667, -0.59193
5.16, -0.592501
5.163333, -0.592833
5.166667, -0.592808
5.17, -0.592207
5.173333, -0.5907
5.176667, -0.588298
5.18, -0.585432
5.183333, -0.58278
5.186667, -0.580948
5.19, -0.579923
5.193333, -0.579075
5.196667, -0.577954
5.2, -0.576722
5.203333, -0.575786
5.206667, -0.575272
5.21, -0.574958
5.213333, -0.574636
5.216667, -0.574316
5.22, -0.574055
5.223333, -0.573917
5.226667, -0.574109
5.23, -0.574838
5.233333, -0.575934
5.236667, -0.576886
5.24, -0.577271
5.243333, -0.576912
5.246667, -0.57583
5.25, -0.574309
5.253333, -0.572739
5.256667, -0.571285
5.26, -0.569864
5.263333, -0.568339
5.266667, -0.566645
5.27, -0.564931
5.273333, -0.56371
5.276667, -0.56346
5.28, -0.563991
5.283333, -0.564563
5.286667, -0.564702
5.29, -0.56454
5.293333, -0.564303
5.296667, -0.563893
5.3, -0.563093
5.303333, -0.561942
5.306667, -0.560762
5.31, -0.559969
5.313333, -0.559914
5.316667, -0.560633
5.32, -0.561633
5.323333, -0.562204
5.326667, -0.562019
5.33, -0.561347
5.333333, -0.560706
5.336667, -0.560437
5.34, -0.56061
5.343333, -0.561058
5.346667, -0.561363
5.35, -0.561003
5.353333, -0.559764
5.356667, -0.55789
5.36, -0.555755
5.363333, -0.55368
5.366667, -0.552007
5.37, -0.55102
5.373333, -0.55085
5.376667, -0.551412
5.38, -0.552439
5.383333, -0.553733
5.386667, -0.555191
5.39, -0.556612
5.393333, -0.557719
5.396667, -0.558322
5.4, -0.558324
5.403333, -0.557575
5.406667, -0.555966
5.41, -0.553827
5.413333, -0.551888
5.416667, -0.550796
5.42, -0.550765
5.423333, -0.551503
5.426667, -0.552485
5.43, -0.553228
5.433333, -0.553473
5.436667, -0.553466
5.44, -0.553777
5.443333, -0.554599
5.446667, -0.555586
5.45, -0.556229
5.453333, -0.556248
5.456667, -0.555821
5.46, -0.5555
5.463333, -0.55584
5.466667, -0.556963
5.47, -0.558423
5.473333, -0.559638
5.476667, -0.56033
5.48, -0.560622
5.483333, -0.561057
5.486667, -0.562177
5.49, -0.563895
5.493333, -0.565592
5.496667, -0.56677
5.5, -0.567329
5.503333, -0.567376
5.506667, -0.566945
5.51, -0.565973
5.513333, -0.564512
5.516667, -0.562945
5.52, -0.561979
5.523333, -0.562331
5.526667, -0.564221
5.53, -0.567089
5.533333, -0.569904
5.536667, -0.571902
5.54, -0.573026
5.543333, -0.573642
5.546667, -0.574146
5.55, -0.574911
5.553333, -0.575992
5.556667, -0.576843
5.56, -0.577051
5.563333, -0.57705
5.566667, -0.577459
5.57, -0.578264
5.573333, -0.579105
5.576667, -0.579833
5.58, -0.58062
5.583333, -0.581723
5.586667, -0.583064
5.59, -0.584206
5.593333, -0.584805
5.596667, -0.584758
5.6, -0.584059
5.603333, -0.582861
5.606667, -0.581536
5.61, -0.580498
5.613333, -0.580069
5.616667, -0.580346
5.62, -0.581092
5.623333, -0.58193
5.626667, -0.58257
5.63, -0.582852
5.633333, -0.582873
5.636667, -0.582879
5.64, -0.582948
5.643333, -0.583033
5.646667, -0.583122
5.65, -0.583271
5.653333, -0.583731
5.656667, -0.584722
5.66, -0.586037
5.663333, -0.587295
5.666667, -0.588395
5.67, -0.589384
5.673333, -0.590177
5.676667, -0.590694
5.68, -0.591116
5.683333, -0.591732
5.686667, -0.592459
5.69, -0.592708
5.693333, -0.591957
5.696667, -0.590274
5.7, -0.588236
5.703333, -0.586605
5.706667, -0.586112
5.71, -0.587176
5.713333, -0.589538
5.716667, -0.59225
5.72, -0.594258
5.723333, -0.595201
5.726667, -0.595618
5.73, -0.596167
5.733333, -0.596916
5.736667, -0.597586
5.74, -0.598091
5.743333, -0.598653
5.746667, -0.599469
5.75, -0.600515
5.753333, -0.601714
5.756667, -0.60311
5.76, -0.604856
5.763333, -0.606933
5.766667, -0.609038
5.77, -0.611004
5.773333, -0.613026
5.776667, -0.615338
5.78, -0.617852
5.783333, -0.620186
5.786667, -0.622035
5.79, -0.623484
5.793333, -0.625023
5.796667, -0.627153
5.8, -0.629839
5.803333, -0.632655
5.806667, -0.635235
5.81, -0.637298
5.813333, -0.638723
5.816667, -0.639663
5.82, -0.640336
5.823333, -0.640814
5.826667, -0.641069
5.83, -0.641149
5.833333, -0.641245
5.836667, -0.64164
5.84, -0.642457
5.843333, -0.64344
5.846667, -0.644243
5.85, -0.644819
5.853333, -0.645262
5.856667, -0.645597
5.86, -0.645891
5.863333, -0.646246
5.866667, -0.646641
5.87, -0.647048
5.873333, -0.647525
5.876667, -0.648119
5.88, -0.648854
5.883333, -0.6498
5.886667, -0.651066
5.89, -0.652492
5.893333, -0.653529
5.896667, -0.653839
5.9, -0.653754
5.903333, -0.653907
5.906667, -0.65457
5.91, -0.655387
5.913333, -0.655692
5.916667, -0.655197
5.92, -0.654379
5.923333, -0.65413
5.926667, -0.654946
5.93, -0.656496
5.933333, -0.658145
5.936667, -0.659701
5.94, -0.661401
5.943333, -0.663548
5.946667, -0.666344
5.95, -0.6696
5.953333, -0.67266
5.956667, -0.675033
5.96, -0.676834
5.963333, -0.678544
5.966667, -0.68067
5.97, -0.683438
5.973333, -0.686495
5.976667, -0.689205
5.98, -0.691313
5.983333, -0.693087
5.986667, -0.694923
5.99, -0.697016
5.993333, -0.699277
5.996667, -0.701328
6.0, -0.702702
6.003333, -0.703233
6.006667, -0.703045
6.01, -0.702237
6.013333, -0.700984
6.016667, -0.699756
6.02, -0.699025
6.023333, -0.69877
6.026667, -0.698472
6.03, -0.697784
6.033333, -0.696985
6.036667, -0.696604
6.04, -0.696975
6.043333, -0.698007
6.046667, -0.699073
6.05, -0.69952
6.053333, -0.699216
6.056667, -0.698321
6.06, -0.696846
6.063333, -0.694731
6.066667, -0.692143
6.07, -0.689488
6.073333, -0.687193
6.076667, -0.685388
6.08, -0.683792
6.083333, -0.682117
6.086667, -0.680486
6.09, -0.679148
6.093333, -0.678081
6.096667, -0.677057
6.1, -0.675799
6.103333, -0.673954
6.106667, -0.671205
6.11, -0.667674
6.113333, -0.663917
6.116667, -0.660311
6.12, -0.656829
6.123333, -0.653524
6.126667, -0.650652
6.13, -0.648179
6.133333, -0.645618
6.136667, -0.64231
6.14, -0.63783
6.143333, -0.632413
6.146667, -0.62699
6.15, -0.62258
6.153333, -0.619629
6.156667, -0.617911
6.16, -0.616783
6.163333, -0.615526
6.166667, -0.613783
6.17, -0.61165
6.173333, -0.609409
6.176667, -0.607485
6.18, -0.606575
6.183333, -0.607316
6.186667, -0.609652
6.19, -0.61288
6.193333, -0.616354
6.196667, -0.619845
6.2, -0.623375
6.203333, -0.626967
6.206667, -0.630567
6.21, -0.634124
6.213333, -0.637555
6.216667, -0.640649
6.22, -0.64319
6.223333, -0.645114
6.226667, -0.646407
6.23, -0.647094
6.233333, -0.647469
6.236667, -0.648039
6.24, -0.649095
6.243333, -0.65048
6.246667, -0.651788
6.25, -0.652624
6.253333, -0.652669
6.256667, -0.651883
6.26, -0.650665
6.263333, -0.649529
6.266667, -0.648693
6.27, -0.648051
6.273333, -0.647371
6.276667, -0.646551
6.28, -0.645777
6.283333, -0.645276
6.286667, -0.64504
6.29, -0.644838
6.293333, -0.644321
6.296667, -0.643387
6.3, -0.642395
6.303333, -0.64161
6.306667, -0.640871
6.31, -0.640159
6.313333, -0.639853
6.316667, -0.640114
6.32, -0.64043
6.323333, -0.640166
6.326667, -0.639417
6.33, -0.638893
6.333333, -0.639139
6.336667, -0.640062
6.34, -0.640929
6.343333, -0.640861
6.346667, -0.639628
6.35, -0.637782
6.353333, -0.635988
6.356667, -0.6346
6.36, -0.633821
6.363333, -0.633814
6.366667, -0.63455
6.37, -0.635612
6.373333, -0.636207
6.376667, -0.635562
6.38, -0.633445
6.383333, -0.630337
6.386667, -0.627083
6.39, -0.624299
6.393333, -0.622069
6.396667, -0.620085
6.4, -0.617839
6.403333, -0.614837
6.406667, -0.610973
6.41, -0.606546
6.413333, -0.601824
6.416667, -0.596953
6.42, -0.592201
6.423333, -0.587823
6.426667, -0.583783
6.43, -0.579893
6.433333, -0.576197
6.436667, -0.573035
6.44, -0.570628
6.443333, -0.568854
6.446667, -0.567539
6.45, -0.566528
6.453333, -0.565435
6.456667, -0.563776
6.46, -0.561454
6.463333, -0.558727
6.466667, -0.555557
6.47, -0.551263
6.473333, -0.544672
6.476667, -0.534433
6.48, -0.519364
6.483333, -0.498613
6.486667, -0.471518
6.49, -0.437397
6.493333, -0.395548
6.496667, -0.345679
6.5, -0.288501
6.503333, -0.226405
6.506667, -0.163748
6.51, -0.106054
6.513333, -0.058486
6.516667, -0.024659
6.52, -0.006289
6.523333, -0.003468
6.526667, -0.015044
6.53, -0.038989
6.533333, -0.072739
6.536667, -0.113486
6.54, -0.158445
6.543333, -0.204975
6.546667, -0.250747
6.55, -0.294107
6.553333, -0.334275
6.556667, -0.371196
6.56, -0.405133
6.563333, -0.436186
6.566667, -0.464139
6.57, -0.488876
6.573333, -0.510672
6.576667, -0.529897
6.58, -0.546844
6.583333, -0.56203
6.586667, -0.576254
6.59, -0.590045
6.593333, -0.603207
6.596667, -0.615266
6.6, -0.626095
6.603333, -0.635833
6.606667, -0.644604
6.61, -0.652537
6.613333, -0.659848
6.616667, -0.666881
6.62, -0.674022
6.623333, -0.681411
6.626667, -0.688719
6.63, -0.695418
6.633333, -0.701085
6.636667, -0.70532
6.64, -0.70787
6.643333, -0.709083
6.646667, -0.709813
6.65, -0.71073
6.653333, -0.711983
6.656667, -0.713454
6.66, -0.715045
6.663333, -0.71671
6.666667, -0.718388
6.67, -0.719952
6.673333, -0.72112
6.676667, -0.721619
6.68, -0.721572
6.683333, -0.721491
6.686667, -0.721794
6.69, -0.722438
6.693333, -0.723047
6.696667, -0.723358
6.7, -0.723384
6.703333, -0.72317
6.706667, -0.722674
6.71, -0.721917
6.713333, -0.721045
6.716667, -0.720249
6.72, -0.719756
6.723333, -0.719981
6.726667, -0.721346
6.73, -0.723618
6.733333, -0.725922
6.736667, -0.727774
6.74, -0.729433
6.743333, -0.731048
6.746667, -0.732255
6.75, -0.732909
6.753333, -0.733646
6.756667, -0.735331
6.76, -0.738044
6.763333, -0.740901
6.766667, -0.742822
6.77, -0.743412
6.773333, -0.743242
6.776667, -0.743405
6.78, -0.744772
6.783333, -0.747439
6.786667, -0.750675
6.79, -0.753432
6.793333, -0.755103
6.796667, -0.755802
6.8, -0.755951
6.803333, -0.755876
6.806667, -0.7558
6.81, -0.756098
6.813333, -0.757294
6.816667, -0.759441
6.82, -0.761839
6.823333, -0.76379
6.826667, -0.765243
6.83, -0.766603
6.833333, -0.768261
6.836667, -0.770329
6.84, -0.772549
6.843333, -0.774283
6.846667, -0.774909
6.85, -0.774464
6.853333, -0.773645
6.856667, -0.773186
6.86, -0.773515
6.863333, -0.774717
6.866667, -0.776573
6.87, -0.778783
6.873333, -0.781175
6.876667, -0.783405
6.88, -0.784697
6.883333, -0.784405
6.886667, -0.782765
6.89, -0.780862
6.893333, -0.77976
6.896667, -0.7797
6.9, -0.780112
6.903333, -0.780358
6.906667, -0.780289
6.91, -0.780085
6.913333, -0.779913
6.916667, -0.779773
6.92, -0.77949
6.923333, -0.778894
6.926667, -0.778024
6.93, -0.777049
6.933333, -0.776101
6.936667, -0.775342
6.94, -0.774979
6.943333, -0.775133
6.946667, -0.775774
6.95, -0.776597
6.953333, -0.77715
6.956667, -0.777296
6.96, -0.777164
6.963333, -0.776762
6.966667, -0.775888
6.97, -0.774273
6.973333, -0.77187
6.976667, -0.769185
6.98, -0.767197
6.983333, -0.766632
6.986667, -0.767241
6.99, -0.76807
6.993333, -0.768483
6.996667, -0.768502
7.0, -0.768222
7.003333, -0.767444
7.006667, -0.765992
7.01, -0.764112
7.013333, -0.762322
7.016667, -0.760939
7.02, -0.759983
7.023333, -0.759456
7.026667, -0.759273
7.03, -0.75895
7.033333, -0.757999
7.036667, -0.75641
7.04, -0.754404
7.043333, -0.752325
7.046667, -0.750809
7.05, -0.750444
7.053333, -0.751304
7.056667, -0.752839
7.06, -0.754154
7.063333, -0.754627
7.066667, -0.754097
7.07, -0.752506
7.073333, -0.750027
7.076667, -0.747334
7.08, -0.745102
7.083333, -0.743598
7.086667, -0.742988
7.09, -0.743496
7.093333, -0.745111
7.096667, -0.74742
7.1, -0.749723
7.103333, -0.751234
7.106667, -0.75137
7.11, -0.750055
7.113333, -0.747733
7.116667, -0.74504
7.12, -0.742451
7.123333, -0.740206
7.126667, -0.73852
7.13, -0.737718
7.133333, -0.737957
7.136667, -0.738831
7.14, -0.739721
7.143333, -0.740401
7.146667, -0.740743
7.15, -0.740373
7.153333, -0.739055
7.156667, -0.736967
7.16, -0.734688
7.163333, -0.732941
7.166667, -0.732095
7.17, -0.731968
7.173333, -0.731957
7.176667, -0.731345
7.18, -0.729899
7.183333, -0.728009
7.186667, -0.726187
7.19, -0.724809
7.193333, -0.724129
7.196667, -0.724156
7.2, -0.72467
7.203333, -0.725474
7.206667, -0.726399
7.21, -0.727207
7.213333, -0.727721
7.216667, -0.727894
7.22, -0.727693
7.223333, -0.727116
7.226667, -0.726397
7.23, -0.725888
7.233333, -0.725771
7.236667, -0.725982
7.24, -0.726276
7.243333, -0.726434
7.246667, -0.726613
7.25, -0.727253
7.253333, -0.728524
7.256667, -0.730026
7.26, -0.731168
7.263333, -0.7317
7.266667, -0.731734
7.27, -0.731441
7.273333, -0.730994
7.276667, -0.730734
7.28, -0.731106
7.283333, -0.732299
7.286667, -0.734157
7.29, -0.736317
7.293333, -0.738236
7.296667, -0.73952
7.3, -0.740381
7.303333, -0.741403
7.306667, -0.743002
7.31, -0.7453
7.313333, -0.748201
7.316667, -0.751502
7.32, -0.75489
7.323333, -0.757816
7.326667, -0.759734
7.33, -0.76059
7.333333, -0.760826
7.336667, -0.761046
7.34, -0.761865
7.343333, -0.76369
7.346667, -0.766439
7.35, -0.769617
7.353333, -0.772655
7.356667, -0.775114
7.36, -0.776726
7.363333, -0.777505
7.366667, -0.777842
7.37, -0.778452
7.373333, -0.780018
7.376667, -0.782663
7.38, -0.785912
7.383333, -0.789141
7.386667, -0.791938
7.39, -0.794162
7.393333, -0.795789
7.396667, -0.796888
7.4, -0.797733
7.403333, -0.798596
7.406667, -0.799402
7.41, -0.799987
7.413333, -0.800575
7.416667, -0.801577
7.42, -0.803264
7.423333, -0.805708
7.426667, -0.808664
7.43, -0.811608
7.433333, -0.814014
7.436667, -0.815539
7.44, -0.816118
7.443333, -0.816053
7.446667, -0.815968
7.45, -0.816452
7.453333, -0.817656
7.456667, -0.819314
7.46, -0.821144
7.463333, -0.823091
7.466667, -0.825024
7.47, -0.826581
7.473333, -0.827564
7.476667, -0.828144
7.48, -0.828681
7.483333, -0.829498
7.486667, -0.830725
7.49, -0.832192
7.493333, -0.833363
7.496667, -0.833723
7.5, -0.83322
7.503333, -0.832084
7.506667, -0.830581
7.51, -0.82904
7.513333, -0.827888
7.516667, -0.827443
7.52, -0.827565
7.523333, -0.827716
7.526667, -0.827392
7.53, -0.826495
7.533333, -0.825467
7.536667, -0.824951
7.54, -0.825114
7.543333, -0.825339
7.546667, -0.824804
7.55, -0.823174
7.553333, -0.820521
7.556667, -0.81694
7.56, -0.812537
7.563333, -0.807574
7.566667, -0.802447
7.57, -0.797492
7.573333, -0.792889
7.576667, -0.788655
7.58, -0.784489
7.583333, -0.779792
7.586667, -0.774174
7.59, -0.767724
7.593333, -0.760615
7.596667, -0.752919
7.6, -0.744876
7.603333, -0.736865
7.606667, -0.729026
7.61, -0.721303
7.613333, -0.713742
7.616667, -0.706393
7.62, -0.699094
7.623333, -0.691513
7.626667, -0.683398
7.63, -0.674822
7.633333, -0.666103
7.636667, -0.657599
7.64, -0.649595
7.643333, -0.642169
7.646667, -0.63526
7.65, -0.628857
7.653333, -0.622748
7.656667, -0.61627
7.66, -0.608854
7.663333, -0.600697
7.666667, -0.592532
7.67, -0.585044
7.673333, -0.578602
7.676667, -0.573163
7.68, -0.568497
7.683333, -0.564688
7.686667, -0.562146
7.69, -0.561081
7.693333, -0.561143
7.696667, -0.561589
7.7, -0.561767
7.703333, -0.561311
7.706667, -0.560016
7.71, -0.558014
7.713333, -0.555945
7.716667, -0.554531
7.72, -0.553999
7.723333, -0.554129
7.726667, -0.5548
7.73, -0.556071
7.733333, -0.557859
7.736667, -0.559996
7.74, -0.562402
7.743333, -0.565066
7.746667, -0.568005
7.75, -0.571115
7.753333, -0.574025
7.756667, -0.576406
7.76, -0.578378
7.763333, -0.580506
7.766667, -0.583644
7.77, -0.588665
7.773333, -0.59586
7.776667, -0.604625
7.78, -0.613869
7.783333, -0.622586
7.786667, -0.630368
7.79, -0.637618
7.793333, -0.644982
7.796667, -0.652779
7.8, -0.661152
7.803333, -0.670392
7.806667, -0.680707
7.81, -0.691739
7.813333, -0.702663
7.816667, -0.712786
7.82, -0.721919
7.823333, -0.730294
7.826667, -0.73836
7.83, -0.746546
7.833333, -0.755011
7.836667, -0.763666
7.84, -0.772414
7.843333, -0.781135
7.846667, -0.789526
7.85, -0.797168
7.853333, -0.80386
7.856667, -0.809761
7.86, -0.815137
7.863333, -0.820192
7.866667, -0.825192
7.87, -0.830481
7.873333, -0.836213
7.876667, -0.842229
7.88, -0.848312
7.883333, -0.854286
7.886667, -0.859902
7.89, -0.864895
7.893333, -0.869177
7.896667, -0.872837
7.9, -0.875969
7.903333, -0.87859
7.906667, -0.880713
7.91, -0.882412
7.913333, -0.883954
7.916667, -0.885836
7.92, -0.888398
7.923333, -0.891424
7.926667, -0.894396
7.93, -0.897001
7.933333, -0.899186
7.936667, -0.900936
7.94, -0.902227
7.943333, -0.903051
7.946667, -0.903424
7.95, -0.903526
7.953333, -0.903625
7.956667, -0.903745
7.96, -0.903737
7.963333, -0.903663
7.966667, -0.903779
7.97, -0.904293
7.973333, -0.905204
7.976667, -0.906166
7.98, -0.906631
7.983333, -0.906199
7.986667, -0.904892
7.99, -0.903285
7.993333, -0.902181
7.996667, -0.901962
8.0, -0.902276
8.003333, -0.902426
8.006667, -0.902155
8.01, -0.901871
8.013333, -0.901983
8.016667, -0.902445
8.02, -0.902821
8.023333, -0.902422
8.026667, -0.900725
8.03, -0.897957
8.033333, -0.895084
8.036667, -0.893136
8.04, -0.892558
8.043333, -0.893104
8.046667, -0.894092
8.05, -0.894713
8.053333, -0.894425
8.056667, -0.893273
8.06, -0.891741
8.063333, -0.890249
8.066667, -0.888942
8.07, -0.887796
8.073333, -0.886589
8.076667, -0.885031
8.08, -0.883156
8.083333, -0.88128
8.086667, -0.879555
8.09, -0.877893
8.093333, -0.876204
8.096667, -0.87445
8.1, -0.872616
8.103333, -0.870771
8.106667, -0.869086
8.11, -0.867621
8.113333, -0.866165
8.116667, -0.864639
8.12, -0.863317
8.123333, -0.862265
8.126667, -0.86103
8.13, -0.859064
8.133333, -0.856149
8.136667, -0.852504
8.14, -0.848563
8.143333, -0.844613
8.146667, -0.840804
8.15, -0.837328
8.153333, -0.834333
8.156667, -0.831812
8.16, -0.829613
8.163333, -0.827323
8.166667, -0.82435
8.17, -0.820472
8.173333, -0.816036
8.176667, -0.811408
8.18, -0.806586
8.183333, -0.801456
8.186667, -0.795999
8.19, -0.790219
8.193333, -0.784239
8.196667, -0.778337
8.2, -0.772706
8.203333, -0.767388
8.206667, -0.762311
8.21, -0.757247
8.213333, -0.752012
8.216667, -0.746699
8.22, -0.741326
8.223333, -0.735519
8.226667, -0.728911
8.23, -0.721594
8.233333, -0.713994
8.236667, -0.706525
8.24, -0.699339
8.243333, -0.692189
8.246667, -0.684682
8.25, -0.676892
8.253333, -0.669466
8.256667, -0.662835
8.26, -0.656665
8.263333, -0.65026
8.266667, -0.643151
8.27, -0.635291
8.273333, -0.626959
8.276667, -0.618436
8.28, -0.609777
8.283333, -0.600978
8.286667, -0.592112
8.29, -0.583189
8.293333, -0.574265
8.296667, -0.565716
8.3, -0.557999
8.303333, -0.551114
8.306667, -0.544545
8.31, -0.537725
8.313333, -0.530484
8.316667, -0.523094
8.32, -0.516084
8.323333, -0.510013
8.326667, -0.505155
8.33, -0.501299
8.333333, -0.4979
8.336667, -0.494431
8.34, -0.490612
8.343333, -0.486644
8.346667, -0.483217
8.35, -0.480808
8.353333, -0.479286
8.356667, -0.478549
8.36, -0.478727
8.363333, -0.479557
8.366667, -0.480443
8.37, -0.481316
8.373333, -0.482858
8.376667, -0.485617
8.38, -0.489348
8.383333, -0.493412
8.386667, -0.497394
8.39, -0.50133
8.393333, -0.5056
8.396667, -0.510615
8.4, -0.516464
8.403333, -0.522778
8.406667, -0.529096
8.41, -0.535365
8.413333, -0.54184
8.416667, -0.548512
8.42, -0.555014
8.423333, -0.561175
8.426667, -0.567415
8.43, -0.574374
8.433333, -0.582336
8.436667, -0.591072
8.44, -0.599959
8.443333, -0.608218
8.446667, -0.615354
8.45, -0.621613
8.453333, -0.62788
8.456667, -0.634813
8.46, -0.642242
8.463333, -0.649605
8.466667, -0.65665
8.47, -0.663501
8.473333, -0.670502
8.476667, -0.678111
8.48, -0.686545
8.483333, -0.695424
8.486667, -0.703867
8.49, -0.710948
8.493333, -0.716393
8.496667, -0.720749
8.5, -0.724709
8.503333, -0.728549
8.506667, -0.732187
8.51, -0.735531
8.513333, -0.738779
8.516667, -0.742199
8.52, -0.745765
8.523333, -0.749344
8.526667, -0.752871
8.53, -0.756184
8.533333, -0.759025
8.536667, -0.761256
8.54, -0.762934
8.543333, -0.764325
8.546667, -0.765788
8.55, -0.767468
8.553333, -0.769279
8.556667, -0.771117
8.56, -0.77275
8.563333, -0.773829
8.566667, -0.774344
8.57, -0.774837
8.573333, -0.775918
8.576667, -0.777614
8.58, -0.779388
8.583333, -0.780895
8.586667, -0.782323
8.59, -0.783776
8.593333, -0.784848
8.596667, -0.785089
8.6, -0.784443
8.603333, -0.783309
8.606667, -0.782386
8.61, -0.782134
8.613333, -0.782491
8.616667, -0.783192
8.62, -0.784019
8.623333, -0.784753
8.626667, -0.785128
8.63, -0.78512
8.633333, -0.785127
8.636667, -0.785426
8.64, -0.785793
8.643333, -0.785925
8.646667, -0.785823
8.65, -0.785743
8.653333, -0.785984
8.656667, -0.786653
8.66, -0.787608
8.663333, -0.788665
8.666667, -0.789819
8.67, -0.791101
8.673333, -0.792231
8.676667, -0.792655
8.68, -0.792097
8.683333, -0.790957
8.686667, -0.790012
8.69, -0.789881
8.693333, -0.790734
8.696667, -0.792198
8.7, -0.793613
8.703333, -0.794599
8.706667, -0.79522
8.71, -0.795659
8.713333, -0.795985
8.716667, -0.796212
8.72, -0.796487
8.723333, -0.797121
8.726667, -0.798254
8.73, -0.799689
8.733333, -0.801203
8.736667, -0.802699
8.74, -0.804081
8.743333, -0.805188
8.746667, -0.80584
8.75, -0.805933
8.753333, -0.805611
8.756667, -0.805208
8.76, -0.805063
8.763333, -0.805453
8.766667, -0.80653
8.77, -0.808228
8.773333, -0.810206
8.776667, -0.811949
8.78, -0.813112
8.783333, -0.813732
8.786667, -0.814011
8.79, -0.814172
8.793333, -0.81446
8.796667, -0.815061
8.8, -0.816046
8.803333, -0.817394
8.806667, -0.819029
8.81, -0.820831
8.813333, -0.822499
8.816667, -0.823688
8.82, -0.824353
8.823333, -0.824583
8.826667, -0.824324
8.83, -0.823566
8.833333, -0.82247
8.836667, -0.821248
8.84, -0.820081
8.843333, -0.819106
8.846667, -0.818467
8.85, -0.818395
8.853333, -0.819066
8.856667, -0.820335
8.86, -0.821749
8.863333, -0.822995
8.866667, -0.824278
8.87, -0.826044
8.873333, -0.828256
8.876667, -0.830292
8.88, -0.831573
8.883333, -0.831917
8.886667, -0.831481
8.89, -0.830655
8.893333, -0.829835
8.896667, -0.829187
8.9, -0.82866
8.903333, -0.828137
8.906667, -0.827608
8.91, -0.827405
8.913333, -0.828215
8.916667, -0.83053
8.92, -0.834122
8.923333, -0.838292
8.926667, -0.842311
8.93, -0.845444
8.933333, -0.84706
8.936667, -0.847123
8.94, -0.846291
8.943333, -0.845313
8.946667, -0.844384
8.95, -0.843188
8.953333, -0.841526
8.956667, -0.839766
8.96, -0.838604
8.963333, -0.838456
8.966667, -0.839114
8.97, -0.839967
8.973333, -0.840631
8.976667, -0.841298
8.98, -0.842268
8.983333, -0.843388
8.986667, -0.844195
8.99, -0.844507
8.993333, -0.844634
8.996667, -0.844864
9.0, -0.844899
9.003333, -0.844134
9.006667, -0.84248
9.01, -0.840587
9.013333, -0.839226
9.016667, -0.838777
9.02, -0.839218
9.023333, -0.840084
9.026667, -0.840485
9.03, -0.839734
9.033333, -0.838025
9.036667, -0.836216
9.04, -0.835161
9.043333, -0.835303
9.046667, -0.836477
9.05, -0.838069
9.053333, -0.839475
9.056667, -0.840373
9.06, -0.840693
9.063333, -0.840577
9.066667, -0.840565
9.07, -0.841456
9.073333, -0.843379
9.076667, -0.845484
9.08, -0.846834
9.083333, -0.847169
9.086667, -0.846948
9.09, -0.847093
9.093333, -0.848403
9.096667, -0.850835
9.1, -0.853456
9.103333, -0.855305
9.106667, -0.856149
9.11, -0.8564
9.113333, -0.856495
9.116667, -0.856505
9.12, -0.856486
9.123333, -0.856827
9.126667, -0.857751
9.13, -0.858848
9.133333, -0.85955
9.136667, -0.859803
9.14, -0.859845
9.143333, -0.859591
9.146667, -0.858866
9.15, -0.857933
9.153333, -0.857347
9.156667, -0.857467
9.16, -0.858136
9.163333, -0.85877
9.166667, -0.858824
9.17, -0.85811
9.173333, -0.856906
9.176667, -0.855909
9.18, -0.855734
9.183333, -0.856344
9.186667, -0.856991
9.19, -0.856829
9.193333, -0.855659
9.196667, -0.85399
9.2, -0.85241
9.203333, -0.851221
9.206667, -0.850511
9.21, -0.850203
9.213333, -0.850046
9.216667, -0.84968
9.22, -0.848775
9.223333, -0.847247
9.226667, -0.845386
9.23, -0.843762
9.233333, -0.843005
9.236667, -0.843336
9.24, -0.844274
9.243333, -0.845199
9.246667, -0.846049
9.25, -0.847084
9.253333, -0.848352
9.256667, -0.849596
9.26, -0.850371
9.263333, -0.850338
9.266667, -0.849651
9.27, -0.84885
9.273333, -0.848403
9.276667, -0.848497
9.28, -0.848971
9.283333, -0.849422
9.286667, -0.849621
9.29, -0.849678
9.293333, -0.849656
9.296667, -0.849337
9.3, -0.848598
9.303333, -0.847739
9.306667, -0.847236
9.31, -0.847293
9.313333, -0.84771
9.316667, -0.848287
9.32, -0.849182
9.323333, -0.850638
9.326667, -0.85252
9.33, -0.854323
9.333333, -0.855549
9.336667, -0.856114
9.34, -0.856323
9.343333, -0.856435
9.346667, -0.856551
9.35, -0.857047
9.353333, -0.858561
9.356667, -0.861119
9.36, -0.863793
9.363333, -0.865601
9.366667, -0.866285
9.37, -0.866164
9.373333, -0.865805
9.376667, -0.865831
9.38, -0.866566
9.383333, -0.867752
9.386667, -0.868902
9.39, -0.869808
9.393333, -0.870363
9.396667, -0.870395
9.4, -0.870035
9.403333, -0.86964
9.406667, -0.869395
9.41, -0.869314
9.413333, -0.869365
9.416667, -0.869562
9.42, -0.870015
9.423333, -0.87067
9.426667, -0.871135
9.43, -0.870901
9.433333, -0.869726
9.436667, -0.867962
9.44, -0.866373
9.443333, -0.865334
9.446667, -0.864559
9.45, -0.863827
9.453333, -0.863483
9.456667, -0.863851
9.46, -0.864575
9.463333, -0.865066
9.466667, -0.86528
9.47, -0.865679
9.473333, -0.866615
9.476667, -0.867913
9.48, -0.869019
9.483333, -0.86943
9.486667, -0.868979
9.49, -0.867922
9.493333, -0.866746
9.496667, -0.865831
9.5, -0.865433
9.503333, -0.865782
9.506667, -0.866894
9.51, -0.868469
9.513333, -0.870091
9.516667, -0.871388
9.52, -0.87213
9.523333, -0.872306
9.526667, -0.87212
9.53, -0.871908
9.533333, -0.871854
9.536667, -0.871868
9.54, -0.871949
9.543333, -0.87229
9.546667, -0.872846
9.55, -0.873223
9.553333, -0.873177
9.556667, -0.872915
9.56, -0.872733
9.563333, -0.872581
9.566667, -0.872257
9.57, -0.87187
9.573333, -0.871688
9.576667, -0.871529
9.58, -0.870855
9.583333, -0.869423
9.586667, -0.86747
9.59, -0.865412
9.593333, -0.863587
9.596667, -0.862223
9.6, -0.86154
9.603333, -0.861717
9.606667, -0.862769
9.61, -0.864272
9.613333, -0.865218
9.616667, -0.864691
9.62, -0.862655
9.623333, -0.859961
9.626667, -0.857741
9.63, -0.856572
9.633333, -0.856106
9.636667, -0.855642
9.64, -0.854887
9.643333, -0.854085
9.646667, -0.853592
9.65, -0.853542
9.653333, -0.853888
9.656667, -0.854426
9.66, -0.854836
9.663333, -0.855017
9.666667, -0.855202
9.67, -0.855709
9.673333, -0.856647
9.676667, -0.857668
9.68, -0.858216
9.683333, -0.858167
9.686667, -0.85787
9.69, -0.857603
9.693333, -0.857525
9.696667, -0.857926
9.7, -0.858891
9.703333, -0.860013
9.706667, -0.860667
9.71, -0.860264
9.713333, -0.858648
9.716667, -0.856368
9.72, -0.854172
9.723333, -0.852465
9.726667, -0.851457
9.73, -0.851417
9.733333, -0.852515
9.736667, -0.854544
9.74, -0.856947
9.743333, -0.8591
9.746667, -0.860513
9.75, -0.86105
9.753333, -0.860982
9.756667, -0.860743
9.76, -0.860749
9.763333, -0.861196
9.766667, -0.861985
9.77, -0.862891
9.773333, -0.863732
9.776667, -0.864432
9.78, -0.864847
9.783333, -0.864659
9.786667, -0.863813
9.79, -0.862891
9.793333, -0.86266
9.796667, -0.863318
9.8, -0.864354
9.803333, -0.86492
9.806667, -0.864385
9.81, -0.862924
9.813333, -0.861445
9.816667, -0.860766
9.82, -0.861109
9.823333, -0.8623
9.826667, -0.863997
9.83, -0.865864
9.833333, -0.867826
9.836667, -0.869915
9.84, -0.871957
9.843333, -0.873758
9.846667, -0.875147
9.85, -0.875774
9.853333, -0.875496
9.856667, -0.874775
9.86, -0.874186
9.863333, -0.873816
9.866667, -0.873452
9.87, -0.873174
9.873333, -0.873335
9.876667, -0.873885
9.88, -0.874329
9.883333, -0.874439
9.886667, -0.874495
9.89, -0.875034
9.893333, -0.876486
9.896667, -0.878771
9.9, -0.881268
9.903333, -0.883204
9.906667, -0.884042
9.91, -0.883725
9.913333, -0.882866
9.916667, -0.88251
9.92, -0.883404
9.923333, -0.885497
9.926667, -0.888156
9.93, -0.890667
9.933333, -0.892519
9.936667, -0.893519
9.94, -0.893794
9.943333, -0.893613
9.946667, -0.893145
9.95, -0.892347
9.953333, -0.891217
9.956667, -0.890068
9.96, -0.889412
9.963333, -0.889499
9.966667, -0.890059
9.97, -0.89059
9.973333, -0.890812
9.976667, -0.890887
9.98, -0.891268
9.983333, -0.892235
9.986667, -0.893653
9.99, -0.895232
9.993333, -0.896995
9.996667, -0.899303
10.0, -0.902178
10.003333, -0.905043
10.006667, -0.907383
10.01, -0.90911
10.013333, -0.910151
10.016667, -0.910291
10.02, -0.909562
10.023333, -0.908461
10.026667, -0.907501
10.03, -0.906712
10.033333, -0.90587
10.036667, -0.904853
10.04, -0.903713
10.043333, -0.902857
10.046667, -0.90286
10.05, -0.903901
10.053333, -0.90568
10.056667, -0.907623
10.06, -0.909065
10.063333, -0.909708
10.066667, -0.909991
10.07, -0.9107
10.073333, -0.912147
10.076667, -0.913956
10.08, -0.91564
10.083333, -0.917062
10.086667, -0.918215
10.09, -0.918921
10.093333, -0.919128
10.096667, -0.919226
10.1, -0.919683
10.103333, -0.920484
10.106667, -0.921123
10.11, -0.921065
10.113333, -0.920197
10.116667, -0.918962
10.12, -0.918123
10.123333, -0.918336
10.126667, -0.91979
10.13, -0.922054
10.133333, -0.924215
10.136667, -0.925413
10.14, -0.925366
10.143333, -0.92453
10.146667, -0.923895
10.15, -0.924282
10.153333, -0.92554
10.156667, -0.926777
10.16, -0.927352
10.163333, -0.927095
10.166667, -0.925972
10.17, -0.924311
10.173333, -0.922944
10.176667, -0.922541
10.18, -0.923006
10.183333, -0.923619
10.186667, -0.923626
10.19, -0.922748
10.193333, -0.921265
10.196667, -0.919777
10.2, -0.918865
10.203333, -0.918729
10.206667, -0.91907
10.21, -0.91941
10.213333, -0.919444
10.216667, -0.918948
10.22, -0.917733
10.223333, -0.915969
10.226667, -0.914296
10.23, -0.913446
10.233333, -0.913748
10.236667, -0.914862
10.24, -0.915944
10.243333, -0.916194
10.246667, -0.915443
10.25, -0.914198
10.253333, -0.913
10.256667, -0.91198
10.26, -0.911108
10.263333, -0.910485
10.266667, -0.910273
10.27, -0.910485
10.273333, -0.910892
10.276667, -0.911041
10.28, -0.91033
10.283333, -0.908456
10.286667, -0.905839
10.29, -0.903345
10.293333, -0.901663
10.296667, -0.901031
10.3, -0.901259
10.303333, -0.901887
10.306667, -0.902411
10.31, -0.902375
10.313333, -0.901498
10.316667, -0.899906
10.32, -0.898057
10.323333, -0.896512
10.326667, -0.895718
10.33, -0.89579
10.333333, -0.896427
10.336667, -0.897109
10.34, -0.897414
10.343333, -0.897201
10.346667, -0.896537
10.35, -0.895695
10.353333, -0.89514
10.356667, -0.895099
10.36, -0.895315
10.363333, -0.895486
10.366667, -0.895536
10.37, -0.895377
10.373333, -0.895079
10.376667, -0.89512
10.38, -0.8958
10.383333, -0.896854
10.386667, -0.897981
10.39, -0.899047
10.393333, -0.899869
10.396667, -0.900358
10.4, -0.900686
10.403333, -0.901146
10.406667, -0.901978
10.41, -0.903073
10.413333, -0.9039
10.416667, -0.904114
10.42, -0.903995
10.423333, -0.904014
10.426667, -0.904472
10.43, -0.905566
10.433333, -0.907241
10.436667, -0.909144
10.44, -0.91093
10.443333, -0.912371
10.446667, -0.913229
10.45, -0.913328
10.453333, -0.9128
10.456667, -0.912083
10.46, -0.9116
10.463333, -0.911612
10.466667, -0.912251
10.47, -0.913383
10.473333, -0.914505
10.476667, -0.915127
10.48, -0.915283
10.483333, -0.915461
10.486667, -0.916072
10.49, -0.917223
10.493333, -0.918733
10.496667, -0.920001
10.5, -0.920228
10.503333, -0.919039
10.506667, -0.916699
10.51, -0.913995
10.513333, -0.912021
10.516667, -0.911514
10.52, -0.912217
10.523333, -0.913241
10.526667, -0.913949
10.53, -0.914228
10.533333, -0.914211
10.536667, -0.914098
10.54, -0.914002
10.543333, -0.913932
10.546667, -0.913999
10.55, -0.914338
10.553333, -0.91493
10.556667, -0.915751
10.56, -0.916906
10.563333, -0.918495
10.566667, -0.920319
10.57, -0.921917
10.573333, -0.923076
10.576667, -0.923964
10.58, -0.924683
10.583333, -0.925074
10.586667, -0.924956
10.59, -0.924429
10.593333, -0.923919
10.596667, -0.9238
10.6, -0.923957
10.603333, -0.924068
10.606667, -0.924171
10.61, -0.924462
10.613333, -0.924794
10.616667, -0.924872
10.62, -0.924739
10.623333, -0.924746
10.626667, -0.925133
10.63, -0.925784
10.633333, -0.926392
10.636667, -0.92678
10.64, -0.926985
10.643333, -0.927036
10.646667, -0.926902
10.65, -0.926619
10.653333, -0.926285
10.656667, -0.925916
10.66, -0.925414
10.663333, -0.924836
10.666667, -0.924506
10.67, -0.924505
10.673333, -0.924568
10.676667, -0.9246
10.68, -0.92477
10.683333, -0.92524
10.686667, -0.92612
10.69, -0.927505
10.693333, -0.929372
10.696667, -0.931378
10.7, -0.932926
10.703333, -0.933674
10.706667, -0.933766
10.71, -0.933496
10.713333, -0.932959
10.716667, -0.932072
10.72, -0.930818
10.723333, -0.929489
10.726667, -0.92869
10.73, -0.928904
10.733333, -0.929986
10.736667, -0.931377
10.74, -0.93265
10.743333, -0.933577
10.746667, -0.934078
10.75, -0.934308
10.753333, -0.934473
10.756667, -0.934573
10.76, -0.934475
10.763333, -0.934097
10.766667, -0.933558
10.77, -0.933248
10.773333, -0.933609
10.776667, -0.934748
10.78, -0.936141
10.783333, -0.936794
10.786667, -0.936138
10.79, -0.934743
10.793333, -0.933695
10.796667, -0.933482
10.8, -0.933746
10.803333, -0.933823
10.806667, -0.933451
10.81, -0.933003
10.813333, -0.933012
10.816667, -0.933636
10.82, -0.934554
10.823333, -0.935287
10.826667, -0.935552
10.83, -0.935259
10.833333, -0.934439
10.836667, -0.93348
10.84, -0.933031
10.843333, -0.933414
10.846667, -0.934375
10.85, -0.935356
10.853333, -0.935876
10.856667, -0.935837
10.86, -0.935563
10.863333, -0.935394
10.866667, -0.935351
10.87, -0.935491
10.873333, -0.936157
10.876667, -0.937514
10.88, -0.939305
10.883333, -0.940985
10.886667, -0.941795
10.89, -0.941282
10.893333, -0.939721
10.896667, -0.937559
10.9, -0.934986
10.903333, -0.932304
10.906667, -0.930107
10.91, -0.928895
10.913333, -0.928822
10.916667, -0.929717
10.92, -0.930942
10.923333, -0.93146
10.926667, -0.93059
10.93, -0.928517
10.933333, -0.925883
10.936667, -0.923324
10.94, -0.921375
10.943333, -0.920125
10.946667, -0.918992
10.95, -0.917255
10.953333, -0.914752
10.956667, -0.912006
10.96, -0.909743
10.963333, -0.908248
10.966667, -0.907208
10.97, -0.906072
10.973333, -0.904473
10.976667, -0.902394
10.98, -0.900094
10.983333, -0.897923
10.986667, -0.896136
10.99, -0.894941
10.993333, -0.894534
10.996667, -0.894846
11.0, -0.895481
11.003333, -0.896021
11.006667, -0.896214
11.01, -0.895961
11.013333, -0.895192
11.016667, -0.893674
11.02, -0.891064
11.023333, -0.887401
11.026667, -0.8834
11.03, -0.879888
11.033333, -0.876998
11.036667, -0.874324
11.04, -0.871618
11.043333, -0.868882
11.046667, -0.86616
11.05, -0.863563
11.053333, -0.861221
11.056667, -0.859132
11.06, -0.857218
11.063333, -0.855573
11.066667, -0.854413
11.07, -0.85374
11.073333, -0.853249
11.076667, -0.85249
11.08, -0.851133
11.083333, -0.849245
11.086667, -0.84722
11.09, -0.845316
11.093333, -0.843364
11.096667, -0.841108
11.1, -0.838581
11.103333, -0.83601
11.106667, -0.83378
11.11, -0.83237
11.113333, -0.831843
11.116667, -0.831783
11.12, -0.831923
11.123333, -0.832303
11.126667, -0.832954
11.13, -0.833707
11.133333, -0.834127
11.136667, -0.833756
11.14, -0.832759
11.143333, -0.831965
11.146667, -0.832053
11.15, -0.833167
11.153333, -0.835144
11.156667, -0.837617
11.16, -0.840245
11.163333, -0.842923
11.166667, -0.845568
11.17, -0.847796
11.173333, -0.848967
11.176667, -0.84881
11.18, -0.847862
11.183333, -0.846902
11.186667, -0.846288
11.19, -0.846126
11.193333, -0.846528
11.196667, -0.847294
11.2, -0.847793
11.203333, -0.847485
11.206667, -0.846485
11.21, -0.84553
11.213333, -0.845345
11.216667, -0.846218
11.22, -0.848136
11.223333, -0.850872
11.226667, -0.853852
11.23, -0.856298
11.233333, -0.857666
11.236667, -0.857912
11.24, -0.857372
11.243333, -0.856375
11.246667, -0.855022
11.25, -0.853491
11.253333, -0.8522
11.256667, -0.851436
11.26, -0.8511
11.263333, -0.850918
11.266667, -0.85072
11.27, -0.850609
11.273333, -0.850818
11.276667, -0.85149
11.28, -0.852741
11.283333, -0.854587
11.286667, -0.856664
11.29, -0.858356
11.293333, -0.85927
11.296667, -0.859494
11.3, -0.859307
11.303333, -0.858799
11.306667, -0.858038
11.31, -0.857326
11.313333, -0.857005
11.316667, -0.857268
11.32, -0.858144
11.323333, -0.859459
11.326667, -0.860878
11.33, -0.862137
11.333333, -0.863243
11.336667, -0.864335
11.34, -0.865453
11.343333, -0.866546
11.346667, -0.867459
11.35, -0.868062
11.353333, -0.868394
11.356667, -0.868486
11.36, -0.868302
11.363333, -0.86788
11.366667, -0.867341
11.37, -0.866827
11.373333, -0.866433
11.376667, -0.866196
11.38, -0.866146
11.383333, -0.866372
11.386667, -0.86711
11.39, -0.86856
11.393333, -0.870644
11.396667, -0.872952
11.4, -0.874726
11.403333, -0.87513
11.406667, -0.873931
11.41, -0.871782
11.413333, -0.869697
11.416667, -0.868392
11.42, -0.86815
11.423333, -0.868948
11.426667, -0.870487
11.43, -0.872248
11.433333, -0.873721
11.436667, -0.874685
11.44, -0.875156
11.443333, -0.87512
11.446667, -0.874676
11.45, -0.874315
11.453333, -0.874604
11.456667, -0.875715
11.46, -0.877325
11.463333, -0.878826
11.466667, -0.879755
11.47, -0.88001
11.473333, -0.879636
11.476667, -0.878718
11.48, -0.877493
11.483333, -0.876262
11.486667, -0.875197
11.49, -0.87437
11.493333, -0.873858
11.496667, -0.873702
11.5, -0.873896
11.503333, -0.874333
11.506667, -0.874618
11.51, -0.87435
11.513333, -0.873728
11.516667, -0.873437
11.52, -0.874019
11.523333, -0.875595
11.526667, -0.877791
11.53, -0.87983
11.533333, -0.880942
11.536667, -0.880712
11.54, -0.879237
11.543333, -0.877098
11.546667, -0.874988
11.55, -0.873368
11.553333, -0.872377
11.556667, -0.87188
11.56, -0.871783
11.563333, -0.872233
11.566667, -0.873242
11.57, -0.874448
11.573333, -0.875492
11.576667, -0.87625
11.58, -0.876549
11.583333, -0.876108
11.586667, -0.874982
11.59, -0.873714
11.593333, -0.872831
11.596667, -0.872415
11.6, -0.872213
11.603333, -0.871834
11.606667, -0.870934
11.61, -0.869504
11.613333, -0.867764
11.616667, -0.865952
11.62, -0.864511
11.623333, -0.863983
11.626667, -0.864442
11.63, -0.86536
11.633333, -0.866053
11.636667, -0.866093
11.64, -0.865493
11.643333, -0.864676
11.646667, -0.864042
11.65, -0.863644
11.653333, -0.863525
11.656667, -0.863853
11.66, -0.864445
11.663333, -0.864807
11.666667, -0.864776
11.67, -0.86455
11.673333, -0.864256
11.676667, -0.86379
11.68, -0.862803
11.683333, -0.860908
11.686667, -0.858245
11.69, -0.855777
11.693333, -0.854738
11.696667, -0.855605
11.7, -0.857634
11.703333, -0.859526
11.706667, -0.860341
11.71, -0.859762
11.713333, -0.857968
11.716667, -0.855626
11.72, -0.85366
11.723333, -0.852603
11.726667, -0.852322
11.73, -0.852479
11.733333, -0.852916
11.736667, -0.853471
11.74, -0.853858
11.743333, -0.853869
11.746667, -0.853466
11.75, -0.852687
11.753333, -0.851656
11.756667, -0.850683
11.76, -0.850092
11.763333, -0.849841
11.766667, -0.849535
11.77, -0.848895
11.773333, -0.848
11.776667, -0.846949
11.78, -0.84563
11.783333, -0.843969
11.786667, -0.842062
11.79, -0.840024
11.793333, -0.837981
11.796667, -0.836089
11.8, -0.834466
11.803333, -0.833158
11.806667, -0.832146
11.81, -0.831245
11.813333, -0.830072
11.816667, -0.828388
11.82, -0.826558
11.823333, -0.825221
11.826667, -0.824395
11.83, -0.823334
11.833333, -0.82122
11.836667, -0.817853
11.84, -0.813788
11.843333, -0.809684
11.846667, -0.805681
11.85, -0.801633
11.853333, -0.797509
11.856667, -0.793298
11.86, -0.788819
11.863333, -0.783827
11.866667, -0.778247
11.87, -0.772235
11.873333, -0.76601
11.876667, -0.75975
11.88, -0.753596
11.883333, -0.747666
11.886667, -0.742231
11.89, -0.737622
11.893333, -0.733641
11.896667, -0.729395
11.9, -0.723811
11.903333, -0.716292
11.906667, -0.707221
11.91, -0.697766
11.913333, -0.688903
11.916667, -0.680827
11.92, -0.673246
11.923333, -0.665876
11.926667, -0.658615
11.93, -0.651462
11.933333, -0.644315
11.936667, -0.637074
11.94, -0.62993
11.943333, -0.623099
11.946667, -0.616407
11.95, -0.609532
11.953333, -0.602454
11.956667, -0.595355
11.96, -0.588351
11.963333, -0.581641
11.966667, -0.575555
11.97, -0.570166
11.973333, -0.565154
11.976667, -0.560154
11.98, -0.555086
11.983333, -0.55014
11.986667, -0.545605
11.99, -0.541803
11.993333, -0.539022
11.996667, -0.537343
12.0, -0.536468
12.003333, -0.535743
12.006667, -0.534615
12.01, -0.533247
12.013333, -0.532332
12.016667, -0.532309
12.02, -0.533134
12.023333, -0.534515
12.026667, -0.536081
12.03, -0.537639
12.033333, -0.539504
12.036667, -0.542358
12.04, -0.546534
12.043333, -0.551607
12.046667, -0.55691
12.05, -0.562138
12.053333, -0.567304
12.056667, -0.572465
12.06, -0.57774
12.063333, -0.583482
12.066667, -0.590219
12.07, -0.598136
12.073333, -0.606619
12.076667, -0.614662
12.08, -0.621816
12.083333, -0.628615
12.086667, -0.635961
12.09, -0.644202
12.093333, -0.653006
12.096667, -0.661737
12.1, -0.669649
12.103333, -0.676231
12.106667, -0.68178
12.11, -0.687395
12.113333, -0.6941
12.116667, -0.701971
12.12, -0.710286
12.123333, -0.718318
12.126667, -0.725623
12.13, -0.731905
12.133333, -0.737121
12.136667, -0.741538
12.14, -0.745453
12.143333, -0.749058
12.146667, -0.752672
12.15, -0.756749
12.153333, -0.761559
12.156667, -0.767021
12.16, -0.772737
12.163333, -0.778032
12.166667, -0.782173
12.17, -0.784859
12.173333, -0.786492
12.176667, -0.78779
12.18, -0.78921
12.183333, -0.790805
12.186667, -0.792354
12.19, -0.793608
12.193333, -0.794543
12.196667, -0.795214
12.2, -0.79557
12.203333, -0.795643
12.206667, -0.795623
12.21, -0.795624
12.213333, -0.795823
12.216667, -0.796632
12.22, -0.798242
12.223333, -0.800292
12.226667, -0.802211
12.23, -0.803579
12.233333, -0.804228
12.236667, -0.804118
12.24, -0.803296
12.243333, -0.802225
12.246667, -0.801688
12.25, -0.801981
12.253333, -0.802615
12.256667, -0.802913
12.26, -0.80267
12.263333, -0.802161
12.266667, -0.801652
12.27, -0.801174
12.273333, -0.800689
12.276667, -0.800159
12.28, -0.799502
12.283333, -0.798715
12.286667, -0.797985
12.29, -0.797469
12.293333, -0.796899
12.296667, -0.795674
12.3, -0.793584
12.303333, -0.791179
12.306667, -0.789251
12.31, -0.788055
12.313333, -0.787127
12.316667, -0.785806
12.32, -0.783732
12.323333, -0.780947
12.326667, -0.777672
12.33, -0.773926
12.333333, -0.769553
12.336667, -0.76454
12.34, -0.758853
12.343333, -0.752188
12.346667, -0.744352
12.35, -0.735492
12.353333, -0.725841
12.356667, -0.715548
12.36, -0.70449
12.363333, -0.692307
12.366667, -0.679042
12.37, -0.665294
12.373333, -0.651386
12.376667, -0.636876
12.38, -0.620934
12.383333, -0.60268
12.386667, -0.581485
12.39, -0.557476
12.393333, -0.531326
12.396667, -0.503367
12.4, -0.473174
12.403333, -0.44002
12.406667, -0.40345
12.41, -0.363534
12.413333, -0.320805
12.416667, -0.275795
12.42, -0.22838
12.423333, -0.177766
12.426667, -0.123161
12.43, -0.064155
12.433333, -0.000555
12.436667, 0.067736
12.44, 0.140799
12.443333, 0.218783
12.446667, 0.301823
12.45, 0.389903
12.453333, 0.482954
12.456667, 0.581199
12.46, 0.685148
12.463333, 0.795113
12.466667, 0.911112
12.47, 1.033212
12.473333, 1.161665
12.476667, 1.296863
12.48, 1.439099
12.483333, 1.588347
12.486667, 1.744429
12.49, 1.907299
12.493333, 2.077186
12.496667, 2.25459
12.5, 2.440001
12.503333, 2.633407
12.506667, 2.834107
12.51, 3.041142
12.513333, 3.253845
12.516667, 3.472058
12.52, 3.696005
12.523333, 3.925928
12.526667, 4.161788
12.53, 4.403332
12.533333, 4.650271
12.536667, 4.90212
12.54, 5.15824
12.543333, 5.418304
12.546667, 5.682258
12.55, 5.949739
12.553333, 6.219915
12.556667, 6.49174
12.56, 6.764097
12.563333, 7.036045
12.566667, 7.307156
12.57, 7.577429
12.573333, 7.846785
12.576667, 8.11462
12.58, 8.379846
12.583333, 8.64132
12.586667, 8.898185
12.59, 9.14997
12.593333, 9.39638
12.596667, 9.636665
12.6, 9.869467
12.603333, 10.093515
12.606667, 10.30811
12.61, 10.512854
12.613333, 10.707293
12.616667, 10.89094
12.62, 11.063489
12.623333, 11.224774
12.626667, 11.374497
12.63, 11.512052
12.633333, 11.636634
12.636667, 11.74748
12.64, 11.84391
12.643333, 11.925334
12.646667, 11.991401
12.65, 12.041887
12.653333, 12.076511
12.656667, 12.095128
12.66, 12.097794
12.663333, 12.084712
12.666667, 12.056218
12.67, 12.012474
12.673333, 11.953409
12.676667, 11.879108
12.68, 11.789889
12.683333, 11.686056
12.686667, 11.567845
12.69, 11.435679
12.693333, 11.290287
12.696667, 11.13241
12.7, 10.962646
12.703333, 10.781648
12.706667, 10.590028
12.71, 10.388145
12.713333, 10.176426
12.716667, 9.955578
12.72, 9.726409
12.723333, 9.48967
12.726667, 9.246035
12.73, 8.996284
12.733333, 8.741453
12.736667, 8.482579
12.74, 8.220326
12.743333, 7.955144
12.746667, 7.687786
12.75, 7.419315
12.753333, 7.150578
12.756667, 6.88208
12.76, 6.61431
12.763333, 6.34784
12.766667, 6.08326
12.77, 5.821158
12.773333, 5.5621
12.776667, 5.306669
12.78, 5.055513
12.783333, 4.809194
12.786667, 4.568036
12.79, 4.332234
12.793333, 4.102002
12.796667, 3.877486
12.8, 3.658744
12.803333, 3.446044
12.806667, 3.239892
12.81, 3.040513
12.813333, 2.847649
12.816667, 2.66108
12.82, 2.481054
12.823333, 2.307892
12.826667, 2.141472
12.83, 1.981458
12.833333, 1.82784
12.836667, 1.680899
12.84, 1.54081
12.843333, 1.407612
12.846667, 1.28118
12.85, 1.160983
12.853333, 1.046247
12.856667, 0.936504
12.86, 0.831803
12.863333, 0.73232
12.866667, 0.637883
12.87, 0.548081
12.873333, 0.462734
12.876667, 0.382051
12.88, 0.306372
12.883333, 0.235821
12.886667, 0.170155
12.89, 0.108947
12.893333, 0.051739
12.896667, -0.002061
12.9, -0.053237
12.903333, -0.102429
12.906667, -0.149689
12.91, -0.194434
12.913333, -0.236052
12.916667, -0.274459
12.92, -0.309943
12.923333, -0.342827
12.926667, -0.373423
12.93, -0.402049
12.933333, -0.428898
12.936667, -0.454036
12.94, -0.477517
12.943333, -0.499357
12.946667, -0.519634
12.95, -0.538607
12.953333, -0.556453
12.956667, -0.573208
12.96, -0.589029
12.963333, -0.604137
12.966667, -0.618567
12.97, -0.632245
12.973333, -0.645157
12.976667, -0.657244
12.98, -0.668188
12.983333, -0.677673
12.986667, -0.686001
12.99, -0.694097
12.993333, -0.702706
12.996667, -0.711708
13.0, -0.720297
13.003333, -0.727786
13.006667, -0.73422
13.01, -0.740189
13.013333, -0.746197
13.016667, -0.752339
13.02, -0.758462
13.023333, -0.764461
13.026667, -0.770338
13.03, -0.776069
13.033333, -0.78146
13.036667, -0.786126
13.04, -0.78973
13.043333, -0.792359
13.046667, -0.794642
13.05, -0.79733
13.053333, -0.800686
13.056667, -0.804424
13.06, -0.808191
13.063333, -0.811979
13.066667, -0.815881
13.07, -0.819631
13.073333, -0.822818
13.076667, -0.825384
13.08, -0.827577
13.083333, -0.829691
13.086667, -0.832011
13.09, -0.834774
13.093333, -0.837967
13.096667, -0.841194
13.1, -0.843917
13.103333, -0.845767
13.106667, -0.846787
13.11, -0.847561
13.113333, -0.848739
13.116667, -0.850401
13.12, -0.852237
13.123333, -0.854073
13.126667, -0.855986
13.13, -0.858067
13.133333, -0.860162
13.136667, -0.861946
13.14, -0.863174
13.143333, -0.863728
13.146667, -0.863834
13.15, -0.864259
13.153333, -0.86569
13.156667, -0.867966
13.16, -0.870325
13.163333, -0.87226
13.166667, -0.873864
13.17, -0.87538
13.173333, -0.876676
13.176667, -0.877373
13.18, -0.87748
13.183333, -0.877473
13.186667, -0.877503
13.19, -0.877215
13.193333, -0.876538
13.196667, -0.8759
13.2, -0.875512
13.203333, -0.875104
13.206667, -0.874479
13.21, -0.873818
13.213333, -0.873449
13.216667, -0.873724
13.22, -0.874976
13.223333, -0.877211
13.226667, -0.87983
13.23, -0.881903
13.233333, -0.882873
13.236667, -0.882872
13.24, -0.882372
13.243333, -0.88185
13.246667, -0.881677
13.25, -0.882021
13.253333, -0.882791
13.256667, -0.883864
13.26, -0.885479
13.263333, -0.888099
13.266667, -0.8917
13.27, -0.895516
13.273333, -0.898685
13.276667, -0.900886
13.28, -0.902294
13.283333, -0.903175
13.286667, -0.903653
13.29, -0.903681
13.293333, -0.903117
13.296667, -0.901996
13.3, -0.900807
13.303333, -0.900323
13.306667, -0.900893
13.31, -0.901947
13.313333, -0.902504
13.316667, -0.902152
13.32, -0.901331
13.323333, -0.90077
13.326667, -0.90082
13.33, -0.901348
13.333333, -0.902066
13.336667, -0.902824
13.34, -0.903563
13.343333, -0.904282
13.346667, -0.905237
13.35, -0.906788
13.353333, -0.908823
13.356667, -0.910771
13.36, -0.912258
13.363333, -0.913484
13.366667, -0.914966
13.37, -0.91698
13.373333, -0.919303
13.376667, -0.921413
13.38, -0.922744
13.383333, -0.92304
13.386667, -0.922619
13.39, -0.92212
13.393333, -0.922036
13.396667, -0.922492
13.4, -0.923275
13.403333, -0.924065
13.406667, -0.924743
13.41, -0.925386
13.413333, -0.925999
13.416667, -0.92645
13.42, -0.926636
13.423333, -0.926525
13.426667, -0.926362
13.43, -0.926859
13.433333, -0.928655
13.436667, -0.931645
13.44, -0.935118
13.443333, -0.938331
13.446667, -0.94083
13.45, -0.942476
13.453333, -0.943348
13.456667, -0.943662
13.46, -0.943771
13.463333, -0.944028
13.466667, -0.944528
13.47, -0.945261
13.473333, -0.946343
13.476667, -0.947708
13.48, -0.948868
13.483333, -0.949169
13.486667, -0.948218
13.49, -0.946116
13.493333, -0.943364
13.496667, -0.940642
13.5, -0.938689
13.503333, -0.938104
13.506667, -0.939095
13.51, -0.941399
13.513333, -0.944401
13.516667, -0.947414
13.52, -0.950056
13.523333, -0.952459
13.526667, -0.954924
13.53, -0.95734
13.533333, -0.959244
13.536667, -0.960423
13.54, -0.961115
13.543333, -0.961655
13.546667, -0.962191
13.55, -0.962752
13.553333, -0.963497
13.556667, -0.964711
13.56, -0.966405
13.563333, -0.968189
13.566667, -0.969722
13.57, -0.971091
13.573333, -0.97268
13.576667, -0.974712
13.58, -0.976952
13.583333, -0.978853
13.586667, -0.979874
13.59, -0.979831
13.593333, -0.979285
13.596667, -0.979369
13.6, -0.980995
13.603333, -0.984293
13.606667, -0.988607
13.61, -0.99295
13.613333, -0.996649
13.616667, -0.999426
13.62, -1.000901
13.623333, -1.000527
13.626667, -0.998144
13.63, -0.994374
13.633333, -0.990385
13.636667, -0.987039
13.64, -0.984319
13.643333, -0.98166
13.646667, -0.978409
13.65, -0.974039
13.653333, -0.968667
13.656667, -0.96328
13.66, -0.958796
13.663333, -0.955203
13.666667, -0.951794
13.67, -0.94771
13.673333, -0.942224
13.676667, -0.935044
13.68, -0.926421
13.683333, -0.916696
13.686667, -0.905745
13.69, -0.893049
13.693333, -0.878373
13.696667, -0.862101
13.7, -0.844553
13.703333, -0.825054
13.706667, -0.801994
13.71, -0.773808
13.713333, -0.739779
13.716667, -0.700105
13.72, -0.655262
13.723333, -0.605242
13.726667, -0.549506
13.73, -0.487372
13.733333, -0.417984
13.736667, -0.340077
13.74, -0.252049
13.743333, -0.152274
13.746667, -0.039213
13.75, 0.088814
13.753333, 0.233706
13.756667, 0.397526
13.76, 0.582723
13.763333, 0.792003
13.766667, 1.027743
13.77, 1.292043
13.773333, 1.58731
13.776667, 1.916657
13.78, 2.284036
13.783333, 2.69398
13.786667, 3.151084
13.79, 3.659849
13.793333, 4.224999
13.796667, 4.851765
13.8, 5.545844
13.803333, 6.313341
13.806667, 7.160736
13.81, 8.094768
13.813333, 9.121841
13.816667, 10.246937
13.82, 11.473372
13.823333, 12.804332
13.826667, 14.244788
13.83, 15.801989
13.833333, 17.484946
13.836667, 19.30426
13.84, 21.272178
13.843333, 23.402181
13.846667, 25.708216
13.85, 28.203877
13.853333, 30.9016
13.856667, 33.812213
13.86, 36.945172
13.863333, 40.309459
13.866667, 43.914736
13.87, 47.771977
13.873333, 51.892689
13.876667, 56.287515
13.88, 60.965585
13.883333, 65.934166
13.886667, 71.197795
13.89, 76.757734
13.893333, 82.61229
13.896667, 88.757592
13.9, 95.188413
13.903333, 101.898618
13.906667, 108.8813
13.91, 116.128942
13.913333, 123.6333
13.916667, 131.384918
13.92, 139.372853
13.923333, 147.584461
13.926667, 156.003856
13.93, 164.609433
13.933333, 173.373797
13.936667, 182.267694
13.94, 191.26446
13.943333, 200.341403
13.946667, 209.478973
13.95, 218.659733
13.953333, 227.867372
13.956667, 237.08512
13.96, 246.293594
13.963333, 255.469231
13.966667, 264.584205
13.97, 273.607764
13.973333, 282.508232
13.976667, 291.254908
13.98, 299.819372
13.983333, 308.175864
13.986667, 316.300868
13.99, 324.171944
13.993333, 331.766366
13.996667, 339.061045
14.0, 346.033157
14.003333, 352.660227
14.006667, 358.920493
14.01, 364.793798
14.013333, 370.262318
14.016667, 375.311233
14.02, 379.928869
14.023333, 384.105923
14.026667, 387.835035
14.03, 391.111117
14.033333, 393.931247
14.036667, 396.293913
14.04, 398.198193
14.043333, 399.643132
14.046667, 400.62741
14.05, 401.14966
14.053333, 401.209891
14.056667, 400.8115
14.06, 399.962036
14.063333, 398.672166
14.066667, 396.954875
14.07, 394.82563
14.073333, 392.301958
14.076667, 389.402191
14.08, 386.144488
14.083333, 382.546677
14.086667, 378.627004
14.09, 374.405087
14.093333, 369.902341
14.096667, 365.141586
14.1, 360.14496
14.103333, 354.931322
14.106667, 349.516295
14.11, 343.914071
14.113333, 338.138566
14.116667, 332.204388
14.12, 326.127291
14.123333, 319.923198
14.126667, 313.607353
14.13, 307.19454
14.133333, 300.699302
14.136667, 294.135898
14.14, 287.518282
14.143333, 280.85995
14.146667, 274.17445
14.15, 267.478348
14.153333, 260.794771
14.156667, 254.151545
14.16, 247.573437
14.163333, 241.075866
14.166667, 234.663954
14.17, 228.334515
14.173333, 222.078795
14.176667, 215.885519
14.18, 209.743953
14.183333, 203.646317
14.186667, 197.589187
14.19, 191.57418
14.193333, 185.607502
14.196667, 179.698128
14.2, 173.855637
14.203333, 168.088369
14.206667, 162.40223
14.21, 156.800623
14.213333, 151.285548
14.216667, 145.859339
14.22, 140.526201
14.223333, 135.292627
14.226667, 130.166407
14.23, 125.15496
14.233333, 120.264216
14.236667, 115.498376
14.24, 110.86012
14.243333, 106.35085
14.246667, 101.970684
14.25, 97.718596
14.253333, 93.593016
14.256667, 89.592096
14.26, 85.713025
14.263333, 81.951123
14.266667, 78.300264
14.27, 74.754875
14.273333, 71.311685
14.276667, 67.970213
14.28, 64.732645
14.283333, 61.603236
14.286667, 58.587079
14.29, 55.688734
14.293333, 52.911092
14.296667, 50.254743
14.3, 47.71823
14.303333, 45.298657
14.306667, 42.992139
14.31, 40.794389
14.313333, 38.701185
14.316667, 36.708413
14.32, 34.812094
14.323333, 33.008326
14.326667, 31.293136
14.33, 29.662403
14.333333, 28.111843
14.336667, 26.637228
14.34, 25.234901
14.343333, 23.901958
14.346667, 22.635709
14.35, 21.433128
14.353333, 20.291157
14.356667, 19.207327
14.36, 18.179499
14.363333, 17.205305
14.366667, 16.282428
14.37, 15.409014
14.373333, 14.583376
14.376667, 13.80353
14.38, 13.067283
14.383333, 12.372772
14.386667, 11.718724
14.39, 11.104055
14.393333, 10.527267
14.396667, 9.986048
14.4, 9.477242
14.403333, 8.997182
14.406667, 8.542338
14.41, 8.109988
14.413333, 7.698356
14.416667, 7.306375
14.42, 6.933523
14.423333, 6.579613
14.426667, 6.244462
14.43, 5.927543
14.433333, 5.627761
14.436667, 5.343721
14.44, 5.074447
14.443333, 4.819423
14.446667, 4.577972
14.45, 4.349324
14.453333, 4.133077
14.456667, 3.92892
14.46, 3.736299
14.463333, 3.554641
14.466667, 3.383441
14.47, 3.222015
14.473333, 3.069456
14.476667, 2.924929
14.48, 2.787848
14.483333, 2.657753
14.486667, 2.534211
14.49, 2.416849
14.493333, 2.305364
14.496667, 2.19947
14.5, 2.098746
14.503333, 2.002643
14.506667, 1.910943
14.51, 1.823972
14.513333, 1.742102
14.516667, 1.665212
14.52, 1.592601
14.523333, 1.523333
14.526667, 1.456773
14.53, 1.392679
14.533333, 1.330786
14.536667, 1.270701
14.54, 1.212318
14.543333, 1.156054
14.546667, 1.102502
14.55, 1.051882
14.553333, 1.003822
14.556667, 0.95764
14.56, 0.912947
14.563333, 0.869913
14.566667, 0.828844
14.57, 0.789608
14.573333, 0.751589
14.576667, 0.714015
14.58, 0.676452
14.583333, 0.639135
14.586667, 0.602632
14.59, 0.567407
14.593333, 0.533958
14.596667, 0.502822
14.6, 0.47429
14.603333, 0.44824
14.606667, 0.424011
14.61, 0.40043
14.613333, 0.376363
14.616667, 0.351302
14.62, 0.32544
14.623333, 0.299378
14.626667, 0.273726
14.63, 0.248585
14.633333, 0.223521
14.636667, 0.198324
14.64, 0.173396
14.643333, 0.149264
14.646667, 0.126266
14.65, 0.104315
14.653333, 0.08276
14.656667, 0.061198
14.66, 0.040152
14.663333, 0.020374
14.666667, 0.001968
14.67, -0.015536
14.673333, -0.032625
14.676667, -0.049694
14.68, -0.067182
14.683333, -0.085208
14.686667, -0.103262
14.69, -0.120756
14.693333, -0.137515
14.696667, -0.153569
14.7, -0.16896
14.703333, -0.183832
14.706667, -0.198452
14.71, -0.2132
14.713333, -0.228575
14.716667, -0.244946
14.72, -0.262019
14.723333, -0.278755
14.726667, -0.294142
14.73, -0.307827
14.733333, -0.320004
14.736667, -0.3311
14.74, -0.341573
14.743333, -0.351763
14.746667, -0.36183
14.75, -0.37174
14.753333, -0.381363
14.756667, -0.390638
14.76, -0.399548
14.763333, -0.408072
14.766667, -0.416322
14.77, -0.424567
14.773333, -0.43296
14.776667, -0.441449
14.78, -0.449936
14.783333, -0.458348
14.786667, -0.466632
14.79, -0.474677
14.793333, -0.48234
14.796667, -0.489646
14.8, -0.496772
14.803333, -0.503843
14.806667, -0.510851
14.81, -0.517744
14.813333, -0.524536
14.816667, -0.531298
14.82, -0.538074
14.823333, -0.544629
14.826667, -0.550398
14.83, -0.554948
14.833333, -0.558418
14.836667, -0.561455
14.84, -0.564787
14.843333, -0.568815
14.846667, -0.57351
14.85, -0.578652
14.853333, -0.584159
14.856667, -0.590077
14.86, -0.596397
14.863333, -0.603071
14.866667, -0.610004
14.87, -0.616937
14.873333, -0.623512
14.876667, -0.629539
14.88, -0.635091
14.883333, -0.64022
14.886667, -0.64485
14.89, -0.649097
14.893333, -0.653437
14.896667, -0.658458
14.9, -0.664398
14.903333, -0.670732
14.906667, -0.676512
14.91, -0.681361
14.913333, -0.68568
14.916667, -0.689803
14.92, -0.69352
14.923333, -0.6965
14.926667, -0.698798
14.93, -0.701001
14.933333, -0.704131
14.936667, -0.709246
14.94, -0.716734
14.943333, -0.725931
14.946667, -0.735499
14.95, -0.7441
14.953333, -0.750754
14.956667, -0.755067
14.96, -0.757347
14.963333, -0.75838
14.966667, -0.758906
14.97, -0.75919
14.973333, -0.759271
14.976667, -0.759481
14.98, -0.760315
14.983333, -0.761928
14.986667, -0.764001
14.99, -0.766123
14.993333, -0.768201
14.996667, -0.770246
15.0, -0.772044
15.003333, -0.773539
15.006667, -0.775182
15.01, -0.777485
15.013333, -0.780514
15.016667, -0.783967
15.02, -0.787503
15.023333, -0.790885
15.026667, -0.793853
15.03, -0.796047
15.033333, -0.797414
15.036667, -0.798429
15.04, -0.799514
15.043333, -0.800516
15.046667, -0.801175
15.05, -0.801923
15.053333, -0.803592
15.056667, -0.806395
15.06, -0.80975
15.063333, -0.812929
15.066667, -0.815575
15.07, -0.817849
15.073333, -0.820221
15.076667, -0.823085
15.08, -0.826565
15.083333, -0.8305
15.086667, -0.83449
15.09, -0.838223
15.093333, -0.841793
15.096667, -0.845351
15.1, -0.848663
15.103333, -0.851474
15.106667, -0.853971
15.11, -0.856565
15.113333, -0.859411
15.116667, -0.862494
15.12, -0.865921
15.123333, -0.869682
15.126667, -0.873302
15.13, -0.876095
15.133333, -0.877803
15.136667, -0.878867
15.14, -0.879994
15.143333, -0.881654
15.146667, -0.88388
15.15, -0.886212
15.153333, -0.887843
15.156667, -0.888135
15.16, -0.887148
15.163333, -0.88564
15.166667, -0.884385
15.17, -0.883635
15.173333, -0.88332
15.176667, -0.883516
15.18, -0.884443
15.183333, -0.886087
15.186667, -0.888252
15.19, -0.890846
15.193333, -0.893676
15.196667, -0.896362
15.2, -0.898808
15.203333, -0.901292
15.206667, -0.903974
15.21, -0.906667
15.213333, -0.909071
15.216667, -0.911043
15.22, -0.912701
15.223333, -0.914357
15.226667, -0.916279
15.23, -0.91851
15.233333, -0.920981
15.236667, -0.923609
15.24, -0.926116
15.243333, -0.928122
15.246667, -0.929505
15.25, -0.930472
15.253333, -0.931344
15.256667, -0.932319
15.26, -0.933352
15.263333, -0.934363
15.266667, -0.935698
15.27, -0.93821
15.273333, -0.942565
15.276667, -0.948393
15.28, -0.954419
15.283333, -0.959374
15.286667, -0.962502
15.29, -0.963613
15.293333, -0.963115
15.296667, -0.961838
15.3, -0.96052
15.303333, -0.959353
15.306667, -0.958059
15.31, -0.95641
15.313333, -0.954472
15.316667, -0.95238
15.32, -0.950239
15.323333, -0.948332
15.326667, -0.947165
15.33, -0.947109
15.333333, -0.948069
15.336667, -0.94951
15.34, -0.950723
15.343333, -0.951141
15.346667, -0.950519
15.35, -0.949065
15.353333, -0.947349
15.356667, -0.945872
15.36, -0.9449
15.363333, -0.944641
15.366667, -0.945149
15.37, -0.946162
15.373333, -0.947239
15.376667, -0.947965
15.38, -0.947906
15.383333, -0.946661
15.386667, -0.944224
15.39, -0.941265
15.393333, -0.9389
15.396667, -0.937997
15.4, -0.938606
15.403333, -0.940124
15.406667, -0.941848
15.41, -0.943378
15.413333, -0.944738
15.416667, -0.94627
15.42, -0.948304
15.423333, -0.950906
15.426667, -0.953919
15.43, -0.956963
15.433333, -0.959466
15.436667, -0.960901
15.44, -0.961061
15.443333, -0.960379
15.446667, -0.959914
15.45, -0.960639
15.453333, -0.962628
15.456667, -0.965068
15.46, -0.967042
15.463333, -0.968213
15.466667, -0.968799
15.47, -0.969209
15.473333, -0.969923
15.476667, -0.971303
15.48, -0.973177
15.483333, -0.974891
15.486667, -0.976022
15.49, -0.976909
15.493333, -0.97828
15.496667, -0.980462
15.5, -0.983223
15.503333, -0.985959
15.506667, -0.987881
15.51, -0.988603
15.513333, -0.988419
15.516667, -0.987916
15.52, -0.987636
15.523333, -0.9878
15.526667, -0.988114
15.53, -0.988052
15.533333, -0.987271
15.536667, -0.985778
15.54, -0.983846
15.543333, -0.981864
15.546667, -0.980155
15.55, -0.978768
15.553333, -0.977425
15.556667, -0.975864
15.56, -0.974137
15.563333, -0.972449
15.566667, -0.971053
15.57, -0.970285
15.573333, -0.9703
15.576667, -0.970775
15.58, -0.971046
15.583333, -0.970449
15.586667, -0.968731
15.59, -0.966415
15.593333, -0.964661
15.596667, -0.96436
15.6, -0.96534
15.603333, -0.966728
15.606667, -0.96786
15.61, -0.96856
15.613333, -0.968826
15.616667, -0.968661
15.62, -0.968212
15.623333, -0.967673
15.626667, -0.966874
15.63, -0.965427
15.633333, -0.963354
15.636667, -0.961064
15.64, -0.958974
15.643333, -0.95753
15.646667, -0.957014
15.65, -0.957199
15.653333, -0.957616
15.656667, -0.95797
15.66, -0.958176
15.663333, -0.958237
15.666667, -0.958228
15.67, -0.95821
15.673333, -0.957969
15.676667, -0.957076
15.68, -0.955413
15.683333, -0.95339
15.686667, -0.9516
15.69, -0.950413
15.693333, -0.949817
15.696667, -0.949471
15.7, -0.948955
15.703333, -0.948128
15.706667, -0.947153
15.71, -0.946073
15.713333, -0.944508
15.716667, -0.941922
15.72, -0.93823
15.723333, -0.933999
15.726667, -0.930054
15.73, -0.927064
15.733333, -0.925389
15.736667, -0.925073
15.74, -0.925814
15.743333, -0.927025
15.746667, -0.928156
15.75, -0.92904
15.753333, -0.929837
15.756667, -0.930646
15.76, -0.931355
15.763333, -0.931854
15.766667, -0.932166
15.77, -0.93235
15.773333, -0.932355
15.776667, -0.932122
15.78, -0.931824
15.783333, -0.931739
15.786667, -0.931991
15.79, -0.932475
15.793333, -0.932994
15.796667, -0.933581
15.8, -0.934374
15.803333, -0.935091
15.806667, -0.935154
15.81, -0.934327
15.813333, -0.932887
15.816667, -0.931496
15.82, -0.931053
15.823333, -0.932268
15.826667, -0.935356
15.83, -0.940156
15.833333, -0.946139
15.836667, -0.952328
15.84, -0.957681
15.843333, -0.96141
15.846667, -0.962969
15.85, -0.962318
15.853333, -0.960166
15.856667, -0.957679
15.86, -0.95588
15.863333, -0.955153
15.866667, -0.955094
15.87, -0.954842
15.873333, -0.953765
15.876667, -0.951961
15.88, -0.950084
15.883333, -0.948686
15.886667, -0.947896
15.89, -0.947626
15.893333, -0.947772
15.896667, -0.948282
15.9, -0.949167
15.903333, -0.950489
15.906667, -0.95225
15.91, -0.954144
15.913333, -0.955633
15.916667, -0.956386
15.92, -0.956459
15.923333, -0.95618
15.926667, -0.955988
15.93, -0.956202
15.933333, -0.956734
15.936667, -0.957001
15.94, -0.956244
15.943333, -0.954094
15.946667, -0.950932
15.95, -0.947672
15.953333, -0.945296
15.956667, -0.94433
15.96, -0.944543
15.963333, -0.945367
15.966667, -0.94648
15.97, -0.947717
15.973333, -0.948763
15.976667, -0.949287
15.98, -0.94929
15.983333, -0.949106
15.986667, -0.949057
15.99, -0.949227
15.993333, -0.94947
15.996667, -0.949403
16.0, -0.948454
16.003333, -0.946242
16.006667, -0.942936
16.01, -0.939157
16.013333, -0.935602
16.016667, -0.932532
16.02, -0.929639
16.023333, -0.926461
16.026667, -0.92267
16.03, -0.91816
16.033333, -0.913047
16.036667, -0.907411
16.04, -0.901167
16.043333, -0.894398
16.046667, -0.88766
16.05, -0.881867
16.053333, -0.877795
16.056667, -0.875383
16.06, -0.873544
16.063333, -0.870917
16.066667, -0.866627
16.07, -0.860377
16.073333, -0.852242
16.076667, -0.842422
16.08, -0.831158
16.083333, -0.818906
16.086667, -0.806371
16.09, -0.79402
16.093333, -0.781671
16.096667, -0.768845
16.1, -0.755297
16.103333, -0.741017
16.106667, -0.726168
16.11, -0.711098
16.113333, -0.696109
16.116667, -0.681193
16.12, -0.666102
16.123333, -0.65075
16.126667, -0.635387
16.13, -0.620252
16.133333, -0.605369
16.136667, -0.590735
16.14, -0.576211
16.143333, -0.561192
16.146667, -0.54501
16.15, -0.527577
16.153333, -0.509225
16.156667, -0.490276
16.16, -0.471131
16.163333, -0.452337
16.166667, -0.434194
16.17, -0.416534
16.173333, -0.399073
16.176667, -0.381656
16.18, -0.364086
16.183333, -0.346103
16.186667, -0.327613
16.19, -0.308809
16.193333, -0.290053
16.196667, -0.271542
16.2, -0.253215
16.203333, -0.235094
16.206667, -0.217472
16.21, -0.20071
16.213333, -0.184879
16.216667, -0.169544
16.22, -0.154127
16.223333, -0.138514
16.226667, -0.123178
16.23, -0.108741
16.233333, -0.095402
16.236667, -0.082869
16.24, -0.070965
16.243333, -0.059867
16.246667, -0.049569
16.25, -0.039559
16.253333, -0.029244
16.256667, -0.018509
16.26, -0.007853
16.263333, 0.002033
16.266667, 0.010856
16.27, 0.018917
16.273333, 0.026871
16.276667, 0.035235
16.28, 0.044
16.283333, 0.052591
16.286667, 0.06015
16.29, 0.065955
16.293333, 0.069689
16.296667, 0.071468
16.3, 0.07164
16.303333, 0.070542
16.306667, 0.068401
16.31, 0.065279
16.313333, 0.060975
16.316667, 0.055187
16.32, 0.047875
16.323333, 0.039402
16.326667, 0.030332
16.33, 0.021149
16.333333, 0.012081
16.336667, 0.003059
16.34, -0.006128
16.343333, -0.01569
16.346667, -0.025742
16.35, -0.036334
16.353333, -0.047647
16.356667, -0.060037
16.36, -0.073639
16.363333, -0.088042
16.366667, -0.102676
16.37, -0.117388
16.373333, -0.132406
16.376667, -0.147813
16.38, -0.163299
16.383333, -0.178661
16.386667, -0.194427
16.39, -0.211476
16.393333, -0.230103
16.396667, -0.249798
16.4, -0.269502
16.403333, -0.287927
16.406667, -0.304267
16.41, -0.318732
16.413333, -0.332183
16.416667, -0.345379
16.42, -0.358679
16.423333, -0.372143
16.426667, -0.385673
16.43, -0.399077
16.433333, -0.412161
16.436667, -0.424896
16.44, -0.437351
16.443333, -0.449508
16.446667, -0.461308
16.45, -0.472766
16.453333, -0.483835
16.456667, -0.494358
16.46, -0.504351
16.463333, -0.514081
16.466667, -0.523639
16.47, -0.532664
16.473333, -0.540586
16.476667, -0.547062
16.48, -0.552284
16.483333, -0.556876
16.486667, -0.561302
16.49, -0.565167
16.493333, -0.567183
16.496667, -0.56604
16.5, -0.561344
16.503333, -0.5538
16.506667, -0.544571
16.51, -0.534265
16.513333, -0.522505
16.516667, -0.508325
16.52, -0.490836
16.523333, -0.469656
16.526667, -0.444835
16.53, -0.416526
16.533333, -0.38475
16.536667, -0.349369
16.54, -0.310149
16.543333, -0.266823
16.546667, -0.219023
16.55, -0.166103
16.553333, -0.10717
16.556667, -0.041485
16.56, 0.031283
16.563333, 0.111479
16.566667, 0.199936
16.57, 0.297604
16.573333, 0.404945
16.576667, 0.522096
16.58, 0.649387
16.583333, 0.787447
16.586667, 0.937018
16.59, 1.099045
16.593333, 1.274747
16.596667, 1.465241
16.6, 1.671283
16.603333, 1.893448
16.606667, 2.13197
16.61, 2.386555
16.613333, 2.657049
16.616667, 2.944186
16.62, 3.249627
16.623333, 3.575709
16.626667, 3.924885
16.63, 4.299214
16.633333, 4.700673
16.636667, 5.131755
16.64, 5.595254
16.643333, 6.093396
16.646667, 6.627499
16.65, 7.198523
16.653333, 7.807849
16.656667, 8.457698
16.66, 9.150807
16.663333, 9.889872
16.666667, 10.677563
16.67, 11.516704
16.673333, 12.410093
16.676667, 13.360179
16.68, 14.368901
16.683333, 15.437724
16.686667, 16.567941
16.69, 17.761184
16.693333, 19.019632
16.696667, 20.345773
16.7, 21.742207
16.703333, 23.211658
16.706667, 24.757042
16.71, 26.381291
16.713333, 28.086745
16.716667, 29.874561
16.72, 31.744815
16.723333, 33.697422
16.726667, 35.733135
16.73, 37.853735
16.733333, 40.061753
16.736667, 42.360219
16.74, 44.752254
16.743333, 47.240629
16.746667, 49.827841
16.75, 52.516218
16.753333, 55.307217
16.756667, 58.200729
16.76, 61.195489
16.763333, 64.290081
16.766667, 67.483764
16.77, 70.776707
16.773333, 74.169782
16.776667, 77.664317
16.78, 81.261499
16.783333, 84.961318
16.786667, 88.761926
16.79, 92.659869
16.793333, 96.651012
16.796667, 100.731499
16.8, 104.898066
16.803333, 109.147862
16.806667, 113.478506
16.81, 117.888368
16.813333, 122.37629
16.816667, 126.940507
16.82, 131.577706
16.823333, 136.284248
16.826667, 141.059856
16.83, 145.909155
16.833333, 150.837829
16.836667, 155.847759
16.84, 160.935525
16.843333, 166.092929
16.846667, 171.307566
16.85, 176.563423
16.853333, 181.842409
16.856667, 187.127209
16.86, 192.403776
16.863333, 197.661808
16.866667, 202.89374
16.87, 208.093449
16.873333, 213.255
16.876667, 218.371376
16.88, 223.433972
16.883333, 228.433286
16.886667, 233.359965
16.89, 238.206055
16.893333, 242.965911
16.896667, 247.635602
16.9, 252.211272
16.903333, 256.688159
16.906667, 261.06084
16.91, 265.323865
16.913333, 269.471755
16.916667, 273.498262
16.92, 277.396004
16.923333, 281.15733
16.926667, 284.77534
16.93, 288.244005
16.933333, 291.557664
16.936667, 294.71007
16.94, 297.693803
16.943333, 300.501243
16.946667, 303.126234
16.95, 305.564844
16.953333, 307.815143
16.956667, 309.876556
16.96, 311.748972
16.963333, 313.43188
16.966667, 314.923821
16.97, 316.222368
16.973333, 317.324786
16.976667, 318.228917
16.98, 318.933295
16.983333, 319.436165
16.986667, 319.734943
16.99, 319.827331
16.993333, 319.712137
16.996667, 319.388416
17.0, 318.854941
17.003333, 318.111148
17.006667, 317.157868
17.01, 315.99701
17.013333, 314.63112
17.016667, 313.063188
17.02, 311.296658
17.023333, 309.335629
17.026667, 307.18495
17.03, 304.850142
17.033333, 302.337116
17.036667, 299.651579
17.04, 296.798734
17.043333, 293.783805
17.046667, 290.612702
17.05, 287.293291
17.053333, 283.838342
17.056667, 280.267386
17.06, 276.603555
17.063333, 272.867088
17.066667, 269.07061
17.07, 265.218201
17.073333, 261.306652
17.076667, 257.327464
17.08, 253.269558
17.083333, 249.122711
17.086667, 244.880993
17.09, 240.544641
17.093333, 236.11966
17.096667, 231.616001
17.1, 227.044842
17.103333, 222.415425
17.106667, 217.733416
17.11, 213.001819
17.113333, 208.22289
17.116667, 203.399913
17.12, 198.538889
17.123333, 193.649375
17.126667, 188.743934
17.13, 183.836709
17.133333, 178.941498
17.136667, 174.069888
17.14, 169.230577
17.143333, 164.429738
17.146667, 159.671451
17.15, 154.958414
17.153333, 150.293254
17.156667, 145.678993
17.16, 141.117057
17.163333, 136.604135
17.166667, 132.132221
17.17, 127.693195
17.173333, 123.283609
17.176667, 118.906511
17.18, 114.571224
17.183333, 110.292139
17.186667, 106.086475
17.19, 101.971437
17.193333, 97.961675
17.196667, 94.06745
17.2, 90.293918
17.203333, 86.64194
17.206667, 83.109752
17.21, 79.694551
17.213333, 76.393807
17.216667, 73.20601
17.22, 70.130397
17.223333, 67.165911
17.226667, 64.310177
17.23, 61.559185
17.233333, 58.907782
17.236667, 56.350665
17.24, 53.883513
17.243333, 51.50351
17.246667, 49.208758
17.25, 46.997419
17.253333, 44.867457
17.256667, 42.816808
17.26, 40.84354
17.263333, 38.945741
17.266667, 37.121507
17.27, 35.369406
17.273333, 33.68902
17.276667, 32.080996
17.28, 30.546171
17.283333, 29.08439
17.286667, 27.693974
17.29, 26.371703
17.293333, 25.113209
17.296667, 23.913659
17.3, 22.768084
17.303333, 21.671533
17.306667, 20.619512
17.31, 19.608635
17.313333, 18.637122
17.316667, 17.704452
17.32, 16.810358
17.323333, 15.954356
17.326667, 15.135795
17.33, 14.35373
17.333333, 13.606732
17.336667, 12.893052
17.34, 12.211086
17.343333, 11.559724
17.346667, 10.938356
17.35, 10.346795
17.353333, 9.785165
17.356667, 9.253322
17.36, 8.750081
17.363333, 8.273479
17.366667, 7.821961
17.37, 7.394722
17.373333, 6.990897
17.376667, 6.609135
17.38, 6.248105
17.383333, 5.906797
17.386667, 5.584214
17.39, 5.279178
17.393333, 4.990532
17.396667, 4.717389
17.4, 4.459292
17.403333, 4.216062
17.406667, 3.987176
17.41, 3.77141
17.413333, 3.567251
17.416667, 3.37352
17.42, 3.189729
17.423333, 3.015931
17.426667, 2.852177
17.43, 2.698168
17.433333, 2.553284
17.436667, 2.416763
17.44, 2.287801
17.443333, 2.165536
17.446667, 2.049177
17.45, 1.938228
17.453333, 1.832505
17.456667, 1.731938
17.46, 1.636303
17.463333, 1.545131
17.466667, 1.457808
17.47, 1.373887
17.473333, 1.293558
17.476667, 1.217563
17.48, 1.146405
17.483333, 1.079954
17.486667, 1.017609
17.49, 0.958459
17.493333, 0.901685
17.496667, 0.847203
17.5, 0.795634
17.503333, 0.747314
17.506667, 0.701697
17.51, 0.657895
17.513333, 0.615344
17.516667, 0.573855
17.52, 0.533477
17.523333, 0.494389
17.526667, 0.456562
17.53, 0.419606
17.533333, 0.383239
17.536667, 0.347779
17.54, 0.313829
17.543333, 0.281533
17.546667, 0.250546
17.55, 0.220563
17.553333, 0.191613
17.556667, 0.163936
17.56, 0.13761
17.563333, 0.112439
17.566667, 0.088254
17.57, 0.064975
17.573333, 0.042554
17.576667, 0.021033
17.58, 0.000392
17.583333, -0.019528
17.586667, -0.038912
17.59, -0.057818
17.593333, -0.076127
17.596667, -0.093828
17.6, -0.111153
17.603333, -0.128226
17.606667, -0.14505
17.61, -0.161899
17.613333, -0.179276
17.616667, -0.197441
17.62, -0.216088
17.623333, -0.234438
17.626667, -0.251634
17.63, -0.267083
17.633333, -0.280495
17.636667, -0.29189
17.64, -0.301702
17.643333, -0.310635
17.646667, -0.319252
17.65, -0.327885
17.653333, -0.33694
17.656667, -0.346856
17.66, -0.357531
17.663333, -0.368244
17.666667, -0.378278
17.67, -0.387411
17.673333, -0.396004
17.676667, -0.404722
17.68, -0.413895
17.683333, -0.423391
17.686667, -0.433118
17.69, -0.443118
17.693333, -0.453197
17.696667, -0.462904
17.7, -0.471817
17.703333, -0.479667
17.706667, -0.486424
17.71, -0.492518
17.713333, -0.498631
17.716667, -0.504953
17.72, -0.51091
17.723333, -0.515936
17.726667, -0.520191
17.73, -0.524186
17.733333, -0.528211
17.736667, -0.532558
17.74, -0.537714
17.743333, -0.543827
17.746667, -0.550492
17.75, -0.55718
17.753333, -0.563591
17.756667, -0.569733
17.76, -0.575889
17.763333, -0.582515
17.766667, -0.589912
17.77, -0.597811
17.773333, -0.605568
17.776667, -0.612722
17.78, -0.619075
17.783333, -0.62464
17.786667, -0.62989
17.79, -0.635681
17.793333, -0.64249
17.796667, -0.649803
17.8, -0.656568
17.803333, -0.662157
17.806667, -0.666708
17.81, -0.670925
17.813333, -0.675566
17.816667, -0.680911
17.82, -0.686823
17.823333, -0.693126
17.826667, -0.699717
17.83, -0.706603
17.833333, -0.714092
17.836667, -0.722672
17.84, -0.732392
17.843333, -0.742391
17.846667, -0.75126
17.85, -0.758076
17.853333, -0.763112
17.856667, -0.767398
17.86, -0.771813
17.863333, -0.776665
17.866667, -0.781709
17.87, -0.786464
17.873333, -0.790637
17.876667, -0.794295
17.88, -0.797677
17.883333, -0.800997
17.886667, -0.804605
17.89, -0.808928
17.893333, -0.813955
17.896667, -0.819147
17.9, -0.824076
17.903333, -0.828876
17.906667, -0.833993
17.91, -0.839795
17.913333, -0.846435
17.916667, -0.853777
17.92, -0.86141
17.923333, -0.868921
17.926667, -0.876187
17.93, -0.883305
17.933333, -0.890245
17.936667, -0.896679
17.94, -0.902338
17.943333, -0.907549
17.946667, -0.91307
17.95, -0.919286
17.953333, -0.925921
17.956667, -0.932493
17.96, -0.938847
17.963333, -0.945266
17.966667, -0.952082
17.97, -0.959416
17.973333, -0.967378
17.976667, -0.976094
17.98, -0.985428
17.983333, -0.994738
17.986667, -1.003117
17.99, -1.010205
17.993333, -1.016611
17.996667, -1.023429
18.0, -1.031336
18.003333, -1.040076
18.006667, -1.048838
18.01, -1.056973
18.013333, -1.064231
18.016667, -1.070731
18.02, -1.077114
18.023333, -1.08428
18.026667, -1.092611
18.03, -1.101754
18.033333, -1.111042
18.036667, -1.119792
18.04, -1.127456
18.043333, -1.133909
18.046667, -1.139577
18.05, -1.145053
18.053333, -1.150614
18.056667, -1.156196
18.06, -1.161483
18.063333, -1.166035
18.066667, -1.169786
18.07, -1.173314
18.073333, -1.177363
18.076667, -1.182273
18.08, -1.18779
18.083333, -1.193428
18.086667, -1.199072
18.09, -1.204958
18.093333, -1.211196
18.096667, -1.217592
18.1, -1.223837
18.103333, -1.229623
18.106667, -1.234633
18.11, -1.238648
18.113333, -1.241753
18.116667, -1.244393
18.12, -1.247188
18.123333, -1.250502
18.126667, -1.254253
18.13, -1.258111
18.133333, -1.261683
18.136667, -1.264753
18.14, -1.267429
18.143333, -1.269973
18.146667, -1.272595
18.15, -1.275352
18.153333, -1.278111
18.156667, -1.280631
18.16, -1.282686
18.163333, -1.284222
18.166667, -1.285508
18.17, -1.287125
18.173333, -1.289583
18.176667, -1.292672
18.18, -1.29541
18.183333, -1.296883
18.186667, -1.297055
18.19, -1.296684
18.193333, -1.296417
18.196667, -1.296222
18.2, -1.295747
18.203333, -1.294659
18.206667, -1.292706
18.21, -1.289976
18.213333, -1.286991
18.216667, -1.284363
18.22, -1.282387
18.223333, -1.280951
18.226667, -1.279742
18.23, -1.278475
18.233333, -1.276895
18.236667, -1.274777
18.24, -1.272169
18.243333, -1.269419
18.246667, -1.266804
18.25, -1.2643
18.253333, -1.26168
18.256667, -1.258857
18.26, -1.256055
18.263333, -1.253476
18.266667, -1.251176
18.27, -1.249386
18.273333, -1.248271
18.276667, -1.247266
18.28, -1.245308
18.283333, -1.241839
18.286667, -1.237114
18.29, -1.231643
18.293333, -1.22595
18.296667, -1.220881
18.3, -1.217403
18.303333, -1.215702
18.306667, -1.21487
18.31, -1.213659
18.313333, -1.211365
18.316667, -1.208233
18.32, -1.205243
18.323333, -1.203313
18.326667, -1.202665
18.33, -1.202877
18.333333, -1.203283
18.336667, -1.203276
18.34, -1.202498
18.343333, -1.201002
18.346667, -1.199307
18.35, -1.198149
18.353333, -1.197921
18.356667, -1.198268
18.36, -1.198239
18.363333, -1.197028
18.366667, -1.194733
18.37, -1.192244
18.373333, -1.190427
18.376667, -1.189579
18.38, -1.189522
18.383333, -1.189908
18.386667, -1.190563
18.39, -1.191735
18.393333, -1.19377
18.396667, -1.196564
18.4, -1.199602
18.403333, -1.202375
18.406667, -1.204515
18.41, -1.205655
18.413333, -1.205356
18.416667, -1.203399
18.42, -1.200218
18.423333, -1.196701
18.426667, -1.193509
18.43, -1.190903
18.433333, -1.188912
18.436667, -1.187223
18.44, -1.185383
18.443333, -1.183424
18.446667, -1.181778
18.45, -1.18053
18.453333, -1.179335
18.456667, -1.177987
18.46, -1.176623
18.463333, -1.175442
18.466667, -1.174446
18.47, -1.173407
18.473333, -1.172116
18.476667, -1.17074
18.48, -1.169621
18.483333, -1.168753
18.486667, -1.167866
18.49, -1.166849
18.493333, -1.165721
18.496667, -1.164422
18.5, -1.162794
18.503333, -1.160752
18.506667, -1.158556
18.51, -1.156728
18.513333, -1.155543
18.516667, -1.154719
18.52, -1.153732
18.523333, -1.152315
18.526667, -1.150528
18.53, -1.148444
18.533333, -1.14583
18.536667, -1.142448
18.54, -1.138757
18.543333, -1.135688
18.546667, -1.133734
18.55, -1.132774
18.553333, -1.132485
18.556667, -1.132411
18.56, -1.131956
18.563333, -1.130689
18.566667, -1.128648
18.57, -1.126313
18.573333, -1.124112
18.576667, -1.121995
18.58, -1.119781
18.583333, -1.117599
18.586667, -1.115794
18.59, -1.114647
18.593333, -1.114285
18.596667, -1.114703
18.6, -1.115703
18.603333, -1.116727
18.606667, -1.117042
18.61, -1.116266
18.613333, -1.114379
18.616667, -1.111345
18.62, -1.107273
18.623333, -1.102701
18.626667, -1.098174
18.63, -1.093812
18.633333, -1.089777
18.636667, -1.086833
18.64, -1.085839
18.643333, -1.08673
18.646667, -1.088447
18.65, -1.089898
18.653333, -1.090702
18.656667, -1.090987
18.66, -1.090874
18.663333, -1.090357
18.666667, -1.089482
18.67, -1.088458
18.673333, -1.087418
18.676667, -1.086373
18.68, -1.085472
18.683333, -1.084782
18.686667, -1.084074
18.69, -1.08323
18.693333, -1.082382
18.696667, -1.081564
18.7, -1.080632
18.703333, -1.079533
18.706667, -1.078408
18.71, -1.077369
18.713333, -1.076416
18.716667, -1.075712
18.72, -1.075596
18.723333, -1.076174
18.726667, -1.077195
18.73, -1.078225
18.733333, -1.07876
18.736667, -1.078415
18.74, -1.077148
18.743333, -1.07509
18.746667, -1.072299
18.75, -1.068908
18.753333, -1.065065
18.756667, -1.060638
18.76, -1.055446
18.763333, -1.049607
18.766667, -1.043349
18.77, -1.036687
18.773333, -1.029543
18.776667, -1.021979
18.78, -1.014217
18.783333, -1.006669
18.786667, -0.999817
18.79, -0.993755
18.793333, -0.987983
18.796667, -0.981802
18.8, -0.97479
18.803333, -0.967036
18.806667, -0.959152
18.81, -0.951874
18.813333, -0.945535
18.816667, -0.939985
18.82, -0.934756
18.823333, -0.929212
18.826667, -0.922963
18.83, -0.91607
18.833333, -0.908798
18.836667, -0.901454
18.84, -0.894302
18.843333, -0.887406
18.846667, -0.880609
18.85, -0.873745
18.853333, -0.867019
18.856667, -0.861217
18.86, -0.85715
18.863333, -0.854766
18.866667, -0.853225
18.87, -0.851766
18.873333, -0.850041
18.876667, -0.848001
18.88, -0.845902
18.883333, -0.843972
18.886667, -0.842164
18.89, -0.840618
18.893333, -0.83981
18.896667, -0.839951
18.9, -0.840637
18.903333, -0.841184
18.906667, -0.841158
18.91, -0.840634
18.913333, -0.839951
18.916667, -0.83929
18.92, -0.838681
18.923333, -0.838283
18.926667, -0.838274
18.93, -0.838593
18.933333, -0.839016
18.936667, -0.839335
18.94, -0.839515
18.943333, -0.839823
18.946667, -0.840771
18.95, -0.842795
18.953333, -0.845885
18.956667, -0.849604
18.96, -0.853314
18.963333, -0.856469
18.966667, -0.858989
18.97, -0.861149
18.973333, -0.862963
18.976667, -0.864188
18.98, -0.86483
18.983333, -0.865113
18.986667, -0.865107
18.99, -0.864626
18.993333, -0.863358
18.996667, -0.86122
19.0, -0.858627
19.003333, -0.856206
19.006667, -0.854383
19.01, -0.853328
19.013333, -0.853059
19.016667, -0.853409
19.02, -0.854001
19.023333, -0.854591
19.026667, -0.85536
19.03, -0.85648
19.033333, -0.857769
19.036667, -0.859012
19.04, -0.860178
19.043333, -0.861278
19.046667, -0.862325
19.05, -0.863489
19.053333, -0.865052
19.056667, -0.867021
19.06, -0.868904
19.063333, -0.870165
19.066667, -0.870895
19.07, -0.871583
19.073333, -0.872389
19.076667, -0.87316
19.08, -0.873808
19.083333, -0.874411
19.086667, -0.8752
19.09, -0.876403
19.093333, -0.877971
19.096667, -0.879625
19.1, -0.881296
19.103333, -0.883273
19.106667, -0.885732
19.11, -0.888412
19.113333, -0.890843
19.116667, -0.892733
19.12, -0.894149
19.123333, -0.89536
19.126667, -0.896643
19.13, -0.898191
19.133333, -0.900021
19.136667, -0.90213
19.14, -0.904811
19.143333, -0.908501
19.146667, -0.91325
19.15, -0.918578
19.153333, -0.923783
19.156667, -0.928292
19.16, -0.932004
19.163333, -0.935333
19.166667, -0.938662
19.17, -0.941747
19.173333, -0.943923
19.176667, -0.945029
19.18, -0.945613
19.183333, -0.946252
19.186667, -0.947395
19.19, -0.949498
19.193333, -0.952597
19.196667, -0.956027
19.2, -0.958928
19.203333, -0.961035
19.206667, -0.962807
19.21, -0.964847
19.213333, -0.967467
19.216667, -0.970683
19.22, -0.974287
19.223333, -0.978013
19.226667, -0.981744
19.23, -0.985434
19.233333, -0.988871
19.236667, -0.991728
19.24, -0.993963
19.243333, -0.995925
19.246667, -0.997922
19.25, -1.000022
19.253333, -1.002229
19.256667, -1.004493
19.26, -1.00673
19.263333, -1.008891
19.266667, -1.010917
19.27, -1.012745
19.273333, -1.01431
19.276667, -1.015578
19.28, -1.01673
19.283333, -1.018185
19.286667, -1.020263
19.29, -1.022842
19.293333, -1.025375
19.296667, -1.027333
19.3, -1.028608
19.303333, -1.029356
19.306667, -1.029637
19.31, -1.029535
19.313333, -1.029407
19.316667, -1.029472
19.32, -1.02934
19.323333, -1.028422
19.326667, -1.026543
19.33, -1.02392
19.333333, -1.020897
19.336667, -1.017844
19.34, -1.014986
19.343333, -1.012313
19.346667, -1.009672
19.35, -1.006872
19.353333, -1.003913
19.356667, -1.001187
19.36, -0.999248
19.363333, -0.99821
19.366667, -0.997553
19.37, -0.996697
19.373333, -0.995514
19.376667, -0.994121
19.38, -0.9925
19.383333, -0.990555
19.386667, -0.988253
19.39, -0.985469
19.393333, -0.981923
19.396667, -0.977308
19.4, -0.971587
19.403333, -0.965367
19.406667, -0.959802
19.41, -0.955898
19.413333, -0.953839
19.416667, -0.95303
19.42, -0.952784
19.423333, -0.952764
19.426667, -0.952735
19.43, -0.952557
19.433333, -0.952537
19.436667, -0.953166
19.44, -0.954592
19.443333, -0.95654
19.446667, -0.958403
19.45, -0.959567
19.453333, -0.959853
19.456667, -0.95956
19.46, -0.959223
19.463333, -0.95921
19.466667, -0.959441
19.47, -0.959613
19.473333, -0.959482
19.476667, -0.958865
19.48, -0.957707
19.483333, -0.956215
19.486667, -0.954738
19.49, -0.953492
19.493333, -0.952613
19.496667, -0.952337
19.5, -0.952854
19.503333, -0.954163
19.506667, -0.95625
19.51, -0.95925
19.513333, -0.963206
19.516667, -0.967719
19.52, -0.972169
19.523333, -0.976111
19.526667, -0.979013
19.53, -0.980308
19.533333, -0.980216
19.536667, -0.979833
19.54, -0.980172
19.543333, -0.981415
19.546667, -0.982992
19.55, -0.984244
19.553333, -0.984925
19.556667, -0.98503
19.56, -0.98448
19.563333, -0.983269
19.566667, -0.981732
19.57, -0.980505
19.573333, -0.980121
19.576667, -0.980651
19.58, -0.981872
19.583333, -0.983732
19.586667, -0.986278
19.59, -0.989252
19.593333, -0.992074
19.596667, -0.994234
19.6, -0.995673
19.603333, -0.996745
19.606667, -0.997728
19.61, -0.998675
19.613333, -0.999723
19.616667, -1.00099
19.62, -1.00226
19.623333, -1.003295
19.626667, -1.00433
19.63, -1.005839
19.633333, -1.007785
19.636667, -1.009632
19.64, -1.011389
19.643333, -1.013884
19.646667, -1.017471
19.65, -1.021326
19.653333, -1.024532
19.656667, -1.02706
19.66, -1.029511
19.663333, -1.032515
19.666667, -1.036299
19.67, -1.040532
19.673333, -1.044705
19.676667, -1.048494
19.68, -1.051734
19.683333, -1.054531
19.686667, -1.057329
19.69, -1.060474
19.693333, -1.063975
19.696667, -1.067674
19.7, -1.071218
19.703333, -1.074147
19.706667, -1.076452
19.71, -1.078791
19.713333, -1.081943
19.716667, -1.086039
19.72, -1.090359
19.723333, -1.093832
19.726667, -1.095664
19.73, -1.095728
19.733333, -1.094605
19.736667, -1.093099
19.74, -1.091783
19.743333, -1.091101
19.746667, -1.091527
19.75, -1.093414
19.753333, -1.096858
19.756667, -1.101685
19.76, -1.10734
19.763333, -1.112866
19.766667, -1.117288
19.77, -1.120244
19.773333, -1.122188
19.776667, -1.123956
19.78, -1.126279
19.783333, -1.129466
19.786667, -1.133115
19.79, -1.136386
19.793333, -1.13878
19.796667, -1.140442
19.8, -1.141726
19.803333, -1.142729
19.806667, -1.143191
19.81, -1.142746
19.813333, -1.141415
19.816667, -1.139876
19.82, -1.138991
19.823333, -1.139017
19.826667, -1.13945
19.83, -1.13968
19.833333, -1.139652
19.836667, -1.139891
19.84, -1.141167
19.843333, -1.143961
19.846667, -1.147998
19.85, -1.152361
19.853333, -1.156059
19.856667, -1.158409
19.86, -1.158991
19.863333, -1.157635
19.866667, -1.154568
19.87, -1.150383
19.873333, -1.145769
19.876667, -1.141238
19.88, -1.137061
19.883333, -1.133342
19.886667, -1.130059
19.89, -1.127139
19.893333, -1.124509
19.896667, -1.121923
19.9, -1.118941
19.903333, -1.115304
19.906667, -1.111207
19.91, -1.107059
19.913333, -1.103192
19.916667, -1.09995
19.92, -1.097587
19.923333, -1.095916
19.926667, -1.094308
19.93, -1.092119
19.933333, -1.089228
19.936667, -1.086007
19.94, -1.082648
19.943333, -1.079077
19.946667, -1.075362
19.95, -1.071516
19.953333, -1.067391
19.956667, -1.062968
19.96, -1.058332
19.963333, -1.053633
19.966667, -1.049202
19.97, -1.045355
19.973333, -1.042181
19.976667, -1.039734
19.98, -1.038132
19.983333, -1.037373
19.986667, -1.037302
19.99, -1.037898
19.993333, -1.039318
19.996667, -1.041447
20.0, -1.043762
20.003333, -1.045903
20.006667, -1.047864
20.01, -1.049561
20.013333, -1.050795
20.016667, -1.051523
20.02, -1.051827
20.023333, -1.051793
20.026667, -1.051446
20.03, -1.050817
20.033333, -1.050125
20.036667, -1.049683
20.04, -1.049741
20.043333, -1.050523
20.046667, -1.051983
20.05, -1.053613
20.053333, -1.054902
20.056667, -1.055817
20.06, -1.056822
20.063333, -1.058755
20.066667, -1.062335
20.07, -1.067454
20.073333, -1.073177
20.076667, -1.078497
20.08, -1.082848
20.083333, -1.086024
20.086667, -1.08796
20.09, -1.088735
20.093333, -1.088631
20.096667, -1.08795
20.1, -1.086872
20.103333, -1.0857
20.106667, -1.08492
20.11, -1.08466
20.113333, -1.084469
20.116667, -1.083861
20.12, -1.082653
20.123333, -1.080942
20.126667, -1.079088
20.13, -1.077382
20.133333, -1.075791
20.136667, -1.074355
20.14, -1.073393
20.143333, -1.072958
20.146667, -1.072696
20.15, -1.072541
20.153333, -1.072788
20.156667, -1.073258
20.16, -1.073297
20.163333, -1.072844
20.166667, -1.072673
20.17, -1.073355
20.173333, -1.074609
20.176667, -1.075665
20.18, -1.075917
20.183333, -1.07542
20.186667, -1.074819
20.19, -1.074671
20.193333, -1.074947
20.196667, -1.075137
20.2, -1.074791
20.203333, -1.073983
20.206667, -1.073183
20.21, -1.07273
20.213333, -1.072584
20.216667, -1.072517
20.22, -1.072389
20.223333, -1.072387
20.226667, -1.072941
20.23, -1.074099
20.233333, -1.075196
20.236667, -1.075426
20.24, -1.074652
20.243333, -1.073524
20.246667, -1.072998
20.25, -1.073803
20.253333, -1.075961
20.256667, -1.078682
20.26, -1.081028
20.263333, -1.082501
20.266667, -1.082859
20.27, -1.081901
20.273333, -1.079834
20.276667, -1.077551
20.28, -1.076051
20.283333, -1.075534
20.286667, -1.075297
20.29, -1.074507
20.293333, -1.072877
20.296667, -1.07075
20.3, -1.068896
20.303333, -1.06804
20.306667, -1.068425
20.31, -1.069842
20.313333, -1.071745
20.316667, -1.073357
20.32, -1.074185
20.323333, -1.074583
20.326667, -1.07553
20.33, -1.077576
20.333333, -1.080261
20.336667, -1.082709
20.34, -1.084385
20.343333, -1.085172
20.346667, -1.08529
20.35, -1.085345
20.353333, -1.086003
20.356667, -1.08736
20.36, -1.088879
20.363333, -1.090057
20.366667, -1.090921
20.37, -1.091618
20.373333, -1.091886
20.376667, -1.091326
20.38, -1.089989
20.383333, -1.088509
20.386667, -1.087687
20.39, -1.087832
20.393333, -1.088526
20.396667, -1.08928
20.4, -1.090105
20.403333, -1.091183
20.406667, -1.0925
20.41, -1.094062
20.413333, -1.095956
20.416667, -1.097984
20.42, -1.099509
20.423333, -1.099936
20.426667, -1.09917
20.43, -1.097454
20.433333, -1.09504
20.436667, -1.092087
20.44, -1.088653
20.443333, -1.084816
20.446667, -1.080845
20.45, -1.077181
20.453333, -1.074278
20.456667, -1.072319
20.46, -1.070841
20.463333, -1.069055
20.466667, -1.066561
20.47, -1.06348
20.473333, -1.060199
20.476667, -1.057303
20.48, -1.055415
20.483333, -1.054836
20.486667, -1.055329
20.49, -1.056152
20.493333, -1.056355
20.496667, -1.055338
20.5, -1.053253
20.503333, -1.050857
20.506667, -1.048753
20.51, -1.04677
20.513333, -1.044293
20.516667, -1.040977
20.52, -1.037038
20.523333, -1.033064
20.526667, -1.02956
20.53, -1.026695
20.533333, -1.024445
20.536667, -1.022797
20.54, -1.021714
20.543333, -1.020968
20.546667, -1.020163
20.55, -1.019042
20.553333, -1.017811
20.556667, -1.016958
20.56, -1.01662
20.563333, -1.01647
20.566667, -1.016238
20.57, -1.015843
20.573333, -1.015137
20.576667, -1.01405
20.58, -1.012768
20.583333, -1.011512
20.586667, -1.010416
20.59, -1.0096
20.593333, -1.009198
20.596667, -1.009441
20.6, -1.010527
20.603333, -1.012191
20.606667, -1.013691
20.61, -1.014491
20.613333, -1.014725
20.616667, -1.014895
20.62, -1.015463
20.623333, -1.016722
20.626667, -1.018614
20.63, -1.020692
20.633333, -1.022365
20.636667, -1.023196
20.64, -1.023192
20.643333, -1.022982
20.646667, -1.023342
20.65, -1.024306
20.653333, -1.025166
20.656667, -1.025477
20.66, -1.025588
20.663333, -1.026156
20.666667, -1.027574
20.67, -1.029845
20.673333, -1.032622
20.676667, -1.03522
20.68, -1.037
20.683333, -1.038005
20.686667, -1.038951
20.69, -1.040382
20.693333, -1.042069
20.696667, -1.04343
20.7, -1.044274
20.703333, -1.044788
20.706667, -1.045176
20.71, -1.04563
20.713333, -1.046369
20.716667, -1.047546
20.72, -1.049047
20.723333, -1.050486
20.726667, -1.05155
20.73, -1.052311
20.733333, -1.053237
20.736667, -1.054885
20.74, -1.057523
20.743333, -1.060938
20.746667, -1.064514
20.75, -1.067617
20.753333, -1.069876
20.756667, -1.071217
20.76, -1.071838
20.763333, -1.072127
20.766667, -1.07263
20.77, -1.073982
20.773333, -1.076584
20.776667, -1.080299
20.78, -1.084473
20.783333, -1.088382
20.786667, -1.091885
20.79, -1.095426
20.793333, -1.099184
20.796667, -1.102597
20.8, -1.104909
20.803333, -1.106072
20.806667, -1.106993
20.81, -1.108707
20.813333, -1.111442
20.816667, -1.11468
20.82, -1.117868
20.823333, -1.120905
20.826667, -1.124103
20.83, -1.127714
20.833333, -1.131538
20.836667, -1.135082
20.84, -1.138001
20.843333, -1.140317
20.846667, -1.142198
20.85, -1.143585
20.853333, -1.144252
20.856667, -1.144187
20.86, -1.143779
20.863333, -1.143767
20.866667, -1.144894
20.87, -1.147395
20.873333, -1.150914
20.876667, -1.154769
20.88, -1.158148
20.883333, -1.160517
20.886667, -1.162044
20.89, -1.163292
20.893333, -1.164608
20.896667, -1.166062
20.9, -1.167558
20.903333, -1.168802
20.906667, -1.169549
20.91, -1.169815
20.913333, -1.169745
20.916667, -1.169572
20.92, -1.169617
20.923333, -1.170086
20.926667, -1.170988
20.93, -1.172171
20.933333, -1.173174
20.936667, -1.173389
20.94, -1.172702
20.943333, -1.17167
20.946667, -1.170962
20.95, -1.170962
20.953333, -1.171869
20.956667, -1.173779
20.96, -1.176589
20.963333, -1.179939
20.966667, -1.183254
20.97, -1.185925
20.973333, -1.187579
20.976667, -1.188128
20.98, -1.187484
20.983333, -1.185246
20.986667, -1.181039
20.99, -1.175185
20.993333, -1.168573
20.996667, -1.16195
21.0, -1.155811
21.003333, -1.150647
21.006667, -1.146655
21.01, -1.143366
21.013333, -1.14006
21.016667, -1.13645
21.02, -1.132756
21.023333, -1.129302
21.026667, -1.12619
21.03, -1.123175
21.033333, -1.119722
21.036667, -1.11544
21.04, -1.110449
21.043333, -1.105145
21.046667, -1.099881
21.05, -1.095117
21.053333, -1.091441
21.056667, -1.08907
21.06, -1.087456
21.063333, -1.085436
21.066667, -1.081757
21.07, -1.07582
21.073333, -1.068095
21.076667, -1.059681
21.08, -1.051441
21.083333, -1.043772
21.086667, -1.037067
21.09, -1.031898
21.093333, -1.028499
21.096667, -1.026458
21.1, -1.025204
21.103333, -1.024507
21.106667, -1.024357
21.11, -1.024759
21.113333, -1.025651
21.116667, -1.026787
21.12, -1.027706
21.123333, -1.027965
21.126667, -1.027486
21.13, -1.02658
21.133333, -1.025663
21.136667, -1.025099
21.14, -1.025044
21.143333, -1.025286
21.146667, -1.025498
21.15, -1.025479
21.153333, -1.025038
21.156667, -1.023977
21.16, -1.022347
21.163333, -1.020575
21.166667, -1.019139
21.17, -1.018308
21.173333, -1.018331
21.176667, -1.019439
21.18, -1.021604
21.183333, -1.024602
21.186667, -1.028038
21.19, -1.031364
21.193333, -1.034101
21.196667, -1.035821
21.2, -1.036149
21.203333, -1.035079
21.206667, -1.033081
21.21, -1.030764
21.213333, -1.028493
21.216667, -1.026438
21.22, -1.024865
21.223333, -1.024001
21.226667, -1.023787
21.23, -1.024031
21.233333, -1.024539
21.236667, -1.025031
21.24, -1.02516
21.243333, -1.024791
21.246667, -1.024172
21.25, -1.023681
21.253333, -1.023429
21.256667, -1.02332
21.26, -1.023266
21.263333, -1.023222
21.266667, -1.023182
21.27, -1.023219
21.273333, -1.023404
21.276667, -1.023635
21.28, -1.02392
21.283333, -1.024663
21.286667, -1.026189
21.29, -1.028434
21.293333, -1.031227
21.296667, -1.034368
21.3, -1.037537
21.303333, -1.040521
21.306667, -1.043403
21.31, -1.046285
21.313333, -1.049035
21.316667, -1.05141
21.32, -1.053229
21.323333, -1.054599
21.326667, -1.056042
21.33, -1.058147
21.333333, -1.061052
21.336667, -1.064381
21.34, -1.067716
21.343333, -1.070907
21.346667, -1.073863
21.35, -1.076498
21.353333, -1.079061
21.356667, -1.082061
21.36, -1.085756
21.363333, -1.089796
21.366667, -1.093479
21.37, -1.096461
21.373333, -1.099063
21.376667, -1.10188
21.38, -1.105249
21.383333, -1.109014
21.386667, -1.112777
21.39, -1.11648
21.393333, -1.120458
21.396667, -1.124849
21.4, -1.129135
21.403333, -1.132346
21.406667, -1.133921
21.41, -1.134178
21.413333, -1.133825
21.416667, -1.133467
21.42, -1.133633
21.423333, -1.134691
21.426667, -1.13658
21.43, -1.138925
21.433333, -1.141531
21.436667, -1.144492
21.44, -1.147858
21.443333, -1.151452
21.446667, -1.155073
21.45, -1.158595
21.453333, -1.161688
21.456667, -1.16388
21.46, -1.165178
21.463333, -1.166136
21.466667, -1.167181
21.47, -1.168245
21.473333, -1.169079
21.476667, -1.169737
21.48, -1.17066
21.483333, -1.172264
21.486667, -1.174588
21.49, -1.177231
21.493333, -1.179516
21.496667, -1.180878
21.5, -1.181247
21.503333, -1.181032
21.506667, -1.180729
21.51, -1.180679
21.513333, -1.181295
21.516667, -1.183137
21.52, -1.186469
21.523333, -1.190821
21.526667, -1.195055
21.53, -1.19791
21.533333, -1.198487
21.536667, -1.196604
21.54, -1.193074
21.543333, -1.189268
21.546667, -1.18613
21.55, -1.183693
21.553333, -1.181361
21.556667, -1.178488
21.56, -1.174901
21.563333, -1.171092
21.566667, -1.167668
21.57, -1.164634
21.573333, -1.16165
21.576667, -1.158627
21.58, -1.155689
21.583333, -1.152919
21.586667, -1.150314
21.59, -1.147805
21.593333, -1.145328
21.596667, -1.142826
21.6, -1.140152
21.603333, -1.137147
21.606667, -1.133823
21.61, -1.130394
21.613333, -1.127135
21.616667, -1.124118
21.62, -1.121137
21.623333, -1.117959
21.626667, -1.114521
21.63, -1.110935
21.633333, -1.107288
21.636667, -1.103507
21.64, -1.099474
21.643333, -1.095196
21.646667, -1.090929
21.65, -1.087181
21.653333, -1.084413
21.656667, -1.082825
21.66, -1.082487
21.663333, -1.083329
21.666667, -1.08488
21.67, -1.086413
21.673333, -1.087537
21.676667, -1.088346
21.68, -1.088936
21.683333, -1.089175
21.686667, -1.089006
21.69, -1.088663
21.693333, -1.08855
21.696667, -1.088976
21.7, -1.089976
21.703333, -1.091328
21.706667, -1.092707
21.71, -1.093851
21.713333, -1.094756
21.716667, -1.095704
21.72, -1.097027
21.723333, -1.098946
21.726667, -1.10152
21.73, -1.104555
21.733333, -1.107766
21.736667, -1.111085
21.74, -1.114728
21.743333, -1.119108
21.746667, -1.124597
21.75, -1.131067
21.753333, -1.137597
21.756667, -1.142895
21.76, -1.146182
21.763333, -1.147615
21.766667, -1.147914
21.77, -1.147881
21.773333, -1.14813
21.776667, -1.148883
21.78, -1.149999
21.783333, -1.151384
21.786667, -1.153206
21.79, -1.155608
21.793333, -1.158442
21.796667, -1.161427
21.8, -1.16444
21.803333, -1.167512
21.806667, -1.170612
21.81, -1.173655
21.813333, -1.176656
21.816667, -1.179765
21.82, -1.183197
21.823333, -1.187099
21.826667, -1.191385
21.83, -1.195679
21.833333, -1.199552
21.836667, -1.202809
21.84, -1.205499
21.843333, -1.207741
21.846667, -1.209713
21.85, -1.211731
21.853333, -1.214146
21.856667, -1.216988
21.86, -1.219861
21.863333, -1.222477
21.866667, -1.2251
21.87, -1.228219
21.873333, -1.231905
21.876667, -1.235555
21.88, -1.238383
21.883333, -1.240163
21.886667, -1.241432
21.89, -1.242853
21.893333, -1.244571
21.896667, -1.246397
21.9, -1.24819
21.903333, -1.249793
21.906667, -1.251032
21.91, -1.251919
21.913333, -1.252595
21.916667, -1.253145
21.92, -1.253668
21.923333, -1.254227
21.926667, -1.254567
21.93, -1.254268
21.933333, -1.253277
21.936667, -1.252018
21.94, -1.250954
21.943333, -1.250258
21.946667, -1.249824
21.95, -1.24938
21.953333, -1.248683
21.956667, -1.247544
21.96, -1.245622
21.963333, -1.242535
21.966667, -1.238281
21.97, -1.233441
21.973333, -1.228915
21.976667, -1.22537
21.98, -1.222971
21.983333, -1.221609
21.986667, -1.221088
21.99, -1.221033
21.993333, -1.220955
21.996667, -1.220457
22.0, -1.219441
22.003333, -1.218262
22.006667, -1.21751
22.01, -1.217549
22.013333, -1.218222
22.016667, -1.218863
22.02, -1.21875
22.023333, -1.217692
22.026667, -1.216183
22.03, -1.214948
22.033333, -1.214247
22.036667, -1.213656
22.04, -1.212662
22.043333, -1.211236
22.046667, -1.209659
22.05, -1.208173
22.053333, -1.206891
22.056667, -1.20573
22.06, -1.204527
22.063333, -1.203401
22.066667, -1.202829
22.07, -1.203362
22.073333, -1.20527
22.076667, -1.208307
22.08, -1.211733
22.083333, -1.2147
22.086667, -1.216715
22.09, -1.217639
22.093333, -1.217414
22.096667, -1.216105
22.1, -1.21413
22.103333, -1.212021
22.106667, -1.209982
22.11, -1.207905
22.113333, -1.205728
22.116667, -1.203614
22.12, -1.201714
22.123333, -1.199872
22.126667, -1.197792
22.13, -1.195443
22.133333, -1.193225
22.136667, -1.191633
22.14, -1.190838
22.143333, -1.190634
22.146667, -1.190556
22.15, -1.190072
22.153333, -1.188985
22.156667, -1.187577
22.16, -1.186285
22.163333, -1.185267
22.166667, -1.184227
22.17, -1.182712
22.173333, -1.180612
22.176667, -1.178204
22.18, -1.175643
22.183333, -1.172693
22.186667, -1.169215
22.19, -1.165443
22.193333, -1.161558
22.196667, -1.157508
22.2, -1.153476
22.203333, -1.150111
22.206667, -1.147905
22.21, -1.146508
22.213333, -1.145083
22.216667, -1.14322
22.22, -1.141195
22.223333, -1.139444
22.226667, -1.13806
22.23, -1.1368
22.233333, -1.135446
22.236667, -1.133852
22.24, -1.131636
22.243333, -1.128238
22.246667, -1.123587
22.25, -1.118507
22.253333, -1.11412
22.256667, -1.110992
22.26, -1.109099
22.263333, -1.108052
22.266667, -1.107045
22.27, -1.105179
22.273333, -1.102132
22.276667, -1.098304
22.28, -1.094384
22.283333, -1.090913
22.286667, -1.08819
22.29, -1.086301
22.293333, -1.085194
22.296667, -1.08493
22.3, -1.085592
22.303333, -1.0868
22.306667, -1.087774
22.31, -1.087811
22.313333, -1.086448
22.316667, -1.083514
22.32, -1.079258
22.323333, -1.074244
22.326667, -1.069115
22.33, -1.0643
22.333333, -1.059763
22.336667, -1.055095
22.34, -1.049856
22.343333, -1.043939
22.346667, -1.037835
22.35, -1.032306
22.353333, -1.027718
22.356667, -1.02395
22.36, -1.020836
22.363333, -1.01841
22.366667, -1.016655
22.37, -1.015175
22.373333, -1.01323
22.376667, -1.01029
22.38, -1.006511
22.383333, -1.002441
22.386667, -0.998632
22.39, -0.995621
22.393333, -0.993798
22.396667, -0.993164
22.4, -0.993346
22.403333, -0.993909
22.406667, -0.994569
22.41, -0.994903
22.413333, -0.994289
22.416667, -0.99247
22.42, -0.989799
22.423333, -0.9869
22.426667, -0.984442
22.43, -0.982991
22.433333, -0.982786
22.436667, -0.983676
22.44, -0.985213
22.443333, -0.986849
22.446667, -0.988145
22.45, -0.989038
22.453333, -0.989845
22.456667, -0.990647
22.46, -0.991014
22.463333, -0.990703
22.466667, -0.990197
22.47, -0.990384
22.473333, -0.991816
22.476667, -0.994337
22.48, -0.997336
22.483333, -1.000106
22.486667, -1.00206
22.49, -1.003038
22.493333, -1.003403
22.496667, -1.003792
22.5, -1.004773
22.503333, -1.006566
22.506667, -1.008942
22.51, -1.011392
22.513333, -1.01341
22.516667, -1.014691
22.52, -1.015215
22.523333, -1.015237
22.526667, -1.015149
22.53, -1.015212
22.533333, -1.015383
22.536667, -1.01547
22.54, -1.015577
22.543333, -1.016339
22.546667, -1.018552
22.55, -1.022541
22.553333, -1.02794
22.556667, -1.033896
22.56, -1.039481
22.563333, -1.044042
22.566667, -1.047395
22.57, -1.049855
22.573333, -1.05209
22.576667, -1.054806
22.58, -1.058364
22.583333, -1.062538
22.586667, -1.06675
22.59, -1.070649
22.593333, -1.074408
22.596667, -1.078485
22.6, -1.083257
22.603333, -1.088816
22.606667, -1.094783
22.61, -1.100339
22.613333, -1.104801
22.616667, -1.108207
22.62, -1.111081
22.623333, -1.11397
22.626667, -1.117614
22.63, -1.123026
22.633333, -1.130797
22.636667, -1.140529
22.64, -1.151068
22.643333, -1.161009
22.646667, -1.169166
22.65, -1.175137
22.653333, -1.179361
22.656667, -1.182541
22.66, -1.18518
22.663333, -1.18748
22.666667, -1.189431
22.67, -1.190955
22.673333, -1.192065
22.676667, -1.193004
22.68, -1.194104
22.683333, -1.195599
22.686667, -1.197558
22.69, -1.199884
22.693333, -1.202348
22.696667, -1.204726
22.7, -1.206978
22.703333, -1.209262
22.706667, -1.211769
22.71, -1.214602
22.713333, -1.217697
22.716667, -1.220767
22.72, -1.223499
22.723333, -1.22589
22.726667, -1.228185
22.73, -1.230469
22.733333, -1.232501
22.736667, -1.233768
22.74, -1.233611
22.743333, -1.231646
22.746667, -1.228276
22.75, -1.224537
22.753333, -1.221547
22.756667, -1.220187
22.76, -1.220828
22.763333, -1.223151
22.766667, -1.22641
22.77, -1.229754
22.773333, -1.232361
22.776667, -1.233823
22.78, -1.234399
22.783333, -1.23463
22.786667, -1.234942
22.79, -1.235642
22.793333, -1.236948
22.796667, -1.238837
22.8, -1.240884
22.803333, -1.242268
22.806667, -1.242218
22.81, -1.240739
22.813333, -1.238597
22.816667, -1.236572
22.82, -1.235167
22.823333, -1.234735
22.826667, -1.235165
22.83, -1.235645
22.833333, -1.235282
22.836667, -1.233835
22.84, -1.231614
22.843333, -1.229064
22.846667, -1.226707
22.85, -1.225185
22.853333, -1.225124
22.856667, -1.226724
22.86, -1.22932
22.863333, -1.231659
22.866667, -1.232803
22.87, -1.232654
22.873333, -1.231612
22.876667, -1.229927
22.88, -1.227483
22.883333, -1.224141
22.886667, -1.220095
22.89, -1.21584
22.893333, -1.21188
22.896667, -1.208401
22.9, -1.205163
22.903333, -1.201845
22.906667, -1.198303
22.91, -1.194431
22.913333, -1.190255
22.916667, -1.186088
22.92, -1.182311
22.923333, -1.179103
22.926667, -1.176323
22.93, -1.173659
22.933333, -1.170938
22.936667, -1.168244
22.94, -1.165876
22.943333, -1.164119
22.946667, -1.162989
22.95, -1.162321
22.953333, -1.161985
22.956667, -1.161827
22.96, -1.161474
22.963333, -1.16034
22.966667, -1.1581
22.97, -1.155211
22.973333, -1.152647
22.976667, -1.151101
22.98, -1.150693
22.983333, -1.151099
22.986667, -1.151531
22.99, -1.15098
22.993333, -1.148998
22.996667, -1.146152
23.0, -1.143695
23.003333, -1.14266
23.006667, -1.142965
23.01, -1.143601
23.013333, -1.143628
23.016667, -1.142615
23.02, -1.140585
23.023333, -1.138131
23.026667, -1.136188
23.03, -1.135159
23.033333, -1.134589
23.036667, -1.134001
23.04, -1.133423
23.043333, -1.132971
23.046667, -1.132663
23.05, -1.132718
23.053333, -1.133405
23.056667, -1.134499
23.06, -1.135345
23.063333, -1.135541
23.066667, -1.135224
23.07, -1.134603
23.073333, -1.133398
23.076667, -1.13096
23.08, -1.127034
23.083333, -1.122254
23.086667, -1.117682
23.09, -1.11395
23.093333, -1.111159
23.096667, -1.109451
23.1, -1.109072
23.103333, -1.109901
23.106667, -1.111563
23.11, -1.113855
23.113333, -1.116653
23.116667, -1.119661
23.12, -1.122412
23.123333, -1.124481
23.126667, -1.125748
23.13, -1.126257
23.133333, -1.125935
23.136667, -1.124811
23.14, -1.123362
23.143333, -1.122264
23.146667, -1.121757
23.15, -1.121495
23.153333, -1.121174
23.156667, -1.121003
23.16, -1.121317
23.163333, -1.122038
23.166667, -1.122596
23.17, -1.122294
23.173333, -1.12104
23.176667, -1.119538
23.18, -1.118591
23.183333, -1.118712
23.186667, -1.1204
23.19, -1.12411
23.193333, -1.129669
23.196667, -1.13595
23.2, -1.141453
23.203333, -1.145293
23.206667, -1.14736
23.21, -1.147705
23.213333, -1.146226
23.216667, -1.142936
23.22, -1.138328
23.223333, -1.133332
23.226667, -1.128813
23.23, -1.125185
23.233333, -1.12243
23.236667, -1.120203
23.24, -1.11798
23.243333, -1.115427
23.246667, -1.112637
23.25, -1.110016
23.253333, -1.108016
23.256667, -1.10686
23.26, -1.106288
23.263333, -1.10545
23.266667, -1.103433
23.27, -1.100214
23.273333, -1.096725
23.276667, -1.093983
23.28, -1.092447
23.283333, -1.091848
23.286667, -1.091481
23.29, -1.090738
23.293333, -1.089274
23.296667, -1.086797
23.3, -1.082838
23.303333, -1.076974
23.306667, -1.069475
23.31, -1.06138
23.313333, -1.053823
23.316667, -1.04759
23.32, -1.043171
23.323333, -1.04082
23.326667, -1.040489
23.33, -1.041723
23.333333, -1.043638
23.336667, -1.045104
23.34, -1.045225
23.343333, -1.043825
23.346667, -1.041358
23.35, -1.03828
23.353333, -1.034741
23.356667, -1.030882
23.36, -1.027175
23.363333, -1.024313
23.366667, -1.022557
23.37, -1.021323
23.373333, -1.019785
23.376667, -1.017622
23.38, -1.01492
23.383333, -1.011784
23.386667, -1.008406
23.39, -1.005147
23.393333, -1.002214
23.396667, -0.999475
23.4, -0.996626
23.403333, -0.99329
23.406667, -0.989426
23.41, -0.985878
23.413333, -0.983959
23.416667, -0.984307
23.42, -0.986302
23.423333, -0.988472
23.426667, -0.989526
23.43, -0.988972
23.433333, -0.98677
23.436667, -0.983013
23.44, -0.978122
23.443333, -0.972669
23.446667, -0.966926
23.45, -0.96088
23.453333, -0.954478
23.456667, -0.947902
23.46, -0.941784
23.463333, -0.936789
23.466667, -0.933005
23.47, -0.930087
23.473333, -0.927685
23.476667, -0.925564
23.48, -0.923594
23.483333, -0.921633
23.486667, -0.91942
23.49, -0.916799
23.493333, -0.914044
23.496667, -0.911695
23.5, -0.910088
23.503333, -0.909091
23.506667, -0.908179
23.51, -0.906779
23.513333, -0.904657
23.516667, -0.902067
23.52, -0.899524
23.523333, -0.897473
23.526667, -0.896178
23.53, -0.895646
23.533333, -0.895628
23.536667, -0.895861
23.54, -0.896209
23.543333, -0.896504
23.546667, -0.896479
23.55, -0.896014
23.553333, -0.895273
23.556667, -0.89451
23.56, -0.893961
23.563333, -0.893971
23.566667, -0.894889
23.57, -0.896708
23.573333, -0.898922
23.576667, -0.900881
23.58, -0.902192
23.583333, -0.902785
23.586667, -0.902906
23.59, -0.903068
23.593333, -0.903767
23.596667, -0.905195
23.6, -0.907096
23.603333, -0.908907
23.606667, -0.910235
23.61, -0.911117
23.613333, -0.911858
23.616667, -0.912726
23.62, -0.913564
23.623333, -0.913782
23.626667, -0.913023
23.63, -0.91163
23.633333, -0.910302
23.636667, -0.909486
23.64, -0.909281
23.643333, -0.90977
23.646667, -0.911179
23.65, -0.913618
23.653333, -0.916722
23.656667, -0.919809
23.66, -0.922395
23.663333, -0.924324
23.666667, -0.925689
23.67, -0.926818
23.673333, -0.92798
23.676667, -0.929111
23.68, -0.930043
23.683333, -0.930789
23.686667, -0.931554
23.69, -0.932644
23.693333, -0.934283
23.696667, -0.936411
23.7, -0.938698
23.703333, -0.940761
23.706667, -0.942444
23.71, -0.943998
23.713333, -0.945829
23.716667, -0.948098
23.72, -0.950744
23.723333, -0.953689
23.726667, -0.956738
23.73, -0.959572
23.733333, -0.961992
23.736667, -0.964004
23.74, -0.965862
23.743333, -0.968058
23.746667, -0.971056
23.75, -0.974972
23.753333, -0.979492
23.756667, -0.98418
23.76, -0.988705
23.763333, -0.992568
23.766667, -0.99523
23.77, -0.996796
23.773333, -0.997937
23.776667, -0.999036
23.78, -0.999971
23.783333, -1.000579
23.786667, -1.000918
23.79, -1.001148
23.793333, -1.001279
23.796667, -1.001046
23.8, -1.000197
23.803333, -0.998896
23.806667, -0.997616
23.81, -0.996727
23.813333, -0.996422
23.816667, -0.996843
23.82, -0.997942
23.823333, -0.999426
23.826667, -1.000982
23.83, -1.002398
23.833333, -1.003586
23.836667, -1.004582
23.84, -1.005405
23.843333, -1.00601
23.846667, -1.006484
23.85, -1.007083
23.853333, -1.00782
23.856667, -1.008345
23.86, -1.008376
23.863333, -1.007948
23.866667, -1.00724
23.87, -1.006366
23.873333, -1.005388
23.876667, -1.004397
23.88, -1.003525
23.883333, -1.002962
23.886667, -1.002877
23.89, -1.003126
23.893333, -1.003277
23.896667, -1.003084
23.9, -1.002631
23.903333, -1.001998
23.906667, -1.001164
23.91, -1.000231
23.913333, -0.999429
23.916667, -0.99895
23.92, -0.99871
23.923333, -0.998185
23.926667, -0.996824
23.93, -0.994636
23.933333, -0.99214
23.936667, -0.990034
23.94, -0.988867
23.943333, -0.988647
23.946667, -0.988783
23.95, -0.988478
23.953333, -0.987264
23.956667, -0.985281
23.96, -0.983022
23.963333, -0.98076
23.966667, -0.978327
23.97, -0.97539
23.973333, -0.971771
23.976667, -0.967665
23.98, -0.963669
23.983333, -0.960437
23.986667, -0.958181
23.99, -0.956749
23.993333, -0.956064
23.996667, -0.956204
24.0, -0.957213
24.003333, -0.958977
24.006667, -0.961141
24.01, -0.963169
24.013333, -0.964539
24.016667, -0.964895
24.02, -0.964187
24.023333, -0.962853
24.026667, -0.961693
24.03, -0.961203
24.033333, -0.961193
24.036667, -0.961315
24.04, -0.961518
24.043333, -0.961809
24.046667, -0.962065
24.05, -0.962286
24.053333, -0.962722
24.056667, -0.963562
24.06, -0.964757
24.063333, -0.966215
24.066667, -0.967932
24.07, -0.969957
24.073333, -0.972302
24.076667, -0.975112
24.08, -0.978958
24.083333, -0.984422
24.086667, -0.991164
24.09, -0.997683
24.093333, -1.002232
24.096667, -1.004011
24.1, -1.003522
24.103333, -1.001866
24.106667, -0.999968
24.11, -0.998447
24.113333, -0.997632
24.116667, -0.997437
24.12, -0.997487
24.123333, -0.997305
24.126667, -0.996552
24.13, -0.995366
24.133333, -0.994329
24.136667, -0.993941
24.14, -0.994078
24.143333, -0.994138
24.146667, -0.993774
24.15, -0.993281
24.153333, -0.993257
24.156667, -0.993972
24.16, -0.995201
24.163333, -0.996575
24.166667, -0.997828
24.17, -0.998738
24.173333, -0.999097
24.176667, -0.998937
24.18, -0.998666
24.183333, -0.998664
24.186667, -0.998743
24.19, -0.998297
24.193333, -0.996921
24.196667, -0.994844
24.2, -0.992879
24.203333, -0.991844
24.206667, -0.992055
24.21, -0.993425
24.213333, -0.995707
24.216667, -0.998565
24.22, -1.001523
24.223333, -1.004084
24.226667, -1.00609
24.23, -1.007715
24.233333, -1.009093
24.236667, -1.010312
24.24, -1.011721
24.243333, -1.013804
24.246667, -1.016579
24.25, -1.019493
24.253333, -1.02205
24.256667, -1.024228
24.26, -1.026226
24.263333, -1.028206
24.266667, -1.030213
24.27, -1.032179
24.273333, -1.034214
24.276667, -1.036644
24.28, -1.039377
24.283333, -1.041766
24.286667, -1.043458
24.29, -1.044721
24.293333, -1.045796
24.296667, -1.046807
24.3, -1.048339
24.303333, -1.051232
24.306667, -1.055821
24.31, -1.061714
24.313333, -1.067991
24.316667, -1.073628
24.32, -1.078049
24.323333, -1.081192
24.326667, -1.082998
24.33, -1.083291
24.333333, -1.082388
24.336667, -1.081179
24.34, -1.08029
24.343333, -1.079716
24.346667, -1.079226
24.35, -1.078725
24.353333, -1.078385
24.356667, -1.078414
24.36, -1.0787
24.363333, -1.078858
24.366667, -1.078691
24.37, -1.078392
24.373333, -1.078349
24.376667, -1.07883
24.38, -1.079661
24.383333, -1.080326
24.386667, -1.080352
24.39, -1.079374
24.393333, -1.077334
24.396667, -1.074775
24.4, -1.072511
24.403333, -1.071104
24.406667, -1.070697
24.41, -1.07104
24.413333, -1.071703
24.416667, -1.072327
24.42, -1.072668
24.423333, -1.07262
24.426667, -1.072283
24.43, -1.071715
24.433333, -1.070764
24.436667, -1.069475
24.44, -1.068276
24.443333, -1.067417
24.446667, -1.066649
24.45, -1.065558
24.453333, -1.063991
24.456667, -1.062189
24.46, -1.060695
24.463333, -1.059998
24.466667, -1.060115
24.47, -1.060488
24.473333, -1.060284
24.476667, -1.058831
24.48, -1.056056
24.483333, -1.052696
24.486667, -1.049849
24.49, -1.04817
24.493333, -1.047472
24.496667, -1.046937
24.5, -1.045749
24.503333, -1.043624
24.506667, -1.040768
24.51, -1.037581
24.513333, -1.034563
24.516667, -1.032176
24.52, -1.030422
24.523333, -1.028583
24.526667, -1.025559
24.53, -1.020709
24.533333, -1.014608
24.536667, -1.00884
24.54, -1.004802
24.543333, -1.002738
24.546667, -1.002103
24.55, -1.002484
24.553333, -1.003578
24.556667, -1.004722
24.56, -1.00503
24.563333, -1.003961
24.566667, -1.001822
24.57, -0.999655
24.573333, -0.998425
24.576667, -0.998387
24.58, -0.99925
24.583333, -1.000647
24.586667, -1.002275
24.59, -1.003872
24.593333, -1.005347
24.596667, -1.006681
24.6, -1.007762
24.603333, -1.008545
24.606667, -1.009165
24.61, -1.009835
24.613333, -1.010692
24.616667, -1.011632
24.62, -1.012386
24.623333, -1.012703
24.626667, -1.012521
24.63, -1.012256
24.633333, -1.012862
24.636667, -1.015251
24.64, -1.019563
24.643333, -1.02501
24.646667, -1.030414
24.65, -1.034771
24.653333, -1.037445
24.656667, -1.038307
24.66, -1.037861
24.663333, -1.037002
24.666667, -1.03648
24.67, -1.036535
24.673333, -1.03693
24.676667, -1.037138
24.68, -1.036659
24.683333, -1.035381
24.686667, -1.033681
24.69, -1.03215
24.693333, -1.031022
24.696667, -1.029986
24.7, -1.028708
24.703333, -1.027175
24.706667, -1.025531
24.71, -1.024071
24.713333, -1.023222
24.716667, -1.023138
24.72, -1.023552
24.723333, -1.024206
24.726667, -1.025128
24.73, -1.026519
24.733333, -1.028461
24.736667, -1.030677
24.74, -1.032761
24.743333, -1.034639
24.746667, -1.036436
24.75, -1.037999
24.753333, -1.039055
24.756667, -1.039613
24.76, -1.039866
24.763333, -1.039903
24.766667, -1.039766
24.77, -1.039673
24.773333, -1.039919
24.776667, -1.040702
24.78, -1.042063
24.783333, -1.043792
24.786667, -1.045573
24.79, -1.047291
24.793333, -1.049026
24.796667, -1.050883
24.8, -1.052833
24.803333, -1.054657
24.806667, -1.056199
24.81, -1.057651
24.813333, -1.059238
24.816667, -1.06084
24.82, -1.062301
24.823333, -1.063745
24.826667, -1.065268
24.83, -1.06684
24.833333, -1.068686
24.836667, -1.071142
24.84, -1.074124
24.843333, -1.077177
24.846667, -1.079902
24.85, -1.082128
24.853333, -1.083819
24.856667, -1.08497
24.86, -1.085583
24.863333, -1.085681
24.866667, -1.085403
24.87, -1.08508
24.873333, -1.08494
24.876667, -1.084783
24.88, -1.084343
24.883333, -1.08394
24.886667, -1.084293
24.89, -1.085715
24.893333, -1.087909
24.896667, -1.090418
24.9, -1.092978
24.903333, -1.095632
24.906667, -1.098496
24.91, -1.101215
24.913333, -1.103059
24.916667, -1.103676
24.92, -1.103381
24.923333, -1.102785
24.926667, -1.102499
24.93, -1.102983
24.933333, -1.104262
24.936667, -1.105865
24.94, -1.107251
24.943333, -1.108098
24.946667, -1.108319
24.95, -1.108101
24.953333, -1.107894
24.956667, -1.108309
24.96, -1.109732
24.963333, -1.111862
24.966667, -1.114058
24.97, -1.116165
24.973333, -1.118654
24.976667, -1.12193
24.98, -1.125617
24.983333, -1.128629
24.986667, -1.130061
24.99, -1.129958
24.993333, -1.12908
24.996667, -1.128065
25.0, -1.127029
25.003333, -1.12584
25.006667, -1.124401
25.01, -1.122426
25.013333, -1.119433
25.016667, -1.115471
25.02, -1.111402
25.023333, -1.108139
25.026667, -1.105864
25.03, -1.103974
25.033333, -1.101693
25.036667, -1.098698
25.04, -1.095196
25.043333, -1.09159
25.046667, -1.088235
25.05, -1.085509
25.053333, -1.083767
25.056667, -1.082871
25.06, -1.082195
25.063333, -1.081298
25.066667, -1.080127
25.07, -1.078637
25.073333, -1.076778
25.076667, -1.074681
25.08, -1.072424
25.083333, -1.069886
25.086667, -1.066948
25.09, -1.063546
25.093333, -1.059699
25.096667, -1.055678
25.1, -1.05194
25.103333, -1.048837
25.106667, -1.046454
25.11, -1.04472
25.113333, -1.043663
25.116667, -1.043547
25.12, -1.044546
25.123333, -1.046312
25.126667, -1.048023
25.13, -1.049027
25.133333, -1.049545
25.136667, -1.050425
25.14, -1.052156
25.143333, -1.054475
25.146667, -1.05672
25.15, -1.058266
25.153333, -1.058939
25.156667, -1.059155
25.16, -1.05955
25.163333, -1.060519
25.166667, -1.062091
25.17, -1.064098
25.173333, -1.066355
25.176667, -1.068687
25.18, -1.07089
25.183333, -1.072895
25.186667, -1.075106
25.19, -1.07829
25.193333, -1.082857
25.196667, -1.088545
25.2, -1.094818
25.203333, -1.101159
25.206667, -1.107087
25.21, -1.112214
25.213333, -1.116303
25.216667, -1.119364
25.22, -1.121673
25.223333, -1.123425
25.226667, -1.124414
25.23, -1.124443
25.233333, -1.123919
25.236667, -1.123605
25.24, -1.124063
25.243333, -1.125526
25.246667, -1.12783
25.25, -1.130417
25.253333, -1.132828
25.256667, -1.135157
25.26, -1.137775
25.263333, -1.140886
25.266667, -1.144515
25.27, -1.148594
25.273333, -1.15283
25.276667, -1.156711
25.28, -1.159835
25.283333, -1.162218
25.286667, -1.164289
25.29, -1.166582
25.293333, -1.169388
25.296667, -1.172792
25.3, -1.176789
25.303333, -1.181119
25.306667, -1.185192
25.31, -1.188404
25.313333, -1.190584
25.316667, -1.192078
25.32, -1.193315
25.323333, -1.194488
25.326667, -1.195591
25.33, -1.196614
25.333333, -1.197835
25.336667, -1.199759
25.34, -1.202608
25.343333, -1.206241
25.346667, -1.210488
25.35, -1.215095
25.353333, -1.219646
25.356667, -1.223848
25.36, -1.227505
25.363333, -1.230374
25.366667, -1.232432
25.37, -1.233997
25.373333, -1.235636
25.376667, -1.237967
25.38, -1.241209
25.383333, -1.244966
25.386667, -1.248644
25.39, -1.252031
25.393333, -1.255382
25.396667, -1.258963
25.4, -1.2627
25.403333, -1.266186
25.406667, -1.269019
25.41, -1.271057
25.413333, -1.272174
25.416667, -1.271899
25.42, -1.269765
25.423333, -1.26613
25.426667, -1.262216
25.43, -1.259291
25.433333, -1.258149
25.436667, -1.258961
25.44, -1.261222
25.443333, -1.264266
25.446667, -1.267708
25.45, -1.271218
25.453333, -1.274456
25.456667, -1.277218
25.46, -1.279445
25.463333, -1.281317
25.466667, -1.283097
25.47, -1.284881
25.473333, -1.286805
25.476667, -1.289116
25.48, -1.291828
25.483333, -1.294557
25.486667, -1.296725
25.49, -1.297916
25.493333, -1.298043
25.496667, -1.297202
25.5, -1.29563
25.503333, -1.293805
25.506667, -1.292191
25.51, -1.290942
25.513333, -1.290052
25.516667, -1.289571
25.52, -1.289681
25.523333, -1.290616
25.526667, -1.292346
25.53, -1.294463
25.533333, -1.296539
25.536667, -1.298314
25.54, -1.299451
25.543333, -1.299514
25.546667, -1.29835
25.55, -1.296229
25.553333, -1.293632
25.556667, -1.291058
25.56, -1.288738
25.563333, -1.286374
25.566667, -1.283491
25.57, -1.279945
25.573333, -1.275981
25.576667, -1.271968
25.58, -1.268008
25.583333, -1.264152
25.586667, -1.260915
25.59, -1.258908
25.593333, -1.258041
25.596667, -1.257472
25.6, -1.25628
25.603333, -1.254169
25.606667, -1.251492
25.61, -1.248569
25.613333, -1.245286
25.616667, -1.24152
25.62, -1.237539
25.623333, -1.233912
25.626667, -1.231125
25.63, -1.229079
25.633333, -1.227087
25.636667, -1.224448
25.64, -1.220915
25.643333, -1.216644
25.646667, -1.211902
25.65, -1.206994
25.653333, -1.202323
25.656667, -1.198341
25.66, -1.195437
25.663333, -1.193794
25.666667, -1.193355
25.67, -1.193808
25.673333, -1.194506
25.676667, -1.194742
25.68, -1.194108
25.683333, -1.192637
25.686667, -1.190977
25.69, -1.190092
25.693333, -1.190392
25.696667, -1.191484
25.7, -1.192593
25.703333, -1.193017
25.706667, -1.192568
25.71, -1.19176
25.713333, -1.191411
25.716667, -1.192013
25.72, -1.193421
25.723333, -1.195048
25.726667, -1.196253
25.73, -1.196648
25.733333, -1.196379
25.736667, -1.196031
25.74, -1.196102
25.743333, -1.196729
25.746667, -1.197896
25.75, -1.199766
25.753333, -1.202679
25.756667, -1.206693
25.76, -1.211233
25.763333, -1.215336
25.766667, -1.218259
25.77, -1.219726
25.773333, -1.219776
25.776667, -1.218805
25.78, -1.217424
25.783333, -1.215909
25.786667, -1.214039
25.79, -1.211604
25.793333, -1.208854
25.796667, -1.206334
25.8, -1.204387
25.803333, -1.202846
25.806667, -1.201209
25.81, -1.199114
25.813333, -1.196599
25.816667, -1.194074
25.82, -1.192096
25.823333, -1.190854
25.826667, -1.189923
25.83, -1.188775
25.833333, -1.187286
25.836667, -1.18558
25.84, -1.183565
25.843333, -1.181029
25.846667, -1.178175
25.85, -1.175537
25.853333, -1.173355
25.856667, -1.171448
25.86, -1.169523
25.863333, -1.167293
25.866667, -1.16463
25.87, -1.161846
25.873333, -1.159441
25.876667, -1.157559
25.88, -1.156022
25.883333, -1.154683
25.886667, -1.153404
25.89, -1.151923
25.893333, -1.150033
25.896667, -1.147681
25.9, -1.144949
25.903333, -1.142126
25.906667, -1.139562
25.91, -1.137498
25.913333, -1.136178
25.916667, -1.135643
25.92, -1.13553
25.923333, -1.135426
25.926667, -1.135053
25.93, -1.134138
25.933333, -1.132672
25.936667, -1.131312
25.94, -1.131003
25.943333, -1.131938
25.946667, -1.133253
25.95, -1.133941
25.953333, -1.133768
25.956667, -1.133328
25.96, -1.133357
25.963333, -1.133963
25.966667, -1.134664
25.97, -1.135035
25.973333, -1.134964
25.976667, -1.13446
25.98, -1.133467
25.983333, -1.132082
25.986667, -1.130891
25.99, -1.130446
25.993333, -1.130604
25.996667, -1.130925
26.0, -1.131304
26.003333, -1.131908
26.006667, -1.132785
26.01, -1.133872
26.013333, -1.135326
26.016667, -1.137444
26.02, -1.140204
26.023333, -1.143113
26.026667, -1.145534
26.03, -1.147049
26.033333, -1.147718
26.036667, -1.148154
26.04, -1.149096
26.043333, -1.150731
26.046667, -1.152508
26.05, -1.153847
26.053333, -1.15476
26.056667, -1.155443
26.06, -1.15584
26.063333, -1.155967
26.066667, -1.156122
26.07, -1.156437
26.073333, -1.15653
26.076667, -1.155991
26.08, -1.155172
26.083333, -1.155138
26.086667, -1.156736
26.09, -1.159881
26.093333, -1.163705
26.096667, -1.167221
26.1, -1.169777
26.103333, -1.171022
26.106667, -1.170656
26.11, -1.168438
26.113333, -1.164691
26.116667, -1.160513
26.12, -1.157112
26.123333, -1.154986
26.126667, -1.153779
26.13, -1.15291
26.133333, -1.152084
26.136667, -1.151025
26.14, -1.149253
26.143333, -1.146487
26.146667, -1.142928
26.15, -1.13924
26.153333, -1.136379
26.156667, -1.134884
26.16, -1.134223
26.163333, -1.133193
26.166667, -1.130969
26.17, -1.127689
26.173333, -1.124125
26.176667, -1.120845
26.18, -1.11783
26.183333, -1.114916
26.186667, -1.112194
26.19, -1.109668
26.193333, -1.106911
26.196667, -1.103289
26.2, -1.098403
26.203333, -1.092462
26.206667, -1.086249
26.21, -1.080697
26.213333, -1.07654
26.216667, -1.074083
26.22, -1.072956
26.223333, -1.072247
26.226667, -1.071071
26.23, -1.069084
26.233333, -1.066575
26.236667, -1.064126
26.24, -1.062105
26.243333, -1.060528
26.246667, -1.059348
26.25, -1.058618
26.253333, -1.058203
26.256667, -1.057598
26.26, -1.056374
26.263333, -1.054595
26.266667, -1.052695
26.27, -1.051163
26.273333, -1.050283
26.276667, -1.050025
26.28, -1.05015
26.283333, -1.050301
26.286667, -1.050229
26.29, -1.049944
26.293333, -1.049272
26.296667, -1.04778
26.3, -1.045663
26.303333, -1.043903
26.306667, -1.04341
26.31, -1.044587
26.313333, -1.047374
26.316667, -1.051237
26.32, -1.055326
26.323333, -1.058827
26.326667, -1.061131
26.33, -1.061958
26.333333, -1.061604
26.336667, -1.060728
26.34, -1.059612
26.343333, -1.057957
26.346667, -1.055464
26.35, -1.052412
26.353333, -1.049607
26.356667, -1.047651
26.36, -1.046351
26.363333, -1.045025
26.366667, -1.043232
26.37, -1.041016
26.373333, -1.038735
26.376667, -1.03692
26.38, -1.036021
26.383333, -1.036036
26.386667, -1.036468
26.39, -1.036625
26.393333, -1.036061
26.396667, -1.03487
26.4, -1.033554
26.403333, -1.032721
26.406667, -1.032823
26.41, -1.033986
26.413333, -1.035989
26.416667, -1.038322
26.42, -1.040369
26.423333, -1.041822
26.426667, -1.042767
26.43, -1.043241
26.433333, -1.043063
26.436667, -1.04211
26.44, -1.04054
26.443333, -1.038739
26.446667, -1.037164
26.45, -1.036296
26.453333, -1.036558
26.456667, -1.038006
26.46, -1.04041
26.463333, -1.043657
26.466667, -1.047513
26.47, -1.051258
26.473333, -1.054092
26.476667, -1.055851
26.48, -1.056947
26.483333, -1.057704
26.486667, -1.058283
26.49, -1.05909
26.493333, -1.060673
26.496667, -1.063324
26.5, -1.066895
26.503333, -1.070855
26.506667, -1.074711
26.51, -1.078259
26.513333, -1.081237
26.516667, -1.083115
26.52, -1.083659
26.523333, -1.083426
26.526667, -1.083232
26.53, -1.083484
26.533333, -1.084287
26.536667, -1.085592
26.54, -1.087031
26.543333, -1.088023
26.546667, -1.088257
26.55, -1.088169
26.553333, -1.088791
26.556667, -1.090901
26.56, -1.09442
26.563333, -1.098589
26.566667, -1.102591
26.57, -1.106196
26.573333, -1.109624
26.576667, -1.112718
26.58, -1.115035
26.583333, -1.116697
26.586667, -1.118161
26.59, -1.119539
26.593333, -1.120925
26.596667, -1.122581
26.6, -1.124326
26.603333, -1.125565
26.606667, -1.126177
26.61, -1.126706
26.613333, -1.127698
26.616667, -1.129371
26.62, -1.131554
26.623333, -1.1337
26.626667, -1.135481
26.63, -1.137161
26.633333, -1.138877
26.636667, -1.140085
26.64, -1.140192
26.643333, -1.139329
26.646667, -1.138344
26.65, -1.138167
26.653333, -1.139184
26.656667, -1.141128
26.66, -1.143311
26.663333, -1.144913
26.666667, -1.145356
26.67, -1.144511
26.673333, -1.142528
26.676667, -1.139611
26.68, -1.13605
26.683333, -1.132333
26.686667, -1.129062
26.69, -1.126619
26.693333, -1.12492
26.696667, -1.123554
26.7, -1.122151
26.703333, -1.120533
26.706667, -1.118662
26.71, -1.116621
26.713333, -1.114413
26.716667, -1.111831
26.72, -1.108756
26.723333, -1.105379
26.726667, -1.102018
26.73, -1.098816
26.733333, -1.095692
26.736667, -1.092617
26.74, -1.089843
26.743333, -1.087672
26.746667, -1.086121
26.75, -1.084984
26.753333, -1.083982
26.756667, -1.082741
26.76, -1.080881
26.763333, -1.078274
26.766667, -1.075301
26.77, -1.072596
26.773333, -1.070385
26.776667, -1.068406
26.78, -1.066448
26.783333, -1.064639
26.786667, -1.063375
26.79, -1.063151
26.793333, -1.064151
26.796667, -1.065794
26.8, -1.066979
26.803333, -1.066936
26.806667, -1.065609
26.81, -1.063368
26.813333, -1.060872
26.816667, -1.059129
26.82, -1.05905
26.823333, -1.060687
26.826667, -1.063131
26.83, -1.065371
26.833333, -1.067042
26.836667, -1.068269
26.84, -1.069253
26.843333, -1.070195
26.846667, -1.071232
26.85, -1.072167
26.853333, -1.072489
26.856667, -1.071908
26.86, -1.07083
26.863333, -1.070379
26.866667, -1.071919
26.87, -1.076183
26.873333, -1.082807
26.876667, -1.090614
26.88, -1.09809
26.883333, -1.103955
26.886667, -1.107664
26.89, -1.10938
26.893333, -1.109691
26.896667, -1.109288
26.9, -1.108566
26.903333, -1.107742
26.906667, -1.107207
26.91, -1.107278
26.913333, -1.107858
26.916667, -1.108528
26.92, -1.108728
26.923333, -1.108128
26.926667, -1.107088
26.93, -1.106337
26.933333, -1.106332
26.936667, -1.107257
26.94, -1.109139
26.943333, -1.111771
26.946667, -1.11474
26.95, -1.11755
26.953333, -1.119779
26.956667, -1.121299
26.96, -1.122298
26.963333, -1.123174
26.966667, -1.124466
26.97, -1.126692
26.973333, -1.129972
26.976667, -1.133887
26.98, -1.13777
26.983333, -1.141002
26.986667, -1.143169
26.99, -1.144166
26.993333, -1.14425
26.996667, -1.143971
27.0, -1.143925
27.003333, -1.144518
27.006667, -1.146052
27.01, -1.148728
27.013333, -1.152366
27.016667, -1.156386
27.02, -1.160199
27.023333, -1.163647
27.026667, -1.167079
27.03, -1.170815
27.033333, -1.174737
27.036667, -1.178633
27.04, -1.182465
27.043333, -1.186132
27.046667, -1.189474
27.05, -1.192588
27.053333, -1.195738
27.056667, -1.199014
27.06, -1.202478
27.063333, -1.206364
27.066667, -1.210691
27.07, -1.214926
27.073333, -1.218278
27.076667, -1.220394
27.08, -1.221722
27.083333, -1.222998
27.086667, -1.22446
27.09, -1.225731
27.093333, -1.226291
27.096667, -1.226028
27.1, -1.225432
27.103333, -1.225211
27.106667, -1.225852
27.11, -1.227583
27.113333, -1.230408
27.116667, -1.234079
27.12, -1.238227
27.123333, -1.242542
27.126667, -1.246707
27.13, -1.250297
27.133333, -1.252973
27.136667, -1.254742
27.14, -1.255868
27.143333, -1.256584
27.146667, -1.257044
27.15, -1.25761
27.153333, -1.25879
27.156667, -1.260791
27.16, -1.263312
27.163333, -1.265653
27.166667, -1.267104
27.17, -1.267474
27.173333, -1.267052
27.176667, -1.266217
27.18, -1.265321
27.183333, -1.264687
27.186667, -1.264409
27.19, -1.26421
27.193333, -1.263773
27.196667, -1.263228
27.2, -1.263107
27.203333, -1.263882
27.206667, -1.265629
27.21, -1.26794
27.213333, -1.270129
27.216667, -1.271671
27.22, -1.272432
27.223333, -1.272425
27.226667, -1.271473
27.23, -1.269237
27.233333, -1.265642
27.236667, -1.261199
27.24, -1.256658
27.243333, -1.252425
27.246667, -1.248672
27.25, -1.245705
27.253333, -1.243732
27.256667, -1.24253
27.26, -1.241558
27.263333, -1.240192
27.266667, -1.238047
27.27, -1.235335
27.273333, -1.232706
27.276667, -1.23068
27.28, -1.229389
27.283333, -1.228634
27.286667, -1.227954
27.29, -1.226884
27.293333, -1.225421
27.296667, -1.223996
27.3, -1.222776
27.303333, -1.221211
27.306667, -1.218424
27.31, -1.214044
27.313333, -1.208635
27.316667, -1.203271
27.32, -1.198756
27.323333, -1.195311
27.326667, -1.192861
27.33, -1.191351
27.333333, -1.190685
27.336667, -1.190603
27.34, -1.19077
27.343333, -1.191004
27.346667, -1.191398
27.35, -1.192059
27.353333, -1.192885
27.356667, -1.193859
27.36, -1.195226
27.363333, -1.197048
27.366667, -1.198763
27.37, -1.199523
27.373333, -1.199213
27.376667, -1.198912
27.38, -1.199808
27.383333, -1.201983
27.386667, -1.204667
27.39, -1.207239
27.393333, -1.209508
27.396667, -1.211246
27.4, -1.212128
27.403333, -1.212332
27.406667, -1.212558
27.41, -1.21332
27.413333, -1.214687
27.416667, -1.216619
27.42, -1.219201
27.423333, -1.222638
27.426667, -1.227038
27.43, -1.232121
27.433333, -1.237245
27.436667, -1.241806
27.44, -1.245533
27.443333, -1.248382
27.446667, -1.250252
27.45, -1.25105
27.453333, -1.250981
27.456667, -1.250502
27.46, -1.250031
27.463333, -1.24981
27.466667, -1.249846
27.47, -1.249919
27.473333, -1.249723
27.476667, -1.249045
27.48, -1.247988
27.483333, -1.247085
27.486667, -1.246905
27.49, -1.247518
27.493333, -1.248552
27.496667, -1.249579
27.5, -1.250317
27.503333, -1.250799
27.506667, -1.251312
27.51, -1.251967
27.513333, -1.252536
27.516667, -1.252863
27.52, -1.253141
27.523333, -1.253632
27.526667, -1.254239
27.53, -1.254569
27.533333, -1.254434
27.536667, -1.254069
27.54, -1.253756
27.543333, -1.253567
27.546667, -1.253621
27.55, -1.254189
27.553333, -1.255411
27.556667, -1.257145
27.56, -1.259058
27.563333, -1.26065
27.566667, -1.26142
27.57, -1.261286
27.573333, -1.26066
27.576667, -1.260127
27.58, -1.260106
27.583333, -1.260673
27.586667, -1.261639
27.59, -1.262754
27.593333, -1.263702
27.596667, -1.264167
27.6, -1.264235
27.603333, -1.264481
27.606667, -1.265384
27.61, -1.266855
27.613333, -1.26842
27.616667, -1.269783
27.62, -1.271072
27.623333, -1.272379
27.626667, -1.273393
27.63, -1.273856
27.633333, -1.273964
27.636667, -1.273956
27.64, -1.273814
27.643333, -1.273511
27.646667, -1.272949
27.65, -1.27184
27.653333, -1.270105
27.656667, -1.26809
27.66, -1.26638
27.663333, -1.265469
27.666667, -1.265411
27.67, -1.265887
27.673333, -1.266636
27.676667, -1.267542
27.68, -1.268408
27.683333, -1.268984
27.686667, -1.26914
27.69, -1.268893
27.693333, -1.268528
27.696667, -1.268598
27.7, -1.269529
27.703333, -1.271289
27.706667, -1.273402
27.71, -1.275207
27.713333, -1.276177
27.716667, -1.276123
27.72, -1.275297
27.723333, -1.274238
27.726667, -1.273288
27.73, -1.27226
27.733333, -1.270634
27.736667, -1.268131
27.74, -1.265151
27.743333, -1.262536
27.746667, -1.260963
27.75, -1.260528
27.753333, -1.260824
27.756667, -1.261503
27.76, -1.262683
27.763333, -1.264766
27.766667, -1.267789
27.77, -1.27097
27.773333, -1.273056
27.776667, -1.273018
27.78, -1.270466
27.783333, -1.265906
27.786667, -1.260647
27.79, -1.256021
27.793333, -1.252454
27.796667, -1.249358
27.8, -1.245893
27.803333, -1.241723
27.806667, -1.237124
27.81, -1.232599
27.813333, -1.228453
27.816667, -1.22476
27.82, -1.221595
27.823333, -1.218846
27.826667, -1.215998
27.83, -1.212643
27.833333, -1.208899
27.836667, -1.204927
27.84, -1.200563
27.843333, -1.195828
27.846667, -1.191235
27.85, -1.187193
27.853333, -1.183571
27.856667, -1.180145
27.86, -1.177078
27.863333, -1.17482
27.866667, -1.173496
27.87, -1.172264
27.873333, -1.169704
27.876667, -1.165142
27.88, -1.159293
27.883333, -1.153548
27.886667, -1.148874
27.89, -1.145467
27.893333, -1.143063
27.896667, -1.14122
27.9, -1.139504
27.903333, -1.137698
27.906667, -1.135898
27.91, -1.134399
27.913333, -1.133503
27.916667, -1.13337
27.92, -1.133867
27.923333, -1.134553
27.926667, -1.134829
27.93, -1.134174
27.933333, -1.132535
27.936667, -1.130587
27.94, -1.129222
27.943333, -1.1287
27.946667, -1.128581
27.95, -1.128357
27.953333, -1.127978
27.956667, -1.127763
27.96, -1.127856
27.963333, -1.128052
27.966667, -1.128236
27.97, -1.128516
27.973333, -1.128874
27.976667, -1.12918
27.98, -1.129596
27.983333, -1.130656
27.986667, -1.132808
27.99, -1.136025
27.993333, -1.139757
27.996667, -1.143037
28.0, -1.144892
28.003333, -1.145024
28.006667, -1.14401
28.01, -1.142671
28.013333, -1.1414
28.016667, -1.140147
28.02, -1.138732
28.023333, -1.13702
28.026667, -1.135007
28.03, -1.132858
28.033333, -1.130812
28.036667, -1.128867
28.04, -1.126661
28.043333, -1.123892
28.046667, -1.120639
28.05, -1.117255
28.053333, -1.114283
28.056667, -1.112315
28.06, -1.111593
28.063333, -1.111751
28.066667, -1.112054
28.07, -1.111869
28.073333, -1.110849
28.076667, -1.108801
28.08, -1.10572
28.083333, -1.101987
28.086667, -1.098248
28.09, -1.095066
28.093333, -1.092859
28.096667, -1.091925
28.1, -1.092233
28.103333, -1.093307
28.106667, -1.094495
28.11, -1.095343
28.113333, -1.095785
28.116667, -1.095936
28.12, -1.095719
28.123333, -1.094948
28.126667, -1.093716
28.13, -1.092399
28.133333, -1.091334
28.136667, -1.090621
28.14, -1.090188
28.143333, -1.089906
28.146667, -1.089522
28.15, -1.088775
28.153333, -1.087747
28.156667, -1.086776
28.16, -1.086038
28.163333, -1.085558
28.166667, -1.085389
28.17, -1.085508
28.173333, -1.085756
28.176667, -1.086002
28.18, -1.086194
28.183333, -1.086328
28.186667, -1.086431
28.19, -1.086514
28.193333, -1.086692
28.196667, -1.087298
28.2, -1.088538
28.203333, -1.089959
28.206667, -1.090508
28.21, -1.08935
28.213333, -1.086537
28.216667, -1.082904
28.22, -1.079499
28.223333, -1.077007
28.226667, -1.075607
28.23, -1.075155
28.233333, -1.075391
28.236667, -1.076139
28.24, -1.077412
28.243333, -1.079282
28.246667, -1.081574
28.25, -1.083891
28.253333, -1.085926
28.256667, -1.087411
28.26, -1.088081
28.263333, -1.087975
28.266667, -1.087485
28.27, -1.087114
28.273333, -1.087243
28.276667, -1.088005
28.28, -1.089323
28.283333, -1.091024
28.286667, -1.092947
28.29, -1.09506
28.293333, -1.097273
28.296667, -1.099036
28.3, -1.099553
28.303333, -1.098679
28.306667, -1.097342
28.31, -1.096884
28.313333, -1.098242
28.316667, -1.101746
28.32, -1.10713
28.323333, -1.113493
28.326667, -1.119677
28.33, -1.124834
28.333333, -1.128441
28.336667, -1.130098
28.34, -1.12974
28.343333, -1.127896
28.346667, -1.1256
28.35, -1.123866
28.353333, -1.123075
28.356667, -1.122862
28.36, -1.122534
28.363333, -1.121674
28.366667, -1.120509
28.37, -1.119567
28.373333, -1.119121
28.376667, -1.11917
28.38, -1.119725
28.383333, -1.1208
28.386667, -1.122157
28.39, -1.123415
28.393333, -1.12453
28.396667, -1.125861
28.4, -1.127645
28.403333, -1.129693
28.406667, -1.13167
28.41, -1.133417
28.413333, -1.134788
28.416667, -1.135451
28.42, -1.135198
28.423333, -1.134344
28.426667, -1.133584
28.43, -1.133421
28.433333, -1.133846
28.436667, -1.134554
28.44, -1.135231
28.443333, -1.135634
28.446667, -1.135707
28.45, -1.135771
28.453333, -1.136448
28.456667, -1.138192
28.46, -1.141004
28.463333, -1.144715
28.466667, -1.149108
28.47, -1.153656
28.473333, -1.157682
28.476667, -1.16087
28.48, -1.163344
28.483333, -1.165495
28.486667, -1.167938
28.49, -1.171177
28.493333, -1.175132
28.496667, -1.179386
28.5, -1.183607
28.503333, -1.187502
28.506667, -1.19079
28.51, -1.193398
28.513333, -1.195451
28.516667, -1.197093
28.52, -1.198425
28.523333, -1.19954
28.526667, -1.20053
28.53, -1.201455
28.533333, -1.20245
28.536667, -1.204041
28.54, -1.207127
28.543333, -1.21234
28.546667, -1.219316
28.55, -1.226645
28.553333, -1.232636
28.556667, -1.236097
28.56, -1.236697
28.563333, -1.234919
28.566667, -1.231591
28.57, -1.227488
28.573333, -1.22349
28.576667, -1.220624
28.58, -1.219436
28.583333, -1.219515
28.586667, -1.219918
28.59, -1.219872
28.593333, -1.219114
28.596667, -1.217887
28.6, -1.216543
28.603333, -1.215039
28.606667, -1.213113
28.61, -1.210887
28.613333, -1.208777
28.616667, -1.206922
28.62, -1.205128
28.623333, -1.203252
28.626667, -1.201289
28.63, -1.19918
28.633333, -1.196846
28.636667, -1.194311
28.64, -1.19156
28.643333, -1.188636
28.646667, -1.185892
28.65, -1.183766
28.653333, -1.182408
28.656667, -1.181529
28.66, -1.180373
28.663333, -1.17818
28.666667, -1.174967
28.67, -1.171565
28.673333, -1.168684
28.676667, -1.166254
28.68, -1.163951
28.683333, -1.161897
28.686667, -1.160389
28.69, -1.159322
28.693333, -1.158147
28.696667, -1.15627
28.7, -1.15348
28.703333, -1.150048
28.706667, -1.146493
28.71, -1.14325
28.713333, -1.140515
28.716667, -1.138335
28.72, -1.136649
28.723333, -1.135112
28.726667, -1.133203
28.73, -1.130716
28.733333, -1.127972
28.736667, -1.125434
28.74, -1.123165
28.743333, -1.120823
28.746667, -1.118171
28.75, -1.11528
28.753333, -1.11218
28.756667, -1.108602
28.76, -1.104218
28.763333, -1.09899
28.766667, -1.093298
28.77, -1.087831
28.773333, -1.083175
28.776667, -1.07948
28.78, -1.076606
28.783333, -1.074499
28.786667, -1.073251
28.79, -1.072721
28.793333, -1.072399
28.796667, -1.071871
28.8, -1.071084
28.803333, -1.070275
28.806667, -1.069889
28.81, -1.070236
28.813333, -1.071256
28.816667, -1.072699
28.82, -1.074348
28.823333, -1.076108
28.826667, -1.077829
28.83, -1.079095
28.833333, -1.079512
28.836667, -1.079123
28.84, -1.078387
28.843333, -1.077905
28.846667, -1.077939
28.85, -1.078154
28.853333, -1.078196
28.856667, -1.078203
28.86, -1.078506
28.863333, -1.079351
28.866667, -1.080958
28.87, -1.083464
28.873333, -1.086916
28.876667, -1.0914
28.88, -1.096962
28.883333, -1.103223
28.886667, -1.109305
28.89, -1.114276
28.893333, -1.117476
28.896667, -1.118551
28.9, -1.117521
28.903333, -1.11487
28.906667, -1.111531
28.91, -1.108715
28.913333, -1.107402
28.916667, -1.107722
28.92, -1.108964
28.923333, -1.110226
28.926667, -1.110941
28.93, -1.110952
28.933333, -1.110436
28.936667, -1.109674
28.94, -1.108776
28.943333, -1.107928
28.946667, -1.10764
28.95, -1.108304
28.953333, -1.109711
28.956667, -1.111242
28.96, -1.112485
28.963333, -1.113482
28.966667, -1.114287
28.97, -1.114814
28.973333, -1.115317
28.976667, -1.116319
28.98, -1.117749
28.983333, -1.118794
28.986667, -1.11879
28.99, -1.117706
28.993333, -1.115819
28.996667, -1.113484
29.0, -1.111201
29.003333, -1.10957
29.006667, -1.109014
29.01, -1.10968
29.013333, -1.111659
29.016667, -1.115021
29.02, -1.119649
29.023333, -1.125167
29.026667, -1.130931
29.03, -1.136257
29.033333, -1.140867
29.036667, -1.14495
29.04, -1.14882
29.043333, -1.15277
29.046667, -1.157059
29.05, -1.161702
29.053333, -1.166493
29.056667, -1.171232
29.06, -1.175674
29.063333, -1.179502
29.066667, -1.182723
29.07, -1.185867
29.073333, -1.189611
29.076667, -1.194212
29.08, -1.199175
29.083333, -1.203595
29.086667, -1.207127
29.09, -1.210395
29.093333, -1.214449
29.096667, -1.220182
29.1, -1.227984
29.103333, -1.237364
29.106667, -1.24699
29.11, -1.255524
29.113333, -1.262339
29.116667, -1.267212
29.12, -1.269908
29.123333, -1.270454
29.126667, -1.269482
29.13, -1.268188
29.133333, -1.267786
29.136667, -1.268748
29.14, -1.270628
29.143333, -1.272662
29.146667, -1.27447
29.15, -1.27616
29.153333, -1.27806
29.156667, -1.280396
29.16, -1.282913
29.163333, -1.285031
29.166667, -1.286449
29.17, -1.28729
29.173333, -1.28792
29.176667, -1.288813
29.18, -1.290323
29.183333, -1.292399
29.186667, -1.29453
29.19, -1.296093
29.193333, -1.296894
29.196667, -1.297208
29.2, -1.297454
29.203333, -1.298043
29.206667, -1.299239
29.21, -1.301
29.213333, -1.303083
29.216667, -1.305217
29.22, -1.307061
29.223333, -1.30821
29.226667, -1.308446
29.23, -1.307917
29.233333, -1.306996
29.236667, -1.306066
29.24, -1.305338
29.243333, -1.304824
29.246667, -1.304495
29.25, -1.304337
29.253333, -1.304178
29.256667, -1.30357
29.26, -1.302082
29.263333, -1.299675
29.266667, -1.296735
29.27, -1.293884
29.273333, -1.291575
29.276667, -1.289765
29.28, -1.288221
29.283333, -1.286767
29.286667, -1.285005
29.29, -1.282351
29.293333, -1.278628
29.296667, -1.274436
29.3, -1.270661
29.303333, -1.267669
29.306667, -1.265221
29.31, -1.262877
29.313333, -1.260132
29.316667, -1.25638
29.32, -1.251098
29.323333, -1.244237
29.326667, -1.236383
29.33, -1.228507
29.333333, -1.221535
29.336667, -1.215925
29.34, -1.211523
29.343333, -1.207923
29.346667, -1.204864
29.35, -1.202263
29.353333, -1.200066
29.356667, -1.198146
29.36, -1.196221
29.363333, -1.193897
29.366667, -1.190923
29.37, -1.187389
29.373333, -1.183685
29.376667, -1.180273
29.38, -1.177453
29.383333, -1.17523
29.386667, -1.173334
29.39, -1.171434
29.393333, -1.169433
29.396667, -1.167586
29.4, -1.166317
29.403333, -1.165781
29.406667, -1.165574
29.41, -1.16506
29.413333, -1.163813
29.416667, -1.16158
29.42, -1.158234
29.423333, -1.154046
29.426667, -1.149882
29.43, -1.146917
29.433333, -1.145992
29.436667, -1.147138
29.44, -1.149671
29.443333, -1.152645
29.446667, -1.155118
29.45, -1.156313
29.453333, -1.155856
29.456667, -1.153844
29.46, -1.150709
29.463333, -1.146956
29.466667, -1.142918
29.47, -1.138797
29.473333, -1.134724
29.476667, -1.130735
29.48, -1.126864
29.483333, -1.123236
29.486667, -1.120065
29.49, -1.117573
29.493333, -1.115785
29.496667, -1.114433
29.5, -1.113193
29.503333, -1.111948
29.506667, -1.1108
29.51, -1.109957
29.513333, -1.109559
29.516667, -1.109497
29.52, -1.109431
29.523333, -1.108989
29.526667, -1.107878
29.53, -1.105904
29.533333, -1.103205
29.536667, -1.100268
29.54, -1.097375
29.543333, -1.094224
29.546667, -1.090368
29.55, -1.085988
29.553333, -1.082059
29.556667, -1.079605
29.56, -1.078796
29.563333, -1.078837
29.566667, -1.078653
29.57, -1.077643
29.573333, -1.075903
29.576667, -1.074049
29.58, -1.072957
29.583333, -1.073236
29.586667, -1.074864
29.59, -1.077548
29.593333, -1.081031
29.596667, -1.084757
29.6, -1.087681
29.603333, -1.088813
29.606667, -1.087985
29.61, -1.08599
29.613333, -1.083984
29.616667, -1.082863
29.62, -1.082874
29.623333, -1.083555
29.626667, -1.08424
29.63, -1.084597
29.633333, -1.084674
29.636667, -1.08463
29.64, -1.084448
29.643333, -1.083939
29.646667, -1.083037
29.65, -1.082011
29.653333, -1.081524
29.656667, -1.082422
29.66, -1.084991
29.663333, -1.088389
29.666667, -1.091207
29.67, -1.092587
29.673333, -1.092636
29.676667, -1.091988
29.68, -1.091172
29.683333, -1.090424
29.686667, -1.089976
29.69, -1.090027
29.693333, -1.09051
29.696667, -1.091255
29.7, -1.092135
29.703333, -1.092872
29.706667, -1.092919
29.71, -1.091676
29.713333, -1.08902
29.716667, -1.085672
29.72, -1.082817
29.723333, -1.081207
29.726667, -1.080802
29.73, -1.081208
29.733333, -1.082002
29.736667, -1.082811
29.74, -1.083352
29.743333, -1.083502
29.746667, -1.083553
29.75, -1.084141
29.753333, -1.085612
29.756667, -1.087753
29.76, -1.090269
29.763333, -1.093235
29.766667, -1.096989
29.77, -1.101652
29.773333, -1.106644
29.776667, -1.110943
29.78, -1.113947
29.783333, -1.115836
29.786667, -1.11713
29.79, -1.118163
29.793333, -1.119012
29.796667, -1.119738
29.8, -1.120475
29.803333, -1.121417
29.806667, -1.12275
29.81, -1.124516
29.813333, -1.126613
29.816667, -1.128882
29.82, -1.131055
29.823333, -1.132683
29.826667, -1.133323
29.83, -1.132984
29.833333, -1.13223
29.836667, -1.131754
29.84, -1.131941
29.843333, -1.132757
29.846667, -1.134025
29.85, -1.135722
29.853333, -1.137881
29.856667, -1.140343
29.86, -1.142726
29.863333, -1.144631
29.866667, -1.145758
29.87, -1.14588
29.873333, -1.144927
29.876667, -1.143156
29.88, -1.141227
29.883333, -1.139888
29.886667, -1.139376
29.89, -1.139257
29.893333, -1.138892
29.896667, -1.138045
29.9, -1.137265
29.903333, -1.137631
29.906667, -1.139806
29.91, -1.143382
29.913333, -1.147294
29.916667, -1.150701
29.92, -1.153535
29.923333, -1.156294
29.926667, -1.159306
29.93, -1.162398
29.933333, -1.165197
29.936667, -1.167496
29.94, -1.169517
29.943333, -1.171784
29.946667, -1.174558
29.95, -1.177629
29.953333, -1.180647
29.956667, -1.183407
29.96, -1.185978
29.963333, -1.188566
29.966667, -1.191195
29.97, -1.193703
29.973333, -1.195902
29.976667, -1.197503
29.98, -1.198314
29.983333, -1.198793
29.986667, -1.199973
29.99, -1.202726
29.993333, -1.207301
29.996667, -1.213227
30.0, -1.219334
$$ === CHEMSPECTRA INTEGRALS AND MULTIPLETS ===
##$OBSERVEDINTEGRALS= (X Y Z)
(13.879663760249542, 14.51718910644928, 1.0, 24788.065902247283)
##$OBSERVEDMULTIPLETS=
##$OBSERVEDMULTIPLETSPEAKS=
$$ === CHEMSPECTRA SIMULATION ===
##$CSSIMULATIONPEAKS=
##END=


$$ === CHEMSPECTRA PEAK TABLE EDIT ===
##TITLE=multi_hplc.1_bagit
##JCAMP-DX=5.00
##DATA TYPE=HPLC UVVISPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=EDIT_PEAK
##$CSTHRESHOLD=0.05
##MAXX=30.0
##MAXY=401.209891
##MINX=0.0
##MINY=-1.308446
##$CSSOLVENTNAME=- - -
##$CSSOLVENTVALUE=0
##$CSSOLVENTX=0
##NPOINTS=2
##PEAKTABLE= (XY..XY)
14.053333, 401.209891
16.99, 319.827331
##END=


$$ === CHEMSPECTRA PEAK TABLE AUTO ===
##TITLE=multi_hplc.1_bagit
##JCAMP-DX=5.00
##DATA TYPE=HPLC UVVISPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=AUTO_PEAK
##$CSTHRESHOLD=0.05
##MAXX=30.0
##MAXY=401.209891
##MINX=0.0
##MINY=-1.308446
##NPOINTS=2
##PEAKTABLE= (XY..XY)
14.053333, 401.209891
16.99, 319.827331
##END=


$$ === CHEMSPECTRA ORIGINAL METADATA ===
###TITLE= multi_hplc.1_bagit, multi_hplc.1_bagit, multi_hplc.1_bagit, multi_hplc.1_bagit
###JCAMPDX= 5.0, 5.00, 5.00, 5.00
###BLOCKS= 1
###$CSCATEGORY= SPECTRUM, EDIT_PEAK, AUTO_PEAK
###XUNITS= MINUTES
###YUNITS= TRANSMITTANCE
###LASTX= 30.0
###MAXX= 30.0, 30.0, 30.0
###MAXY= 401.209891, 401.209891, 401.209891
###MINX= 0.0, 0.0, 0.0
###MINY= -1.308446, -1.308446, -1.308446
###NPOINTS= 9001, 0, 2
###$OBSERVEDINTEGRALS= (X Y Z)
###$CSTHRESHOLD= 0.05, 0.05
###$CSSOLVENTVALUE= 0
###$CSSOLVENTX= 0
###JCAMPDX= 5.0, 5.00, 5.00, 5.00, 5.00
###BLOCKS= 1
###$CSCATEGORY= SPECTRUM, EDIT_PEAK, AUTO_PEAK
###XUNITS= MINUTES, MINUTES
###YUNITS= TRANSMITTANCE, MILLI-ABSORBANCE UNITS
###LASTX= 30.0, 30.000000
###MAXX= 30.0, 30.0, 30.0, 30.0
###MAXY= 401.209891, 401.209891, 401.209891, 401.209891
###MINX= 0.0, 0.0, 0.0, 0.0
###MINY= -1.308446, -1.308446, -1.308446, -1.308446
###NPOINTS= 9001, 0, 2, 9001
###$OBSERVEDINTEGRALS= (X Y Z)
###$CSTHRESHOLD= 0.05, 0.05
###$CSSOLVENTVALUE= 0
###$CSSOLVENTX= 0
###TITLE= Spectrum
###XYPOINTS= (XY..XY)
0.000000, 0.000000
0.003333, -0.000135
0.006667, -0.001123
0.010000, -0.004562
0.013333, -0.012176
0.016667, -0.024320
0.020000, -0.039356
0.023333, -0.054564
0.026667, -0.067403
0.030000, -0.076169
0.033333, -0.080257
0.036667, -0.080164
0.040000, -0.077103
0.043333, -0.072508
0.046667, -0.067725
0.050000, -0.063768
0.053333, -0.061113
0.056667, -0.059763
0.060000, -0.059447
0.063333, -0.059680
0.066667, -0.059847
0.070000, -0.059607
0.073333, -0.059283
0.076667, -0.059550
0.080000, -0.060545
0.083333, -0.061603
0.086667, -0.062010
0.090000, -0.061728
0.093333, -0.061346
0.096667, -0.061514
0.100000, -0.062506
0.103333, -0.064246
0.106667, -0.066523
0.110000, -0.069020
0.113333, -0.071342
0.116667, -0.073102
0.120000, -0.074006
0.123333, -0.074157
0.126667, -0.074262
0.130000, -0.075227
0.133333, -0.077428
0.136667, -0.080335
0.140000, -0.082913
0.143333, -0.084436
0.146667, -0.084819
0.150000, -0.084284
0.153333, -0.083188
0.156667, -0.082263
0.160000, -0.082321
0.163333, -0.083560
0.166667, -0.085701
0.170000, -0.088473
0.173333, -0.091557
0.176667, -0.094455
0.180000, -0.096680
0.183333, -0.098107
0.186667, -0.099235
0.190000, -0.100837
0.193333, -0.103238
0.196667, -0.106073
0.200000, -0.108727
0.203333, -0.110903
0.206667, -0.112693
0.210000, -0.114232
0.213333, -0.115497
0.216667, -0.116414
0.220000, -0.117027
0.223333, -0.117639
0.226667, -0.118780
0.230000, -0.120806
0.233333, -0.123545
0.236667, -0.126457
0.240000, -0.129121
0.243333, -0.131495
0.246667, -0.133660
0.250000, -0.135447
0.253333, -0.136525
0.256667, -0.136782
0.260000, -0.136518
0.263333, -0.136319
0.266667, -0.136713
0.270000, -0.137978
0.273333, -0.140029
0.276667, -0.142290
0.280000, -0.143966
0.283333, -0.144636
0.286667, -0.144515
0.290000, -0.144247
0.293333, -0.144334
0.296667, -0.144713
0.300000, -0.145171
0.303333, -0.145908
0.306667, -0.147219
0.310000, -0.149007
0.313333, -0.151019
0.316667, -0.153350
0.320000, -0.156337
0.323333, -0.159797
0.326667, -0.162828
0.330000, -0.164737
0.333333, -0.165643
0.336667, -0.166029
0.340000, -0.166254
0.343333, -0.166406
0.346667, -0.166405
0.350000, -0.166427
0.353333, -0.167044
0.356667, -0.168677
0.360000, -0.171152
0.363333, -0.173822
0.366667, -0.175960
0.370000, -0.177323
0.373333, -0.178410
0.376667, -0.179887
0.380000, -0.181874
0.383333, -0.183911
0.386667, -0.185460
0.390000, -0.186491
0.393333, -0.187532
0.396667, -0.189032
0.400000, -0.190937
0.403333, -0.192910
0.406667, -0.194693
0.410000, -0.196267
0.413333, -0.197751
0.416667, -0.199054
0.420000, -0.199845
0.423333, -0.199968
0.426667, -0.199595
0.430000, -0.199159
0.433333, -0.199281
0.436667, -0.200281
0.440000, -0.201806
0.443333, -0.203305
0.446667, -0.204648
0.450000, -0.206033
0.453333, -0.207595
0.456667, -0.209324
0.460000, -0.211174
0.463333, -0.213157
0.466667, -0.215344
0.470000, -0.217840
0.473333, -0.220493
0.476667, -0.222564
0.480000, -0.223283
0.483333, -0.222726
0.486667, -0.221617
0.490000, -0.220693
0.493333, -0.220440
0.496667, -0.220984
0.500000, -0.222128
0.503333, -0.223486
0.506667, -0.224699
0.510000, -0.225750
0.513333, -0.226934
0.516667, -0.228526
0.520000, -0.230601
0.523333, -0.232915
0.526667, -0.234884
0.530000, -0.235905
0.533333, -0.235813
0.536667, -0.234964
0.540000, -0.233973
0.543333, -0.233515
0.546667, -0.234194
0.550000, -0.236243
0.553333, -0.239332
0.556667, -0.242838
0.560000, -0.246227
0.563333, -0.249046
0.566667, -0.250906
0.570000, -0.251720
0.573333, -0.251775
0.576667, -0.251533
0.580000, -0.251410
0.583333, -0.251593
0.586667, -0.251997
0.590000, -0.252478
0.593333, -0.253108
0.596667, -0.254135
0.600000, -0.255691
0.603333, -0.257671
0.606667, -0.259856
0.610000, -0.262048
0.613333, -0.264215
0.616667, -0.266439
0.620000, -0.268645
0.623333, -0.270644
0.626667, -0.272421
0.630000, -0.273934
0.633333, -0.274963
0.636667, -0.275528
0.640000, -0.275977
0.643333, -0.276479
0.646667, -0.276891
0.650000, -0.277190
0.653333, -0.277773
0.656667, -0.279114
0.660000, -0.281208
0.663333, -0.283563
0.666667, -0.285572
0.670000, -0.286805
0.673333, -0.287231
0.676667, -0.287121
0.680000, -0.286709
0.683333, -0.286221
0.686667, -0.286064
0.690000, -0.286736
0.693333, -0.288398
0.696667, -0.290643
0.700000, -0.292863
0.703333, -0.294607
0.706667, -0.295658
0.710000, -0.296001
0.713333, -0.295728
0.716667, -0.295037
0.720000, -0.294218
0.723333, -0.293523
0.726667, -0.293218
0.730000, -0.293573
0.733333, -0.294679
0.736667, -0.296339
0.740000, -0.298127
0.743333, -0.299683
0.746667, -0.300998
0.750000, -0.302379
0.753333, -0.304063
0.756667, -0.305784
0.760000, -0.306973
0.763333, -0.307470
0.766667, -0.307657
0.770000, -0.307793
0.773333, -0.307783
0.776667, -0.307717
0.780000, -0.308089
0.783333, -0.309232
0.786667, -0.310931
0.790000, -0.312662
0.793333, -0.313871
0.796667, -0.314274
0.800000, -0.314130
0.803333, -0.314056
0.806667, -0.314543
0.810000, -0.315437
0.813333, -0.315944
0.816667, -0.315489
0.820000, -0.314311
0.823333, -0.312942
0.826667, -0.311583
0.830000, -0.310119
0.833333, -0.308373
0.836667, -0.306487
0.840000, -0.305173
0.843333, -0.305298
0.846667, -0.307063
0.850000, -0.309736
0.853333, -0.312322
0.856667, -0.314223
0.860000, -0.315268
0.863333, -0.315598
0.866667, -0.315651
0.870000, -0.315948
0.873333, -0.316691
0.876667, -0.317636
0.880000, -0.318487
0.883333, -0.319327
0.886667, -0.320416
0.890000, -0.321665
0.893333, -0.322721
0.896667, -0.323351
0.900000, -0.323340
0.903333, -0.322458
0.906667, -0.320928
0.910000, -0.319466
0.913333, -0.318755
0.916667, -0.319205
0.920000, -0.320809
0.923333, -0.322835
0.926667, -0.324192
0.930000, -0.324323
0.933333, -0.323442
0.936667, -0.322235
0.940000, -0.321561
0.943333, -0.321888
0.946667, -0.322854
0.950000, -0.323694
0.953333, -0.323895
0.956667, -0.323272
0.960000, -0.321933
0.963333, -0.320441
0.966667, -0.319555
0.970000, -0.319609
0.973333, -0.320294
0.976667, -0.321114
0.980000, -0.321765
0.983333, -0.321942
0.986667, -0.321168
0.990000, -0.319292
0.993333, -0.316959
0.996667, -0.315123
1.000000, -0.314112
1.003333, -0.313522
1.006667, -0.312913
1.010000, -0.312219
1.013333, -0.311625
1.016667, -0.311422
1.020000, -0.311834
1.023333, -0.312725
1.026667, -0.313693
1.030000, -0.314664
1.033333, -0.315901
1.036667, -0.317402
1.040000, -0.318745
1.043333, -0.319401
1.046667, -0.319062
1.050000, -0.317888
1.053333, -0.316351
1.056667, -0.314924
1.060000, -0.313959
1.063333, -0.313567
1.066667, -0.313727
1.070000, -0.314588
1.073333, -0.316208
1.076667, -0.318000
1.080000, -0.319020
1.083333, -0.318922
1.086667, -0.318314
1.090000, -0.318032
1.093333, -0.318345
1.096667, -0.319020
1.100000, -0.319816
1.103333, -0.320650
1.106667, -0.321421
1.110000, -0.321979
1.113333, -0.322290
1.116667, -0.322471
1.120000, -0.322519
1.123333, -0.322120
1.126667, -0.321052
1.130000, -0.319710
1.133333, -0.318832
1.136667, -0.318777
1.140000, -0.319343
1.143333, -0.320038
1.146667, -0.320384
1.150000, -0.320206
1.153333, -0.319771
1.156667, -0.319599
1.160000, -0.320061
1.163333, -0.321039
1.166667, -0.321916
1.170000, -0.322269
1.173333, -0.322335
1.176667, -0.322404
1.180000, -0.322444
1.183333, -0.322457
1.186667, -0.322495
1.190000, -0.322567
1.193333, -0.322773
1.196667, -0.323214
1.200000, -0.323668
1.203333, -0.323612
1.206667, -0.322720
1.210000, -0.321190
1.213333, -0.319622
1.216667, -0.318814
1.220000, -0.319412
1.223333, -0.321302
1.226667, -0.323539
1.230000, -0.325043
1.233333, -0.325298
1.236667, -0.324458
1.240000, -0.323029
1.243333, -0.321591
1.246667, -0.320748
1.250000, -0.320893
1.253333, -0.321736
1.256667, -0.322499
1.260000, -0.322761
1.263333, -0.322706
1.266667, -0.322702
1.270000, -0.322956
1.273333, -0.323384
1.276667, -0.323747
1.280000, -0.323821
1.283333, -0.323391
1.286667, -0.322511
1.290000, -0.321651
1.293333, -0.321063
1.296667, -0.320309
1.300000, -0.318737
1.303333, -0.316318
1.306667, -0.313892
1.310000, -0.312231
1.313333, -0.311114
1.316667, -0.309751
1.320000, -0.307693
1.323333, -0.305182
1.326667, -0.302880
1.330000, -0.301203
1.333333, -0.300005
1.336667, -0.298886
1.340000, -0.297558
1.343333, -0.295980
1.346667, -0.294215
1.350000, -0.292076
1.353333, -0.289211
1.356667, -0.285759
1.360000, -0.282404
1.363333, -0.279581
1.366667, -0.277203
1.370000, -0.275083
1.373333, -0.273133
1.376667, -0.271158
1.380000, -0.268775
1.383333, -0.265737
1.386667, -0.262168
1.390000, -0.258401
1.393333, -0.254809
1.396667, -0.251677
1.400000, -0.248977
1.403333, -0.246240
1.406667, -0.242886
1.410000, -0.238791
1.413333, -0.234468
1.416667, -0.230595
1.420000, -0.227363
1.423333, -0.224233
1.426667, -0.220485
1.430000, -0.215992
1.433333, -0.211151
1.436667, -0.206233
1.440000, -0.201292
1.443333, -0.196561
1.446667, -0.192470
1.450000, -0.189126
1.453333, -0.186086
1.456667, -0.182815
1.460000, -0.179182
1.463333, -0.175471
1.466667, -0.171859
1.470000, -0.167914
1.473333, -0.162944
1.476667, -0.156678
1.480000, -0.149430
1.483333, -0.141923
1.486667, -0.134898
1.490000, -0.128642
1.493333, -0.123065
1.496667, -0.118079
1.500000, -0.113578
1.503333, -0.109332
1.506667, -0.105077
1.510000, -0.100636
1.513333, -0.096062
1.516667, -0.091624
1.520000, -0.087379
1.523333, -0.082927
1.526667, -0.077924
1.530000, -0.072703
1.533333, -0.068005
1.536667, -0.064069
1.540000, -0.060250
1.543333, -0.055773
1.546667, -0.050587
1.550000, -0.045130
1.553333, -0.039677
1.556667, -0.034332
1.560000, -0.029267
1.563333, -0.024623
1.566667, -0.020448
1.570000, -0.016761
1.573333, -0.013405
1.576667, -0.010002
1.580000, -0.006356
1.583333, -0.002838
1.586667, -0.000180
1.590000, 0.001318
1.593333, 0.002315
1.596667, 0.003901
1.600000, 0.006592
1.603333, 0.009945
1.606667, 0.013167
1.610000, 0.015872
1.613333, 0.018039
1.616667, 0.019632
1.620000, 0.020552
1.623333, 0.020860
1.626667, 0.020928
1.630000, 0.021215
1.633333, 0.021942
1.636667, 0.023069
1.640000, 0.024397
1.643333, 0.025556
1.646667, 0.026138
1.650000, 0.026055
1.653333, 0.025593
1.656667, 0.024978
1.660000, 0.024179
1.663333, 0.023155
1.666667, 0.022011
1.670000, 0.020917
1.673333, 0.019827
1.676667, 0.018473
1.680000, 0.016915
1.683333, 0.015696
1.686667, 0.015002
1.690000, 0.014258
1.693333, 0.012904
1.696667, 0.010993
1.700000, 0.008883
1.703333, 0.006662
1.706667, 0.004003
1.710000, 0.000697
1.713333, -0.002949
1.716667, -0.006381
1.720000, -0.009184
1.723333, -0.011360
1.726667, -0.013390
1.730000, -0.015758
1.733333, -0.018541
1.736667, -0.021633
1.740000, -0.025027
1.743333, -0.028689
1.746667, -0.032469
1.750000, -0.036239
1.753333, -0.039947
1.756667, -0.043449
1.760000, -0.046495
1.763333, -0.048957
1.766667, -0.050779
1.770000, -0.051842
1.773333, -0.052268
1.776667, -0.052694
1.780000, -0.053904
1.783333, -0.056258
1.786667, -0.059662
1.790000, -0.063979
1.793333, -0.069017
1.796667, -0.074162
1.800000, -0.078544
1.803333, -0.081630
1.806667, -0.083473
1.810000, -0.084471
1.813333, -0.085173
1.816667, -0.086225
1.820000, -0.088204
1.823333, -0.091431
1.826667, -0.095723
1.830000, -0.100353
1.833333, -0.104486
1.836667, -0.107571
1.840000, -0.109534
1.843333, -0.110827
1.846667, -0.112026
1.850000, -0.113290
1.853333, -0.114413
1.856667, -0.115374
1.860000, -0.116577
1.863333, -0.118433
1.866667, -0.120805
1.870000, -0.122957
1.873333, -0.124103
1.876667, -0.124001
1.880000, -0.123122
1.883333, -0.122452
1.886667, -0.122981
1.890000, -0.124934
1.893333, -0.127651
1.896667, -0.130472
1.900000, -0.133323
1.903333, -0.136320
1.906667, -0.139327
1.910000, -0.142101
1.913333, -0.144603
1.916667, -0.146953
1.920000, -0.149069
1.923333, -0.150677
1.926667, -0.151880
1.930000, -0.153170
1.933333, -0.154759
1.936667, -0.156423
1.940000, -0.158009
1.943333, -0.159684
1.946667, -0.161598
1.950000, -0.163583
1.953333, -0.165462
1.956667, -0.167364
1.960000, -0.169396
1.963333, -0.171369
1.966667, -0.173168
1.970000, -0.175065
1.973333, -0.177393
1.976667, -0.180205
1.980000, -0.183348
1.983333, -0.186574
1.986667, -0.189581
1.990000, -0.192123
1.993333, -0.194069
1.996667, -0.195323
2.000000, -0.195968
2.003333, -0.196471
2.006667, -0.197331
2.010000, -0.198612
2.013333, -0.200173
2.016667, -0.201960
2.020000, -0.203813
2.023333, -0.205429
2.026667, -0.206587
2.030000, -0.207262
2.033333, -0.207576
2.036667, -0.207732
2.040000, -0.207958
2.043333, -0.208535
2.046667, -0.209835
2.050000, -0.212059
2.053333, -0.214824
2.056667, -0.217456
2.060000, -0.219637
2.063333, -0.221396
2.066667, -0.222614
2.070000, -0.223010
2.073333, -0.222572
2.076667, -0.221581
2.080000, -0.220355
2.083333, -0.219303
2.086667, -0.218851
2.090000, -0.219026
2.093333, -0.219478
2.096667, -0.220054
2.100000, -0.221156
2.103333, -0.223275
2.106667, -0.226136
2.110000, -0.228724
2.113333, -0.230238
2.116667, -0.230645
2.120000, -0.230445
2.123333, -0.230240
2.126667, -0.230461
2.130000, -0.231248
2.133333, -0.232375
2.136667, -0.233314
2.140000, -0.233539
2.143333, -0.232763
2.146667, -0.230945
2.150000, -0.228345
2.153333, -0.225467
2.156667, -0.222713
2.160000, -0.220321
2.163333, -0.218568
2.166667, -0.217622
2.170000, -0.217332
2.173333, -0.217353
2.176667, -0.217296
2.180000, -0.216822
2.183333, -0.215793
2.186667, -0.214282
2.190000, -0.212466
2.193333, -0.210533
2.196667, -0.208613
2.200000, -0.206860
2.203333, -0.205436
2.206667, -0.204300
2.210000, -0.203307
2.213333, -0.202319
2.216667, -0.201137
2.220000, -0.199756
2.223333, -0.198612
2.226667, -0.198172
2.230000, -0.198368
2.233333, -0.198548
2.236667, -0.197972
2.240000, -0.196329
2.243333, -0.193820
2.246667, -0.190955
2.250000, -0.188335
2.253333, -0.186317
2.256667, -0.184886
2.260000, -0.183912
2.263333, -0.183268
2.266667, -0.182800
2.270000, -0.182482
2.273333, -0.182529
2.276667, -0.183197
2.280000, -0.184327
2.283333, -0.185181
2.286667, -0.185014
2.290000, -0.183737
2.293333, -0.181844
2.296667, -0.180035
2.300000, -0.179029
2.303333, -0.179357
2.306667, -0.181044
2.310000, -0.183492
2.313333, -0.185751
2.316667, -0.187044
2.320000, -0.187181
2.323333, -0.186485
2.326667, -0.185449
2.330000, -0.184538
2.333333, -0.184129
2.336667, -0.184322
2.340000, -0.184789
2.343333, -0.185059
2.346667, -0.184956
2.350000, -0.184675
2.353333, -0.184442
2.356667, -0.184199
2.360000, -0.183857
2.363333, -0.183660
2.366667, -0.183957
2.370000, -0.184771
2.373333, -0.185751
2.376667, -0.186498
2.380000, -0.186945
2.383333, -0.187235
2.386667, -0.187208
2.390000, -0.186492
2.393333, -0.185230
2.396667, -0.184111
2.400000, -0.183561
2.403333, -0.183554
2.406667, -0.184008
2.410000, -0.184889
2.413333, -0.186225
2.416667, -0.188068
2.420000, -0.190209
2.423333, -0.192119
2.426667, -0.193372
2.430000, -0.194021
2.433333, -0.194467
2.436667, -0.195058
2.440000, -0.195906
2.443333, -0.196868
2.446667, -0.197595
2.450000, -0.197756
2.453333, -0.197259
2.456667, -0.196381
2.460000, -0.195663
2.463333, -0.195358
2.466667, -0.195242
2.470000, -0.195139
2.473333, -0.195123
2.476667, -0.195169
2.480000, -0.195146
2.483333, -0.195260
2.486667, -0.196043
2.490000, -0.197726
2.493333, -0.199903
2.496667, -0.201906
2.500000, -0.203349
2.503333, -0.204280
2.506667, -0.204920
2.510000, -0.205312
2.513333, -0.205193
2.516667, -0.204313
2.520000, -0.202888
2.523333, -0.201464
2.526667, -0.200368
2.530000, -0.199538
2.533333, -0.198734
2.536667, -0.197885
2.540000, -0.197197
2.543333, -0.196878
2.546667, -0.197049
2.550000, -0.197799
2.553333, -0.198851
2.556667, -0.199549
2.560000, -0.199367
2.563333, -0.198281
2.566667, -0.196903
2.570000, -0.196232
2.573333, -0.196923
2.576667, -0.198824
2.580000, -0.201216
2.583333, -0.203285
2.586667, -0.204415
2.590000, -0.204354
2.593333, -0.203227
2.596667, -0.201488
2.600000, -0.199913
2.603333, -0.199276
2.606667, -0.199620
2.610000, -0.200208
2.613333, -0.200428
2.616667, -0.200367
2.620000, -0.200562
2.623333, -0.201512
2.626667, -0.203332
2.630000, -0.205706
2.633333, -0.207966
2.636667, -0.209366
2.640000, -0.209636
2.643333, -0.209057
2.646667, -0.208130
2.650000, -0.207526
2.653333, -0.207871
2.656667, -0.209171
2.660000, -0.210824
2.663333, -0.212169
2.666667, -0.212875
2.670000, -0.213128
2.673333, -0.213389
2.676667, -0.213798
2.680000, -0.214211
2.683333, -0.214648
2.686667, -0.215191
2.690000, -0.215806
2.693333, -0.216453
2.696667, -0.216980
2.700000, -0.217148
2.703333, -0.216918
2.706667, -0.216535
2.710000, -0.216342
2.713333, -0.216486
2.716667, -0.216862
2.720000, -0.217425
2.723333, -0.218237
2.726667, -0.219092
2.730000, -0.219485
2.733333, -0.219083
2.736667, -0.218050
2.740000, -0.216985
2.743333, -0.216636
2.746667, -0.217417
2.750000, -0.219048
2.753333, -0.220681
2.756667, -0.221522
2.760000, -0.221446
2.763333, -0.221104
2.766667, -0.221409
2.770000, -0.222786
2.773333, -0.224907
2.776667, -0.227057
2.780000, -0.228635
2.783333, -0.229462
2.786667, -0.229681
2.790000, -0.229420
2.793333, -0.228742
2.796667, -0.227702
2.800000, -0.226283
2.803333, -0.224662
2.806667, -0.223499
2.810000, -0.223542
2.813333, -0.225058
2.816667, -0.227779
2.820000, -0.231007
2.823333, -0.233751
2.826667, -0.235278
2.830000, -0.235722
2.833333, -0.235935
2.836667, -0.236734
2.840000, -0.238273
2.843333, -0.240058
2.846667, -0.241441
2.850000, -0.241955
2.853333, -0.241410
2.856667, -0.239960
2.860000, -0.238025
2.863333, -0.236303
2.866667, -0.235613
2.870000, -0.236241
2.873333, -0.237757
2.876667, -0.239667
2.880000, -0.241800
2.883333, -0.244075
2.886667, -0.246346
2.890000, -0.248437
2.893333, -0.250035
2.896667, -0.250713
2.900000, -0.250410
2.903333, -0.249776
2.906667, -0.249736
2.910000, -0.250695
2.913333, -0.252278
2.916667, -0.253830
2.920000, -0.255071
2.923333, -0.255956
2.926667, -0.256278
2.930000, -0.255971
2.933333, -0.255509
2.936667, -0.255557
2.940000, -0.256339
2.943333, -0.257503
2.946667, -0.258629
2.950000, -0.259763
2.953333, -0.261287
2.956667, -0.263291
2.960000, -0.265285
2.963333, -0.266643
2.966667, -0.267096
2.970000, -0.266642
2.973333, -0.265458
2.976667, -0.264005
2.980000, -0.262831
2.983333, -0.262256
2.986667, -0.262236
2.990000, -0.262369
2.993333, -0.262133
2.996667, -0.261348
3.000000, -0.260310
3.003333, -0.259496
3.006667, -0.259384
3.010000, -0.260256
3.013333, -0.261813
3.016667, -0.263469
3.020000, -0.264967
3.023333, -0.266302
3.026667, -0.267541
3.030000, -0.268840
3.033333, -0.270233
3.036667, -0.271468
3.040000, -0.272196
3.043333, -0.272160
3.046667, -0.271287
3.050000, -0.269819
3.053333, -0.268317
3.056667, -0.267501
3.060000, -0.267846
3.063333, -0.269181
3.066667, -0.270909
3.070000, -0.272517
3.073333, -0.273621
3.076667, -0.273969
3.080000, -0.273750
3.083333, -0.273600
3.086667, -0.274033
3.090000, -0.275010
3.093333, -0.276157
3.096667, -0.277196
3.100000, -0.277924
3.103333, -0.278099
3.106667, -0.277643
3.110000, -0.276827
3.113333, -0.276105
3.116667, -0.275862
3.120000, -0.276316
3.123333, -0.277581
3.126667, -0.279662
3.130000, -0.282266
3.133333, -0.284796
3.136667, -0.286518
3.140000, -0.286825
3.143333, -0.285683
3.146667, -0.283736
3.150000, -0.281742
3.153333, -0.280118
3.156667, -0.279104
3.160000, -0.278977
3.163333, -0.279730
3.166667, -0.280788
3.170000, -0.281434
3.173333, -0.281430
3.176667, -0.281018
3.180000, -0.280463
3.183333, -0.279839
3.186667, -0.279213
3.190000, -0.278844
3.193333, -0.279120
3.196667, -0.280231
3.200000, -0.281813
3.203333, -0.283132
3.206667, -0.283681
3.210000, -0.283416
3.213333, -0.282619
3.216667, -0.281631
3.220000, -0.280613
3.223333, -0.279670
3.226667, -0.279083
3.230000, -0.279173
3.233333, -0.279865
3.236667, -0.280729
3.240000, -0.281543
3.243333, -0.282353
3.246667, -0.283195
3.250000, -0.284128
3.253333, -0.285114
3.256667, -0.285830
3.260000, -0.285927
3.263333, -0.285432
3.266667, -0.284896
3.270000, -0.284993
3.273333, -0.285732
3.276667, -0.286323
3.280000, -0.285997
3.283333, -0.284775
3.286667, -0.283288
3.290000, -0.282060
3.293333, -0.281313
3.296667, -0.281128
3.300000, -0.281310
3.303333, -0.281528
3.306667, -0.281764
3.310000, -0.282233
3.313333, -0.282902
3.316667, -0.283433
3.320000, -0.283455
3.323333, -0.282747
3.326667, -0.281516
3.330000, -0.280516
3.333333, -0.280518
3.336667, -0.281744
3.340000, -0.283844
3.343333, -0.286258
3.346667, -0.288627
3.350000, -0.290883
3.353333, -0.293023
3.356667, -0.294980
3.360000, -0.296591
3.363333, -0.297696
3.366667, -0.298292
3.370000, -0.298428
3.373333, -0.298047
3.376667, -0.297257
3.380000, -0.296567
3.383333, -0.296494
3.386667, -0.297148
3.390000, -0.298447
3.393333, -0.300360
3.396667, -0.302784
3.400000, -0.305433
3.403333, -0.307895
3.406667, -0.309830
3.410000, -0.311252
3.413333, -0.312595
3.416667, -0.314293
3.420000, -0.316108
3.423333, -0.317277
3.426667, -0.317512
3.430000, -0.317279
3.433333, -0.317323
3.436667, -0.318315
3.440000, -0.320483
3.443333, -0.323384
3.446667, -0.326218
3.450000, -0.328319
3.453333, -0.329331
3.456667, -0.329284
3.460000, -0.328744
3.463333, -0.328580
3.466667, -0.329365
3.470000, -0.331072
3.473333, -0.333251
3.476667, -0.335316
3.480000, -0.336901
3.483333, -0.338081
3.486667, -0.339144
3.490000, -0.340267
3.493333, -0.341518
3.496667, -0.342932
3.500000, -0.344547
3.503333, -0.346370
3.506667, -0.348237
3.510000, -0.349923
3.513333, -0.351309
3.516667, -0.352206
3.520000, -0.352291
3.523333, -0.351527
3.526667, -0.350488
3.530000, -0.350020
3.533333, -0.350581
3.536667, -0.352101
3.540000, -0.354273
3.543333, -0.356600
3.546667, -0.358431
3.550000, -0.359441
3.553333, -0.359829
3.556667, -0.360019
3.560000, -0.360402
3.563333, -0.361192
3.566667, -0.362321
3.570000, -0.363495
3.573333, -0.364308
3.576667, -0.364425
3.580000, -0.363785
3.583333, -0.362550
3.586667, -0.360939
3.590000, -0.359251
3.593333, -0.357915
3.596667, -0.357338
3.600000, -0.357692
3.603333, -0.358859
3.606667, -0.360459
3.610000, -0.361996
3.613333, -0.363085
3.616667, -0.363486
3.620000, -0.363076
3.623333, -0.361995
3.626667, -0.360752
3.630000, -0.359978
3.633333, -0.359950
3.636667, -0.360461
3.640000, -0.361003
3.643333, -0.361029
3.646667, -0.360268
3.650000, -0.358784
3.653333, -0.356781
3.656667, -0.354577
3.660000, -0.352612
3.663333, -0.351198
3.666667, -0.350379
3.670000, -0.350142
3.673333, -0.350369
3.676667, -0.350615
3.680000, -0.350408
3.683333, -0.349717
3.686667, -0.348772
3.690000, -0.347633
3.693333, -0.346228
3.696667, -0.344705
3.700000, -0.343421
3.703333, -0.342592
3.706667, -0.342093
3.710000, -0.341530
3.713333, -0.340563
3.716667, -0.339426
3.720000, -0.338881
3.723333, -0.339297
3.726667, -0.340197
3.730000, -0.340862
3.733333, -0.340956
3.736667, -0.340682
3.740000, -0.340584
3.743333, -0.341194
3.746667, -0.342828
3.750000, -0.345320
3.753333, -0.347946
3.756667, -0.350066
3.760000, -0.351865
3.763333, -0.354355
3.766667, -0.358837
3.770000, -0.366267
3.773333, -0.376791
3.776667, -0.389789
3.780000, -0.404367
3.783333, -0.419828
3.786667, -0.435730
3.790000, -0.451600
3.793333, -0.466746
3.796667, -0.480343
3.800000, -0.491539
3.803333, -0.499582
3.806667, -0.504031
3.810000, -0.504817
3.813333, -0.502168
3.816667, -0.496491
3.820000, -0.488378
3.823333, -0.478629
3.826667, -0.468053
3.830000, -0.457261
3.833333, -0.446616
3.836667, -0.436247
3.840000, -0.426162
3.843333, -0.416390
3.846667, -0.407091
3.850000, -0.398511
3.853333, -0.390765
3.856667, -0.383863
3.860000, -0.377864
3.863333, -0.372693
3.866667, -0.368004
3.870000, -0.363396
3.873333, -0.358572
3.876667, -0.353234
3.880000, -0.346975
3.883333, -0.339259
3.886667, -0.329446
3.890000, -0.316995
3.893333, -0.301770
3.896667, -0.284102
3.900000, -0.264465
3.903333, -0.243248
3.906667, -0.220839
3.910000, -0.197652
3.913333, -0.174148
3.916667, -0.151138
3.920000, -0.129939
3.923333, -0.111910
3.926667, -0.097683
3.930000, -0.086646
3.933333, -0.076655
3.936667, -0.063944
3.940000, -0.043406
3.943333, -0.008929
3.946667, 0.046448
3.950000, 0.130063
3.953333, 0.248535
3.956667, 0.406523
3.960000, 0.605790
3.963333, 0.844466
3.966667, 1.116658
3.970000, 1.412622
3.973333, 1.719636
3.976667, 2.023305
3.980000, 2.308692
3.983333, 2.561691
3.986667, 2.771028
3.990000, 2.929771
3.993333, 3.035441
3.996667, 3.089165
4.000000, 3.094671
4.003333, 3.057315
4.006667, 2.982984
4.010000, 2.877036
4.013333, 2.743888
4.016667, 2.587428
4.020000, 2.411487
4.023333, 2.219955
4.026667, 2.016882
4.030000, 1.806610
4.033333, 1.593825
4.036667, 1.383781
4.040000, 1.182739
4.043333, 0.997990
4.046667, 0.837036
4.050000, 0.706520
4.053333, 0.611726
4.056667, 0.556386
4.060000, 0.542383
4.063333, 0.569740
4.066667, 0.637126
4.070000, 0.742231
4.073333, 0.881863
4.076667, 1.052392
4.080000, 1.250452
4.083333, 1.473232
4.086667, 1.718742
4.090000, 1.986367
4.093333, 2.276793
4.096667, 2.591079
4.100000, 2.929911
4.103333, 3.293376
4.106667, 3.680895
4.110000, 4.091215
4.113333, 4.522254
4.116667, 4.970797
4.120000, 5.431958
4.123333, 5.898779
4.126667, 6.362553
4.130000, 6.813593
4.133333, 7.241673
4.136667, 7.635958
4.140000, 7.984899
4.143333, 8.276952
4.146667, 8.501882
4.150000, 8.651394
4.153333, 8.718861
4.156667, 8.699355
4.160000, 8.590693
4.163333, 8.394376
4.166667, 8.115296
4.170000, 7.760674
4.173333, 7.339194
4.176667, 6.860732
4.180000, 6.336556
4.183333, 5.779329
4.186667, 5.202258
4.190000, 4.617824
4.193333, 4.037299
4.196667, 3.471068
4.200000, 2.928469
4.203333, 2.416840
4.206667, 1.940941
4.210000, 1.503570
4.213333, 1.106661
4.216667, 0.751496
4.220000, 0.437905
4.223333, 0.163865
4.226667, -0.073708
4.230000, -0.277902
4.233333, -0.451674
4.236667, -0.598249
4.240000, -0.720962
4.243333, -0.822921
4.246667, -0.907144
4.250000, -0.976533
4.253333, -1.033551
4.256667, -1.080120
4.260000, -1.117738
4.263333, -1.147688
4.266667, -1.171178
4.270000, -1.189145
4.273333, -1.202157
4.276667, -1.210721
4.280000, -1.215367
4.283333, -1.216514
4.286667, -1.214483
4.290000, -1.209458
4.293333, -1.201446
4.296667, -1.190470
4.300000, -1.176656
4.303333, -1.160063
4.306667, -1.140777
4.310000, -1.119079
4.313333, -1.095285
4.316667, -1.069545
4.320000, -1.041889
4.323333, -1.012384
4.326667, -0.981160
4.330000, -0.948249
4.333333, -0.913712
4.336667, -0.878161
4.340000, -0.842834
4.343333, -0.808859
4.346667, -0.776602
4.350000, -0.745834
4.353333, -0.716268
4.356667, -0.687783
4.360000, -0.660432
4.363333, -0.634414
4.366667, -0.609886
4.370000, -0.586816
4.373333, -0.565170
4.376667, -0.545134
4.380000, -0.527111
4.383333, -0.511470
4.386667, -0.498252
4.390000, -0.487198
4.393333, -0.478076
4.396667, -0.470613
4.400000, -0.464298
4.403333, -0.458828
4.406667, -0.454556
4.410000, -0.451971
4.413333, -0.450952
4.416667, -0.450921
4.420000, -0.451377
4.423333, -0.451969
4.426667, -0.452425
4.430000, -0.452659
4.433333, -0.452796
4.436667, -0.453017
4.440000, -0.453433
4.443333, -0.454060
4.446667, -0.454682
4.450000, -0.454927
4.453333, -0.454736
4.456667, -0.454548
4.460000, -0.454909
4.463333, -0.456054
4.466667, -0.457820
4.470000, -0.459802
4.473333, -0.461567
4.476667, -0.462829
4.480000, -0.463575
4.483333, -0.464059
4.486667, -0.464560
4.490000, -0.465128
4.493333, -0.465582
4.496667, -0.465742
4.500000, -0.465790
4.503333, -0.466185
4.506667, -0.467014
4.510000, -0.467811
4.513333, -0.468144
4.516667, -0.467950
4.520000, -0.467287
4.523333, -0.466276
4.526667, -0.465299
4.530000, -0.464821
4.533333, -0.464993
4.536667, -0.465667
4.540000, -0.466617
4.543333, -0.467573
4.546667, -0.468335
4.550000, -0.469010
4.553333, -0.469862
4.556667, -0.470928
4.560000, -0.472066
4.563333, -0.473208
4.566667, -0.474284
4.570000, -0.475160
4.573333, -0.475838
4.576667, -0.476455
4.580000, -0.477110
4.583333, -0.477803
4.586667, -0.478489
4.590000, -0.479131
4.593333, -0.479704
4.596667, -0.480242
4.600000, -0.480937
4.603333, -0.481936
4.606667, -0.482977
4.610000, -0.483588
4.613333, -0.483550
4.616667, -0.482855
4.620000, -0.481566
4.623333, -0.479921
4.626667, -0.478441
4.630000, -0.477765
4.633333, -0.478110
4.636667, -0.479153
4.640000, -0.480758
4.643333, -0.483112
4.646667, -0.485967
4.650000, -0.488466
4.653333, -0.489815
4.656667, -0.489887
4.660000, -0.489325
4.663333, -0.489143
4.666667, -0.489942
4.670000, -0.491557
4.673333, -0.493632
4.676667, -0.495975
4.680000, -0.498244
4.683333, -0.500059
4.686667, -0.501445
4.690000, -0.502535
4.693333, -0.502986
4.696667, -0.502297
4.700000, -0.500689
4.703333, -0.499315
4.706667, -0.499328
4.710000, -0.500863
4.713333, -0.503084
4.716667, -0.505074
4.720000, -0.506500
4.723333, -0.507536
4.726667, -0.508518
4.730000, -0.509740
4.733333, -0.511255
4.736667, -0.512840
4.740000, -0.514131
4.743333, -0.514858
4.746667, -0.515147
4.750000, -0.515643
4.753333, -0.517156
4.756667, -0.519921
4.760000, -0.523368
4.763333, -0.526751
4.766667, -0.529549
4.770000, -0.531329
4.773333, -0.531880
4.776667, -0.531573
4.780000, -0.531251
4.783333, -0.531611
4.786667, -0.532832
4.790000, -0.534665
4.793333, -0.536679
4.796667, -0.538537
4.800000, -0.540281
4.803333, -0.542348
4.806667, -0.545266
4.810000, -0.549156
4.813333, -0.553447
4.816667, -0.557324
4.820000, -0.560449
4.823333, -0.563150
4.826667, -0.566106
4.830000, -0.569821
4.833333, -0.574189
4.836667, -0.578635
4.840000, -0.582685
4.843333, -0.586314
4.846667, -0.589875
4.850000, -0.593716
4.853333, -0.597880
4.856667, -0.602166
4.860000, -0.606370
4.863333, -0.610491
4.866667, -0.614772
4.870000, -0.619399
4.873333, -0.624204
4.876667, -0.628816
4.880000, -0.632863
4.883333, -0.636031
4.886667, -0.638241
4.890000, -0.639644
4.893333, -0.640409
4.896667, -0.640741
4.900000, -0.640758
4.903333, -0.640308
4.906667, -0.639284
4.910000, -0.637950
4.913333, -0.636831
4.916667, -0.636382
4.920000, -0.636703
4.923333, -0.637520
4.926667, -0.638289
4.930000, -0.638391
4.933333, -0.637538
4.936667, -0.635983
4.940000, -0.634338
4.943333, -0.633200
4.946667, -0.632899
4.950000, -0.633449
4.953333, -0.634354
4.956667, -0.634704
4.960000, -0.633999
4.963333, -0.632488
4.966667, -0.630510
4.970000, -0.628204
4.973333, -0.625782
4.976667, -0.623596
4.980000, -0.621904
4.983333, -0.620702
4.986667, -0.619921
4.990000, -0.619748
4.993333, -0.620314
4.996667, -0.621171
5.000000, -0.621519
5.003333, -0.620790
5.006667, -0.618967
5.010000, -0.616636
5.013333, -0.614603
5.016667, -0.613212
5.020000, -0.612224
5.023333, -0.611444
5.026667, -0.611105
5.030000, -0.611507
5.033333, -0.612607
5.036667, -0.614001
5.040000, -0.615148
5.043333, -0.615692
5.046667, -0.615555
5.050000, -0.614735
5.053333, -0.613343
5.056667, -0.611874
5.060000, -0.611044
5.063333, -0.611280
5.066667, -0.612522
5.070000, -0.614425
5.073333, -0.616477
5.076667, -0.617985
5.080000, -0.618330
5.083333, -0.617440
5.086667, -0.615902
5.090000, -0.614442
5.093333, -0.613352
5.096667, -0.612606
5.100000, -0.612124
5.103333, -0.611634
5.106667, -0.610698
5.110000, -0.609174
5.113333, -0.607373
5.116667, -0.605724
5.120000, -0.604420
5.123333, -0.603316
5.126667, -0.602189
5.130000, -0.600949
5.133333, -0.599497
5.136667, -0.597785
5.140000, -0.595984
5.143333, -0.594297
5.146667, -0.592839
5.150000, -0.591828
5.153333, -0.591543
5.156667, -0.591930
5.160000, -0.592501
5.163333, -0.592833
5.166667, -0.592808
5.170000, -0.592207
5.173333, -0.590700
5.176667, -0.588298
5.180000, -0.585432
5.183333, -0.582780
5.186667, -0.580948
5.190000, -0.579923
5.193333, -0.579075
5.196667, -0.577954
5.200000, -0.576722
5.203333, -0.575786
5.206667, -0.575272
5.210000, -0.574958
5.213333, -0.574636
5.216667, -0.574316
5.220000, -0.574055
5.223333, -0.573917
5.226667, -0.574109
5.230000, -0.574838
5.233333, -0.575934
5.236667, -0.576886
5.240000, -0.577271
5.243333, -0.576912
5.246667, -0.575830
5.250000, -0.574309
5.253333, -0.572739
5.256667, -0.571285
5.260000, -0.569864
5.263333, -0.568339
5.266667, -0.566645
5.270000, -0.564931
5.273333, -0.563710
5.276667, -0.563460
5.280000, -0.563991
5.283333, -0.564563
5.286667, -0.564702
5.290000, -0.564540
5.293333, -0.564303
5.296667, -0.563893
5.300000, -0.563093
5.303333, -0.561942
5.306667, -0.560762
5.310000, -0.559969
5.313333, -0.559914
5.316667, -0.560633
5.320000, -0.561633
5.323333, -0.562204
5.326667, -0.562019
5.330000, -0.561347
5.333333, -0.560706
5.336667, -0.560437
5.340000, -0.560610
5.343333, -0.561058
5.346667, -0.561363
5.350000, -0.561003
5.353333, -0.559764
5.356667, -0.557890
5.360000, -0.555755
5.363333, -0.553680
5.366667, -0.552007
5.370000, -0.551020
5.373333, -0.550850
5.376667, -0.551412
5.380000, -0.552439
5.383333, -0.553733
5.386667, -0.555191
5.390000, -0.556612
5.393333, -0.557719
5.396667, -0.558322
5.400000, -0.558324
5.403333, -0.557575
5.406667, -0.555966
5.410000, -0.553827
5.413333, -0.551888
5.416667, -0.550796
5.420000, -0.550765
5.423333, -0.551503
5.426667, -0.552485
5.430000, -0.553228
5.433333, -0.553473
5.436667, -0.553466
5.440000, -0.553777
5.443333, -0.554599
5.446667, -0.555586
5.450000, -0.556229
5.453333, -0.556248
5.456667, -0.555821
5.460000, -0.555500
5.463333, -0.555840
5.466667, -0.556963
5.470000, -0.558423
5.473333, -0.559638
5.476667, -0.560330
5.480000, -0.560622
5.483333, -0.561057
5.486667, -0.562177
5.490000, -0.563895
5.493333, -0.565592
5.496667, -0.566770
5.500000, -0.567329
5.503333, -0.567376
5.506667, -0.566945
5.510000, -0.565973
5.513333, -0.564512
5.516667, -0.562945
5.520000, -0.561979
5.523333, -0.562331
5.526667, -0.564221
5.530000, -0.567089
5.533333, -0.569904
5.536667, -0.571902
5.540000, -0.573026
5.543333, -0.573642
5.546667, -0.574146
5.550000, -0.574911
5.553333, -0.575992
5.556667, -0.576843
5.560000, -0.577051
5.563333, -0.577050
5.566667, -0.577459
5.570000, -0.578264
5.573333, -0.579105
5.576667, -0.579833
5.580000, -0.580620
5.583333, -0.581723
5.586667, -0.583064
5.590000, -0.584206
5.593333, -0.584805
5.596667, -0.584758
5.600000, -0.584059
5.603333, -0.582861
5.606667, -0.581536
5.610000, -0.580498
5.613333, -0.580069
5.616667, -0.580346
5.620000, -0.581092
5.623333, -0.581930
5.626667, -0.582570
5.630000, -0.582852
5.633333, -0.582873
5.636667, -0.582879
5.640000, -0.582948
5.643333, -0.583033
5.646667, -0.583122
5.650000, -0.583271
5.653333, -0.583731
5.656667, -0.584722
5.660000, -0.586037
5.663333, -0.587295
5.666667, -0.588395
5.670000, -0.589384
5.673333, -0.590177
5.676667, -0.590694
5.680000, -0.591116
5.683333, -0.591732
5.686667, -0.592459
5.690000, -0.592708
5.693333, -0.591957
5.696667, -0.590274
5.700000, -0.588236
5.703333, -0.586605
5.706667, -0.586112
5.710000, -0.587176
5.713333, -0.589538
5.716667, -0.592250
5.720000, -0.594258
5.723333, -0.595201
5.726667, -0.595618
5.730000, -0.596167
5.733333, -0.596916
5.736667, -0.597586
5.740000, -0.598091
5.743333, -0.598653
5.746667, -0.599469
5.750000, -0.600515
5.753333, -0.601714
5.756667, -0.603110
5.760000, -0.604856
5.763333, -0.606933
5.766667, -0.609038
5.770000, -0.611004
5.773333, -0.613026
5.776667, -0.615338
5.780000, -0.617852
5.783333, -0.620186
5.786667, -0.622035
5.790000, -0.623484
5.793333, -0.625023
5.796667, -0.627153
5.800000, -0.629839
5.803333, -0.632655
5.806667, -0.635235
5.810000, -0.637298
5.813333, -0.638723
5.816667, -0.639663
5.820000, -0.640336
5.823333, -0.640814
5.826667, -0.641069
5.830000, -0.641149
5.833333, -0.641245
5.836667, -0.641640
5.840000, -0.642457
5.843333, -0.643440
5.846667, -0.644243
5.850000, -0.644819
5.853333, -0.645262
5.856667, -0.645597
5.860000, -0.645891
5.863333, -0.646246
5.866667, -0.646641
5.870000, -0.647048
5.873333, -0.647525
5.876667, -0.648119
5.880000, -0.648854
5.883333, -0.649800
5.886667, -0.651066
5.890000, -0.652492
5.893333, -0.653529
5.896667, -0.653839
5.900000, -0.653754
5.903333, -0.653907
5.906667, -0.654570
5.910000, -0.655387
5.913333, -0.655692
5.916667, -0.655197
5.920000, -0.654379
5.923333, -0.654130
5.926667, -0.654946
5.930000, -0.656496
5.933333, -0.658145
5.936667, -0.659701
5.940000, -0.661401
5.943333, -0.663548
5.946667, -0.666344
5.950000, -0.669600
5.953333, -0.672660
5.956667, -0.675033
5.960000, -0.676834
5.963333, -0.678544
5.966667, -0.680670
5.970000, -0.683438
5.973333, -0.686495
5.976667, -0.689205
5.980000, -0.691313
5.983333, -0.693087
5.986667, -0.694923
5.990000, -0.697016
5.993333, -0.699277
5.996667, -0.701328
6.000000, -0.702702
6.003333, -0.703233
6.006667, -0.703045
6.010000, -0.702237
6.013333, -0.700984
6.016667, -0.699756
6.020000, -0.699025
6.023333, -0.698770
6.026667, -0.698472
6.030000, -0.697784
6.033333, -0.696985
6.036667, -0.696604
6.040000, -0.696975
6.043333, -0.698007
6.046667, -0.699073
6.050000, -0.699520
6.053333, -0.699216
6.056667, -0.698321
6.060000, -0.696846
6.063333, -0.694731
6.066667, -0.692143
6.070000, -0.689488
6.073333, -0.687193
6.076667, -0.685388
6.080000, -0.683792
6.083333, -0.682117
6.086667, -0.680486
6.090000, -0.679148
6.093333, -0.678081
6.096667, -0.677057
6.100000, -0.675799
6.103333, -0.673954
6.106667, -0.671205
6.110000, -0.667674
6.113333, -0.663917
6.116667, -0.660311
6.120000, -0.656829
6.123333, -0.653524
6.126667, -0.650652
6.130000, -0.648179
6.133333, -0.645618
6.136667, -0.642310
6.140000, -0.637830
6.143333, -0.632413
6.146667, -0.626990
6.150000, -0.622580
6.153333, -0.619629
6.156667, -0.617911
6.160000, -0.616783
6.163333, -0.615526
6.166667, -0.613783
6.170000, -0.611650
6.173333, -0.609409
6.176667, -0.607485
6.180000, -0.606575
6.183333, -0.607316
6.186667, -0.609652
6.190000, -0.612880
6.193333, -0.616354
6.196667, -0.619845
6.200000, -0.623375
6.203333, -0.626967
6.206667, -0.630567
6.210000, -0.634124
6.213333, -0.637555
6.216667, -0.640649
6.220000, -0.643190
6.223333, -0.645114
6.226667, -0.646407
6.230000, -0.647094
6.233333, -0.647469
6.236667, -0.648039
6.240000, -0.649095
6.243333, -0.650480
6.246667, -0.651788
6.250000, -0.652624
6.253333, -0.652669
6.256667, -0.651883
6.260000, -0.650665
6.263333, -0.649529
6.266667, -0.648693
6.270000, -0.648051
6.273333, -0.647371
6.276667, -0.646551
6.280000, -0.645777
6.283333, -0.645276
6.286667, -0.645040
6.290000, -0.644838
6.293333, -0.644321
6.296667, -0.643387
6.300000, -0.642395
6.303333, -0.641610
6.306667, -0.640871
6.310000, -0.640159
6.313333, -0.639853
6.316667, -0.640114
6.320000, -0.640430
6.323333, -0.640166
6.326667, -0.639417
6.330000, -0.638893
6.333333, -0.639139
6.336667, -0.640062
6.340000, -0.640929
6.343333, -0.640861
6.346667, -0.639628
6.350000, -0.637782
6.353333, -0.635988
6.356667, -0.634600
6.360000, -0.633821
6.363333, -0.633814
6.366667, -0.634550
6.370000, -0.635612
6.373333, -0.636207
6.376667, -0.635562
6.380000, -0.633445
6.383333, -0.630337
6.386667, -0.627083
6.390000, -0.624299
6.393333, -0.622069
6.396667, -0.620085
6.400000, -0.617839
6.403333, -0.614837
6.406667, -0.610973
6.410000, -0.606546
6.413333, -0.601824
6.416667, -0.596953
6.420000, -0.592201
6.423333, -0.587823
6.426667, -0.583783
6.430000, -0.579893
6.433333, -0.576197
6.436667, -0.573035
6.440000, -0.570628
6.443333, -0.568854
6.446667, -0.567539
6.450000, -0.566528
6.453333, -0.565435
6.456667, -0.563776
6.460000, -0.561454
6.463333, -0.558727
6.466667, -0.555557
6.470000, -0.551263
6.473333, -0.544672
6.476667, -0.534433
6.480000, -0.519364
6.483333, -0.498613
6.486667, -0.471518
6.490000, -0.437397
6.493333, -0.395548
6.496667, -0.345679
6.500000, -0.288501
6.503333, -0.226405
6.506667, -0.163748
6.510000, -0.106054
6.513333, -0.058486
6.516667, -0.024659
6.520000, -0.006289
6.523333, -0.003468
6.526667, -0.015044
6.530000, -0.038989
6.533333, -0.072739
6.536667, -0.113486
6.540000, -0.158445
6.543333, -0.204975
6.546667, -0.250747
6.550000, -0.294107
6.553333, -0.334275
6.556667, -0.371196
6.560000, -0.405133
6.563333, -0.436186
6.566667, -0.464139
6.570000, -0.488876
6.573333, -0.510672
6.576667, -0.529897
6.580000, -0.546844
6.583333, -0.562030
6.586667, -0.576254
6.590000, -0.590045
6.593333, -0.603207
6.596667, -0.615266
6.600000, -0.626095
6.603333, -0.635833
6.606667, -0.644604
6.610000, -0.652537
6.613333, -0.659848
6.616667, -0.666881
6.620000, -0.674022
6.623333, -0.681411
6.626667, -0.688719
6.630000, -0.695418
6.633333, -0.701085
6.636667, -0.705320
6.640000, -0.707870
6.643333, -0.709083
6.646667, -0.709813
6.650000, -0.710730
6.653333, -0.711983
6.656667, -0.713454
6.660000, -0.715045
6.663333, -0.716710
6.666667, -0.718388
6.670000, -0.719952
6.673333, -0.721120
6.676667, -0.721619
6.680000, -0.721572
6.683333, -0.721491
6.686667, -0.721794
6.690000, -0.722438
6.693333, -0.723047
6.696667, -0.723358
6.700000, -0.723384
6.703333, -0.723170
6.706667, -0.722674
6.710000, -0.721917
6.713333, -0.721045
6.716667, -0.720249
6.720000, -0.719756
6.723333, -0.719981
6.726667, -0.721346
6.730000, -0.723618
6.733333, -0.725922
6.736667, -0.727774
6.740000, -0.729433
6.743333, -0.731048
6.746667, -0.732255
6.750000, -0.732909
6.753333, -0.733646
6.756667, -0.735331
6.760000, -0.738044
6.763333, -0.740901
6.766667, -0.742822
6.770000, -0.743412
6.773333, -0.743242
6.776667, -0.743405
6.780000, -0.744772
6.783333, -0.747439
6.786667, -0.750675
6.790000, -0.753432
6.793333, -0.755103
6.796667, -0.755802
6.800000, -0.755951
6.803333, -0.755876
6.806667, -0.755800
6.810000, -0.756098
6.813333, -0.757294
6.816667, -0.759441
6.820000, -0.761839
6.823333, -0.763790
6.826667, -0.765243
6.830000, -0.766603
6.833333, -0.768261
6.836667, -0.770329
6.840000, -0.772549
6.843333, -0.774283
6.846667, -0.774909
6.850000, -0.774464
6.853333, -0.773645
6.856667, -0.773186
6.860000, -0.773515
6.863333, -0.774717
6.866667, -0.776573
6.870000, -0.778783
6.873333, -0.781175
6.876667, -0.783405
6.880000, -0.784697
6.883333, -0.784405
6.886667, -0.782765
6.890000, -0.780862
6.893333, -0.779760
6.896667, -0.779700
6.900000, -0.780112
6.903333, -0.780358
6.906667, -0.780289
6.910000, -0.780085
6.913333, -0.779913
6.916667, -0.779773
6.920000, -0.779490
6.923333, -0.778894
6.926667, -0.778024
6.930000, -0.777049
6.933333, -0.776101
6.936667, -0.775342
6.940000, -0.774979
6.943333, -0.775133
6.946667, -0.775774
6.950000, -0.776597
6.953333, -0.777150
6.956667, -0.777296
6.960000, -0.777164
6.963333, -0.776762
6.966667, -0.775888
6.970000, -0.774273
6.973333, -0.771870
6.976667, -0.769185
6.980000, -0.767197
6.983333, -0.766632
6.986667, -0.767241
6.990000, -0.768070
6.993333, -0.768483
6.996667, -0.768502
7.000000, -0.768222
7.003333, -0.767444
7.006667, -0.765992
7.010000, -0.764112
7.013333, -0.762322
7.016667, -0.760939
7.020000, -0.759983
7.023333, -0.759456
7.026667, -0.759273
7.030000, -0.758950
7.033333, -0.757999
7.036667, -0.756410
7.040000, -0.754404
7.043333, -0.752325
7.046667, -0.750809
7.050000, -0.750444
7.053333, -0.751304
7.056667, -0.752839
7.060000, -0.754154
7.063333, -0.754627
7.066667, -0.754097
7.070000, -0.752506
7.073333, -0.750027
7.076667, -0.747334
7.080000, -0.745102
7.083333, -0.743598
7.086667, -0.742988
7.090000, -0.743496
7.093333, -0.745111
7.096667, -0.747420
7.100000, -0.749723
7.103333, -0.751234
7.106667, -0.751370
7.110000, -0.750055
7.113333, -0.747733
7.116667, -0.745040
7.120000, -0.742451
7.123333, -0.740206
7.126667, -0.738520
7.130000, -0.737718
7.133333, -0.737957
7.136667, -0.738831
7.140000, -0.739721
7.143333, -0.740401
7.146667, -0.740743
7.150000, -0.740373
7.153333, -0.739055
7.156667, -0.736967
7.160000, -0.734688
7.163333, -0.732941
7.166667, -0.732095
7.170000, -0.731968
7.173333, -0.731957
7.176667, -0.731345
7.180000, -0.729899
7.183333, -0.728009
7.186667, -0.726187
7.190000, -0.724809
7.193333, -0.724129
7.196667, -0.724156
7.200000, -0.724670
7.203333, -0.725474
7.206667, -0.726399
7.210000, -0.727207
7.213333, -0.727721
7.216667, -0.727894
7.220000, -0.727693
7.223333, -0.727116
7.226667, -0.726397
7.230000, -0.725888
7.233333, -0.725771
7.236667, -0.725982
7.240000, -0.726276
7.243333, -0.726434
7.246667, -0.726613
7.250000, -0.727253
7.253333, -0.728524
7.256667, -0.730026
7.260000, -0.731168
7.263333, -0.731700
7.266667, -0.731734
7.270000, -0.731441
7.273333, -0.730994
7.276667, -0.730734
7.280000, -0.731106
7.283333, -0.732299
7.286667, -0.734157
7.290000, -0.736317
7.293333, -0.738236
7.296667, -0.739520
7.300000, -0.740381
7.303333, -0.741403
7.306667, -0.743002
7.310000, -0.745300
7.313333, -0.748201
7.316667, -0.751502
7.320000, -0.754890
7.323333, -0.757816
7.326667, -0.759734
7.330000, -0.760590
7.333333, -0.760826
7.336667, -0.761046
7.340000, -0.761865
7.343333, -0.763690
7.346667, -0.766439
7.350000, -0.769617
7.353333, -0.772655
7.356667, -0.775114
7.360000, -0.776726
7.363333, -0.777505
7.366667, -0.777842
7.370000, -0.778452
7.373333, -0.780018
7.376667, -0.782663
7.380000, -0.785912
7.383333, -0.789141
7.386667, -0.791938
7.390000, -0.794162
7.393333, -0.795789
7.396667, -0.796888
7.400000, -0.797733
7.403333, -0.798596
7.406667, -0.799402
7.410000, -0.799987
7.413333, -0.800575
7.416667, -0.801577
7.420000, -0.803264
7.423333, -0.805708
7.426667, -0.808664
7.430000, -0.811608
7.433333, -0.814014
7.436667, -0.815539
7.440000, -0.816118
7.443333, -0.816053
7.446667, -0.815968
7.450000, -0.816452
7.453333, -0.817656
7.456667, -0.819314
7.460000, -0.821144
7.463333, -0.823091
7.466667, -0.825024
7.470000, -0.826581
7.473333, -0.827564
7.476667, -0.828144
7.480000, -0.828681
7.483333, -0.829498
7.486667, -0.830725
7.490000, -0.832192
7.493333, -0.833363
7.496667, -0.833723
7.500000, -0.833220
7.503333, -0.832084
7.506667, -0.830581
7.510000, -0.829040
7.513333, -0.827888
7.516667, -0.827443
7.520000, -0.827565
7.523333, -0.827716
7.526667, -0.827392
7.530000, -0.826495
7.533333, -0.825467
7.536667, -0.824951
7.540000, -0.825114
7.543333, -0.825339
7.546667, -0.824804
7.550000, -0.823174
7.553333, -0.820521
7.556667, -0.816940
7.560000, -0.812537
7.563333, -0.807574
7.566667, -0.802447
7.570000, -0.797492
7.573333, -0.792889
7.576667, -0.788655
7.580000, -0.784489
7.583333, -0.779792
7.586667, -0.774174
7.590000, -0.767724
7.593333, -0.760615
7.596667, -0.752919
7.600000, -0.744876
7.603333, -0.736865
7.606667, -0.729026
7.610000, -0.721303
7.613333, -0.713742
7.616667, -0.706393
7.620000, -0.699094
7.623333, -0.691513
7.626667, -0.683398
7.630000, -0.674822
7.633333, -0.666103
7.636667, -0.657599
7.640000, -0.649595
7.643333, -0.642169
7.646667, -0.635260
7.650000, -0.628857
7.653333, -0.622748
7.656667, -0.616270
7.660000, -0.608854
7.663333, -0.600697
7.666667, -0.592532
7.670000, -0.585044
7.673333, -0.578602
7.676667, -0.573163
7.680000, -0.568497
7.683333, -0.564688
7.686667, -0.562146
7.690000, -0.561081
7.693333, -0.561143
7.696667, -0.561589
7.700000, -0.561767
7.703333, -0.561311
7.706667, -0.560016
7.710000, -0.558014
7.713333, -0.555945
7.716667, -0.554531
7.720000, -0.553999
7.723333, -0.554129
7.726667, -0.554800
7.730000, -0.556071
7.733333, -0.557859
7.736667, -0.559996
7.740000, -0.562402
7.743333, -0.565066
7.746667, -0.568005
7.750000, -0.571115
7.753333, -0.574025
7.756667, -0.576406
7.760000, -0.578378
7.763333, -0.580506
7.766667, -0.583644
7.770000, -0.588665
7.773333, -0.595860
7.776667, -0.604625
7.780000, -0.613869
7.783333, -0.622586
7.786667, -0.630368
7.790000, -0.637618
7.793333, -0.644982
7.796667, -0.652779
7.800000, -0.661152
7.803333, -0.670392
7.806667, -0.680707
7.810000, -0.691739
7.813333, -0.702663
7.816667, -0.712786
7.820000, -0.721919
7.823333, -0.730294
7.826667, -0.738360
7.830000, -0.746546
7.833333, -0.755011
7.836667, -0.763666
7.840000, -0.772414
7.843333, -0.781135
7.846667, -0.789526
7.850000, -0.797168
7.853333, -0.803860
7.856667, -0.809761
7.860000, -0.815137
7.863333, -0.820192
7.866667, -0.825192
7.870000, -0.830481
7.873333, -0.836213
7.876667, -0.842229
7.880000, -0.848312
7.883333, -0.854286
7.886667, -0.859902
7.890000, -0.864895
7.893333, -0.869177
7.896667, -0.872837
7.900000, -0.875969
7.903333, -0.878590
7.906667, -0.880713
7.910000, -0.882412
7.913333, -0.883954
7.916667, -0.885836
7.920000, -0.888398
7.923333, -0.891424
7.926667, -0.894396
7.930000, -0.897001
7.933333, -0.899186
7.936667, -0.900936
7.940000, -0.902227
7.943333, -0.903051
7.946667, -0.903424
7.950000, -0.903526
7.953333, -0.903625
7.956667, -0.903745
7.960000, -0.903737
7.963333, -0.903663
7.966667, -0.903779
7.970000, -0.904293
7.973333, -0.905204
7.976667, -0.906166
7.980000, -0.906631
7.983333, -0.906199
7.986667, -0.904892
7.990000, -0.903285
7.993333, -0.902181
7.996667, -0.901962
8.000000, -0.902276
8.003333, -0.902426
8.006667, -0.902155
8.010000, -0.901871
8.013333, -0.901983
8.016667, -0.902445
8.020000, -0.902821
8.023333, -0.902422
8.026667, -0.900725
8.030000, -0.897957
8.033333, -0.895084
8.036667, -0.893136
8.040000, -0.892558
8.043333, -0.893104
8.046667, -0.894092
8.050000, -0.894713
8.053333, -0.894425
8.056667, -0.893273
8.060000, -0.891741
8.063333, -0.890249
8.066667, -0.888942
8.070000, -0.887796
8.073333, -0.886589
8.076667, -0.885031
8.080000, -0.883156
8.083333, -0.881280
8.086667, -0.879555
8.090000, -0.877893
8.093333, -0.876204
8.096667, -0.874450
8.100000, -0.872616
8.103333, -0.870771
8.106667, -0.869086
8.110000, -0.867621
8.113333, -0.866165
8.116667, -0.864639
8.120000, -0.863317
8.123333, -0.862265
8.126667, -0.861030
8.130000, -0.859064
8.133333, -0.856149
8.136667, -0.852504
8.140000, -0.848563
8.143333, -0.844613
8.146667, -0.840804
8.150000, -0.837328
8.153333, -0.834333
8.156667, -0.831812
8.160000, -0.829613
8.163333, -0.827323
8.166667, -0.824350
8.170000, -0.820472
8.173333, -0.816036
8.176667, -0.811408
8.180000, -0.806586
8.183333, -0.801456
8.186667, -0.795999
8.190000, -0.790219
8.193333, -0.784239
8.196667, -0.778337
8.200000, -0.772706
8.203333, -0.767388
8.206667, -0.762311
8.210000, -0.757247
8.213333, -0.752012
8.216667, -0.746699
8.220000, -0.741326
8.223333, -0.735519
8.226667, -0.728911
8.230000, -0.721594
8.233333, -0.713994
8.236667, -0.706525
8.240000, -0.699339
8.243333, -0.692189
8.246667, -0.684682
8.250000, -0.676892
8.253333, -0.669466
8.256667, -0.662835
8.260000, -0.656665
8.263333, -0.650260
8.266667, -0.643151
8.270000, -0.635291
8.273333, -0.626959
8.276667, -0.618436
8.280000, -0.609777
8.283333, -0.600978
8.286667, -0.592112
8.290000, -0.583189
8.293333, -0.574265
8.296667, -0.565716
8.300000, -0.557999
8.303333, -0.551114
8.306667, -0.544545
8.310000, -0.537725
8.313333, -0.530484
8.316667, -0.523094
8.320000, -0.516084
8.323333, -0.510013
8.326667, -0.505155
8.330000, -0.501299
8.333333, -0.497900
8.336667, -0.494431
8.340000, -0.490612
8.343333, -0.486644
8.346667, -0.483217
8.350000, -0.480808
8.353333, -0.479286
8.356667, -0.478549
8.360000, -0.478727
8.363333, -0.479557
8.366667, -0.480443
8.370000, -0.481316
8.373333, -0.482858
8.376667, -0.485617
8.380000, -0.489348
8.383333, -0.493412
8.386667, -0.497394
8.390000, -0.501330
8.393333, -0.505600
8.396667, -0.510615
8.400000, -0.516464
8.403333, -0.522778
8.406667, -0.529096
8.410000, -0.535365
8.413333, -0.541840
8.416667, -0.548512
8.420000, -0.555014
8.423333, -0.561175
8.426667, -0.567415
8.430000, -0.574374
8.433333, -0.582336
8.436667, -0.591072
8.440000, -0.599959
8.443333, -0.608218
8.446667, -0.615354
8.450000, -0.621613
8.453333, -0.627880
8.456667, -0.634813
8.460000, -0.642242
8.463333, -0.649605
8.466667, -0.656650
8.470000, -0.663501
8.473333, -0.670502
8.476667, -0.678111
8.480000, -0.686545
8.483333, -0.695424
8.486667, -0.703867
8.490000, -0.710948
8.493333, -0.716393
8.496667, -0.720749
8.500000, -0.724709
8.503333, -0.728549
8.506667, -0.732187
8.510000, -0.735531
8.513333, -0.738779
8.516667, -0.742199
8.520000, -0.745765
8.523333, -0.749344
8.526667, -0.752871
8.530000, -0.756184
8.533333, -0.759025
8.536667, -0.761256
8.540000, -0.762934
8.543333, -0.764325
8.546667, -0.765788
8.550000, -0.767468
8.553333, -0.769279
8.556667, -0.771117
8.560000, -0.772750
8.563333, -0.773829
8.566667, -0.774344
8.570000, -0.774837
8.573333, -0.775918
8.576667, -0.777614
8.580000, -0.779388
8.583333, -0.780895
8.586667, -0.782323
8.590000, -0.783776
8.593333, -0.784848
8.596667, -0.785089
8.600000, -0.784443
8.603333, -0.783309
8.606667, -0.782386
8.610000, -0.782134
8.613333, -0.782491
8.616667, -0.783192
8.620000, -0.784019
8.623333, -0.784753
8.626667, -0.785128
8.630000, -0.785120
8.633333, -0.785127
8.636667, -0.785426
8.640000, -0.785793
8.643333, -0.785925
8.646667, -0.785823
8.650000, -0.785743
8.653333, -0.785984
8.656667, -0.786653
8.660000, -0.787608
8.663333, -0.788665
8.666667, -0.789819
8.670000, -0.791101
8.673333, -0.792231
8.676667, -0.792655
8.680000, -0.792097
8.683333, -0.790957
8.686667, -0.790012
8.690000, -0.789881
8.693333, -0.790734
8.696667, -0.792198
8.700000, -0.793613
8.703333, -0.794599
8.706667, -0.795220
8.710000, -0.795659
8.713333, -0.795985
8.716667, -0.796212
8.720000, -0.796487
8.723333, -0.797121
8.726667, -0.798254
8.730000, -0.799689
8.733333, -0.801203
8.736667, -0.802699
8.740000, -0.804081
8.743333, -0.805188
8.746667, -0.805840
8.750000, -0.805933
8.753333, -0.805611
8.756667, -0.805208
8.760000, -0.805063
8.763333, -0.805453
8.766667, -0.806530
8.770000, -0.808228
8.773333, -0.810206
8.776667, -0.811949
8.780000, -0.813112
8.783333, -0.813732
8.786667, -0.814011
8.790000, -0.814172
8.793333, -0.814460
8.796667, -0.815061
8.800000, -0.816046
8.803333, -0.817394
8.806667, -0.819029
8.810000, -0.820831
8.813333, -0.822499
8.816667, -0.823688
8.820000, -0.824353
8.823333, -0.824583
8.826667, -0.824324
8.830000, -0.823566
8.833333, -0.822470
8.836667, -0.821248
8.840000, -0.820081
8.843333, -0.819106
8.846667, -0.818467
8.850000, -0.818395
8.853333, -0.819066
8.856667, -0.820335
8.860000, -0.821749
8.863333, -0.822995
8.866667, -0.824278
8.870000, -0.826044
8.873333, -0.828256
8.876667, -0.830292
8.880000, -0.831573
8.883333, -0.831917
8.886667, -0.831481
8.890000, -0.830655
8.893333, -0.829835
8.896667, -0.829187
8.900000, -0.828660
8.903333, -0.828137
8.906667, -0.827608
8.910000, -0.827405
8.913333, -0.828215
8.916667, -0.830530
8.920000, -0.834122
8.923333, -0.838292
8.926667, -0.842311
8.930000, -0.845444
8.933333, -0.847060
8.936667, -0.847123
8.940000, -0.846291
8.943333, -0.845313
8.946667, -0.844384
8.950000, -0.843188
8.953333, -0.841526
8.956667, -0.839766
8.960000, -0.838604
8.963333, -0.838456
8.966667, -0.839114
8.970000, -0.839967
8.973333, -0.840631
8.976667, -0.841298
8.980000, -0.842268
8.983333, -0.843388
8.986667, -0.844195
8.990000, -0.844507
8.993333, -0.844634
8.996667, -0.844864
9.000000, -0.844899
9.003333, -0.844134
9.006667, -0.842480
9.010000, -0.840587
9.013333, -0.839226
9.016667, -0.838777
9.020000, -0.839218
9.023333, -0.840084
9.026667, -0.840485
9.030000, -0.839734
9.033333, -0.838025
9.036667, -0.836216
9.040000, -0.835161
9.043333, -0.835303
9.046667, -0.836477
9.050000, -0.838069
9.053333, -0.839475
9.056667, -0.840373
9.060000, -0.840693
9.063333, -0.840577
9.066667, -0.840565
9.070000, -0.841456
9.073333, -0.843379
9.076667, -0.845484
9.080000, -0.846834
9.083333, -0.847169
9.086667, -0.846948
9.090000, -0.847093
9.093333, -0.848403
9.096667, -0.850835
9.100000, -0.853456
9.103333, -0.855305
9.106667, -0.856149
9.110000, -0.856400
9.113333, -0.856495
9.116667, -0.856505
9.120000, -0.856486
9.123333, -0.856827
9.126667, -0.857751
9.130000, -0.858848
9.133333, -0.859550
9.136667, -0.859803
9.140000, -0.859845
9.143333, -0.859591
9.146667, -0.858866
9.150000, -0.857933
9.153333, -0.857347
9.156667, -0.857467
9.160000, -0.858136
9.163333, -0.858770
9.166667, -0.858824
9.170000, -0.858110
9.173333, -0.856906
9.176667, -0.855909
9.180000, -0.855734
9.183333, -0.856344
9.186667, -0.856991
9.190000, -0.856829
9.193333, -0.855659
9.196667, -0.853990
9.200000, -0.852410
9.203333, -0.851221
9.206667, -0.850511
9.210000, -0.850203
9.213333, -0.850046
9.216667, -0.849680
9.220000, -0.848775
9.223333, -0.847247
9.226667, -0.845386
9.230000, -0.843762
9.233333, -0.843005
9.236667, -0.843336
9.240000, -0.844274
9.243333, -0.845199
9.246667, -0.846049
9.250000, -0.847084
9.253333, -0.848352
9.256667, -0.849596
9.260000, -0.850371
9.263333, -0.850338
9.266667, -0.849651
9.270000, -0.848850
9.273333, -0.848403
9.276667, -0.848497
9.280000, -0.848971
9.283333, -0.849422
9.286667, -0.849621
9.290000, -0.849678
9.293333, -0.849656
9.296667, -0.849337
9.300000, -0.848598
9.303333, -0.847739
9.306667, -0.847236
9.310000, -0.847293
9.313333, -0.847710
9.316667, -0.848287
9.320000, -0.849182
9.323333, -0.850638
9.326667, -0.852520
9.330000, -0.854323
9.333333, -0.855549
9.336667, -0.856114
9.340000, -0.856323
9.343333, -0.856435
9.346667, -0.856551
9.350000, -0.857047
9.353333, -0.858561
9.356667, -0.861119
9.360000, -0.863793
9.363333, -0.865601
9.366667, -0.866285
9.370000, -0.866164
9.373333, -0.865805
9.376667, -0.865831
9.380000, -0.866566
9.383333, -0.867752
9.386667, -0.868902
9.390000, -0.869808
9.393333, -0.870363
9.396667, -0.870395
9.400000, -0.870035
9.403333, -0.869640
9.406667, -0.869395
9.410000, -0.869314
9.413333, -0.869365
9.416667, -0.869562
9.420000, -0.870015
9.423333, -0.870670
9.426667, -0.871135
9.430000, -0.870901
9.433333, -0.869726
9.436667, -0.867962
9.440000, -0.866373
9.443333, -0.865334
9.446667, -0.864559
9.450000, -0.863827
9.453333, -0.863483
9.456667, -0.863851
9.460000, -0.864575
9.463333, -0.865066
9.466667, -0.865280
9.470000, -0.865679
9.473333, -0.866615
9.476667, -0.867913
9.480000, -0.869019
9.483333, -0.869430
9.486667, -0.868979
9.490000, -0.867922
9.493333, -0.866746
9.496667, -0.865831
9.500000, -0.865433
9.503333, -0.865782
9.506667, -0.866894
9.510000, -0.868469
9.513333, -0.870091
9.516667, -0.871388
9.520000, -0.872130
9.523333, -0.872306
9.526667, -0.872120
9.530000, -0.871908
9.533333, -0.871854
9.536667, -0.871868
9.540000, -0.871949
9.543333, -0.872290
9.546667, -0.872846
9.550000, -0.873223
9.553333, -0.873177
9.556667, -0.872915
9.560000, -0.872733
9.563333, -0.872581
9.566667, -0.872257
9.570000, -0.871870
9.573333, -0.871688
9.576667, -0.871529
9.580000, -0.870855
9.583333, -0.869423
9.586667, -0.867470
9.590000, -0.865412
9.593333, -0.863587
9.596667, -0.862223
9.600000, -0.861540
9.603333, -0.861717
9.606667, -0.862769
9.610000, -0.864272
9.613333, -0.865218
9.616667, -0.864691
9.620000, -0.862655
9.623333, -0.859961
9.626667, -0.857741
9.630000, -0.856572
9.633333, -0.856106
9.636667, -0.855642
9.640000, -0.854887
9.643333, -0.854085
9.646667, -0.853592
9.650000, -0.853542
9.653333, -0.853888
9.656667, -0.854426
9.660000, -0.854836
9.663333, -0.855017
9.666667, -0.855202
9.670000, -0.855709
9.673333, -0.856647
9.676667, -0.857668
9.680000, -0.858216
9.683333, -0.858167
9.686667, -0.857870
9.690000, -0.857603
9.693333, -0.857525
9.696667, -0.857926
9.700000, -0.858891
9.703333, -0.860013
9.706667, -0.860667
9.710000, -0.860264
9.713333, -0.858648
9.716667, -0.856368
9.720000, -0.854172
9.723333, -0.852465
9.726667, -0.851457
9.730000, -0.851417
9.733333, -0.852515
9.736667, -0.854544
9.740000, -0.856947
9.743333, -0.859100
9.746667, -0.860513
9.750000, -0.861050
9.753333, -0.860982
9.756667, -0.860743
9.760000, -0.860749
9.763333, -0.861196
9.766667, -0.861985
9.770000, -0.862891
9.773333, -0.863732
9.776667, -0.864432
9.780000, -0.864847
9.783333, -0.864659
9.786667, -0.863813
9.790000, -0.862891
9.793333, -0.862660
9.796667, -0.863318
9.800000, -0.864354
9.803333, -0.864920
9.806667, -0.864385
9.810000, -0.862924
9.813333, -0.861445
9.816667, -0.860766
9.820000, -0.861109
9.823333, -0.862300
9.826667, -0.863997
9.830000, -0.865864
9.833333, -0.867826
9.836667, -0.869915
9.840000, -0.871957
9.843333, -0.873758
9.846667, -0.875147
9.850000, -0.875774
9.853333, -0.875496
9.856667, -0.874775
9.860000, -0.874186
9.863333, -0.873816
9.866667, -0.873452
9.870000, -0.873174
9.873333, -0.873335
9.876667, -0.873885
9.880000, -0.874329
9.883333, -0.874439
9.886667, -0.874495
9.890000, -0.875034
9.893333, -0.876486
9.896667, -0.878771
9.900000, -0.881268
9.903333, -0.883204
9.906667, -0.884042
9.910000, -0.883725
9.913333, -0.882866
9.916667, -0.882510
9.920000, -0.883404
9.923333, -0.885497
9.926667, -0.888156
9.930000, -0.890667
9.933333, -0.892519
9.936667, -0.893519
9.940000, -0.893794
9.943333, -0.893613
9.946667, -0.893145
9.950000, -0.892347
9.953333, -0.891217
9.956667, -0.890068
9.960000, -0.889412
9.963333, -0.889499
9.966667, -0.890059
9.970000, -0.890590
9.973333, -0.890812
9.976667, -0.890887
9.980000, -0.891268
9.983333, -0.892235
9.986667, -0.893653
9.990000, -0.895232
9.993333, -0.896995
9.996667, -0.899303
10.000000, -0.902178
10.003333, -0.905043
10.006667, -0.907383
10.010000, -0.909110
10.013333, -0.910151
10.016667, -0.910291
10.020000, -0.909562
10.023333, -0.908461
10.026667, -0.907501
10.030000, -0.906712
10.033333, -0.905870
10.036667, -0.904853
10.040000, -0.903713
10.043333, -0.902857
10.046667, -0.902860
10.050000, -0.903901
10.053333, -0.905680
10.056667, -0.907623
10.060000, -0.909065
10.063333, -0.909708
10.066667, -0.909991
10.070000, -0.910700
10.073333, -0.912147
10.076667, -0.913956
10.080000, -0.915640
10.083333, -0.917062
10.086667, -0.918215
10.090000, -0.918921
10.093333, -0.919128
10.096667, -0.919226
10.100000, -0.919683
10.103333, -0.920484
10.106667, -0.921123
10.110000, -0.921065
10.113333, -0.920197
10.116667, -0.918962
10.120000, -0.918123
10.123333, -0.918336
10.126667, -0.919790
10.130000, -0.922054
10.133333, -0.924215
10.136667, -0.925413
10.140000, -0.925366
10.143333, -0.924530
10.146667, -0.923895
10.150000, -0.924282
10.153333, -0.925540
10.156667, -0.926777
10.160000, -0.927352
10.163333, -0.927095
10.166667, -0.925972
10.170000, -0.924311
10.173333, -0.922944
10.176667, -0.922541
10.180000, -0.923006
10.183333, -0.923619
10.186667, -0.923626
10.190000, -0.922748
10.193333, -0.921265
10.196667, -0.919777
10.200000, -0.918865
10.203333, -0.918729
10.206667, -0.919070
10.210000, -0.919410
10.213333, -0.919444
10.216667, -0.918948
10.220000, -0.917733
10.223333, -0.915969
10.226667, -0.914296
10.230000, -0.913446
10.233333, -0.913748
10.236667, -0.914862
10.240000, -0.915944
10.243333, -0.916194
10.246667, -0.915443
10.250000, -0.914198
10.253333, -0.913000
10.256667, -0.911980
10.260000, -0.911108
10.263333, -0.910485
10.266667, -0.910273
10.270000, -0.910485
10.273333, -0.910892
10.276667, -0.911041
10.280000, -0.910330
10.283333, -0.908456
10.286667, -0.905839
10.290000, -0.903345
10.293333, -0.901663
10.296667, -0.901031
10.300000, -0.901259
10.303333, -0.901887
10.306667, -0.902411
10.310000, -0.902375
10.313333, -0.901498
10.316667, -0.899906
10.320000, -0.898057
10.323333, -0.896512
10.326667, -0.895718
10.330000, -0.895790
10.333333, -0.896427
10.336667, -0.897109
10.340000, -0.897414
10.343333, -0.897201
10.346667, -0.896537
10.350000, -0.895695
10.353333, -0.895140
10.356667, -0.895099
10.360000, -0.895315
10.363333, -0.895486
10.366667, -0.895536
10.370000, -0.895377
10.373333, -0.895079
10.376667, -0.895120
10.380000, -0.895800
10.383333, -0.896854
10.386667, -0.897981
10.390000, -0.899047
10.393333, -0.899869
10.396667, -0.900358
10.400000, -0.900686
10.403333, -0.901146
10.406667, -0.901978
10.410000, -0.903073
10.413333, -0.903900
10.416667, -0.904114
10.420000, -0.903995
10.423333, -0.904014
10.426667, -0.904472
10.430000, -0.905566
10.433333, -0.907241
10.436667, -0.909144
10.440000, -0.910930
10.443333, -0.912371
10.446667, -0.913229
10.450000, -0.913328
10.453333, -0.912800
10.456667, -0.912083
10.460000, -0.911600
10.463333, -0.911612
10.466667, -0.912251
10.470000, -0.913383
10.473333, -0.914505
10.476667, -0.915127
10.480000, -0.915283
10.483333, -0.915461
10.486667, -0.916072
10.490000, -0.917223
10.493333, -0.918733
10.496667, -0.920001
10.500000, -0.920228
10.503333, -0.919039
10.506667, -0.916699
10.510000, -0.913995
10.513333, -0.912021
10.516667, -0.911514
10.520000, -0.912217
10.523333, -0.913241
10.526667, -0.913949
10.530000, -0.914228
10.533333, -0.914211
10.536667, -0.914098
10.540000, -0.914002
10.543333, -0.913932
10.546667, -0.913999
10.550000, -0.914338
10.553333, -0.914930
10.556667, -0.915751
10.560000, -0.916906
10.563333, -0.918495
10.566667, -0.920319
10.570000, -0.921917
10.573333, -0.923076
10.576667, -0.923964
10.580000, -0.924683
10.583333, -0.925074
10.586667, -0.924956
10.590000, -0.924429
10.593333, -0.923919
10.596667, -0.923800
10.600000, -0.923957
10.603333, -0.924068
10.606667, -0.924171
10.610000, -0.924462
10.613333, -0.924794
10.616667, -0.924872
10.620000, -0.924739
10.623333, -0.924746
10.626667, -0.925133
10.630000, -0.925784
10.633333, -0.926392
10.636667, -0.926780
10.640000, -0.926985
10.643333, -0.927036
10.646667, -0.926902
10.650000, -0.926619
10.653333, -0.926285
10.656667, -0.925916
10.660000, -0.925414
10.663333, -0.924836
10.666667, -0.924506
10.670000, -0.924505
10.673333, -0.924568
10.676667, -0.924600
10.680000, -0.924770
10.683333, -0.925240
10.686667, -0.926120
10.690000, -0.927505
10.693333, -0.929372
10.696667, -0.931378
10.700000, -0.932926
10.703333, -0.933674
10.706667, -0.933766
10.710000, -0.933496
10.713333, -0.932959
10.716667, -0.932072
10.720000, -0.930818
10.723333, -0.929489
10.726667, -0.928690
10.730000, -0.928904
10.733333, -0.929986
10.736667, -0.931377
10.740000, -0.932650
10.743333, -0.933577
10.746667, -0.934078
10.750000, -0.934308
10.753333, -0.934473
10.756667, -0.934573
10.760000, -0.934475
10.763333, -0.934097
10.766667, -0.933558
10.770000, -0.933248
10.773333, -0.933609
10.776667, -0.934748
10.780000, -0.936141
10.783333, -0.936794
10.786667, -0.936138
10.790000, -0.934743
10.793333, -0.933695
10.796667, -0.933482
10.800000, -0.933746
10.803333, -0.933823
10.806667, -0.933451
10.810000, -0.933003
10.813333, -0.933012
10.816667, -0.933636
10.820000, -0.934554
10.823333, -0.935287
10.826667, -0.935552
10.830000, -0.935259
10.833333, -0.934439
10.836667, -0.933480
10.840000, -0.933031
10.843333, -0.933414
10.846667, -0.934375
10.850000, -0.935356
10.853333, -0.935876
10.856667, -0.935837
10.860000, -0.935563
10.863333, -0.935394
10.866667, -0.935351
10.870000, -0.935491
10.873333, -0.936157
10.876667, -0.937514
10.880000, -0.939305
10.883333, -0.940985
10.886667, -0.941795
10.890000, -0.941282
10.893333, -0.939721
10.896667, -0.937559
10.900000, -0.934986
10.903333, -0.932304
10.906667, -0.930107
10.910000, -0.928895
10.913333, -0.928822
10.916667, -0.929717
10.920000, -0.930942
10.923333, -0.931460
10.926667, -0.930590
10.930000, -0.928517
10.933333, -0.925883
10.936667, -0.923324
10.940000, -0.921375
10.943333, -0.920125
10.946667, -0.918992
10.950000, -0.917255
10.953333, -0.914752
10.956667, -0.912006
10.960000, -0.909743
10.963333, -0.908248
10.966667, -0.907208
10.970000, -0.906072
10.973333, -0.904473
10.976667, -0.902394
10.980000, -0.900094
10.983333, -0.897923
10.986667, -0.896136
10.990000, -0.894941
10.993333, -0.894534
10.996667, -0.894846
11.000000, -0.895481
11.003333, -0.896021
11.006667, -0.896214
11.010000, -0.895961
11.013333, -0.895192
11.016667, -0.893674
11.020000, -0.891064
11.023333, -0.887401
11.026667, -0.883400
11.030000, -0.879888
11.033333, -0.876998
11.036667, -0.874324
11.040000, -0.871618
11.043333, -0.868882
11.046667, -0.866160
11.050000, -0.863563
11.053333, -0.861221
11.056667, -0.859132
11.060000, -0.857218
11.063333, -0.855573
11.066667, -0.854413
11.070000, -0.853740
11.073333, -0.853249
11.076667, -0.852490
11.080000, -0.851133
11.083333, -0.849245
11.086667, -0.847220
11.090000, -0.845316
11.093333, -0.843364
11.096667, -0.841108
11.100000, -0.838581
11.103333, -0.836010
11.106667, -0.833780
11.110000, -0.832370
11.113333, -0.831843
11.116667, -0.831783
11.120000, -0.831923
11.123333, -0.832303
11.126667, -0.832954
11.130000, -0.833707
11.133333, -0.834127
11.136667, -0.833756
11.140000, -0.832759
11.143333, -0.831965
11.146667, -0.832053
11.150000, -0.833167
11.153333, -0.835144
11.156667, -0.837617
11.160000, -0.840245
11.163333, -0.842923
11.166667, -0.845568
11.170000, -0.847796
11.173333, -0.848967
11.176667, -0.848810
11.180000, -0.847862
11.183333, -0.846902
11.186667, -0.846288
11.190000, -0.846126
11.193333, -0.846528
11.196667, -0.847294
11.200000, -0.847793
11.203333, -0.847485
11.206667, -0.846485
11.210000, -0.845530
11.213333, -0.845345
11.216667, -0.846218
11.220000, -0.848136
11.223333, -0.850872
11.226667, -0.853852
11.230000, -0.856298
11.233333, -0.857666
11.236667, -0.857912
11.240000, -0.857372
11.243333, -0.856375
11.246667, -0.855022
11.250000, -0.853491
11.253333, -0.852200
11.256667, -0.851436
11.260000, -0.851100
11.263333, -0.850918
11.266667, -0.850720
11.270000, -0.850609
11.273333, -0.850818
11.276667, -0.851490
11.280000, -0.852741
11.283333, -0.854587
11.286667, -0.856664
11.290000, -0.858356
11.293333, -0.859270
11.296667, -0.859494
11.300000, -0.859307
11.303333, -0.858799
11.306667, -0.858038
11.310000, -0.857326
11.313333, -0.857005
11.316667, -0.857268
11.320000, -0.858144
11.323333, -0.859459
11.326667, -0.860878
11.330000, -0.862137
11.333333, -0.863243
11.336667, -0.864335
11.340000, -0.865453
11.343333, -0.866546
11.346667, -0.867459
11.350000, -0.868062
11.353333, -0.868394
11.356667, -0.868486
11.360000, -0.868302
11.363333, -0.867880
11.366667, -0.867341
11.370000, -0.866827
11.373333, -0.866433
11.376667, -0.866196
11.380000, -0.866146
11.383333, -0.866372
11.386667, -0.867110
11.390000, -0.868560
11.393333, -0.870644
11.396667, -0.872952
11.400000, -0.874726
11.403333, -0.875130
11.406667, -0.873931
11.410000, -0.871782
11.413333, -0.869697
11.416667, -0.868392
11.420000, -0.868150
11.423333, -0.868948
11.426667, -0.870487
11.430000, -0.872248
11.433333, -0.873721
11.436667, -0.874685
11.440000, -0.875156
11.443333, -0.875120
11.446667, -0.874676
11.450000, -0.874315
11.453333, -0.874604
11.456667, -0.875715
11.460000, -0.877325
11.463333, -0.878826
11.466667, -0.879755
11.470000, -0.880010
11.473333, -0.879636
11.476667, -0.878718
11.480000, -0.877493
11.483333, -0.876262
11.486667, -0.875197
11.490000, -0.874370
11.493333, -0.873858
11.496667, -0.873702
11.500000, -0.873896
11.503333, -0.874333
11.506667, -0.874618
11.510000, -0.874350
11.513333, -0.873728
11.516667, -0.873437
11.520000, -0.874019
11.523333, -0.875595
11.526667, -0.877791
11.530000, -0.879830
11.533333, -0.880942
11.536667, -0.880712
11.540000, -0.879237
11.543333, -0.877098
11.546667, -0.874988
11.550000, -0.873368
11.553333, -0.872377
11.556667, -0.871880
11.560000, -0.871783
11.563333, -0.872233
11.566667, -0.873242
11.570000, -0.874448
11.573333, -0.875492
11.576667, -0.876250
11.580000, -0.876549
11.583333, -0.876108
11.586667, -0.874982
11.590000, -0.873714
11.593333, -0.872831
11.596667, -0.872415
11.600000, -0.872213
11.603333, -0.871834
11.606667, -0.870934
11.610000, -0.869504
11.613333, -0.867764
11.616667, -0.865952
11.620000, -0.864511
11.623333, -0.863983
11.626667, -0.864442
11.630000, -0.865360
11.633333, -0.866053
11.636667, -0.866093
11.640000, -0.865493
11.643333, -0.864676
11.646667, -0.864042
11.650000, -0.863644
11.653333, -0.863525
11.656667, -0.863853
11.660000, -0.864445
11.663333, -0.864807
11.666667, -0.864776
11.670000, -0.864550
11.673333, -0.864256
11.676667, -0.863790
11.680000, -0.862803
11.683333, -0.860908
11.686667, -0.858245
11.690000, -0.855777
11.693333, -0.854738
11.696667, -0.855605
11.700000, -0.857634
11.703333, -0.859526
11.706667, -0.860341
11.710000, -0.859762
11.713333, -0.857968
11.716667, -0.855626
11.720000, -0.853660
11.723333, -0.852603
11.726667, -0.852322
11.730000, -0.852479
11.733333, -0.852916
11.736667, -0.853471
11.740000, -0.853858
11.743333, -0.853869
11.746667, -0.853466
11.750000, -0.852687
11.753333, -0.851656
11.756667, -0.850683
11.760000, -0.850092
11.763333, -0.849841
11.766667, -0.849535
11.770000, -0.848895
11.773333, -0.848000
11.776667, -0.846949
11.780000, -0.845630
11.783333, -0.843969
11.786667, -0.842062
11.790000, -0.840024
11.793333, -0.837981
11.796667, -0.836089
11.800000, -0.834466
11.803333, -0.833158
11.806667, -0.832146
11.810000, -0.831245
11.813333, -0.830072
11.816667, -0.828388
11.820000, -0.826558
11.823333, -0.825221
11.826667, -0.824395
11.830000, -0.823334
11.833333, -0.821220
11.836667, -0.817853
11.840000, -0.813788
11.843333, -0.809684
11.846667, -0.805681
11.850000, -0.801633
11.853333, -0.797509
11.856667, -0.793298
11.860000, -0.788819
11.863333, -0.783827
11.866667, -0.778247
11.870000, -0.772235
11.873333, -0.766010
11.876667, -0.759750
11.880000, -0.753596
11.883333, -0.747666
11.886667, -0.742231
11.890000, -0.737622
11.893333, -0.733641
11.896667, -0.729395
11.900000, -0.723811
11.903333, -0.716292
11.906667, -0.707221
11.910000, -0.697766
11.913333, -0.688903
11.916667, -0.680827
11.920000, -0.673246
11.923333, -0.665876
11.926667, -0.658615
11.930000, -0.651462
11.933333, -0.644315
11.936667, -0.637074
11.940000, -0.629930
11.943333, -0.623099
11.946667, -0.616407
11.950000, -0.609532
11.953333, -0.602454
11.956667, -0.595355
11.960000, -0.588351
11.963333, -0.581641
11.966667, -0.575555
11.970000, -0.570166
11.973333, -0.565154
11.976667, -0.560154
11.980000, -0.555086
11.983333, -0.550140
11.986667, -0.545605
11.990000, -0.541803
11.993333, -0.539022
11.996667, -0.537343
12.000000, -0.536468
12.003333, -0.535743
12.006667, -0.534615
12.010000, -0.533247
12.013333, -0.532332
12.016667, -0.532309
12.020000, -0.533134
12.023333, -0.534515
12.026667, -0.536081
12.030000, -0.537639
12.033333, -0.539504
12.036667, -0.542358
12.040000, -0.546534
12.043333, -0.551607
12.046667, -0.556910
12.050000, -0.562138
12.053333, -0.567304
12.056667, -0.572465
12.060000, -0.577740
12.063333, -0.583482
12.066667, -0.590219
12.070000, -0.598136
12.073333, -0.606619
12.076667, -0.614662
12.080000, -0.621816
12.083333, -0.628615
12.086667, -0.635961
12.090000, -0.644202
12.093333, -0.653006
12.096667, -0.661737
12.100000, -0.669649
12.103333, -0.676231
12.106667, -0.681780
12.110000, -0.687395
12.113333, -0.694100
12.116667, -0.701971
12.120000, -0.710286
12.123333, -0.718318
12.126667, -0.725623
12.130000, -0.731905
12.133333, -0.737121
12.136667, -0.741538
12.140000, -0.745453
12.143333, -0.749058
12.146667, -0.752672
12.150000, -0.756749
12.153333, -0.761559
12.156667, -0.767021
12.160000, -0.772737
12.163333, -0.778032
12.166667, -0.782173
12.170000, -0.784859
12.173333, -0.786492
12.176667, -0.787790
12.180000, -0.789210
12.183333, -0.790805
12.186667, -0.792354
12.190000, -0.793608
12.193333, -0.794543
12.196667, -0.795214
12.200000, -0.795570
12.203333, -0.795643
12.206667, -0.795623
12.210000, -0.795624
12.213333, -0.795823
12.216667, -0.796632
12.220000, -0.798242
12.223333, -0.800292
12.226667, -0.802211
12.230000, -0.803579
12.233333, -0.804228
12.236667, -0.804118
12.240000, -0.803296
12.243333, -0.802225
12.246667, -0.801688
12.250000, -0.801981
12.253333, -0.802615
12.256667, -0.802913
12.260000, -0.802670
12.263333, -0.802161
12.266667, -0.801652
12.270000, -0.801174
12.273333, -0.800689
12.276667, -0.800159
12.280000, -0.799502
12.283333, -0.798715
12.286667, -0.797985
12.290000, -0.797469
12.293333, -0.796899
12.296667, -0.795674
12.300000, -0.793584
12.303333, -0.791179
12.306667, -0.789251
12.310000, -0.788055
12.313333, -0.787127
12.316667, -0.785806
12.320000, -0.783732
12.323333, -0.780947
12.326667, -0.777672
12.330000, -0.773926
12.333333, -0.769553
12.336667, -0.764540
12.340000, -0.758853
12.343333, -0.752188
12.346667, -0.744352
12.350000, -0.735492
12.353333, -0.725841
12.356667, -0.715548
12.360000, -0.704490
12.363333, -0.692307
12.366667, -0.679042
12.370000, -0.665294
12.373333, -0.651386
12.376667, -0.636876
12.380000, -0.620934
12.383333, -0.602680
12.386667, -0.581485
12.390000, -0.557476
12.393333, -0.531326
12.396667, -0.503367
12.400000, -0.473174
12.403333, -0.440020
12.406667, -0.403450
12.410000, -0.363534
12.413333, -0.320805
12.416667, -0.275795
12.420000, -0.228380
12.423333, -0.177766
12.426667, -0.123161
12.430000, -0.064155
12.433333, -0.000555
12.436667, 0.067736
12.440000, 0.140799
12.443333, 0.218783
12.446667, 0.301823
12.450000, 0.389903
12.453333, 0.482954
12.456667, 0.581199
12.460000, 0.685148
12.463333, 0.795113
12.466667, 0.911112
12.470000, 1.033212
12.473333, 1.161665
12.476667, 1.296863
12.480000, 1.439099
12.483333, 1.588347
12.486667, 1.744429
12.490000, 1.907299
12.493333, 2.077186
12.496667, 2.254590
12.500000, 2.440001
12.503333, 2.633407
12.506667, 2.834107
12.510000, 3.041142
12.513333, 3.253845
12.516667, 3.472058
12.520000, 3.696005
12.523333, 3.925928
12.526667, 4.161788
12.530000, 4.403332
12.533333, 4.650271
12.536667, 4.902120
12.540000, 5.158240
12.543333, 5.418304
12.546667, 5.682258
12.550000, 5.949739
12.553333, 6.219915
12.556667, 6.491740
12.560000, 6.764097
12.563333, 7.036045
12.566667, 7.307156
12.570000, 7.577429
12.573333, 7.846785
12.576667, 8.114620
12.580000, 8.379846
12.583333, 8.641320
12.586667, 8.898185
12.590000, 9.149970
12.593333, 9.396380
12.596667, 9.636665
12.600000, 9.869467
12.603333, 10.093515
12.606667, 10.308110
12.610000, 10.512854
12.613333, 10.707293
12.616667, 10.890940
12.620000, 11.063489
12.623333, 11.224774
12.626667, 11.374497
12.630000, 11.512052
12.633333, 11.636634
12.636667, 11.747480
12.640000, 11.843910
12.643333, 11.925334
12.646667, 11.991401
12.650000, 12.041887
12.653333, 12.076511
12.656667, 12.095128
12.660000, 12.097794
12.663333, 12.084712
12.666667, 12.056218
12.670000, 12.012474
12.673333, 11.953409
12.676667, 11.879108
12.680000, 11.789889
12.683333, 11.686056
12.686667, 11.567845
12.690000, 11.435679
12.693333, 11.290287
12.696667, 11.132410
12.700000, 10.962646
12.703333, 10.781648
12.706667, 10.590028
12.710000, 10.388145
12.713333, 10.176426
12.716667, 9.955578
12.720000, 9.726409
12.723333, 9.489670
12.726667, 9.246035
12.730000, 8.996284
12.733333, 8.741453
12.736667, 8.482579
12.740000, 8.220326
12.743333, 7.955144
12.746667, 7.687786
12.750000, 7.419315
12.753333, 7.150578
12.756667, 6.882080
12.760000, 6.614310
12.763333, 6.347840
12.766667, 6.083260
12.770000, 5.821158
12.773333, 5.562100
12.776667, 5.306669
12.780000, 5.055513
12.783333, 4.809194
12.786667, 4.568036
12.790000, 4.332234
12.793333, 4.102002
12.796667, 3.877486
12.800000, 3.658744
12.803333, 3.446044
12.806667, 3.239892
12.810000, 3.040513
12.813333, 2.847649
12.816667, 2.661080
12.820000, 2.481054
12.823333, 2.307892
12.826667, 2.141472
12.830000, 1.981458
12.833333, 1.827840
12.836667, 1.680899
12.840000, 1.540810
12.843333, 1.407612
12.846667, 1.281180
12.850000, 1.160983
12.853333, 1.046247
12.856667, 0.936504
12.860000, 0.831803
12.863333, 0.732320
12.866667, 0.637883
12.870000, 0.548081
12.873333, 0.462734
12.876667, 0.382051
12.880000, 0.306372
12.883333, 0.235821
12.886667, 0.170155
12.890000, 0.108947
12.893333, 0.051739
12.896667, -0.002061
12.900000, -0.053237
12.903333, -0.102429
12.906667, -0.149689
12.910000, -0.194434
12.913333, -0.236052
12.916667, -0.274459
12.920000, -0.309943
12.923333, -0.342827
12.926667, -0.373423
12.930000, -0.402049
12.933333, -0.428898
12.936667, -0.454036
12.940000, -0.477517
12.943333, -0.499357
12.946667, -0.519634
12.950000, -0.538607
12.953333, -0.556453
12.956667, -0.573208
12.960000, -0.589029
12.963333, -0.604137
12.966667, -0.618567
12.970000, -0.632245
12.973333, -0.645157
12.976667, -0.657244
12.980000, -0.668188
12.983333, -0.677673
12.986667, -0.686001
12.990000, -0.694097
12.993333, -0.702706
12.996667, -0.711708
13.000000, -0.720297
13.003333, -0.727786
13.006667, -0.734220
13.010000, -0.740189
13.013333, -0.746197
13.016667, -0.752339
13.020000, -0.758462
13.023333, -0.764461
13.026667, -0.770338
13.030000, -0.776069
13.033333, -0.781460
13.036667, -0.786126
13.040000, -0.789730
13.043333, -0.792359
13.046667, -0.794642
13.050000, -0.797330
13.053333, -0.800686
13.056667, -0.804424
13.060000, -0.808191
13.063333, -0.811979
13.066667, -0.815881
13.070000, -0.819631
13.073333, -0.822818
13.076667, -0.825384
13.080000, -0.827577
13.083333, -0.829691
13.086667, -0.832011
13.090000, -0.834774
13.093333, -0.837967
13.096667, -0.841194
13.100000, -0.843917
13.103333, -0.845767
13.106667, -0.846787
13.110000, -0.847561
13.113333, -0.848739
13.116667, -0.850401
13.120000, -0.852237
13.123333, -0.854073
13.126667, -0.855986
13.130000, -0.858067
13.133333, -0.860162
13.136667, -0.861946
13.140000, -0.863174
13.143333, -0.863728
13.146667, -0.863834
13.150000, -0.864259
13.153333, -0.865690
13.156667, -0.867966
13.160000, -0.870325
13.163333, -0.872260
13.166667, -0.873864
13.170000, -0.875380
13.173333, -0.876676
13.176667, -0.877373
13.180000, -0.877480
13.183333, -0.877473
13.186667, -0.877503
13.190000, -0.877215
13.193333, -0.876538
13.196667, -0.875900
13.200000, -0.875512
13.203333, -0.875104
13.206667, -0.874479
13.210000, -0.873818
13.213333, -0.873449
13.216667, -0.873724
13.220000, -0.874976
13.223333, -0.877211
13.226667, -0.879830
13.230000, -0.881903
13.233333, -0.882873
13.236667, -0.882872
13.240000, -0.882372
13.243333, -0.881850
13.246667, -0.881677
13.250000, -0.882021
13.253333, -0.882791
13.256667, -0.883864
13.260000, -0.885479
13.263333, -0.888099
13.266667, -0.891700
13.270000, -0.895516
13.273333, -0.898685
13.276667, -0.900886
13.280000, -0.902294
13.283333, -0.903175
13.286667, -0.903653
13.290000, -0.903681
13.293333, -0.903117
13.296667, -0.901996
13.300000, -0.900807
13.303333, -0.900323
13.306667, -0.900893
13.310000, -0.901947
13.313333, -0.902504
13.316667, -0.902152
13.320000, -0.901331
13.323333, -0.900770
13.326667, -0.900820
13.330000, -0.901348
13.333333, -0.902066
13.336667, -0.902824
13.340000, -0.903563
13.343333, -0.904282
13.346667, -0.905237
13.350000, -0.906788
13.353333, -0.908823
13.356667, -0.910771
13.360000, -0.912258
13.363333, -0.913484
13.366667, -0.914966
13.370000, -0.916980
13.373333, -0.919303
13.376667, -0.921413
13.380000, -0.922744
13.383333, -0.923040
13.386667, -0.922619
13.390000, -0.922120
13.393333, -0.922036
13.396667, -0.922492
13.400000, -0.923275
13.403333, -0.924065
13.406667, -0.924743
13.410000, -0.925386
13.413333, -0.925999
13.416667, -0.926450
13.420000, -0.926636
13.423333, -0.926525
13.426667, -0.926362
13.430000, -0.926859
13.433333, -0.928655
13.436667, -0.931645
13.440000, -0.935118
13.443333, -0.938331
13.446667, -0.940830
13.450000, -0.942476
13.453333, -0.943348
13.456667, -0.943662
13.460000, -0.943771
13.463333, -0.944028
13.466667, -0.944528
13.470000, -0.945261
13.473333, -0.946343
13.476667, -0.947708
13.480000, -0.948868
13.483333, -0.949169
13.486667, -0.948218
13.490000, -0.946116
13.493333, -0.943364
13.496667, -0.940642
13.500000, -0.938689
13.503333, -0.938104
13.506667, -0.939095
13.510000, -0.941399
13.513333, -0.944401
13.516667, -0.947414
13.520000, -0.950056
13.523333, -0.952459
13.526667, -0.954924
13.530000, -0.957340
13.533333, -0.959244
13.536667, -0.960423
13.540000, -0.961115
13.543333, -0.961655
13.546667, -0.962191
13.550000, -0.962752
13.553333, -0.963497
13.556667, -0.964711
13.560000, -0.966405
13.563333, -0.968189
13.566667, -0.969722
13.570000, -0.971091
13.573333, -0.972680
13.576667, -0.974712
13.580000, -0.976952
13.583333, -0.978853
13.586667, -0.979874
13.590000, -0.979831
13.593333, -0.979285
13.596667, -0.979369
13.600000, -0.980995
13.603333, -0.984293
13.606667, -0.988607
13.610000, -0.992950
13.613333, -0.996649
13.616667, -0.999426
13.620000, -1.000901
13.623333, -1.000527
13.626667, -0.998144
13.630000, -0.994374
13.633333, -0.990385
13.636667, -0.987039
13.640000, -0.984319
13.643333, -0.981660
13.646667, -0.978409
13.650000, -0.974039
13.653333, -0.968667
13.656667, -0.963280
13.660000, -0.958796
13.663333, -0.955203
13.666667, -0.951794
13.670000, -0.947710
13.673333, -0.942224
13.676667, -0.935044
13.680000, -0.926421
13.683333, -0.916696
13.686667, -0.905745
13.690000, -0.893049
13.693333, -0.878373
13.696667, -0.862101
13.700000, -0.844553
13.703333, -0.825054
13.706667, -0.801994
13.710000, -0.773808
13.713333, -0.739779
13.716667, -0.700105
13.720000, -0.655262
13.723333, -0.605242
13.726667, -0.549506
13.730000, -0.487372
13.733333, -0.417984
13.736667, -0.340077
13.740000, -0.252049
13.743333, -0.152274
13.746667, -0.039213
13.750000, 0.088814
13.753333, 0.233706
13.756667, 0.397526
13.760000, 0.582723
13.763333, 0.792003
13.766667, 1.027743
13.770000, 1.292043
13.773333, 1.587310
13.776667, 1.916657
13.780000, 2.284036
13.783333, 2.693980
13.786667, 3.151084
13.790000, 3.659849
13.793333, 4.224999
13.796667, 4.851765
13.800000, 5.545844
13.803333, 6.313341
13.806667, 7.160736
13.810000, 8.094768
13.813333, 9.121841
13.816667, 10.246937
13.820000, 11.473372
13.823333, 12.804332
13.826667, 14.244788
13.830000, 15.801989
13.833333, 17.484946
13.836667, 19.304260
13.840000, 21.272178
13.843333, 23.402181
13.846667, 25.708216
13.850000, 28.203877
13.853333, 30.901600
13.856667, 33.812213
13.860000, 36.945172
13.863333, 40.309459
13.866667, 43.914736
13.870000, 47.771977
13.873333, 51.892689
13.876667, 56.287515
13.880000, 60.965585
13.883333, 65.934166
13.886667, 71.197795
13.890000, 76.757734
13.893333, 82.612290
13.896667, 88.757592
13.900000, 95.188413
13.903333, 101.898618
13.906667, 108.881300
13.910000, 116.128942
13.913333, 123.633300
13.916667, 131.384918
13.920000, 139.372853
13.923333, 147.584461
13.926667, 156.003856
13.930000, 164.609433
13.933333, 173.373797
13.936667, 182.267694
13.940000, 191.264460
13.943333, 200.341403
13.946667, 209.478973
13.950000, 218.659733
13.953333, 227.867372
13.956667, 237.085120
13.960000, 246.293594
13.963333, 255.469231
13.966667, 264.584205
13.970000, 273.607764
13.973333, 282.508232
13.976667, 291.254908
13.980000, 299.819372
13.983333, 308.175864
13.986667, 316.300868
13.990000, 324.171944
13.993333, 331.766366
13.996667, 339.061045
14.000000, 346.033157
14.003333, 352.660227
14.006667, 358.920493
14.010000, 364.793798
14.013333, 370.262318
14.016667, 375.311233
14.020000, 379.928869
14.023333, 384.105923
14.026667, 387.835035
14.030000, 391.111117
14.033333, 393.931247
14.036667, 396.293913
14.040000, 398.198193
14.043333, 399.643132
14.046667, 400.627410
14.050000, 401.149660
14.053333, 401.209891
14.056667, 400.811500
14.060000, 399.962036
14.063333, 398.672166
14.066667, 396.954875
14.070000, 394.825630
14.073333, 392.301958
14.076667, 389.402191
14.080000, 386.144488
14.083333, 382.546677
14.086667, 378.627004
14.090000, 374.405087
14.093333, 369.902341
14.096667, 365.141586
14.100000, 360.144960
14.103333, 354.931322
14.106667, 349.516295
14.110000, 343.914071
14.113333, 338.138566
14.116667, 332.204388
14.120000, 326.127291
14.123333, 319.923198
14.126667, 313.607353
14.130000, 307.194540
14.133333, 300.699302
14.136667, 294.135898
14.140000, 287.518282
14.143333, 280.859950
14.146667, 274.174450
14.150000, 267.478348
14.153333, 260.794771
14.156667, 254.151545
14.160000, 247.573437
14.163333, 241.075866
14.166667, 234.663954
14.170000, 228.334515
14.173333, 222.078795
14.176667, 215.885519
14.180000, 209.743953
14.183333, 203.646317
14.186667, 197.589187
14.190000, 191.574180
14.193333, 185.607502
14.196667, 179.698128
14.200000, 173.855637
14.203333, 168.088369
14.206667, 162.402230
14.210000, 156.800623
14.213333, 151.285548
14.216667, 145.859339
14.220000, 140.526201
14.223333, 135.292627
14.226667, 130.166407
14.230000, 125.154960
14.233333, 120.264216
14.236667, 115.498376
14.240000, 110.860120
14.243333, 106.350850
14.246667, 101.970684
14.250000, 97.718596
14.253333, 93.593016
14.256667, 89.592096
14.260000, 85.713025
14.263333, 81.951123
14.266667, 78.300264
14.270000, 74.754875
14.273333, 71.311685
14.276667, 67.970213
14.280000, 64.732645
14.283333, 61.603236
14.286667, 58.587079
14.290000, 55.688734
14.293333, 52.911092
14.296667, 50.254743
14.300000, 47.718230
14.303333, 45.298657
14.306667, 42.992139
14.310000, 40.794389
14.313333, 38.701185
14.316667, 36.708413
14.320000, 34.812094
14.323333, 33.008326
14.326667, 31.293136
14.330000, 29.662403
14.333333, 28.111843
14.336667, 26.637228
14.340000, 25.234901
14.343333, 23.901958
14.346667, 22.635709
14.350000, 21.433128
14.353333, 20.291157
14.356667, 19.207327
14.360000, 18.179499
14.363333, 17.205305
14.366667, 16.282428
14.370000, 15.409014
14.373333, 14.583376
14.376667, 13.803530
14.380000, 13.067283
14.383333, 12.372772
14.386667, 11.718724
14.390000, 11.104055
14.393333, 10.527267
14.396667, 9.986048
14.400000, 9.477242
14.403333, 8.997182
14.406667, 8.542338
14.410000, 8.109988
14.413333, 7.698356
14.416667, 7.306375
14.420000, 6.933523
14.423333, 6.579613
14.426667, 6.244462
14.430000, 5.927543
14.433333, 5.627761
14.436667, 5.343721
14.440000, 5.074447
14.443333, 4.819423
14.446667, 4.577972
14.450000, 4.349324
14.453333, 4.133077
14.456667, 3.928920
14.460000, 3.736299
14.463333, 3.554641
14.466667, 3.383441
14.470000, 3.222015
14.473333, 3.069456
14.476667, 2.924929
14.480000, 2.787848
14.483333, 2.657753
14.486667, 2.534211
14.490000, 2.416849
14.493333, 2.305364
14.496667, 2.199470
14.500000, 2.098746
14.503333, 2.002643
14.506667, 1.910943
14.510000, 1.823972
14.513333, 1.742102
14.516667, 1.665212
14.520000, 1.592601
14.523333, 1.523333
14.526667, 1.456773
14.530000, 1.392679
14.533333, 1.330786
14.536667, 1.270701
14.540000, 1.212318
14.543333, 1.156054
14.546667, 1.102502
14.550000, 1.051882
14.553333, 1.003822
14.556667, 0.957640
14.560000, 0.912947
14.563333, 0.869913
14.566667, 0.828844
14.570000, 0.789608
14.573333, 0.751589
14.576667, 0.714015
14.580000, 0.676452
14.583333, 0.639135
14.586667, 0.602632
14.590000, 0.567407
14.593333, 0.533958
14.596667, 0.502822
14.600000, 0.474290
14.603333, 0.448240
14.606667, 0.424011
14.610000, 0.400430
14.613333, 0.376363
14.616667, 0.351302
14.620000, 0.325440
14.623333, 0.299378
14.626667, 0.273726
14.630000, 0.248585
14.633333, 0.223521
14.636667, 0.198324
14.640000, 0.173396
14.643333, 0.149264
14.646667, 0.126266
14.650000, 0.104315
14.653333, 0.082760
14.656667, 0.061198
14.660000, 0.040152
14.663333, 0.020374
14.666667, 0.001968
14.670000, -0.015536
14.673333, -0.032625
14.676667, -0.049694
14.680000, -0.067182
14.683333, -0.085208
14.686667, -0.103262
14.690000, -0.120756
14.693333, -0.137515
14.696667, -0.153569
14.700000, -0.168960
14.703333, -0.183832
14.706667, -0.198452
14.710000, -0.213200
14.713333, -0.228575
14.716667, -0.244946
14.720000, -0.262019
14.723333, -0.278755
14.726667, -0.294142
14.730000, -0.307827
14.733333, -0.320004
14.736667, -0.331100
14.740000, -0.341573
14.743333, -0.351763
14.746667, -0.361830
14.750000, -0.371740
14.753333, -0.381363
14.756667, -0.390638
14.760000, -0.399548
14.763333, -0.408072
14.766667, -0.416322
14.770000, -0.424567
14.773333, -0.432960
14.776667, -0.441449
14.780000, -0.449936
14.783333, -0.458348
14.786667, -0.466632
14.790000, -0.474677
14.793333, -0.482340
14.796667, -0.489646
14.800000, -0.496772
14.803333, -0.503843
14.806667, -0.510851
14.810000, -0.517744
14.813333, -0.524536
14.816667, -0.531298
14.820000, -0.538074
14.823333, -0.544629
14.826667, -0.550398
14.830000, -0.554948
14.833333, -0.558418
14.836667, -0.561455
14.840000, -0.564787
14.843333, -0.568815
14.846667, -0.573510
14.850000, -0.578652
14.853333, -0.584159
14.856667, -0.590077
14.860000, -0.596397
14.863333, -0.603071
14.866667, -0.610004
14.870000, -0.616937
14.873333, -0.623512
14.876667, -0.629539
14.880000, -0.635091
14.883333, -0.640220
14.886667, -0.644850
14.890000, -0.649097
14.893333, -0.653437
14.896667, -0.658458
14.900000, -0.664398
14.903333, -0.670732
14.906667, -0.676512
14.910000, -0.681361
14.913333, -0.685680
14.916667, -0.689803
14.920000, -0.693520
14.923333, -0.696500
14.926667, -0.698798
14.930000, -0.701001
14.933333, -0.704131
14.936667, -0.709246
14.940000, -0.716734
14.943333, -0.725931
14.946667, -0.735499
14.950000, -0.744100
14.953333, -0.750754
14.956667, -0.755067
14.960000, -0.757347
14.963333, -0.758380
14.966667, -0.758906
14.970000, -0.759190
14.973333, -0.759271
14.976667, -0.759481
14.980000, -0.760315
14.983333, -0.761928
14.986667, -0.764001
14.990000, -0.766123
14.993333, -0.768201
14.996667, -0.770246
15.000000, -0.772044
15.003333, -0.773539
15.006667, -0.775182
15.010000, -0.777485
15.013333, -0.780514
15.016667, -0.783967
15.020000, -0.787503
15.023333, -0.790885
15.026667, -0.793853
15.030000, -0.796047
15.033333, -0.797414
15.036667, -0.798429
15.040000, -0.799514
15.043333, -0.800516
15.046667, -0.801175
15.050000, -0.801923
15.053333, -0.803592
15.056667, -0.806395
15.060000, -0.809750
15.063333, -0.812929
15.066667, -0.815575
15.070000, -0.817849
15.073333, -0.820221
15.076667, -0.823085
15.080000, -0.826565
15.083333, -0.830500
15.086667, -0.834490
15.090000, -0.838223
15.093333, -0.841793
15.096667, -0.845351
15.100000, -0.848663
15.103333, -0.851474
15.106667, -0.853971
15.110000, -0.856565
15.113333, -0.859411
15.116667, -0.862494
15.120000, -0.865921
15.123333, -0.869682
15.126667, -0.873302
15.130000, -0.876095
15.133333, -0.877803
15.136667, -0.878867
15.140000, -0.879994
15.143333, -0.881654
15.146667, -0.883880
15.150000, -0.886212
15.153333, -0.887843
15.156667, -0.888135
15.160000, -0.887148
15.163333, -0.885640
15.166667, -0.884385
15.170000, -0.883635
15.173333, -0.883320
15.176667, -0.883516
15.180000, -0.884443
15.183333, -0.886087
15.186667, -0.888252
15.190000, -0.890846
15.193333, -0.893676
15.196667, -0.896362
15.200000, -0.898808
15.203333, -0.901292
15.206667, -0.903974
15.210000, -0.906667
15.213333, -0.909071
15.216667, -0.911043
15.220000, -0.912701
15.223333, -0.914357
15.226667, -0.916279
15.230000, -0.918510
15.233333, -0.920981
15.236667, -0.923609
15.240000, -0.926116
15.243333, -0.928122
15.246667, -0.929505
15.250000, -0.930472
15.253333, -0.931344
15.256667, -0.932319
15.260000, -0.933352
15.263333, -0.934363
15.266667, -0.935698
15.270000, -0.938210
15.273333, -0.942565
15.276667, -0.948393
15.280000, -0.954419
15.283333, -0.959374
15.286667, -0.962502
15.290000, -0.963613
15.293333, -0.963115
15.296667, -0.961838
15.300000, -0.960520
15.303333, -0.959353
15.306667, -0.958059
15.310000, -0.956410
15.313333, -0.954472
15.316667, -0.952380
15.320000, -0.950239
15.323333, -0.948332
15.326667, -0.947165
15.330000, -0.947109
15.333333, -0.948069
15.336667, -0.949510
15.340000, -0.950723
15.343333, -0.951141
15.346667, -0.950519
15.350000, -0.949065
15.353333, -0.947349
15.356667, -0.945872
15.360000, -0.944900
15.363333, -0.944641
15.366667, -0.945149
15.370000, -0.946162
15.373333, -0.947239
15.376667, -0.947965
15.380000, -0.947906
15.383333, -0.946661
15.386667, -0.944224
15.390000, -0.941265
15.393333, -0.938900
15.396667, -0.937997
15.400000, -0.938606
15.403333, -0.940124
15.406667, -0.941848
15.410000, -0.943378
15.413333, -0.944738
15.416667, -0.946270
15.420000, -0.948304
15.423333, -0.950906
15.426667, -0.953919
15.430000, -0.956963
15.433333, -0.959466
15.436667, -0.960901
15.440000, -0.961061
15.443333, -0.960379
15.446667, -0.959914
15.450000, -0.960639
15.453333, -0.962628
15.456667, -0.965068
15.460000, -0.967042
15.463333, -0.968213
15.466667, -0.968799
15.470000, -0.969209
15.473333, -0.969923
15.476667, -0.971303
15.480000, -0.973177
15.483333, -0.974891
15.486667, -0.976022
15.490000, -0.976909
15.493333, -0.978280
15.496667, -0.980462
15.500000, -0.983223
15.503333, -0.985959
15.506667, -0.987881
15.510000, -0.988603
15.513333, -0.988419
15.516667, -0.987916
15.520000, -0.987636
15.523333, -0.987800
15.526667, -0.988114
15.530000, -0.988052
15.533333, -0.987271
15.536667, -0.985778
15.540000, -0.983846
15.543333, -0.981864
15.546667, -0.980155
15.550000, -0.978768
15.553333, -0.977425
15.556667, -0.975864
15.560000, -0.974137
15.563333, -0.972449
15.566667, -0.971053
15.570000, -0.970285
15.573333, -0.970300
15.576667, -0.970775
15.580000, -0.971046
15.583333, -0.970449
15.586667, -0.968731
15.590000, -0.966415
15.593333, -0.964661
15.596667, -0.964360
15.600000, -0.965340
15.603333, -0.966728
15.606667, -0.967860
15.610000, -0.968560
15.613333, -0.968826
15.616667, -0.968661
15.620000, -0.968212
15.623333, -0.967673
15.626667, -0.966874
15.630000, -0.965427
15.633333, -0.963354
15.636667, -0.961064
15.640000, -0.958974
15.643333, -0.957530
15.646667, -0.957014
15.650000, -0.957199
15.653333, -0.957616
15.656667, -0.957970
15.660000, -0.958176
15.663333, -0.958237
15.666667, -0.958228
15.670000, -0.958210
15.673333, -0.957969
15.676667, -0.957076
15.680000, -0.955413
15.683333, -0.953390
15.686667, -0.951600
15.690000, -0.950413
15.693333, -0.949817
15.696667, -0.949471
15.700000, -0.948955
15.703333, -0.948128
15.706667, -0.947153
15.710000, -0.946073
15.713333, -0.944508
15.716667, -0.941922
15.720000, -0.938230
15.723333, -0.933999
15.726667, -0.930054
15.730000, -0.927064
15.733333, -0.925389
15.736667, -0.925073
15.740000, -0.925814
15.743333, -0.927025
15.746667, -0.928156
15.750000, -0.929040
15.753333, -0.929837
15.756667, -0.930646
15.760000, -0.931355
15.763333, -0.931854
15.766667, -0.932166
15.770000, -0.932350
15.773333, -0.932355
15.776667, -0.932122
15.780000, -0.931824
15.783333, -0.931739
15.786667, -0.931991
15.790000, -0.932475
15.793333, -0.932994
15.796667, -0.933581
15.800000, -0.934374
15.803333, -0.935091
15.806667, -0.935154
15.810000, -0.934327
15.813333, -0.932887
15.816667, -0.931496
15.820000, -0.931053
15.823333, -0.932268
15.826667, -0.935356
15.830000, -0.940156
15.833333, -0.946139
15.836667, -0.952328
15.840000, -0.957681
15.843333, -0.961410
15.846667, -0.962969
15.850000, -0.962318
15.853333, -0.960166
15.856667, -0.957679
15.860000, -0.955880
15.863333, -0.955153
15.866667, -0.955094
15.870000, -0.954842
15.873333, -0.953765
15.876667, -0.951961
15.880000, -0.950084
15.883333, -0.948686
15.886667, -0.947896
15.890000, -0.947626
15.893333, -0.947772
15.896667, -0.948282
15.900000, -0.949167
15.903333, -0.950489
15.906667, -0.952250
15.910000, -0.954144
15.913333, -0.955633
15.916667, -0.956386
15.920000, -0.956459
15.923333, -0.956180
15.926667, -0.955988
15.930000, -0.956202
15.933333, -0.956734
15.936667, -0.957001
15.940000, -0.956244
15.943333, -0.954094
15.946667, -0.950932
15.950000, -0.947672
15.953333, -0.945296
15.956667, -0.944330
15.960000, -0.944543
15.963333, -0.945367
15.966667, -0.946480
15.970000, -0.947717
15.973333, -0.948763
15.976667, -0.949287
15.980000, -0.949290
15.983333, -0.949106
15.986667, -0.949057
15.990000, -0.949227
15.993333, -0.949470
15.996667, -0.949403
16.000000, -0.948454
16.003333, -0.946242
16.006667, -0.942936
16.010000, -0.939157
16.013333, -0.935602
16.016667, -0.932532
16.020000, -0.929639
16.023333, -0.926461
16.026667, -0.922670
16.030000, -0.918160
16.033333, -0.913047
16.036667, -0.907411
16.040000, -0.901167
16.043333, -0.894398
16.046667, -0.887660
16.050000, -0.881867
16.053333, -0.877795
16.056667, -0.875383
16.060000, -0.873544
16.063333, -0.870917
16.066667, -0.866627
16.070000, -0.860377
16.073333, -0.852242
16.076667, -0.842422
16.080000, -0.831158
16.083333, -0.818906
16.086667, -0.806371
16.090000, -0.794020
16.093333, -0.781671
16.096667, -0.768845
16.100000, -0.755297
16.103333, -0.741017
16.106667, -0.726168
16.110000, -0.711098
16.113333, -0.696109
16.116667, -0.681193
16.120000, -0.666102
16.123333, -0.650750
16.126667, -0.635387
16.130000, -0.620252
16.133333, -0.605369
16.136667, -0.590735
16.140000, -0.576211
16.143333, -0.561192
16.146667, -0.545010
16.150000, -0.527577
16.153333, -0.509225
16.156667, -0.490276
16.160000, -0.471131
16.163333, -0.452337
16.166667, -0.434194
16.170000, -0.416534
16.173333, -0.399073
16.176667, -0.381656
16.180000, -0.364086
16.183333, -0.346103
16.186667, -0.327613
16.190000, -0.308809
16.193333, -0.290053
16.196667, -0.271542
16.200000, -0.253215
16.203333, -0.235094
16.206667, -0.217472
16.210000, -0.200710
16.213333, -0.184879
16.216667, -0.169544
16.220000, -0.154127
16.223333, -0.138514
16.226667, -0.123178
16.230000, -0.108741
16.233333, -0.095402
16.236667, -0.082869
16.240000, -0.070965
16.243333, -0.059867
16.246667, -0.049569
16.250000, -0.039559
16.253333, -0.029244
16.256667, -0.018509
16.260000, -0.007853
16.263333, 0.002033
16.266667, 0.010856
16.270000, 0.018917
16.273333, 0.026871
16.276667, 0.035235
16.280000, 0.044000
16.283333, 0.052591
16.286667, 0.060150
16.290000, 0.065955
16.293333, 0.069689
16.296667, 0.071468
16.300000, 0.071640
16.303333, 0.070542
16.306667, 0.068401
16.310000, 0.065279
16.313333, 0.060975
16.316667, 0.055187
16.320000, 0.047875
16.323333, 0.039402
16.326667, 0.030332
16.330000, 0.021149
16.333333, 0.012081
16.336667, 0.003059
16.340000, -0.006128
16.343333, -0.015690
16.346667, -0.025742
16.350000, -0.036334
16.353333, -0.047647
16.356667, -0.060037
16.360000, -0.073639
16.363333, -0.088042
16.366667, -0.102676
16.370000, -0.117388
16.373333, -0.132406
16.376667, -0.147813
16.380000, -0.163299
16.383333, -0.178661
16.386667, -0.194427
16.390000, -0.211476
16.393333, -0.230103
16.396667, -0.249798
16.400000, -0.269502
16.403333, -0.287927
16.406667, -0.304267
16.410000, -0.318732
16.413333, -0.332183
16.416667, -0.345379
16.420000, -0.358679
16.423333, -0.372143
16.426667, -0.385673
16.430000, -0.399077
16.433333, -0.412161
16.436667, -0.424896
16.440000, -0.437351
16.443333, -0.449508
16.446667, -0.461308
16.450000, -0.472766
16.453333, -0.483835
16.456667, -0.494358
16.460000, -0.504351
16.463333, -0.514081
16.466667, -0.523639
16.470000, -0.532664
16.473333, -0.540586
16.476667, -0.547062
16.480000, -0.552284
16.483333, -0.556876
16.486667, -0.561302
16.490000, -0.565167
16.493333, -0.567183
16.496667, -0.566040
16.500000, -0.561344
16.503333, -0.553800
16.506667, -0.544571
16.510000, -0.534265
16.513333, -0.522505
16.516667, -0.508325
16.520000, -0.490836
16.523333, -0.469656
16.526667, -0.444835
16.530000, -0.416526
16.533333, -0.384750
16.536667, -0.349369
16.540000, -0.310149
16.543333, -0.266823
16.546667, -0.219023
16.550000, -0.166103
16.553333, -0.107170
16.556667, -0.041485
16.560000, 0.031283
16.563333, 0.111479
16.566667, 0.199936
16.570000, 0.297604
16.573333, 0.404945
16.576667, 0.522096
16.580000, 0.649387
16.583333, 0.787447
16.586667, 0.937018
16.590000, 1.099045
16.593333, 1.274747
16.596667, 1.465241
16.600000, 1.671283
16.603333, 1.893448
16.606667, 2.131970
16.610000, 2.386555
16.613333, 2.657049
16.616667, 2.944186
16.620000, 3.249627
16.623333, 3.575709
16.626667, 3.924885
16.630000, 4.299214
16.633333, 4.700673
16.636667, 5.131755
16.640000, 5.595254
16.643333, 6.093396
16.646667, 6.627499
16.650000, 7.198523
16.653333, 7.807849
16.656667, 8.457698
16.660000, 9.150807
16.663333, 9.889872
16.666667, 10.677563
16.670000, 11.516704
16.673333, 12.410093
16.676667, 13.360179
16.680000, 14.368901
16.683333, 15.437724
16.686667, 16.567941
16.690000, 17.761184
16.693333, 19.019632
16.696667, 20.345773
16.700000, 21.742207
16.703333, 23.211658
16.706667, 24.757042
16.710000, 26.381291
16.713333, 28.086745
16.716667, 29.874561
16.720000, 31.744815
16.723333, 33.697422
16.726667, 35.733135
16.730000, 37.853735
16.733333, 40.061753
16.736667, 42.360219
16.740000, 44.752254
16.743333, 47.240629
16.746667, 49.827841
16.750000, 52.516218
16.753333, 55.307217
16.756667, 58.200729
16.760000, 61.195489
16.763333, 64.290081
16.766667, 67.483764
16.770000, 70.776707
16.773333, 74.169782
16.776667, 77.664317
16.780000, 81.261499
16.783333, 84.961318
16.786667, 88.761926
16.790000, 92.659869
16.793333, 96.651012
16.796667, 100.731499
16.800000, 104.898066
16.803333, 109.147862
16.806667, 113.478506
16.810000, 117.888368
16.813333, 122.376290
16.816667, 126.940507
16.820000, 131.577706
16.823333, 136.284248
16.826667, 141.059856
16.830000, 145.909155
16.833333, 150.837829
16.836667, 155.847759
16.840000, 160.935525
16.843333, 166.092929
16.846667, 171.307566
16.850000, 176.563423
16.853333, 181.842409
16.856667, 187.127209
16.860000, 192.403776
16.863333, 197.661808
16.866667, 202.893740
16.870000, 208.093449
16.873333, 213.255000
16.876667, 218.371376
16.880000, 223.433972
16.883333, 228.433286
16.886667, 233.359965
16.890000, 238.206055
16.893333, 242.965911
16.896667, 247.635602
16.900000, 252.211272
16.903333, 256.688159
16.906667, 261.060840
16.910000, 265.323865
16.913333, 269.471755
16.916667, 273.498262
16.920000, 277.396004
16.923333, 281.157330
16.926667, 284.775340
16.930000, 288.244005
16.933333, 291.557664
16.936667, 294.710070
16.940000, 297.693803
16.943333, 300.501243
16.946667, 303.126234
16.950000, 305.564844
16.953333, 307.815143
16.956667, 309.876556
16.960000, 311.748972
16.963333, 313.431880
16.966667, 314.923821
16.970000, 316.222368
16.973333, 317.324786
16.976667, 318.228917
16.980000, 318.933295
16.983333, 319.436165
16.986667, 319.734943
16.990000, 319.827331
16.993333, 319.712137
16.996667, 319.388416
17.000000, 318.854941
17.003333, 318.111148
17.006667, 317.157868
17.010000, 315.997010
17.013333, 314.631120
17.016667, 313.063188
17.020000, 311.296658
17.023333, 309.335629
17.026667, 307.184950
17.030000, 304.850142
17.033333, 302.337116
17.036667, 299.651579
17.040000, 296.798734
17.043333, 293.783805
17.046667, 290.612702
17.050000, 287.293291
17.053333, 283.838342
17.056667, 280.267386
17.060000, 276.603555
17.063333, 272.867088
17.066667, 269.070610
17.070000, 265.218201
17.073333, 261.306652
17.076667, 257.327464
17.080000, 253.269558
17.083333, 249.122711
17.086667, 244.880993
17.090000, 240.544641
17.093333, 236.119660
17.096667, 231.616001
17.100000, 227.044842
17.103333, 222.415425
17.106667, 217.733416
17.110000, 213.001819
17.113333, 208.222890
17.116667, 203.399913
17.120000, 198.538889
17.123333, 193.649375
17.126667, 188.743934
17.130000, 183.836709
17.133333, 178.941498
17.136667, 174.069888
17.140000, 169.230577
17.143333, 164.429738
17.146667, 159.671451
17.150000, 154.958414
17.153333, 150.293254
17.156667, 145.678993
17.160000, 141.117057
17.163333, 136.604135
17.166667, 132.132221
17.170000, 127.693195
17.173333, 123.283609
17.176667, 118.906511
17.180000, 114.571224
17.183333, 110.292139
17.186667, 106.086475
17.190000, 101.971437
17.193333, 97.961675
17.196667, 94.067450
17.200000, 90.293918
17.203333, 86.641940
17.206667, 83.109752
17.210000, 79.694551
17.213333, 76.393807
17.216667, 73.206010
17.220000, 70.130397
17.223333, 67.165911
17.226667, 64.310177
17.230000, 61.559185
17.233333, 58.907782
17.236667, 56.350665
17.240000, 53.883513
17.243333, 51.503510
17.246667, 49.208758
17.250000, 46.997419
17.253333, 44.867457
17.256667, 42.816808
17.260000, 40.843540
17.263333, 38.945741
17.266667, 37.121507
17.270000, 35.369406
17.273333, 33.689020
17.276667, 32.080996
17.280000, 30.546171
17.283333, 29.084390
17.286667, 27.693974
17.290000, 26.371703
17.293333, 25.113209
17.296667, 23.913659
17.300000, 22.768084
17.303333, 21.671533
17.306667, 20.619512
17.310000, 19.608635
17.313333, 18.637122
17.316667, 17.704452
17.320000, 16.810358
17.323333, 15.954356
17.326667, 15.135795
17.330000, 14.353730
17.333333, 13.606732
17.336667, 12.893052
17.340000, 12.211086
17.343333, 11.559724
17.346667, 10.938356
17.350000, 10.346795
17.353333, 9.785165
17.356667, 9.253322
17.360000, 8.750081
17.363333, 8.273479
17.366667, 7.821961
17.370000, 7.394722
17.373333, 6.990897
17.376667, 6.609135
17.380000, 6.248105
17.383333, 5.906797
17.386667, 5.584214
17.390000, 5.279178
17.393333, 4.990532
17.396667, 4.717389
17.400000, 4.459292
17.403333, 4.216062
17.406667, 3.987176
17.410000, 3.771410
17.413333, 3.567251
17.416667, 3.373520
17.420000, 3.189729
17.423333, 3.015931
17.426667, 2.852177
17.430000, 2.698168
17.433333, 2.553284
17.436667, 2.416763
17.440000, 2.287801
17.443333, 2.165536
17.446667, 2.049177
17.450000, 1.938228
17.453333, 1.832505
17.456667, 1.731938
17.460000, 1.636303
17.463333, 1.545131
17.466667, 1.457808
17.470000, 1.373887
17.473333, 1.293558
17.476667, 1.217563
17.480000, 1.146405
17.483333, 1.079954
17.486667, 1.017609
17.490000, 0.958459
17.493333, 0.901685
17.496667, 0.847203
17.500000, 0.795634
17.503333, 0.747314
17.506667, 0.701697
17.510000, 0.657895
17.513333, 0.615344
17.516667, 0.573855
17.520000, 0.533477
17.523333, 0.494389
17.526667, 0.456562
17.530000, 0.419606
17.533333, 0.383239
17.536667, 0.347779
17.540000, 0.313829
17.543333, 0.281533
17.546667, 0.250546
17.550000, 0.220563
17.553333, 0.191613
17.556667, 0.163936
17.560000, 0.137610
17.563333, 0.112439
17.566667, 0.088254
17.570000, 0.064975
17.573333, 0.042554
17.576667, 0.021033
17.580000, 0.000392
17.583333, -0.019528
17.586667, -0.038912
17.590000, -0.057818
17.593333, -0.076127
17.596667, -0.093828
17.600000, -0.111153
17.603333, -0.128226
17.606667, -0.145050
17.610000, -0.161899
17.613333, -0.179276
17.616667, -0.197441
17.620000, -0.216088
17.623333, -0.234438
17.626667, -0.251634
17.630000, -0.267083
17.633333, -0.280495
17.636667, -0.291890
17.640000, -0.301702
17.643333, -0.310635
17.646667, -0.319252
17.650000, -0.327885
17.653333, -0.336940
17.656667, -0.346856
17.660000, -0.357531
17.663333, -0.368244
17.666667, -0.378278
17.670000, -0.387411
17.673333, -0.396004
17.676667, -0.404722
17.680000, -0.413895
17.683333, -0.423391
17.686667, -0.433118
17.690000, -0.443118
17.693333, -0.453197
17.696667, -0.462904
17.700000, -0.471817
17.703333, -0.479667
17.706667, -0.486424
17.710000, -0.492518
17.713333, -0.498631
17.716667, -0.504953
17.720000, -0.510910
17.723333, -0.515936
17.726667, -0.520191
17.730000, -0.524186
17.733333, -0.528211
17.736667, -0.532558
17.740000, -0.537714
17.743333, -0.543827
17.746667, -0.550492
17.750000, -0.557180
17.753333, -0.563591
17.756667, -0.569733
17.760000, -0.575889
17.763333, -0.582515
17.766667, -0.589912
17.770000, -0.597811
17.773333, -0.605568
17.776667, -0.612722
17.780000, -0.619075
17.783333, -0.624640
17.786667, -0.629890
17.790000, -0.635681
17.793333, -0.642490
17.796667, -0.649803
17.800000, -0.656568
17.803333, -0.662157
17.806667, -0.666708
17.810000, -0.670925
17.813333, -0.675566
17.816667, -0.680911
17.820000, -0.686823
17.823333, -0.693126
17.826667, -0.699717
17.830000, -0.706603
17.833333, -0.714092
17.836667, -0.722672
17.840000, -0.732392
17.843333, -0.742391
17.846667, -0.751260
17.850000, -0.758076
17.853333, -0.763112
17.856667, -0.767398
17.860000, -0.771813
17.863333, -0.776665
17.866667, -0.781709
17.870000, -0.786464
17.873333, -0.790637
17.876667, -0.794295
17.880000, -0.797677
17.883333, -0.800997
17.886667, -0.804605
17.890000, -0.808928
17.893333, -0.813955
17.896667, -0.819147
17.900000, -0.824076
17.903333, -0.828876
17.906667, -0.833993
17.910000, -0.839795
17.913333, -0.846435
17.916667, -0.853777
17.920000, -0.861410
17.923333, -0.868921
17.926667, -0.876187
17.930000, -0.883305
17.933333, -0.890245
17.936667, -0.896679
17.940000, -0.902338
17.943333, -0.907549
17.946667, -0.913070
17.950000, -0.919286
17.953333, -0.925921
17.956667, -0.932493
17.960000, -0.938847
17.963333, -0.945266
17.966667, -0.952082
17.970000, -0.959416
17.973333, -0.967378
17.976667, -0.976094
17.980000, -0.985428
17.983333, -0.994738
17.986667, -1.003117
17.990000, -1.010205
17.993333, -1.016611
17.996667, -1.023429
18.000000, -1.031336
18.003333, -1.040076
18.006667, -1.048838
18.010000, -1.056973
18.013333, -1.064231
18.016667, -1.070731
18.020000, -1.077114
18.023333, -1.084280
18.026667, -1.092611
18.030000, -1.101754
18.033333, -1.111042
18.036667, -1.119792
18.040000, -1.127456
18.043333, -1.133909
18.046667, -1.139577
18.050000, -1.145053
18.053333, -1.150614
18.056667, -1.156196
18.060000, -1.161483
18.063333, -1.166035
18.066667, -1.169786
18.070000, -1.173314
18.073333, -1.177363
18.076667, -1.182273
18.080000, -1.187790
18.083333, -1.193428
18.086667, -1.199072
18.090000, -1.204958
18.093333, -1.211196
18.096667, -1.217592
18.100000, -1.223837
18.103333, -1.229623
18.106667, -1.234633
18.110000, -1.238648
18.113333, -1.241753
18.116667, -1.244393
18.120000, -1.247188
18.123333, -1.250502
18.126667, -1.254253
18.130000, -1.258111
18.133333, -1.261683
18.136667, -1.264753
18.140000, -1.267429
18.143333, -1.269973
18.146667, -1.272595
18.150000, -1.275352
18.153333, -1.278111
18.156667, -1.280631
18.160000, -1.282686
18.163333, -1.284222
18.166667, -1.285508
18.170000, -1.287125
18.173333, -1.289583
18.176667, -1.292672
18.180000, -1.295410
18.183333, -1.296883
18.186667, -1.297055
18.190000, -1.296684
18.193333, -1.296417
18.196667, -1.296222
18.200000, -1.295747
18.203333, -1.294659
18.206667, -1.292706
18.210000, -1.289976
18.213333, -1.286991
18.216667, -1.284363
18.220000, -1.282387
18.223333, -1.280951
18.226667, -1.279742
18.230000, -1.278475
18.233333, -1.276895
18.236667, -1.274777
18.240000, -1.272169
18.243333, -1.269419
18.246667, -1.266804
18.250000, -1.264300
18.253333, -1.261680
18.256667, -1.258857
18.260000, -1.256055
18.263333, -1.253476
18.266667, -1.251176
18.270000, -1.249386
18.273333, -1.248271
18.276667, -1.247266
18.280000, -1.245308
18.283333, -1.241839
18.286667, -1.237114
18.290000, -1.231643
18.293333, -1.225950
18.296667, -1.220881
18.300000, -1.217403
18.303333, -1.215702
18.306667, -1.214870
18.310000, -1.213659
18.313333, -1.211365
18.316667, -1.208233
18.320000, -1.205243
18.323333, -1.203313
18.326667, -1.202665
18.330000, -1.202877
18.333333, -1.203283
18.336667, -1.203276
18.340000, -1.202498
18.343333, -1.201002
18.346667, -1.199307
18.350000, -1.198149
18.353333, -1.197921
18.356667, -1.198268
18.360000, -1.198239
18.363333, -1.197028
18.366667, -1.194733
18.370000, -1.192244
18.373333, -1.190427
18.376667, -1.189579
18.380000, -1.189522
18.383333, -1.189908
18.386667, -1.190563
18.390000, -1.191735
18.393333, -1.193770
18.396667, -1.196564
18.400000, -1.199602
18.403333, -1.202375
18.406667, -1.204515
18.410000, -1.205655
18.413333, -1.205356
18.416667, -1.203399
18.420000, -1.200218
18.423333, -1.196701
18.426667, -1.193509
18.430000, -1.190903
18.433333, -1.188912
18.436667, -1.187223
18.440000, -1.185383
18.443333, -1.183424
18.446667, -1.181778
18.450000, -1.180530
18.453333, -1.179335
18.456667, -1.177987
18.460000, -1.176623
18.463333, -1.175442
18.466667, -1.174446
18.470000, -1.173407
18.473333, -1.172116
18.476667, -1.170740
18.480000, -1.169621
18.483333, -1.168753
18.486667, -1.167866
18.490000, -1.166849
18.493333, -1.165721
18.496667, -1.164422
18.500000, -1.162794
18.503333, -1.160752
18.506667, -1.158556
18.510000, -1.156728
18.513333, -1.155543
18.516667, -1.154719
18.520000, -1.153732
18.523333, -1.152315
18.526667, -1.150528
18.530000, -1.148444
18.533333, -1.145830
18.536667, -1.142448
18.540000, -1.138757
18.543333, -1.135688
18.546667, -1.133734
18.550000, -1.132774
18.553333, -1.132485
18.556667, -1.132411
18.560000, -1.131956
18.563333, -1.130689
18.566667, -1.128648
18.570000, -1.126313
18.573333, -1.124112
18.576667, -1.121995
18.580000, -1.119781
18.583333, -1.117599
18.586667, -1.115794
18.590000, -1.114647
18.593333, -1.114285
18.596667, -1.114703
18.600000, -1.115703
18.603333, -1.116727
18.606667, -1.117042
18.610000, -1.116266
18.613333, -1.114379
18.616667, -1.111345
18.620000, -1.107273
18.623333, -1.102701
18.626667, -1.098174
18.630000, -1.093812
18.633333, -1.089777
18.636667, -1.086833
18.640000, -1.085839
18.643333, -1.086730
18.646667, -1.088447
18.650000, -1.089898
18.653333, -1.090702
18.656667, -1.090987
18.660000, -1.090874
18.663333, -1.090357
18.666667, -1.089482
18.670000, -1.088458
18.673333, -1.087418
18.676667, -1.086373
18.680000, -1.085472
18.683333, -1.084782
18.686667, -1.084074
18.690000, -1.083230
18.693333, -1.082382
18.696667, -1.081564
18.700000, -1.080632
18.703333, -1.079533
18.706667, -1.078408
18.710000, -1.077369
18.713333, -1.076416
18.716667, -1.075712
18.720000, -1.075596
18.723333, -1.076174
18.726667, -1.077195
18.730000, -1.078225
18.733333, -1.078760
18.736667, -1.078415
18.740000, -1.077148
18.743333, -1.075090
18.746667, -1.072299
18.750000, -1.068908
18.753333, -1.065065
18.756667, -1.060638
18.760000, -1.055446
18.763333, -1.049607
18.766667, -1.043349
18.770000, -1.036687
18.773333, -1.029543
18.776667, -1.021979
18.780000, -1.014217
18.783333, -1.006669
18.786667, -0.999817
18.790000, -0.993755
18.793333, -0.987983
18.796667, -0.981802
18.800000, -0.974790
18.803333, -0.967036
18.806667, -0.959152
18.810000, -0.951874
18.813333, -0.945535
18.816667, -0.939985
18.820000, -0.934756
18.823333, -0.929212
18.826667, -0.922963
18.830000, -0.916070
18.833333, -0.908798
18.836667, -0.901454
18.840000, -0.894302
18.843333, -0.887406
18.846667, -0.880609
18.850000, -0.873745
18.853333, -0.867019
18.856667, -0.861217
18.860000, -0.857150
18.863333, -0.854766
18.866667, -0.853225
18.870000, -0.851766
18.873333, -0.850041
18.876667, -0.848001
18.880000, -0.845902
18.883333, -0.843972
18.886667, -0.842164
18.890000, -0.840618
18.893333, -0.839810
18.896667, -0.839951
18.900000, -0.840637
18.903333, -0.841184
18.906667, -0.841158
18.910000, -0.840634
18.913333, -0.839951
18.916667, -0.839290
18.920000, -0.838681
18.923333, -0.838283
18.926667, -0.838274
18.930000, -0.838593
18.933333, -0.839016
18.936667, -0.839335
18.940000, -0.839515
18.943333, -0.839823
18.946667, -0.840771
18.950000, -0.842795
18.953333, -0.845885
18.956667, -0.849604
18.960000, -0.853314
18.963333, -0.856469
18.966667, -0.858989
18.970000, -0.861149
18.973333, -0.862963
18.976667, -0.864188
18.980000, -0.864830
18.983333, -0.865113
18.986667, -0.865107
18.990000, -0.864626
18.993333, -0.863358
18.996667, -0.861220
19.000000, -0.858627
19.003333, -0.856206
19.006667, -0.854383
19.010000, -0.853328
19.013333, -0.853059
19.016667, -0.853409
19.020000, -0.854001
19.023333, -0.854591
19.026667, -0.855360
19.030000, -0.856480
19.033333, -0.857769
19.036667, -0.859012
19.040000, -0.860178
19.043333, -0.861278
19.046667, -0.862325
19.050000, -0.863489
19.053333, -0.865052
19.056667, -0.867021
19.060000, -0.868904
19.063333, -0.870165
19.066667, -0.870895
19.070000, -0.871583
19.073333, -0.872389
19.076667, -0.873160
19.080000, -0.873808
19.083333, -0.874411
19.086667, -0.875200
19.090000, -0.876403
19.093333, -0.877971
19.096667, -0.879625
19.100000, -0.881296
19.103333, -0.883273
19.106667, -0.885732
19.110000, -0.888412
19.113333, -0.890843
19.116667, -0.892733
19.120000, -0.894149
19.123333, -0.895360
19.126667, -0.896643
19.130000, -0.898191
19.133333, -0.900021
19.136667, -0.902130
19.140000, -0.904811
19.143333, -0.908501
19.146667, -0.913250
19.150000, -0.918578
19.153333, -0.923783
19.156667, -0.928292
19.160000, -0.932004
19.163333, -0.935333
19.166667, -0.938662
19.170000, -0.941747
19.173333, -0.943923
19.176667, -0.945029
19.180000, -0.945613
19.183333, -0.946252
19.186667, -0.947395
19.190000, -0.949498
19.193333, -0.952597
19.196667, -0.956027
19.200000, -0.958928
19.203333, -0.961035
19.206667, -0.962807
19.210000, -0.964847
19.213333, -0.967467
19.216667, -0.970683
19.220000, -0.974287
19.223333, -0.978013
19.226667, -0.981744
19.230000, -0.985434
19.233333, -0.988871
19.236667, -0.991728
19.240000, -0.993963
19.243333, -0.995925
19.246667, -0.997922
19.250000, -1.000022
19.253333, -1.002229
19.256667, -1.004493
19.260000, -1.006730
19.263333, -1.008891
19.266667, -1.010917
19.270000, -1.012745
19.273333, -1.014310
19.276667, -1.015578
19.280000, -1.016730
19.283333, -1.018185
19.286667, -1.020263
19.290000, -1.022842
19.293333, -1.025375
19.296667, -1.027333
19.300000, -1.028608
19.303333, -1.029356
19.306667, -1.029637
19.310000, -1.029535
19.313333, -1.029407
19.316667, -1.029472
19.320000, -1.029340
19.323333, -1.028422
19.326667, -1.026543
19.330000, -1.023920
19.333333, -1.020897
19.336667, -1.017844
19.340000, -1.014986
19.343333, -1.012313
19.346667, -1.009672
19.350000, -1.006872
19.353333, -1.003913
19.356667, -1.001187
19.360000, -0.999248
19.363333, -0.998210
19.366667, -0.997553
19.370000, -0.996697
19.373333, -0.995514
19.376667, -0.994121
19.380000, -0.992500
19.383333, -0.990555
19.386667, -0.988253
19.390000, -0.985469
19.393333, -0.981923
19.396667, -0.977308
19.400000, -0.971587
19.403333, -0.965367
19.406667, -0.959802
19.410000, -0.955898
19.413333, -0.953839
19.416667, -0.953030
19.420000, -0.952784
19.423333, -0.952764
19.426667, -0.952735
19.430000, -0.952557
19.433333, -0.952537
19.436667, -0.953166
19.440000, -0.954592
19.443333, -0.956540
19.446667, -0.958403
19.450000, -0.959567
19.453333, -0.959853
19.456667, -0.959560
19.460000, -0.959223
19.463333, -0.959210
19.466667, -0.959441
19.470000, -0.959613
19.473333, -0.959482
19.476667, -0.958865
19.480000, -0.957707
19.483333, -0.956215
19.486667, -0.954738
19.490000, -0.953492
19.493333, -0.952613
19.496667, -0.952337
19.500000, -0.952854
19.503333, -0.954163
19.506667, -0.956250
19.510000, -0.959250
19.513333, -0.963206
19.516667, -0.967719
19.520000, -0.972169
19.523333, -0.976111
19.526667, -0.979013
19.530000, -0.980308
19.533333, -0.980216
19.536667, -0.979833
19.540000, -0.980172
19.543333, -0.981415
19.546667, -0.982992
19.550000, -0.984244
19.553333, -0.984925
19.556667, -0.985030
19.560000, -0.984480
19.563333, -0.983269
19.566667, -0.981732
19.570000, -0.980505
19.573333, -0.980121
19.576667, -0.980651
19.580000, -0.981872
19.583333, -0.983732
19.586667, -0.986278
19.590000, -0.989252
19.593333, -0.992074
19.596667, -0.994234
19.600000, -0.995673
19.603333, -0.996745
19.606667, -0.997728
19.610000, -0.998675
19.613333, -0.999723
19.616667, -1.000990
19.620000, -1.002260
19.623333, -1.003295
19.626667, -1.004330
19.630000, -1.005839
19.633333, -1.007785
19.636667, -1.009632
19.640000, -1.011389
19.643333, -1.013884
19.646667, -1.017471
19.650000, -1.021326
19.653333, -1.024532
19.656667, -1.027060
19.660000, -1.029511
19.663333, -1.032515
19.666667, -1.036299
19.670000, -1.040532
19.673333, -1.044705
19.676667, -1.048494
19.680000, -1.051734
19.683333, -1.054531
19.686667, -1.057329
19.690000, -1.060474
19.693333, -1.063975
19.696667, -1.067674
19.700000, -1.071218
19.703333, -1.074147
19.706667, -1.076452
19.710000, -1.078791
19.713333, -1.081943
19.716667, -1.086039
19.720000, -1.090359
19.723333, -1.093832
19.726667, -1.095664
19.730000, -1.095728
19.733333, -1.094605
19.736667, -1.093099
19.740000, -1.091783
19.743333, -1.091101
19.746667, -1.091527
19.750000, -1.093414
19.753333, -1.096858
19.756667, -1.101685
19.760000, -1.107340
19.763333, -1.112866
19.766667, -1.117288
19.770000, -1.120244
19.773333, -1.122188
19.776667, -1.123956
19.780000, -1.126279
19.783333, -1.129466
19.786667, -1.133115
19.790000, -1.136386
19.793333, -1.138780
19.796667, -1.140442
19.800000, -1.141726
19.803333, -1.142729
19.806667, -1.143191
19.810000, -1.142746
19.813333, -1.141415
19.816667, -1.139876
19.820000, -1.138991
19.823333, -1.139017
19.826667, -1.139450
19.830000, -1.139680
19.833333, -1.139652
19.836667, -1.139891
19.840000, -1.141167
19.843333, -1.143961
19.846667, -1.147998
19.850000, -1.152361
19.853333, -1.156059
19.856667, -1.158409
19.860000, -1.158991
19.863333, -1.157635
19.866667, -1.154568
19.870000, -1.150383
19.873333, -1.145769
19.876667, -1.141238
19.880000, -1.137061
19.883333, -1.133342
19.886667, -1.130059
19.890000, -1.127139
19.893333, -1.124509
19.896667, -1.121923
19.900000, -1.118941
19.903333, -1.115304
19.906667, -1.111207
19.910000, -1.107059
19.913333, -1.103192
19.916667, -1.099950
19.920000, -1.097587
19.923333, -1.095916
19.926667, -1.094308
19.930000, -1.092119
19.933333, -1.089228
19.936667, -1.086007
19.940000, -1.082648
19.943333, -1.079077
19.946667, -1.075362
19.950000, -1.071516
19.953333, -1.067391
19.956667, -1.062968
19.960000, -1.058332
19.963333, -1.053633
19.966667, -1.049202
19.970000, -1.045355
19.973333, -1.042181
19.976667, -1.039734
19.980000, -1.038132
19.983333, -1.037373
19.986667, -1.037302
19.990000, -1.037898
19.993333, -1.039318
19.996667, -1.041447
20.000000, -1.043762
20.003333, -1.045903
20.006667, -1.047864
20.010000, -1.049561
20.013333, -1.050795
20.016667, -1.051523
20.020000, -1.051827
20.023333, -1.051793
20.026667, -1.051446
20.030000, -1.050817
20.033333, -1.050125
20.036667, -1.049683
20.040000, -1.049741
20.043333, -1.050523
20.046667, -1.051983
20.050000, -1.053613
20.053333, -1.054902
20.056667, -1.055817
20.060000, -1.056822
20.063333, -1.058755
20.066667, -1.062335
20.070000, -1.067454
20.073333, -1.073177
20.076667, -1.078497
20.080000, -1.082848
20.083333, -1.086024
20.086667, -1.087960
20.090000, -1.088735
20.093333, -1.088631
20.096667, -1.087950
20.100000, -1.086872
20.103333, -1.085700
20.106667, -1.084920
20.110000, -1.084660
20.113333, -1.084469
20.116667, -1.083861
20.120000, -1.082653
20.123333, -1.080942
20.126667, -1.079088
20.130000, -1.077382
20.133333, -1.075791
20.136667, -1.074355
20.140000, -1.073393
20.143333, -1.072958
20.146667, -1.072696
20.150000, -1.072541
20.153333, -1.072788
20.156667, -1.073258
20.160000, -1.073297
20.163333, -1.072844
20.166667, -1.072673
20.170000, -1.073355
20.173333, -1.074609
20.176667, -1.075665
20.180000, -1.075917
20.183333, -1.075420
20.186667, -1.074819
20.190000, -1.074671
20.193333, -1.074947
20.196667, -1.075137
20.200000, -1.074791
20.203333, -1.073983
20.206667, -1.073183
20.210000, -1.072730
20.213333, -1.072584
20.216667, -1.072517
20.220000, -1.072389
20.223333, -1.072387
20.226667, -1.072941
20.230000, -1.074099
20.233333, -1.075196
20.236667, -1.075426
20.240000, -1.074652
20.243333, -1.073524
20.246667, -1.072998
20.250000, -1.073803
20.253333, -1.075961
20.256667, -1.078682
20.260000, -1.081028
20.263333, -1.082501
20.266667, -1.082859
20.270000, -1.081901
20.273333, -1.079834
20.276667, -1.077551
20.280000, -1.076051
20.283333, -1.075534
20.286667, -1.075297
20.290000, -1.074507
20.293333, -1.072877
20.296667, -1.070750
20.300000, -1.068896
20.303333, -1.068040
20.306667, -1.068425
20.310000, -1.069842
20.313333, -1.071745
20.316667, -1.073357
20.320000, -1.074185
20.323333, -1.074583
20.326667, -1.075530
20.330000, -1.077576
20.333333, -1.080261
20.336667, -1.082709
20.340000, -1.084385
20.343333, -1.085172
20.346667, -1.085290
20.350000, -1.085345
20.353333, -1.086003
20.356667, -1.087360
20.360000, -1.088879
20.363333, -1.090057
20.366667, -1.090921
20.370000, -1.091618
20.373333, -1.091886
20.376667, -1.091326
20.380000, -1.089989
20.383333, -1.088509
20.386667, -1.087687
20.390000, -1.087832
20.393333, -1.088526
20.396667, -1.089280
20.400000, -1.090105
20.403333, -1.091183
20.406667, -1.092500
20.410000, -1.094062
20.413333, -1.095956
20.416667, -1.097984
20.420000, -1.099509
20.423333, -1.099936
20.426667, -1.099170
20.430000, -1.097454
20.433333, -1.095040
20.436667, -1.092087
20.440000, -1.088653
20.443333, -1.084816
20.446667, -1.080845
20.450000, -1.077181
20.453333, -1.074278
20.456667, -1.072319
20.460000, -1.070841
20.463333, -1.069055
20.466667, -1.066561
20.470000, -1.063480
20.473333, -1.060199
20.476667, -1.057303
20.480000, -1.055415
20.483333, -1.054836
20.486667, -1.055329
20.490000, -1.056152
20.493333, -1.056355
20.496667, -1.055338
20.500000, -1.053253
20.503333, -1.050857
20.506667, -1.048753
20.510000, -1.046770
20.513333, -1.044293
20.516667, -1.040977
20.520000, -1.037038
20.523333, -1.033064
20.526667, -1.029560
20.530000, -1.026695
20.533333, -1.024445
20.536667, -1.022797
20.540000, -1.021714
20.543333, -1.020968
20.546667, -1.020163
20.550000, -1.019042
20.553333, -1.017811
20.556667, -1.016958
20.560000, -1.016620
20.563333, -1.016470
20.566667, -1.016238
20.570000, -1.015843
20.573333, -1.015137
20.576667, -1.014050
20.580000, -1.012768
20.583333, -1.011512
20.586667, -1.010416
20.590000, -1.009600
20.593333, -1.009198
20.596667, -1.009441
20.600000, -1.010527
20.603333, -1.012191
20.606667, -1.013691
20.610000, -1.014491
20.613333, -1.014725
20.616667, -1.014895
20.620000, -1.015463
20.623333, -1.016722
20.626667, -1.018614
20.630000, -1.020692
20.633333, -1.022365
20.636667, -1.023196
20.640000, -1.023192
20.643333, -1.022982
20.646667, -1.023342
20.650000, -1.024306
20.653333, -1.025166
20.656667, -1.025477
20.660000, -1.025588
20.663333, -1.026156
20.666667, -1.027574
20.670000, -1.029845
20.673333, -1.032622
20.676667, -1.035220
20.680000, -1.037000
20.683333, -1.038005
20.686667, -1.038951
20.690000, -1.040382
20.693333, -1.042069
20.696667, -1.043430
20.700000, -1.044274
20.703333, -1.044788
20.706667, -1.045176
20.710000, -1.045630
20.713333, -1.046369
20.716667, -1.047546
20.720000, -1.049047
20.723333, -1.050486
20.726667, -1.051550
20.730000, -1.052311
20.733333, -1.053237
20.736667, -1.054885
20.740000, -1.057523
20.743333, -1.060938
20.746667, -1.064514
20.750000, -1.067617
20.753333, -1.069876
20.756667, -1.071217
20.760000, -1.071838
20.763333, -1.072127
20.766667, -1.072630
20.770000, -1.073982
20.773333, -1.076584
20.776667, -1.080299
20.780000, -1.084473
20.783333, -1.088382
20.786667, -1.091885
20.790000, -1.095426
20.793333, -1.099184
20.796667, -1.102597
20.800000, -1.104909
20.803333, -1.106072
20.806667, -1.106993
20.810000, -1.108707
20.813333, -1.111442
20.816667, -1.114680
20.820000, -1.117868
20.823333, -1.120905
20.826667, -1.124103
20.830000, -1.127714
20.833333, -1.131538
20.836667, -1.135082
20.840000, -1.138001
20.843333, -1.140317
20.846667, -1.142198
20.850000, -1.143585
20.853333, -1.144252
20.856667, -1.144187
20.860000, -1.143779
20.863333, -1.143767
20.866667, -1.144894
20.870000, -1.147395
20.873333, -1.150914
20.876667, -1.154769
20.880000, -1.158148
20.883333, -1.160517
20.886667, -1.162044
20.890000, -1.163292
20.893333, -1.164608
20.896667, -1.166062
20.900000, -1.167558
20.903333, -1.168802
20.906667, -1.169549
20.910000, -1.169815
20.913333, -1.169745
20.916667, -1.169572
20.920000, -1.169617
20.923333, -1.170086
20.926667, -1.170988
20.930000, -1.172171
20.933333, -1.173174
20.936667, -1.173389
20.940000, -1.172702
20.943333, -1.171670
20.946667, -1.170962
20.950000, -1.170962
20.953333, -1.171869
20.956667, -1.173779
20.960000, -1.176589
20.963333, -1.179939
20.966667, -1.183254
20.970000, -1.185925
20.973333, -1.187579
20.976667, -1.188128
20.980000, -1.187484
20.983333, -1.185246
20.986667, -1.181039
20.990000, -1.175185
20.993333, -1.168573
20.996667, -1.161950
21.000000, -1.155811
21.003333, -1.150647
21.006667, -1.146655
21.010000, -1.143366
21.013333, -1.140060
21.016667, -1.136450
21.020000, -1.132756
21.023333, -1.129302
21.026667, -1.126190
21.030000, -1.123175
21.033333, -1.119722
21.036667, -1.115440
21.040000, -1.110449
21.043333, -1.105145
21.046667, -1.099881
21.050000, -1.095117
21.053333, -1.091441
21.056667, -1.089070
21.060000, -1.087456
21.063333, -1.085436
21.066667, -1.081757
21.070000, -1.075820
21.073333, -1.068095
21.076667, -1.059681
21.080000, -1.051441
21.083333, -1.043772
21.086667, -1.037067
21.090000, -1.031898
21.093333, -1.028499
21.096667, -1.026458
21.100000, -1.025204
21.103333, -1.024507
21.106667, -1.024357
21.110000, -1.024759
21.113333, -1.025651
21.116667, -1.026787
21.120000, -1.027706
21.123333, -1.027965
21.126667, -1.027486
21.130000, -1.026580
21.133333, -1.025663
21.136667, -1.025099
21.140000, -1.025044
21.143333, -1.025286
21.146667, -1.025498
21.150000, -1.025479
21.153333, -1.025038
21.156667, -1.023977
21.160000, -1.022347
21.163333, -1.020575
21.166667, -1.019139
21.170000, -1.018308
21.173333, -1.018331
21.176667, -1.019439
21.180000, -1.021604
21.183333, -1.024602
21.186667, -1.028038
21.190000, -1.031364
21.193333, -1.034101
21.196667, -1.035821
21.200000, -1.036149
21.203333, -1.035079
21.206667, -1.033081
21.210000, -1.030764
21.213333, -1.028493
21.216667, -1.026438
21.220000, -1.024865
21.223333, -1.024001
21.226667, -1.023787
21.230000, -1.024031
21.233333, -1.024539
21.236667, -1.025031
21.240000, -1.025160
21.243333, -1.024791
21.246667, -1.024172
21.250000, -1.023681
21.253333, -1.023429
21.256667, -1.023320
21.260000, -1.023266
21.263333, -1.023222
21.266667, -1.023182
21.270000, -1.023219
21.273333, -1.023404
21.276667, -1.023635
21.280000, -1.023920
21.283333, -1.024663
21.286667, -1.026189
21.290000, -1.028434
21.293333, -1.031227
21.296667, -1.034368
21.300000, -1.037537
21.303333, -1.040521
21.306667, -1.043403
21.310000, -1.046285
21.313333, -1.049035
21.316667, -1.051410
21.320000, -1.053229
21.323333, -1.054599
21.326667, -1.056042
21.330000, -1.058147
21.333333, -1.061052
21.336667, -1.064381
21.340000, -1.067716
21.343333, -1.070907
21.346667, -1.073863
21.350000, -1.076498
21.353333, -1.079061
21.356667, -1.082061
21.360000, -1.085756
21.363333, -1.089796
21.366667, -1.093479
21.370000, -1.096461
21.373333, -1.099063
21.376667, -1.101880
21.380000, -1.105249
21.383333, -1.109014
21.386667, -1.112777
21.390000, -1.116480
21.393333, -1.120458
21.396667, -1.124849
21.400000, -1.129135
21.403333, -1.132346
21.406667, -1.133921
21.410000, -1.134178
21.413333, -1.133825
21.416667, -1.133467
21.420000, -1.133633
21.423333, -1.134691
21.426667, -1.136580
21.430000, -1.138925
21.433333, -1.141531
21.436667, -1.144492
21.440000, -1.147858
21.443333, -1.151452
21.446667, -1.155073
21.450000, -1.158595
21.453333, -1.161688
21.456667, -1.163880
21.460000, -1.165178
21.463333, -1.166136
21.466667, -1.167181
21.470000, -1.168245
21.473333, -1.169079
21.476667, -1.169737
21.480000, -1.170660
21.483333, -1.172264
21.486667, -1.174588
21.490000, -1.177231
21.493333, -1.179516
21.496667, -1.180878
21.500000, -1.181247
21.503333, -1.181032
21.506667, -1.180729
21.510000, -1.180679
21.513333, -1.181295
21.516667, -1.183137
21.520000, -1.186469
21.523333, -1.190821
21.526667, -1.195055
21.530000, -1.197910
21.533333, -1.198487
21.536667, -1.196604
21.540000, -1.193074
21.543333, -1.189268
21.546667, -1.186130
21.550000, -1.183693
21.553333, -1.181361
21.556667, -1.178488
21.560000, -1.174901
21.563333, -1.171092
21.566667, -1.167668
21.570000, -1.164634
21.573333, -1.161650
21.576667, -1.158627
21.580000, -1.155689
21.583333, -1.152919
21.586667, -1.150314
21.590000, -1.147805
21.593333, -1.145328
21.596667, -1.142826
21.600000, -1.140152
21.603333, -1.137147
21.606667, -1.133823
21.610000, -1.130394
21.613333, -1.127135
21.616667, -1.124118
21.620000, -1.121137
21.623333, -1.117959
21.626667, -1.114521
21.630000, -1.110935
21.633333, -1.107288
21.636667, -1.103507
21.640000, -1.099474
21.643333, -1.095196
21.646667, -1.090929
21.650000, -1.087181
21.653333, -1.084413
21.656667, -1.082825
21.660000, -1.082487
21.663333, -1.083329
21.666667, -1.084880
21.670000, -1.086413
21.673333, -1.087537
21.676667, -1.088346
21.680000, -1.088936
21.683333, -1.089175
21.686667, -1.089006
21.690000, -1.088663
21.693333, -1.088550
21.696667, -1.088976
21.700000, -1.089976
21.703333, -1.091328
21.706667, -1.092707
21.710000, -1.093851
21.713333, -1.094756
21.716667, -1.095704
21.720000, -1.097027
21.723333, -1.098946
21.726667, -1.101520
21.730000, -1.104555
21.733333, -1.107766
21.736667, -1.111085
21.740000, -1.114728
21.743333, -1.119108
21.746667, -1.124597
21.750000, -1.131067
21.753333, -1.137597
21.756667, -1.142895
21.760000, -1.146182
21.763333, -1.147615
21.766667, -1.147914
21.770000, -1.147881
21.773333, -1.148130
21.776667, -1.148883
21.780000, -1.149999
21.783333, -1.151384
21.786667, -1.153206
21.790000, -1.155608
21.793333, -1.158442
21.796667, -1.161427
21.800000, -1.164440
21.803333, -1.167512
21.806667, -1.170612
21.810000, -1.173655
21.813333, -1.176656
21.816667, -1.179765
21.820000, -1.183197
21.823333, -1.187099
21.826667, -1.191385
21.830000, -1.195679
21.833333, -1.199552
21.836667, -1.202809
21.840000, -1.205499
21.843333, -1.207741
21.846667, -1.209713
21.850000, -1.211731
21.853333, -1.214146
21.856667, -1.216988
21.860000, -1.219861
21.863333, -1.222477
21.866667, -1.225100
21.870000, -1.228219
21.873333, -1.231905
21.876667, -1.235555
21.880000, -1.238383
21.883333, -1.240163
21.886667, -1.241432
21.890000, -1.242853
21.893333, -1.244571
21.896667, -1.246397
21.900000, -1.248190
21.903333, -1.249793
21.906667, -1.251032
21.910000, -1.251919
21.913333, -1.252595
21.916667, -1.253145
21.920000, -1.253668
21.923333, -1.254227
21.926667, -1.254567
21.930000, -1.254268
21.933333, -1.253277
21.936667, -1.252018
21.940000, -1.250954
21.943333, -1.250258
21.946667, -1.249824
21.950000, -1.249380
21.953333, -1.248683
21.956667, -1.247544
21.960000, -1.245622
21.963333, -1.242535
21.966667, -1.238281
21.970000, -1.233441
21.973333, -1.228915
21.976667, -1.225370
21.980000, -1.222971
21.983333, -1.221609
21.986667, -1.221088
21.990000, -1.221033
21.993333, -1.220955
21.996667, -1.220457
22.000000, -1.219441
22.003333, -1.218262
22.006667, -1.217510
22.010000, -1.217549
22.013333, -1.218222
22.016667, -1.218863
22.020000, -1.218750
22.023333, -1.217692
22.026667, -1.216183
22.030000, -1.214948
22.033333, -1.214247
22.036667, -1.213656
22.040000, -1.212662
22.043333, -1.211236
22.046667, -1.209659
22.050000, -1.208173
22.053333, -1.206891
22.056667, -1.205730
22.060000, -1.204527
22.063333, -1.203401
22.066667, -1.202829
22.070000, -1.203362
22.073333, -1.205270
22.076667, -1.208307
22.080000, -1.211733
22.083333, -1.214700
22.086667, -1.216715
22.090000, -1.217639
22.093333, -1.217414
22.096667, -1.216105
22.100000, -1.214130
22.103333, -1.212021
22.106667, -1.209982
22.110000, -1.207905
22.113333, -1.205728
22.116667, -1.203614
22.120000, -1.201714
22.123333, -1.199872
22.126667, -1.197792
22.130000, -1.195443
22.133333, -1.193225
22.136667, -1.191633
22.140000, -1.190838
22.143333, -1.190634
22.146667, -1.190556
22.150000, -1.190072
22.153333, -1.188985
22.156667, -1.187577
22.160000, -1.186285
22.163333, -1.185267
22.166667, -1.184227
22.170000, -1.182712
22.173333, -1.180612
22.176667, -1.178204
22.180000, -1.175643
22.183333, -1.172693
22.186667, -1.169215
22.190000, -1.165443
22.193333, -1.161558
22.196667, -1.157508
22.200000, -1.153476
22.203333, -1.150111
22.206667, -1.147905
22.210000, -1.146508
22.213333, -1.145083
22.216667, -1.143220
22.220000, -1.141195
22.223333, -1.139444
22.226667, -1.138060
22.230000, -1.136800
22.233333, -1.135446
22.236667, -1.133852
22.240000, -1.131636
22.243333, -1.128238
22.246667, -1.123587
22.250000, -1.118507
22.253333, -1.114120
22.256667, -1.110992
22.260000, -1.109099
22.263333, -1.108052
22.266667, -1.107045
22.270000, -1.105179
22.273333, -1.102132
22.276667, -1.098304
22.280000, -1.094384
22.283333, -1.090913
22.286667, -1.088190
22.290000, -1.086301
22.293333, -1.085194
22.296667, -1.084930
22.300000, -1.085592
22.303333, -1.086800
22.306667, -1.087774
22.310000, -1.087811
22.313333, -1.086448
22.316667, -1.083514
22.320000, -1.079258
22.323333, -1.074244
22.326667, -1.069115
22.330000, -1.064300
22.333333, -1.059763
22.336667, -1.055095
22.340000, -1.049856
22.343333, -1.043939
22.346667, -1.037835
22.350000, -1.032306
22.353333, -1.027718
22.356667, -1.023950
22.360000, -1.020836
22.363333, -1.018410
22.366667, -1.016655
22.370000, -1.015175
22.373333, -1.013230
22.376667, -1.010290
22.380000, -1.006511
22.383333, -1.002441
22.386667, -0.998632
22.390000, -0.995621
22.393333, -0.993798
22.396667, -0.993164
22.400000, -0.993346
22.403333, -0.993909
22.406667, -0.994569
22.410000, -0.994903
22.413333, -0.994289
22.416667, -0.992470
22.420000, -0.989799
22.423333, -0.986900
22.426667, -0.984442
22.430000, -0.982991
22.433333, -0.982786
22.436667, -0.983676
22.440000, -0.985213
22.443333, -0.986849
22.446667, -0.988145
22.450000, -0.989038
22.453333, -0.989845
22.456667, -0.990647
22.460000, -0.991014
22.463333, -0.990703
22.466667, -0.990197
22.470000, -0.990384
22.473333, -0.991816
22.476667, -0.994337
22.480000, -0.997336
22.483333, -1.000106
22.486667, -1.002060
22.490000, -1.003038
22.493333, -1.003403
22.496667, -1.003792
22.500000, -1.004773
22.503333, -1.006566
22.506667, -1.008942
22.510000, -1.011392
22.513333, -1.013410
22.516667, -1.014691
22.520000, -1.015215
22.523333, -1.015237
22.526667, -1.015149
22.530000, -1.015212
22.533333, -1.015383
22.536667, -1.015470
22.540000, -1.015577
22.543333, -1.016339
22.546667, -1.018552
22.550000, -1.022541
22.553333, -1.027940
22.556667, -1.033896
22.560000, -1.039481
22.563333, -1.044042
22.566667, -1.047395
22.570000, -1.049855
22.573333, -1.052090
22.576667, -1.054806
22.580000, -1.058364
22.583333, -1.062538
22.586667, -1.066750
22.590000, -1.070649
22.593333, -1.074408
22.596667, -1.078485
22.600000, -1.083257
22.603333, -1.088816
22.606667, -1.094783
22.610000, -1.100339
22.613333, -1.104801
22.616667, -1.108207
22.620000, -1.111081
22.623333, -1.113970
22.626667, -1.117614
22.630000, -1.123026
22.633333, -1.130797
22.636667, -1.140529
22.640000, -1.151068
22.643333, -1.161009
22.646667, -1.169166
22.650000, -1.175137
22.653333, -1.179361
22.656667, -1.182541
22.660000, -1.185180
22.663333, -1.187480
22.666667, -1.189431
22.670000, -1.190955
22.673333, -1.192065
22.676667, -1.193004
22.680000, -1.194104
22.683333, -1.195599
22.686667, -1.197558
22.690000, -1.199884
22.693333, -1.202348
22.696667, -1.204726
22.700000, -1.206978
22.703333, -1.209262
22.706667, -1.211769
22.710000, -1.214602
22.713333, -1.217697
22.716667, -1.220767
22.720000, -1.223499
22.723333, -1.225890
22.726667, -1.228185
22.730000, -1.230469
22.733333, -1.232501
22.736667, -1.233768
22.740000, -1.233611
22.743333, -1.231646
22.746667, -1.228276
22.750000, -1.224537
22.753333, -1.221547
22.756667, -1.220187
22.760000, -1.220828
22.763333, -1.223151
22.766667, -1.226410
22.770000, -1.229754
22.773333, -1.232361
22.776667, -1.233823
22.780000, -1.234399
22.783333, -1.234630
22.786667, -1.234942
22.790000, -1.235642
22.793333, -1.236948
22.796667, -1.238837
22.800000, -1.240884
22.803333, -1.242268
22.806667, -1.242218
22.810000, -1.240739
22.813333, -1.238597
22.816667, -1.236572
22.820000, -1.235167
22.823333, -1.234735
22.826667, -1.235165
22.830000, -1.235645
22.833333, -1.235282
22.836667, -1.233835
22.840000, -1.231614
22.843333, -1.229064
22.846667, -1.226707
22.850000, -1.225185
22.853333, -1.225124
22.856667, -1.226724
22.860000, -1.229320
22.863333, -1.231659
22.866667, -1.232803
22.870000, -1.232654
22.873333, -1.231612
22.876667, -1.229927
22.880000, -1.227483
22.883333, -1.224141
22.886667, -1.220095
22.890000, -1.215840
22.893333, -1.211880
22.896667, -1.208401
22.900000, -1.205163
22.903333, -1.201845
22.906667, -1.198303
22.910000, -1.194431
22.913333, -1.190255
22.916667, -1.186088
22.920000, -1.182311
22.923333, -1.179103
22.926667, -1.176323
22.930000, -1.173659
22.933333, -1.170938
22.936667, -1.168244
22.940000, -1.165876
22.943333, -1.164119
22.946667, -1.162989
22.950000, -1.162321
22.953333, -1.161985
22.956667, -1.161827
22.960000, -1.161474
22.963333, -1.160340
22.966667, -1.158100
22.970000, -1.155211
22.973333, -1.152647
22.976667, -1.151101
22.980000, -1.150693
22.983333, -1.151099
22.986667, -1.151531
22.990000, -1.150980
22.993333, -1.148998
22.996667, -1.146152
23.000000, -1.143695
23.003333, -1.142660
23.006667, -1.142965
23.010000, -1.143601
23.013333, -1.143628
23.016667, -1.142615
23.020000, -1.140585
23.023333, -1.138131
23.026667, -1.136188
23.030000, -1.135159
23.033333, -1.134589
23.036667, -1.134001
23.040000, -1.133423
23.043333, -1.132971
23.046667, -1.132663
23.050000, -1.132718
23.053333, -1.133405
23.056667, -1.134499
23.060000, -1.135345
23.063333, -1.135541
23.066667, -1.135224
23.070000, -1.134603
23.073333, -1.133398
23.076667, -1.130960
23.080000, -1.127034
23.083333, -1.122254
23.086667, -1.117682
23.090000, -1.113950
23.093333, -1.111159
23.096667, -1.109451
23.100000, -1.109072
23.103333, -1.109901
23.106667, -1.111563
23.110000, -1.113855
23.113333, -1.116653
23.116667, -1.119661
23.120000, -1.122412
23.123333, -1.124481
23.126667, -1.125748
23.130000, -1.126257
23.133333, -1.125935
23.136667, -1.124811
23.140000, -1.123362
23.143333, -1.122264
23.146667, -1.121757
23.150000, -1.121495
23.153333, -1.121174
23.156667, -1.121003
23.160000, -1.121317
23.163333, -1.122038
23.166667, -1.122596
23.170000, -1.122294
23.173333, -1.121040
23.176667, -1.119538
23.180000, -1.118591
23.183333, -1.118712
23.186667, -1.120400
23.190000, -1.124110
23.193333, -1.129669
23.196667, -1.135950
23.200000, -1.141453
23.203333, -1.145293
23.206667, -1.147360
23.210000, -1.147705
23.213333, -1.146226
23.216667, -1.142936
23.220000, -1.138328
23.223333, -1.133332
23.226667, -1.128813
23.230000, -1.125185
23.233333, -1.122430
23.236667, -1.120203
23.240000, -1.117980
23.243333, -1.115427
23.246667, -1.112637
23.250000, -1.110016
23.253333, -1.108016
23.256667, -1.106860
23.260000, -1.106288
23.263333, -1.105450
23.266667, -1.103433
23.270000, -1.100214
23.273333, -1.096725
23.276667, -1.093983
23.280000, -1.092447
23.283333, -1.091848
23.286667, -1.091481
23.290000, -1.090738
23.293333, -1.089274
23.296667, -1.086797
23.300000, -1.082838
23.303333, -1.076974
23.306667, -1.069475
23.310000, -1.061380
23.313333, -1.053823
23.316667, -1.047590
23.320000, -1.043171
23.323333, -1.040820
23.326667, -1.040489
23.330000, -1.041723
23.333333, -1.043638
23.336667, -1.045104
23.340000, -1.045225
23.343333, -1.043825
23.346667, -1.041358
23.350000, -1.038280
23.353333, -1.034741
23.356667, -1.030882
23.360000, -1.027175
23.363333, -1.024313
23.366667, -1.022557
23.370000, -1.021323
23.373333, -1.019785
23.376667, -1.017622
23.380000, -1.014920
23.383333, -1.011784
23.386667, -1.008406
23.390000, -1.005147
23.393333, -1.002214
23.396667, -0.999475
23.400000, -0.996626
23.403333, -0.993290
23.406667, -0.989426
23.410000, -0.985878
23.413333, -0.983959
23.416667, -0.984307
23.420000, -0.986302
23.423333, -0.988472
23.426667, -0.989526
23.430000, -0.988972
23.433333, -0.986770
23.436667, -0.983013
23.440000, -0.978122
23.443333, -0.972669
23.446667, -0.966926
23.450000, -0.960880
23.453333, -0.954478
23.456667, -0.947902
23.460000, -0.941784
23.463333, -0.936789
23.466667, -0.933005
23.470000, -0.930087
23.473333, -0.927685
23.476667, -0.925564
23.480000, -0.923594
23.483333, -0.921633
23.486667, -0.919420
23.490000, -0.916799
23.493333, -0.914044
23.496667, -0.911695
23.500000, -0.910088
23.503333, -0.909091
23.506667, -0.908179
23.510000, -0.906779
23.513333, -0.904657
23.516667, -0.902067
23.520000, -0.899524
23.523333, -0.897473
23.526667, -0.896178
23.530000, -0.895646
23.533333, -0.895628
23.536667, -0.895861
23.540000, -0.896209
23.543333, -0.896504
23.546667, -0.896479
23.550000, -0.896014
23.553333, -0.895273
23.556667, -0.894510
23.560000, -0.893961
23.563333, -0.893971
23.566667, -0.894889
23.570000, -0.896708
23.573333, -0.898922
23.576667, -0.900881
23.580000, -0.902192
23.583333, -0.902785
23.586667, -0.902906
23.590000, -0.903068
23.593333, -0.903767
23.596667, -0.905195
23.600000, -0.907096
23.603333, -0.908907
23.606667, -0.910235
23.610000, -0.911117
23.613333, -0.911858
23.616667, -0.912726
23.620000, -0.913564
23.623333, -0.913782
23.626667, -0.913023
23.630000, -0.911630
23.633333, -0.910302
23.636667, -0.909486
23.640000, -0.909281
23.643333, -0.909770
23.646667, -0.911179
23.650000, -0.913618
23.653333, -0.916722
23.656667, -0.919809
23.660000, -0.922395
23.663333, -0.924324
23.666667, -0.925689
23.670000, -0.926818
23.673333, -0.927980
23.676667, -0.929111
23.680000, -0.930043
23.683333, -0.930789
23.686667, -0.931554
23.690000, -0.932644
23.693333, -0.934283
23.696667, -0.936411
23.700000, -0.938698
23.703333, -0.940761
23.706667, -0.942444
23.710000, -0.943998
23.713333, -0.945829
23.716667, -0.948098
23.720000, -0.950744
23.723333, -0.953689
23.726667, -0.956738
23.730000, -0.959572
23.733333, -0.961992
23.736667, -0.964004
23.740000, -0.965862
23.743333, -0.968058
23.746667, -0.971056
23.750000, -0.974972
23.753333, -0.979492
23.756667, -0.984180
23.760000, -0.988705
23.763333, -0.992568
23.766667, -0.995230
23.770000, -0.996796
23.773333, -0.997937
23.776667, -0.999036
23.780000, -0.999971
23.783333, -1.000579
23.786667, -1.000918
23.790000, -1.001148
23.793333, -1.001279
23.796667, -1.001046
23.800000, -1.000197
23.803333, -0.998896
23.806667, -0.997616
23.810000, -0.996727
23.813333, -0.996422
23.816667, -0.996843
23.820000, -0.997942
23.823333, -0.999426
23.826667, -1.000982
23.830000, -1.002398
23.833333, -1.003586
23.836667, -1.004582
23.840000, -1.005405
23.843333, -1.006010
23.846667, -1.006484
23.850000, -1.007083
23.853333, -1.007820
23.856667, -1.008345
23.860000, -1.008376
23.863333, -1.007948
23.866667, -1.007240
23.870000, -1.006366
23.873333, -1.005388
23.876667, -1.004397
23.880000, -1.003525
23.883333, -1.002962
23.886667, -1.002877
23.890000, -1.003126
23.893333, -1.003277
23.896667, -1.003084
23.900000, -1.002631
23.903333, -1.001998
23.906667, -1.001164
23.910000, -1.000231
23.913333, -0.999429
23.916667, -0.998950
23.920000, -0.998710
23.923333, -0.998185
23.926667, -0.996824
23.930000, -0.994636
23.933333, -0.992140
23.936667, -0.990034
23.940000, -0.988867
23.943333, -0.988647
23.946667, -0.988783
23.950000, -0.988478
23.953333, -0.987264
23.956667, -0.985281
23.960000, -0.983022
23.963333, -0.980760
23.966667, -0.978327
23.970000, -0.975390
23.973333, -0.971771
23.976667, -0.967665
23.980000, -0.963669
23.983333, -0.960437
23.986667, -0.958181
23.990000, -0.956749
23.993333, -0.956064
23.996667, -0.956204
24.000000, -0.957213
24.003333, -0.958977
24.006667, -0.961141
24.010000, -0.963169
24.013333, -0.964539
24.016667, -0.964895
24.020000, -0.964187
24.023333, -0.962853
24.026667, -0.961693
24.030000, -0.961203
24.033333, -0.961193
24.036667, -0.961315
24.040000, -0.961518
24.043333, -0.961809
24.046667, -0.962065
24.050000, -0.962286
24.053333, -0.962722
24.056667, -0.963562
24.060000, -0.964757
24.063333, -0.966215
24.066667, -0.967932
24.070000, -0.969957
24.073333, -0.972302
24.076667, -0.975112
24.080000, -0.978958
24.083333, -0.984422
24.086667, -0.991164
24.090000, -0.997683
24.093333, -1.002232
24.096667, -1.004011
24.100000, -1.003522
24.103333, -1.001866
24.106667, -0.999968
24.110000, -0.998447
24.113333, -0.997632
24.116667, -0.997437
24.120000, -0.997487
24.123333, -0.997305
24.126667, -0.996552
24.130000, -0.995366
24.133333, -0.994329
24.136667, -0.993941
24.140000, -0.994078
24.143333, -0.994138
24.146667, -0.993774
24.150000, -0.993281
24.153333, -0.993257
24.156667, -0.993972
24.160000, -0.995201
24.163333, -0.996575
24.166667, -0.997828
24.170000, -0.998738
24.173333, -0.999097
24.176667, -0.998937
24.180000, -0.998666
24.183333, -0.998664
24.186667, -0.998743
24.190000, -0.998297
24.193333, -0.996921
24.196667, -0.994844
24.200000, -0.992879
24.203333, -0.991844
24.206667, -0.992055
24.210000, -0.993425
24.213333, -0.995707
24.216667, -0.998565
24.220000, -1.001523
24.223333, -1.004084
24.226667, -1.006090
24.230000, -1.007715
24.233333, -1.009093
24.236667, -1.010312
24.240000, -1.011721
24.243333, -1.013804
24.246667, -1.016579
24.250000, -1.019493
24.253333, -1.022050
24.256667, -1.024228
24.260000, -1.026226
24.263333, -1.028206
24.266667, -1.030213
24.270000, -1.032179
24.273333, -1.034214
24.276667, -1.036644
24.280000, -1.039377
24.283333, -1.041766
24.286667, -1.043458
24.290000, -1.044721
24.293333, -1.045796
24.296667, -1.046807
24.300000, -1.048339
24.303333, -1.051232
24.306667, -1.055821
24.310000, -1.061714
24.313333, -1.067991
24.316667, -1.073628
24.320000, -1.078049
24.323333, -1.081192
24.326667, -1.082998
24.330000, -1.083291
24.333333, -1.082388
24.336667, -1.081179
24.340000, -1.080290
24.343333, -1.079716
24.346667, -1.079226
24.350000, -1.078725
24.353333, -1.078385
24.356667, -1.078414
24.360000, -1.078700
24.363333, -1.078858
24.366667, -1.078691
24.370000, -1.078392
24.373333, -1.078349
24.376667, -1.078830
24.380000, -1.079661
24.383333, -1.080326
24.386667, -1.080352
24.390000, -1.079374
24.393333, -1.077334
24.396667, -1.074775
24.400000, -1.072511
24.403333, -1.071104
24.406667, -1.070697
24.410000, -1.071040
24.413333, -1.071703
24.416667, -1.072327
24.420000, -1.072668
24.423333, -1.072620
24.426667, -1.072283
24.430000, -1.071715
24.433333, -1.070764
24.436667, -1.069475
24.440000, -1.068276
24.443333, -1.067417
24.446667, -1.066649
24.450000, -1.065558
24.453333, -1.063991
24.456667, -1.062189
24.460000, -1.060695
24.463333, -1.059998
24.466667, -1.060115
24.470000, -1.060488
24.473333, -1.060284
24.476667, -1.058831
24.480000, -1.056056
24.483333, -1.052696
24.486667, -1.049849
24.490000, -1.048170
24.493333, -1.047472
24.496667, -1.046937
24.500000, -1.045749
24.503333, -1.043624
24.506667, -1.040768
24.510000, -1.037581
24.513333, -1.034563
24.516667, -1.032176
24.520000, -1.030422
24.523333, -1.028583
24.526667, -1.025559
24.530000, -1.020709
24.533333, -1.014608
24.536667, -1.008840
24.540000, -1.004802
24.543333, -1.002738
24.546667, -1.002103
24.550000, -1.002484
24.553333, -1.003578
24.556667, -1.004722
24.560000, -1.005030
24.563333, -1.003961
24.566667, -1.001822
24.570000, -0.999655
24.573333, -0.998425
24.576667, -0.998387
24.580000, -0.999250
24.583333, -1.000647
24.586667, -1.002275
24.590000, -1.003872
24.593333, -1.005347
24.596667, -1.006681
24.600000, -1.007762
24.603333, -1.008545
24.606667, -1.009165
24.610000, -1.009835
24.613333, -1.010692
24.616667, -1.011632
24.620000, -1.012386
24.623333, -1.012703
24.626667, -1.012521
24.630000, -1.012256
24.633333, -1.012862
24.636667, -1.015251
24.640000, -1.019563
24.643333, -1.025010
24.646667, -1.030414
24.650000, -1.034771
24.653333, -1.037445
24.656667, -1.038307
24.660000, -1.037861
24.663333, -1.037002
24.666667, -1.036480
24.670000, -1.036535
24.673333, -1.036930
24.676667, -1.037138
24.680000, -1.036659
24.683333, -1.035381
24.686667, -1.033681
24.690000, -1.032150
24.693333, -1.031022
24.696667, -1.029986
24.700000, -1.028708
24.703333, -1.027175
24.706667, -1.025531
24.710000, -1.024071
24.713333, -1.023222
24.716667, -1.023138
24.720000, -1.023552
24.723333, -1.024206
24.726667, -1.025128
24.730000, -1.026519
24.733333, -1.028461
24.736667, -1.030677
24.740000, -1.032761
24.743333, -1.034639
24.746667, -1.036436
24.750000, -1.037999
24.753333, -1.039055
24.756667, -1.039613
24.760000, -1.039866
24.763333, -1.039903
24.766667, -1.039766
24.770000, -1.039673
24.773333, -1.039919
24.776667, -1.040702
24.780000, -1.042063
24.783333, -1.043792
24.786667, -1.045573
24.790000, -1.047291
24.793333, -1.049026
24.796667, -1.050883
24.800000, -1.052833
24.803333, -1.054657
24.806667, -1.056199
24.810000, -1.057651
24.813333, -1.059238
24.816667, -1.060840
24.820000, -1.062301
24.823333, -1.063745
24.826667, -1.065268
24.830000, -1.066840
24.833333, -1.068686
24.836667, -1.071142
24.840000, -1.074124
24.843333, -1.077177
24.846667, -1.079902
24.850000, -1.082128
24.853333, -1.083819
24.856667, -1.084970
24.860000, -1.085583
24.863333, -1.085681
24.866667, -1.085403
24.870000, -1.085080
24.873333, -1.084940
24.876667, -1.084783
24.880000, -1.084343
24.883333, -1.083940
24.886667, -1.084293
24.890000, -1.085715
24.893333, -1.087909
24.896667, -1.090418
24.900000, -1.092978
24.903333, -1.095632
24.906667, -1.098496
24.910000, -1.101215
24.913333, -1.103059
24.916667, -1.103676
24.920000, -1.103381
24.923333, -1.102785
24.926667, -1.102499
24.930000, -1.102983
24.933333, -1.104262
24.936667, -1.105865
24.940000, -1.107251
24.943333, -1.108098
24.946667, -1.108319
24.950000, -1.108101
24.953333, -1.107894
24.956667, -1.108309
24.960000, -1.109732
24.963333, -1.111862
24.966667, -1.114058
24.970000, -1.116165
24.973333, -1.118654
24.976667, -1.121930
24.980000, -1.125617
24.983333, -1.128629
24.986667, -1.130061
24.990000, -1.129958
24.993333, -1.129080
24.996667, -1.128065
25.000000, -1.127029
25.003333, -1.125840
25.006667, -1.124401
25.010000, -1.122426
25.013333, -1.119433
25.016667, -1.115471
25.020000, -1.111402
25.023333, -1.108139
25.026667, -1.105864
25.030000, -1.103974
25.033333, -1.101693
25.036667, -1.098698
25.040000, -1.095196
25.043333, -1.091590
25.046667, -1.088235
25.050000, -1.085509
25.053333, -1.083767
25.056667, -1.082871
25.060000, -1.082195
25.063333, -1.081298
25.066667, -1.080127
25.070000, -1.078637
25.073333, -1.076778
25.076667, -1.074681
25.080000, -1.072424
25.083333, -1.069886
25.086667, -1.066948
25.090000, -1.063546
25.093333, -1.059699
25.096667, -1.055678
25.100000, -1.051940
25.103333, -1.048837
25.106667, -1.046454
25.110000, -1.044720
25.113333, -1.043663
25.116667, -1.043547
25.120000, -1.044546
25.123333, -1.046312
25.126667, -1.048023
25.130000, -1.049027
25.133333, -1.049545
25.136667, -1.050425
25.140000, -1.052156
25.143333, -1.054475
25.146667, -1.056720
25.150000, -1.058266
25.153333, -1.058939
25.156667, -1.059155
25.160000, -1.059550
25.163333, -1.060519
25.166667, -1.062091
25.170000, -1.064098
25.173333, -1.066355
25.176667, -1.068687
25.180000, -1.070890
25.183333, -1.072895
25.186667, -1.075106
25.190000, -1.078290
25.193333, -1.082857
25.196667, -1.088545
25.200000, -1.094818
25.203333, -1.101159
25.206667, -1.107087
25.210000, -1.112214
25.213333, -1.116303
25.216667, -1.119364
25.220000, -1.121673
25.223333, -1.123425
25.226667, -1.124414
25.230000, -1.124443
25.233333, -1.123919
25.236667, -1.123605
25.240000, -1.124063
25.243333, -1.125526
25.246667, -1.127830
25.250000, -1.130417
25.253333, -1.132828
25.256667, -1.135157
25.260000, -1.137775
25.263333, -1.140886
25.266667, -1.144515
25.270000, -1.148594
25.273333, -1.152830
25.276667, -1.156711
25.280000, -1.159835
25.283333, -1.162218
25.286667, -1.164289
25.290000, -1.166582
25.293333, -1.169388
25.296667, -1.172792
25.300000, -1.176789
25.303333, -1.181119
25.306667, -1.185192
25.310000, -1.188404
25.313333, -1.190584
25.316667, -1.192078
25.320000, -1.193315
25.323333, -1.194488
25.326667, -1.195591
25.330000, -1.196614
25.333333, -1.197835
25.336667, -1.199759
25.340000, -1.202608
25.343333, -1.206241
25.346667, -1.210488
25.350000, -1.215095
25.353333, -1.219646
25.356667, -1.223848
25.360000, -1.227505
25.363333, -1.230374
25.366667, -1.232432
25.370000, -1.233997
25.373333, -1.235636
25.376667, -1.237967
25.380000, -1.241209
25.383333, -1.244966
25.386667, -1.248644
25.390000, -1.252031
25.393333, -1.255382
25.396667, -1.258963
25.400000, -1.262700
25.403333, -1.266186
25.406667, -1.269019
25.410000, -1.271057
25.413333, -1.272174
25.416667, -1.271899
25.420000, -1.269765
25.423333, -1.266130
25.426667, -1.262216
25.430000, -1.259291
25.433333, -1.258149
25.436667, -1.258961
25.440000, -1.261222
25.443333, -1.264266
25.446667, -1.267708
25.450000, -1.271218
25.453333, -1.274456
25.456667, -1.277218
25.460000, -1.279445
25.463333, -1.281317
25.466667, -1.283097
25.470000, -1.284881
25.473333, -1.286805
25.476667, -1.289116
25.480000, -1.291828
25.483333, -1.294557
25.486667, -1.296725
25.490000, -1.297916
25.493333, -1.298043
25.496667, -1.297202
25.500000, -1.295630
25.503333, -1.293805
25.506667, -1.292191
25.510000, -1.290942
25.513333, -1.290052
25.516667, -1.289571
25.520000, -1.289681
25.523333, -1.290616
25.526667, -1.292346
25.530000, -1.294463
25.533333, -1.296539
25.536667, -1.298314
25.540000, -1.299451
25.543333, -1.299514
25.546667, -1.298350
25.550000, -1.296229
25.553333, -1.293632
25.556667, -1.291058
25.560000, -1.288738
25.563333, -1.286374
25.566667, -1.283491
25.570000, -1.279945
25.573333, -1.275981
25.576667, -1.271968
25.580000, -1.268008
25.583333, -1.264152
25.586667, -1.260915
25.590000, -1.258908
25.593333, -1.258041
25.596667, -1.257472
25.600000, -1.256280
25.603333, -1.254169
25.606667, -1.251492
25.610000, -1.248569
25.613333, -1.245286
25.616667, -1.241520
25.620000, -1.237539
25.623333, -1.233912
25.626667, -1.231125
25.630000, -1.229079
25.633333, -1.227087
25.636667, -1.224448
25.640000, -1.220915
25.643333, -1.216644
25.646667, -1.211902
25.650000, -1.206994
25.653333, -1.202323
25.656667, -1.198341
25.660000, -1.195437
25.663333, -1.193794
25.666667, -1.193355
25.670000, -1.193808
25.673333, -1.194506
25.676667, -1.194742
25.680000, -1.194108
25.683333, -1.192637
25.686667, -1.190977
25.690000, -1.190092
25.693333, -1.190392
25.696667, -1.191484
25.700000, -1.192593
25.703333, -1.193017
25.706667, -1.192568
25.710000, -1.191760
25.713333, -1.191411
25.716667, -1.192013
25.720000, -1.193421
25.723333, -1.195048
25.726667, -1.196253
25.730000, -1.196648
25.733333, -1.196379
25.736667, -1.196031
25.740000, -1.196102
25.743333, -1.196729
25.746667, -1.197896
25.750000, -1.199766
25.753333, -1.202679
25.756667, -1.206693
25.760000, -1.211233
25.763333, -1.215336
25.766667, -1.218259
25.770000, -1.219726
25.773333, -1.219776
25.776667, -1.218805
25.780000, -1.217424
25.783333, -1.215909
25.786667, -1.214039
25.790000, -1.211604
25.793333, -1.208854
25.796667, -1.206334
25.800000, -1.204387
25.803333, -1.202846
25.806667, -1.201209
25.810000, -1.199114
25.813333, -1.196599
25.816667, -1.194074
25.820000, -1.192096
25.823333, -1.190854
25.826667, -1.189923
25.830000, -1.188775
25.833333, -1.187286
25.836667, -1.185580
25.840000, -1.183565
25.843333, -1.181029
25.846667, -1.178175
25.850000, -1.175537
25.853333, -1.173355
25.856667, -1.171448
25.860000, -1.169523
25.863333, -1.167293
25.866667, -1.164630
25.870000, -1.161846
25.873333, -1.159441
25.876667, -1.157559
25.880000, -1.156022
25.883333, -1.154683
25.886667, -1.153404
25.890000, -1.151923
25.893333, -1.150033
25.896667, -1.147681
25.900000, -1.144949
25.903333, -1.142126
25.906667, -1.139562
25.910000, -1.137498
25.913333, -1.136178
25.916667, -1.135643
25.920000, -1.135530
25.923333, -1.135426
25.926667, -1.135053
25.930000, -1.134138
25.933333, -1.132672
25.936667, -1.131312
25.940000, -1.131003
25.943333, -1.131938
25.946667, -1.133253
25.950000, -1.133941
25.953333, -1.133768
25.956667, -1.133328
25.960000, -1.133357
25.963333, -1.133963
25.966667, -1.134664
25.970000, -1.135035
25.973333, -1.134964
25.976667, -1.134460
25.980000, -1.133467
25.983333, -1.132082
25.986667, -1.130891
25.990000, -1.130446
25.993333, -1.130604
25.996667, -1.130925
26.000000, -1.131304
26.003333, -1.131908
26.006667, -1.132785
26.010000, -1.133872
26.013333, -1.135326
26.016667, -1.137444
26.020000, -1.140204
26.023333, -1.143113
26.026667, -1.145534
26.030000, -1.147049
26.033333, -1.147718
26.036667, -1.148154
26.040000, -1.149096
26.043333, -1.150731
26.046667, -1.152508
26.050000, -1.153847
26.053333, -1.154760
26.056667, -1.155443
26.060000, -1.155840
26.063333, -1.155967
26.066667, -1.156122
26.070000, -1.156437
26.073333, -1.156530
26.076667, -1.155991
26.080000, -1.155172
26.083333, -1.155138
26.086667, -1.156736
26.090000, -1.159881
26.093333, -1.163705
26.096667, -1.167221
26.100000, -1.169777
26.103333, -1.171022
26.106667, -1.170656
26.110000, -1.168438
26.113333, -1.164691
26.116667, -1.160513
26.120000, -1.157112
26.123333, -1.154986
26.126667, -1.153779
26.130000, -1.152910
26.133333, -1.152084
26.136667, -1.151025
26.140000, -1.149253
26.143333, -1.146487
26.146667, -1.142928
26.150000, -1.139240
26.153333, -1.136379
26.156667, -1.134884
26.160000, -1.134223
26.163333, -1.133193
26.166667, -1.130969
26.170000, -1.127689
26.173333, -1.124125
26.176667, -1.120845
26.180000, -1.117830
26.183333, -1.114916
26.186667, -1.112194
26.190000, -1.109668
26.193333, -1.106911
26.196667, -1.103289
26.200000, -1.098403
26.203333, -1.092462
26.206667, -1.086249
26.210000, -1.080697
26.213333, -1.076540
26.216667, -1.074083
26.220000, -1.072956
26.223333, -1.072247
26.226667, -1.071071
26.230000, -1.069084
26.233333, -1.066575
26.236667, -1.064126
26.240000, -1.062105
26.243333, -1.060528
26.246667, -1.059348
26.250000, -1.058618
26.253333, -1.058203
26.256667, -1.057598
26.260000, -1.056374
26.263333, -1.054595
26.266667, -1.052695
26.270000, -1.051163
26.273333, -1.050283
26.276667, -1.050025
26.280000, -1.050150
26.283333, -1.050301
26.286667, -1.050229
26.290000, -1.049944
26.293333, -1.049272
26.296667, -1.047780
26.300000, -1.045663
26.303333, -1.043903
26.306667, -1.043410
26.310000, -1.044587
26.313333, -1.047374
26.316667, -1.051237
26.320000, -1.055326
26.323333, -1.058827
26.326667, -1.061131
26.330000, -1.061958
26.333333, -1.061604
26.336667, -1.060728
26.340000, -1.059612
26.343333, -1.057957
26.346667, -1.055464
26.350000, -1.052412
26.353333, -1.049607
26.356667, -1.047651
26.360000, -1.046351
26.363333, -1.045025
26.366667, -1.043232
26.370000, -1.041016
26.373333, -1.038735
26.376667, -1.036920
26.380000, -1.036021
26.383333, -1.036036
26.386667, -1.036468
26.390000, -1.036625
26.393333, -1.036061
26.396667, -1.034870
26.400000, -1.033554
26.403333, -1.032721
26.406667, -1.032823
26.410000, -1.033986
26.413333, -1.035989
26.416667, -1.038322
26.420000, -1.040369
26.423333, -1.041822
26.426667, -1.042767
26.430000, -1.043241
26.433333, -1.043063
26.436667, -1.042110
26.440000, -1.040540
26.443333, -1.038739
26.446667, -1.037164
26.450000, -1.036296
26.453333, -1.036558
26.456667, -1.038006
26.460000, -1.040410
26.463333, -1.043657
26.466667, -1.047513
26.470000, -1.051258
26.473333, -1.054092
26.476667, -1.055851
26.480000, -1.056947
26.483333, -1.057704
26.486667, -1.058283
26.490000, -1.059090
26.493333, -1.060673
26.496667, -1.063324
26.500000, -1.066895
26.503333, -1.070855
26.506667, -1.074711
26.510000, -1.078259
26.513333, -1.081237
26.516667, -1.083115
26.520000, -1.083659
26.523333, -1.083426
26.526667, -1.083232
26.530000, -1.083484
26.533333, -1.084287
26.536667, -1.085592
26.540000, -1.087031
26.543333, -1.088023
26.546667, -1.088257
26.550000, -1.088169
26.553333, -1.088791
26.556667, -1.090901
26.560000, -1.094420
26.563333, -1.098589
26.566667, -1.102591
26.570000, -1.106196
26.573333, -1.109624
26.576667, -1.112718
26.580000, -1.115035
26.583333, -1.116697
26.586667, -1.118161
26.590000, -1.119539
26.593333, -1.120925
26.596667, -1.122581
26.600000, -1.124326
26.603333, -1.125565
26.606667, -1.126177
26.610000, -1.126706
26.613333, -1.127698
26.616667, -1.129371
26.620000, -1.131554
26.623333, -1.133700
26.626667, -1.135481
26.630000, -1.137161
26.633333, -1.138877
26.636667, -1.140085
26.640000, -1.140192
26.643333, -1.139329
26.646667, -1.138344
26.650000, -1.138167
26.653333, -1.139184
26.656667, -1.141128
26.660000, -1.143311
26.663333, -1.144913
26.666667, -1.145356
26.670000, -1.144511
26.673333, -1.142528
26.676667, -1.139611
26.680000, -1.136050
26.683333, -1.132333
26.686667, -1.129062
26.690000, -1.126619
26.693333, -1.124920
26.696667, -1.123554
26.700000, -1.122151
26.703333, -1.120533
26.706667, -1.118662
26.710000, -1.116621
26.713333, -1.114413
26.716667, -1.111831
26.720000, -1.108756
26.723333, -1.105379
26.726667, -1.102018
26.730000, -1.098816
26.733333, -1.095692
26.736667, -1.092617
26.740000, -1.089843
26.743333, -1.087672
26.746667, -1.086121
26.750000, -1.084984
26.753333, -1.083982
26.756667, -1.082741
26.760000, -1.080881
26.763333, -1.078274
26.766667, -1.075301
26.770000, -1.072596
26.773333, -1.070385
26.776667, -1.068406
26.780000, -1.066448
26.783333, -1.064639
26.786667, -1.063375
26.790000, -1.063151
26.793333, -1.064151
26.796667, -1.065794
26.800000, -1.066979
26.803333, -1.066936
26.806667, -1.065609
26.810000, -1.063368
26.813333, -1.060872
26.816667, -1.059129
26.820000, -1.059050
26.823333, -1.060687
26.826667, -1.063131
26.830000, -1.065371
26.833333, -1.067042
26.836667, -1.068269
26.840000, -1.069253
26.843333, -1.070195
26.846667, -1.071232
26.850000, -1.072167
26.853333, -1.072489
26.856667, -1.071908
26.860000, -1.070830
26.863333, -1.070379
26.866667, -1.071919
26.870000, -1.076183
26.873333, -1.082807
26.876667, -1.090614
26.880000, -1.098090
26.883333, -1.103955
26.886667, -1.107664
26.890000, -1.109380
26.893333, -1.109691
26.896667, -1.109288
26.900000, -1.108566
26.903333, -1.107742
26.906667, -1.107207
26.910000, -1.107278
26.913333, -1.107858
26.916667, -1.108528
26.920000, -1.108728
26.923333, -1.108128
26.926667, -1.107088
26.930000, -1.106337
26.933333, -1.106332
26.936667, -1.107257
26.940000, -1.109139
26.943333, -1.111771
26.946667, -1.114740
26.950000, -1.117550
26.953333, -1.119779
26.956667, -1.121299
26.960000, -1.122298
26.963333, -1.123174
26.966667, -1.124466
26.970000, -1.126692
26.973333, -1.129972
26.976667, -1.133887
26.980000, -1.137770
26.983333, -1.141002
26.986667, -1.143169
26.990000, -1.144166
26.993333, -1.144250
26.996667, -1.143971
27.000000, -1.143925
27.003333, -1.144518
27.006667, -1.146052
27.010000, -1.148728
27.013333, -1.152366
27.016667, -1.156386
27.020000, -1.160199
27.023333, -1.163647
27.026667, -1.167079
27.030000, -1.170815
27.033333, -1.174737
27.036667, -1.178633
27.040000, -1.182465
27.043333, -1.186132
27.046667, -1.189474
27.050000, -1.192588
27.053333, -1.195738
27.056667, -1.199014
27.060000, -1.202478
27.063333, -1.206364
27.066667, -1.210691
27.070000, -1.214926
27.073333, -1.218278
27.076667, -1.220394
27.080000, -1.221722
27.083333, -1.222998
27.086667, -1.224460
27.090000, -1.225731
27.093333, -1.226291
27.096667, -1.226028
27.100000, -1.225432
27.103333, -1.225211
27.106667, -1.225852
27.110000, -1.227583
27.113333, -1.230408
27.116667, -1.234079
27.120000, -1.238227
27.123333, -1.242542
27.126667, -1.246707
27.130000, -1.250297
27.133333, -1.252973
27.136667, -1.254742
27.140000, -1.255868
27.143333, -1.256584
27.146667, -1.257044
27.150000, -1.257610
27.153333, -1.258790
27.156667, -1.260791
27.160000, -1.263312
27.163333, -1.265653
27.166667, -1.267104
27.170000, -1.267474
27.173333, -1.267052
27.176667, -1.266217
27.180000, -1.265321
27.183333, -1.264687
27.186667, -1.264409
27.190000, -1.264210
27.193333, -1.263773
27.196667, -1.263228
27.200000, -1.263107
27.203333, -1.263882
27.206667, -1.265629
27.210000, -1.267940
27.213333, -1.270129
27.216667, -1.271671
27.220000, -1.272432
27.223333, -1.272425
27.226667, -1.271473
27.230000, -1.269237
27.233333, -1.265642
27.236667, -1.261199
27.240000, -1.256658
27.243333, -1.252425
27.246667, -1.248672
27.250000, -1.245705
27.253333, -1.243732
27.256667, -1.242530
27.260000, -1.241558
27.263333, -1.240192
27.266667, -1.238047
27.270000, -1.235335
27.273333, -1.232706
27.276667, -1.230680
27.280000, -1.229389
27.283333, -1.228634
27.286667, -1.227954
27.290000, -1.226884
27.293333, -1.225421
27.296667, -1.223996
27.300000, -1.222776
27.303333, -1.221211
27.306667, -1.218424
27.310000, -1.214044
27.313333, -1.208635
27.316667, -1.203271
27.320000, -1.198756
27.323333, -1.195311
27.326667, -1.192861
27.330000, -1.191351
27.333333, -1.190685
27.336667, -1.190603
27.340000, -1.190770
27.343333, -1.191004
27.346667, -1.191398
27.350000, -1.192059
27.353333, -1.192885
27.356667, -1.193859
27.360000, -1.195226
27.363333, -1.197048
27.366667, -1.198763
27.370000, -1.199523
27.373333, -1.199213
27.376667, -1.198912
27.380000, -1.199808
27.383333, -1.201983
27.386667, -1.204667
27.390000, -1.207239
27.393333, -1.209508
27.396667, -1.211246
27.400000, -1.212128
27.403333, -1.212332
27.406667, -1.212558
27.410000, -1.213320
27.413333, -1.214687
27.416667, -1.216619
27.420000, -1.219201
27.423333, -1.222638
27.426667, -1.227038
27.430000, -1.232121
27.433333, -1.237245
27.436667, -1.241806
27.440000, -1.245533
27.443333, -1.248382
27.446667, -1.250252
27.450000, -1.251050
27.453333, -1.250981
27.456667, -1.250502
27.460000, -1.250031
27.463333, -1.249810
27.466667, -1.249846
27.470000, -1.249919
27.473333, -1.249723
27.476667, -1.249045
27.480000, -1.247988
27.483333, -1.247085
27.486667, -1.246905
27.490000, -1.247518
27.493333, -1.248552
27.496667, -1.249579
27.500000, -1.250317
27.503333, -1.250799
27.506667, -1.251312
27.510000, -1.251967
27.513333, -1.252536
27.516667, -1.252863
27.520000, -1.253141
27.523333, -1.253632
27.526667, -1.254239
27.530000, -1.254569
27.533333, -1.254434
27.536667, -1.254069
27.540000, -1.253756
27.543333, -1.253567
27.546667, -1.253621
27.550000, -1.254189
27.553333, -1.255411
27.556667, -1.257145
27.560000, -1.259058
27.563333, -1.260650
27.566667, -1.261420
27.570000, -1.261286
27.573333, -1.260660
27.576667, -1.260127
27.580000, -1.260106
27.583333, -1.260673
27.586667, -1.261639
27.590000, -1.262754
27.593333, -1.263702
27.596667, -1.264167
27.600000, -1.264235
27.603333, -1.264481
27.606667, -1.265384
27.610000, -1.266855
27.613333, -1.268420
27.616667, -1.269783
27.620000, -1.271072
27.623333, -1.272379
27.626667, -1.273393
27.630000, -1.273856
27.633333, -1.273964
27.636667, -1.273956
27.640000, -1.273814
27.643333, -1.273511
27.646667, -1.272949
27.650000, -1.271840
27.653333, -1.270105
27.656667, -1.268090
27.660000, -1.266380
27.663333, -1.265469
27.666667, -1.265411
27.670000, -1.265887
27.673333, -1.266636
27.676667, -1.267542
27.680000, -1.268408
27.683333, -1.268984
27.686667, -1.269140
27.690000, -1.268893
27.693333, -1.268528
27.696667, -1.268598
27.700000, -1.269529
27.703333, -1.271289
27.706667, -1.273402
27.710000, -1.275207
27.713333, -1.276177
27.716667, -1.276123
27.720000, -1.275297
27.723333, -1.274238
27.726667, -1.273288
27.730000, -1.272260
27.733333, -1.270634
27.736667, -1.268131
27.740000, -1.265151
27.743333, -1.262536
27.746667, -1.260963
27.750000, -1.260528
27.753333, -1.260824
27.756667, -1.261503
27.760000, -1.262683
27.763333, -1.264766
27.766667, -1.267789
27.770000, -1.270970
27.773333, -1.273056
27.776667, -1.273018
27.780000, -1.270466
27.783333, -1.265906
27.786667, -1.260647
27.790000, -1.256021
27.793333, -1.252454
27.796667, -1.249358
27.800000, -1.245893
27.803333, -1.241723
27.806667, -1.237124
27.810000, -1.232599
27.813333, -1.228453
27.816667, -1.224760
27.820000, -1.221595
27.823333, -1.218846
27.826667, -1.215998
27.830000, -1.212643
27.833333, -1.208899
27.836667, -1.204927
27.840000, -1.200563
27.843333, -1.195828
27.846667, -1.191235
27.850000, -1.187193
27.853333, -1.183571
27.856667, -1.180145
27.860000, -1.177078
27.863333, -1.174820
27.866667, -1.173496
27.870000, -1.172264
27.873333, -1.169704
27.876667, -1.165142
27.880000, -1.159293
27.883333, -1.153548
27.886667, -1.148874
27.890000, -1.145467
27.893333, -1.143063
27.896667, -1.141220
27.900000, -1.139504
27.903333, -1.137698
27.906667, -1.135898
27.910000, -1.134399
27.913333, -1.133503
27.916667, -1.133370
27.920000, -1.133867
27.923333, -1.134553
27.926667, -1.134829
27.930000, -1.134174
27.933333, -1.132535
27.936667, -1.130587
27.940000, -1.129222
27.943333, -1.128700
27.946667, -1.128581
27.950000, -1.128357
27.953333, -1.127978
27.956667, -1.127763
27.960000, -1.127856
27.963333, -1.128052
27.966667, -1.128236
27.970000, -1.128516
27.973333, -1.128874
27.976667, -1.129180
27.980000, -1.129596
27.983333, -1.130656
27.986667, -1.132808
27.990000, -1.136025
27.993333, -1.139757
27.996667, -1.143037
28.000000, -1.144892
28.003333, -1.145024
28.006667, -1.144010
28.010000, -1.142671
28.013333, -1.141400
28.016667, -1.140147
28.020000, -1.138732
28.023333, -1.137020
28.026667, -1.135007
28.030000, -1.132858
28.033333, -1.130812
28.036667, -1.128867
28.040000, -1.126661
28.043333, -1.123892
28.046667, -1.120639
28.050000, -1.117255
28.053333, -1.114283
28.056667, -1.112315
28.060000, -1.111593
28.063333, -1.111751
28.066667, -1.112054
28.070000, -1.111869
28.073333, -1.110849
28.076667, -1.108801
28.080000, -1.105720
28.083333, -1.101987
28.086667, -1.098248
28.090000, -1.095066
28.093333, -1.092859
28.096667, -1.091925
28.100000, -1.092233
28.103333, -1.093307
28.106667, -1.094495
28.110000, -1.095343
28.113333, -1.095785
28.116667, -1.095936
28.120000, -1.095719
28.123333, -1.094948
28.126667, -1.093716
28.130000, -1.092399
28.133333, -1.091334
28.136667, -1.090621
28.140000, -1.090188
28.143333, -1.089906
28.146667, -1.089522
28.150000, -1.088775
28.153333, -1.087747
28.156667, -1.086776
28.160000, -1.086038
28.163333, -1.085558
28.166667, -1.085389
28.170000, -1.085508
28.173333, -1.085756
28.176667, -1.086002
28.180000, -1.086194
28.183333, -1.086328
28.186667, -1.086431
28.190000, -1.086514
28.193333, -1.086692
28.196667, -1.087298
28.200000, -1.088538
28.203333, -1.089959
28.206667, -1.090508
28.210000, -1.089350
28.213333, -1.086537
28.216667, -1.082904
28.220000, -1.079499
28.223333, -1.077007
28.226667, -1.075607
28.230000, -1.075155
28.233333, -1.075391
28.236667, -1.076139
28.240000, -1.077412
28.243333, -1.079282
28.246667, -1.081574
28.250000, -1.083891
28.253333, -1.085926
28.256667, -1.087411
28.260000, -1.088081
28.263333, -1.087975
28.266667, -1.087485
28.270000, -1.087114
28.273333, -1.087243
28.276667, -1.088005
28.280000, -1.089323
28.283333, -1.091024
28.286667, -1.092947
28.290000, -1.095060
28.293333, -1.097273
28.296667, -1.099036
28.300000, -1.099553
28.303333, -1.098679
28.306667, -1.097342
28.310000, -1.096884
28.313333, -1.098242
28.316667, -1.101746
28.320000, -1.107130
28.323333, -1.113493
28.326667, -1.119677
28.330000, -1.124834
28.333333, -1.128441
28.336667, -1.130098
28.340000, -1.129740
28.343333, -1.127896
28.346667, -1.125600
28.350000, -1.123866
28.353333, -1.123075
28.356667, -1.122862
28.360000, -1.122534
28.363333, -1.121674
28.366667, -1.120509
28.370000, -1.119567
28.373333, -1.119121
28.376667, -1.119170
28.380000, -1.119725
28.383333, -1.120800
28.386667, -1.122157
28.390000, -1.123415
28.393333, -1.124530
28.396667, -1.125861
28.400000, -1.127645
28.403333, -1.129693
28.406667, -1.131670
28.410000, -1.133417
28.413333, -1.134788
28.416667, -1.135451
28.420000, -1.135198
28.423333, -1.134344
28.426667, -1.133584
28.430000, -1.133421
28.433333, -1.133846
28.436667, -1.134554
28.440000, -1.135231
28.443333, -1.135634
28.446667, -1.135707
28.450000, -1.135771
28.453333, -1.136448
28.456667, -1.138192
28.460000, -1.141004
28.463333, -1.144715
28.466667, -1.149108
28.470000, -1.153656
28.473333, -1.157682
28.476667, -1.160870
28.480000, -1.163344
28.483333, -1.165495
28.486667, -1.167938
28.490000, -1.171177
28.493333, -1.175132
28.496667, -1.179386
28.500000, -1.183607
28.503333, -1.187502
28.506667, -1.190790
28.510000, -1.193398
28.513333, -1.195451
28.516667, -1.197093
28.520000, -1.198425
28.523333, -1.199540
28.526667, -1.200530
28.530000, -1.201455
28.533333, -1.202450
28.536667, -1.204041
28.540000, -1.207127
28.543333, -1.212340
28.546667, -1.219316
28.550000, -1.226645
28.553333, -1.232636
28.556667, -1.236097
28.560000, -1.236697
28.563333, -1.234919
28.566667, -1.231591
28.570000, -1.227488
28.573333, -1.223490
28.576667, -1.220624
28.580000, -1.219436
28.583333, -1.219515
28.586667, -1.219918
28.590000, -1.219872
28.593333, -1.219114
28.596667, -1.217887
28.600000, -1.216543
28.603333, -1.215039
28.606667, -1.213113
28.610000, -1.210887
28.613333, -1.208777
28.616667, -1.206922
28.620000, -1.205128
28.623333, -1.203252
28.626667, -1.201289
28.630000, -1.199180
28.633333, -1.196846
28.636667, -1.194311
28.640000, -1.191560
28.643333, -1.188636
28.646667, -1.185892
28.650000, -1.183766
28.653333, -1.182408
28.656667, -1.181529
28.660000, -1.180373
28.663333, -1.178180
28.666667, -1.174967
28.670000, -1.171565
28.673333, -1.168684
28.676667, -1.166254
28.680000, -1.163951
28.683333, -1.161897
28.686667, -1.160389
28.690000, -1.159322
28.693333, -1.158147
28.696667, -1.156270
28.700000, -1.153480
28.703333, -1.150048
28.706667, -1.146493
28.710000, -1.143250
28.713333, -1.140515
28.716667, -1.138335
28.720000, -1.136649
28.723333, -1.135112
28.726667, -1.133203
28.730000, -1.130716
28.733333, -1.127972
28.736667, -1.125434
28.740000, -1.123165
28.743333, -1.120823
28.746667, -1.118171
28.750000, -1.115280
28.753333, -1.112180
28.756667, -1.108602
28.760000, -1.104218
28.763333, -1.098990
28.766667, -1.093298
28.770000, -1.087831
28.773333, -1.083175
28.776667, -1.079480
28.780000, -1.076606
28.783333, -1.074499
28.786667, -1.073251
28.790000, -1.072721
28.793333, -1.072399
28.796667, -1.071871
28.800000, -1.071084
28.803333, -1.070275
28.806667, -1.069889
28.810000, -1.070236
28.813333, -1.071256
28.816667, -1.072699
28.820000, -1.074348
28.823333, -1.076108
28.826667, -1.077829
28.830000, -1.079095
28.833333, -1.079512
28.836667, -1.079123
28.840000, -1.078387
28.843333, -1.077905
28.846667, -1.077939
28.850000, -1.078154
28.853333, -1.078196
28.856667, -1.078203
28.860000, -1.078506
28.863333, -1.079351
28.866667, -1.080958
28.870000, -1.083464
28.873333, -1.086916
28.876667, -1.091400
28.880000, -1.096962
28.883333, -1.103223
28.886667, -1.109305
28.890000, -1.114276
28.893333, -1.117476
28.896667, -1.118551
28.900000, -1.117521
28.903333, -1.114870
28.906667, -1.111531
28.910000, -1.108715
28.913333, -1.107402
28.916667, -1.107722
28.920000, -1.108964
28.923333, -1.110226
28.926667, -1.110941
28.930000, -1.110952
28.933333, -1.110436
28.936667, -1.109674
28.940000, -1.108776
28.943333, -1.107928
28.946667, -1.107640
28.950000, -1.108304
28.953333, -1.109711
28.956667, -1.111242
28.960000, -1.112485
28.963333, -1.113482
28.966667, -1.114287
28.970000, -1.114814
28.973333, -1.115317
28.976667, -1.116319
28.980000, -1.117749
28.983333, -1.118794
28.986667, -1.118790
28.990000, -1.117706
28.993333, -1.115819
28.996667, -1.113484
29.000000, -1.111201
29.003333, -1.109570
29.006667, -1.109014
29.010000, -1.109680
29.013333, -1.111659
29.016667, -1.115021
29.020000, -1.119649
29.023333, -1.125167
29.026667, -1.130931
29.030000, -1.136257
29.033333, -1.140867
29.036667, -1.144950
29.040000, -1.148820
29.043333, -1.152770
29.046667, -1.157059
29.050000, -1.161702
29.053333, -1.166493
29.056667, -1.171232
29.060000, -1.175674
29.063333, -1.179502
29.066667, -1.182723
29.070000, -1.185867
29.073333, -1.189611
29.076667, -1.194212
29.080000, -1.199175
29.083333, -1.203595
29.086667, -1.207127
29.090000, -1.210395
29.093333, -1.214449
29.096667, -1.220182
29.100000, -1.227984
29.103333, -1.237364
29.106667, -1.246990
29.110000, -1.255524
29.113333, -1.262339
29.116667, -1.267212
29.120000, -1.269908
29.123333, -1.270454
29.126667, -1.269482
29.130000, -1.268188
29.133333, -1.267786
29.136667, -1.268748
29.140000, -1.270628
29.143333, -1.272662
29.146667, -1.274470
29.150000, -1.276160
29.153333, -1.278060
29.156667, -1.280396
29.160000, -1.282913
29.163333, -1.285031
29.166667, -1.286449
29.170000, -1.287290
29.173333, -1.287920
29.176667, -1.288813
29.180000, -1.290323
29.183333, -1.292399
29.186667, -1.294530
29.190000, -1.296093
29.193333, -1.296894
29.196667, -1.297208
29.200000, -1.297454
29.203333, -1.298043
29.206667, -1.299239
29.210000, -1.301000
29.213333, -1.303083
29.216667, -1.305217
29.220000, -1.307061
29.223333, -1.308210
29.226667, -1.308446
29.230000, -1.307917
29.233333, -1.306996
29.236667, -1.306066
29.240000, -1.305338
29.243333, -1.304824
29.246667, -1.304495
29.250000, -1.304337
29.253333, -1.304178
29.256667, -1.303570
29.260000, -1.302082
29.263333, -1.299675
29.266667, -1.296735
29.270000, -1.293884
29.273333, -1.291575
29.276667, -1.289765
29.280000, -1.288221
29.283333, -1.286767
29.286667, -1.285005
29.290000, -1.282351
29.293333, -1.278628
29.296667, -1.274436
29.300000, -1.270661
29.303333, -1.267669
29.306667, -1.265221
29.310000, -1.262877
29.313333, -1.260132
29.316667, -1.256380
29.320000, -1.251098
29.323333, -1.244237
29.326667, -1.236383
29.330000, -1.228507
29.333333, -1.221535
29.336667, -1.215925
29.340000, -1.211523
29.343333, -1.207923
29.346667, -1.204864
29.350000, -1.202263
29.353333, -1.200066
29.356667, -1.198146
29.360000, -1.196221
29.363333, -1.193897
29.366667, -1.190923
29.370000, -1.187389
29.373333, -1.183685
29.376667, -1.180273
29.380000, -1.177453
29.383333, -1.175230
29.386667, -1.173334
29.390000, -1.171434
29.393333, -1.169433
29.396667, -1.167586
29.400000, -1.166317
29.403333, -1.165781
29.406667, -1.165574
29.410000, -1.165060
29.413333, -1.163813
29.416667, -1.161580
29.420000, -1.158234
29.423333, -1.154046
29.426667, -1.149882
29.430000, -1.146917
29.433333, -1.145992
29.436667, -1.147138
29.440000, -1.149671
29.443333, -1.152645
29.446667, -1.155118
29.450000, -1.156313
29.453333, -1.155856
29.456667, -1.153844
29.460000, -1.150709
29.463333, -1.146956
29.466667, -1.142918
29.470000, -1.138797
29.473333, -1.134724
29.476667, -1.130735
29.480000, -1.126864
29.483333, -1.123236
29.486667, -1.120065
29.490000, -1.117573
29.493333, -1.115785
29.496667, -1.114433
29.500000, -1.113193
29.503333, -1.111948
29.506667, -1.110800
29.510000, -1.109957
29.513333, -1.109559
29.516667, -1.109497
29.520000, -1.109431
29.523333, -1.108989
29.526667, -1.107878
29.530000, -1.105904
29.533333, -1.103205
29.536667, -1.100268
29.540000, -1.097375
29.543333, -1.094224
29.546667, -1.090368
29.550000, -1.085988
29.553333, -1.082059
29.556667, -1.079605
29.560000, -1.078796
29.563333, -1.078837
29.566667, -1.078653
29.570000, -1.077643
29.573333, -1.075903
29.576667, -1.074049
29.580000, -1.072957
29.583333, -1.073236
29.586667, -1.074864
29.590000, -1.077548
29.593333, -1.081031
29.596667, -1.084757
29.600000, -1.087681
29.603333, -1.088813
29.606667, -1.087985
29.610000, -1.085990
29.613333, -1.083984
29.616667, -1.082863
29.620000, -1.082874
29.623333, -1.083555
29.626667, -1.084240
29.630000, -1.084597
29.633333, -1.084674
29.636667, -1.084630
29.640000, -1.084448
29.643333, -1.083939
29.646667, -1.083037
29.650000, -1.082011
29.653333, -1.081524
29.656667, -1.082422
29.660000, -1.084991
29.663333, -1.088389
29.666667, -1.091207
29.670000, -1.092587
29.673333, -1.092636
29.676667, -1.091988
29.680000, -1.091172
29.683333, -1.090424
29.686667, -1.089976
29.690000, -1.090027
29.693333, -1.090510
29.696667, -1.091255
29.700000, -1.092135
29.703333, -1.092872
29.706667, -1.092919
29.710000, -1.091676
29.713333, -1.089020
29.716667, -1.085672
29.720000, -1.082817
29.723333, -1.081207
29.726667, -1.080802
29.730000, -1.081208
29.733333, -1.082002
29.736667, -1.082811
29.740000, -1.083352
29.743333, -1.083502
29.746667, -1.083553
29.750000, -1.084141
29.753333, -1.085612
29.756667, -1.087753
29.760000, -1.090269
29.763333, -1.093235
29.766667, -1.096989
29.770000, -1.101652
29.773333, -1.106644
29.776667, -1.110943
29.780000, -1.113947
29.783333, -1.115836
29.786667, -1.117130
29.790000, -1.118163
29.793333, -1.119012
29.796667, -1.119738
29.800000, -1.120475
29.803333, -1.121417
29.806667, -1.122750
29.810000, -1.124516
29.813333, -1.126613
29.816667, -1.128882
29.820000, -1.131055
29.823333, -1.132683
29.826667, -1.133323
29.830000, -1.132984
29.833333, -1.132230
29.836667, -1.131754
29.840000, -1.131941
29.843333, -1.132757
29.846667, -1.134025
29.850000, -1.135722
29.853333, -1.137881
29.856667, -1.140343
29.860000, -1.142726
29.863333, -1.144631
29.866667, -1.145758
29.870000, -1.145880
29.873333, -1.144927
29.876667, -1.143156
29.880000, -1.141227
29.883333, -1.139888
29.886667, -1.139376
29.890000, -1.139257
29.893333, -1.138892
29.896667, -1.138045
29.900000, -1.137265
29.903333, -1.137631
29.906667, -1.139806
29.910000, -1.143382
29.913333, -1.147294
29.916667, -1.150701
29.920000, -1.153535
29.923333, -1.156294
29.926667, -1.159306
29.930000, -1.162398
29.933333, -1.165197
29.936667, -1.167496
29.940000, -1.169517
29.943333, -1.171784
29.946667, -1.174558
29.950000, -1.177629
29.953333, -1.180647
29.956667, -1.183407
29.960000, -1.185978
29.963333, -1.188566
29.966667, -1.191195
29.970000, -1.193703
29.973333, -1.195902
29.976667, -1.197503
29.980000, -1.198314
29.983333, -1.198793
29.986667, -1.199973
29.990000, -1.202726
29.993333, -1.207301
29.996667, -1.213227
30.000000, -1.219334


##END=




`;

export default hplcUVVisJcamp;
